webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/* exports provided: default */
/* exports used: default */
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(/*! ./app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slug__ = __webpack_require__(/*! slug */ 336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slug__);



__WEBPACK_IMPORTED_MODULE_1_slug___default.a.charmap['.'] = '-';

__WEBPACK_IMPORTED_MODULE_1_slug___default.a.defaults.modes.custom = {
  replacement: '-',
  symbols: true,
  remove: /[%]/g,
  lower: true,
  charmap: __WEBPACK_IMPORTED_MODULE_1_slug___default.a.charmap,
  multicharmap: __WEBPACK_IMPORTED_MODULE_1_slug___default.a.multicharmap
};

__WEBPACK_IMPORTED_MODULE_1_slug___default.a.defaults.mode = 'custom';

/* harmony default export */ __webpack_exports__["a"] = {
  clearTitle: function clearTitle() {
    document.title = 'slotlist.info - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('title.browser');
  },
  setTitle: function setTitle(suffix) {
    document.title = 'slotlist.info - ' + suffix;
  },
  slug: function slug(val) {
    return __WEBPACK_IMPORTED_MODULE_1_slug___default()(val);
  }
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/* exports provided: app, router, store, i18n */
/* exports used: app, i18n */
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__(/*! bluebird */ 291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(/*! vue */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__(/*! bootstrap-vue/dist/bootstrap-vue.esm */ 292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(/*! bootstrap-vue/dist/bootstrap-vue.css */ 299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(/*! bootstrap/dist/css/bootstrap.min.css */ 300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_css_app_css__ = __webpack_require__(/*! ../static/css/app.css */ 304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_css_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_css_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_css_arma3_css__ = __webpack_require__(/*! ../static/css/arma3.css */ 305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_css_arma3_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_css_arma3_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_css_editors_css__ = __webpack_require__(/*! ../static/css/editors.css */ 306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_css_editors_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_css_editors_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_popovers_css__ = __webpack_require__(/*! ../static/css/popovers.css */ 307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_css_popovers_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_css_popovers_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_tables_css__ = __webpack_require__(/*! ../static/css/tables.css */ 308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_css_tables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_css_tables_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_App__ = __webpack_require__(/*! ./components/App */ 344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router__ = __webpack_require__(/*! ./router */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__(/*! ./store */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_raven_js_plugins_vue__ = __webpack_require__(/*! raven-js/plugins/vue */ 328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plugins_acl__ = __webpack_require__(/*! ./plugins/acl */ 281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_ls__ = __webpack_require__(/*! vue-ls */ 581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_simple_spinner__ = __webpack_require__(/*! vue-simple-spinner */ 584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_click_confirm__ = __webpack_require__(/*! click-confirm */ 294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_click_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_click_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuejs_paginate__ = __webpack_require__(/*! vuejs-paginate */ 586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_i18n__ = __webpack_require__(/*! vue-i18n */ 342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_clipboard2__ = __webpack_require__(/*! vue-clipboard2 */ 341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Typeahead_vue__ = __webpack_require__(/*! ./components/Typeahead.vue */ 348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Typeahead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Typeahead_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_LoadingOverlay_vue__ = __webpack_require__(/*! ./components/LoadingOverlay.vue */ 347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_LoadingOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_LoadingOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_EditorExplanation_vue__ = __webpack_require__(/*! ./components/EditorExplanation.vue */ 346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_EditorExplanation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_EditorExplanation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_quill__ = __webpack_require__(/*! quill */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_quill_image_resize_module__ = __webpack_require__(/*! quill-image-resize-module */ 327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_quill_image_resize_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_quill_image_resize_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_quill_editor__ = __webpack_require__(/*! vue-quill-editor */ 582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_quill_editor__);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return i18n; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






























// Patch Promise globally to use more feature-rich bluebird Promises
__WEBPACK_IMPORTED_MODULE_2_bluebird___default.a.config({
  warnings: false
});

window.Promise = __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a;

// Taken from https://stackoverflow.com/a/27081419 on 2018-03-23 15:36
if ((typeof localStorage === 'undefined' ? 'undefined' : _typeof(localStorage)) === 'object') {
  try {
    localStorage.setItem('sl__localStorageTest', 1);
    localStorage.removeItem('sl__localStorageTest');

    console.debug('Your web browser supports local storage. Authentication and local preferences will be persisted!');
  } catch (err) {
    Storage.prototype._setItem = Storage.prototype.setItem;
    Storage.prototype.setItem = function () {};

    console.warn('Your web browser does not support local storage. Authentication and local preferences will not be persisted!');
  }
}

// Blank-require API/axios utils
__webpack_require__(/*! ./api/util */ 22);

if ({"NODE_ENV":"production","BASE_URL":"https://slotlist.walthex.com","BASE_API_URL":"https://api.slotlist.walthex.com","FRONTEND_VERSION":"1.1.1"}.SENTRY_DSN) {
  console.info('Configuring sentry.io integration');
  __WEBPACK_IMPORTED_MODULE_16_raven_js___default.a.config({"NODE_ENV":"production","BASE_URL":"https://slotlist.walthex.com","BASE_API_URL":"https://api.slotlist.walthex.com","FRONTEND_VERSION":"1.1.1"}.SENTRY_DSN, {
    autoBreadcrumbs: true,
    environment: "production" || 'unknown',
    release: "1.1.1" || 'unknown'
  }).addPlugin(__WEBPACK_IMPORTED_MODULE_17_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]).install();
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_esm__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18__plugins_acl__["a" /* default */], {
  router: __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue_ls___default.a, {
  namespace: 'sl__'
});




__WEBPACK_IMPORTED_MODULE_28_quill___default.a.register('modules/imageResize', __WEBPACK_IMPORTED_MODULE_29_quill_image_resize_module___default.a);
var Link = __WEBPACK_IMPORTED_MODULE_28_quill___default.a.import('formats/link');
Link.PROTOCOL_WHITELIST = __WEBPACK_IMPORTED_MODULE_0_lodash__["concat"](Link.PROTOCOL_WHITELIST, 'ts3server', 'ftp');



__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_30_vue_quill_editor___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_23_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_24_vue_clipboard2___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('click-confirm', __WEBPACK_IMPORTED_MODULE_21_click_confirm___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('spinner', __WEBPACK_IMPORTED_MODULE_20_vue_simple_spinner___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('loading-overlay', __WEBPACK_IMPORTED_MODULE_26__components_LoadingOverlay_vue___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('paginate', __WEBPACK_IMPORTED_MODULE_22_vuejs_paginate___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('typeahead', __WEBPACK_IMPORTED_MODULE_25__components_Typeahead_vue___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('editor-explanation', __WEBPACK_IMPORTED_MODULE_27__components_EditorExplanation_vue___default.a);

var i18n = new __WEBPACK_IMPORTED_MODULE_23_vue_i18n__["a" /* default */]({
  fallbackLocale: 'en',
  locale: 'en',
  messages: {
    de: __webpack_require__(/*! ./i18n/de.json */ 592),
    'de-at': __webpack_require__(/*! ./i18n/de-at.json */ 591),
    en: __webpack_require__(/*! ./i18n/en.json */ 593)
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].mixin({
  methods: {
    formatDateTime: function formatDateTime(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(dateTime).format('L LT');
    },
    formatUserWithTag: function formatUserWithTag(user) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user.community) ? user.nickname : '[' + user.community.tag + '] ' + user.nickname;
    }
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */],
  i18n: i18n
}, __WEBPACK_IMPORTED_MODULE_13__components_App___default.a));



/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/* exports provided: router, default */
/* exports used: default */
/*!*****************************!*\
  !*** ./src/router/index.js ***!
  \*****************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(/*! ../store */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home__ = __webpack_require__(/*! ../views/Home */ 449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CommunityList__ = __webpack_require__(/*! ../views/CommunityList */ 448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_CommunityList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_CommunityList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CommunityDetails__ = __webpack_require__(/*! ../views/CommunityDetails */ 447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_CommunityDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_CommunityDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_CommunityCreator__ = __webpack_require__(/*! ../views/CommunityCreator */ 446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_CommunityCreator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_CommunityCreator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_MissionList__ = __webpack_require__(/*! ../views/MissionList */ 454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_MissionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_MissionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_MissionDetails__ = __webpack_require__(/*! ../views/MissionDetails */ 453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_MissionDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_MissionDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_MissionCreator__ = __webpack_require__(/*! ../views/MissionCreator */ 452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_MissionCreator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_MissionCreator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_MissionSlotTemplateList__ = __webpack_require__(/*! ../views/MissionSlotTemplateList */ 457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_MissionSlotTemplateList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_MissionSlotTemplateList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_MissionSlotTemplateDetails__ = __webpack_require__(/*! ../views/MissionSlotTemplateDetails */ 456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_MissionSlotTemplateDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_MissionSlotTemplateDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_MissionSlotTemplateCreator__ = __webpack_require__(/*! ../views/MissionSlotTemplateCreator */ 455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_MissionSlotTemplateCreator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_MissionSlotTemplateCreator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_NotificationList__ = __webpack_require__(/*! ../views/NotificationList */ 458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_NotificationList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_NotificationList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_UserDetails__ = __webpack_require__(/*! ../views/UserDetails */ 460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_UserDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_UserDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_UserList__ = __webpack_require__(/*! ../views/UserList */ 461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_UserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Account__ = __webpack_require__(/*! ../views/Account */ 444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_Account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Login__ = __webpack_require__(/*! ../views/Login */ 451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_About__ = __webpack_require__(/*! ../views/About */ 443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Imprint__ = __webpack_require__(/*! ../views/Imprint */ 450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Imprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_Imprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Privacy__ = __webpack_require__(/*! ../views/Privacy */ 459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Api__ = __webpack_require__(/*! ../views/Api */ 445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_Api__);
/* unused harmony export router */























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Home___default.a
  }, {
    path: '/communities',
    name: 'communityList',
    component: __WEBPACK_IMPORTED_MODULE_4__views_CommunityList___default.a
  }, {
    path: '/communities/:communitySlug',
    name: 'communityDetails',
    component: __WEBPACK_IMPORTED_MODULE_5__views_CommunityDetails___default.a
  }, {
    path: '/community-creator',
    name: 'communityCreator',
    component: __WEBPACK_IMPORTED_MODULE_6__views_CommunityCreator___default.a,
    meta: {
      authenticated: true // only logged in users can access this page
    }
  }, {
    path: '/missions',
    name: 'missionList',
    component: __WEBPACK_IMPORTED_MODULE_7__views_MissionList___default.a
  }, {
    path: '/missions/:missionSlug',
    name: 'missionDetails',
    component: __WEBPACK_IMPORTED_MODULE_8__views_MissionDetails___default.a
  }, {
    path: '/mission-creator',
    name: 'missionCreator',
    component: __WEBPACK_IMPORTED_MODULE_9__views_MissionCreator___default.a,
    meta: {
      authenticated: true // only logged in users can access this page
    }
  }, {
    path: '/mission-slot-templates',
    name: 'missionSlotTemplateList',
    component: __WEBPACK_IMPORTED_MODULE_10__views_MissionSlotTemplateList___default.a
  }, {
    path: '/mission-slot-templates/:missionSlotTemplateUid',
    name: 'missionSlotTemplateDetails',
    component: __WEBPACK_IMPORTED_MODULE_11__views_MissionSlotTemplateDetails___default.a
  }, {
    path: '/mission-slot-templates-creator',
    name: 'missionSlotTemplateCreator',
    component: __WEBPACK_IMPORTED_MODULE_12__views_MissionSlotTemplateCreator___default.a,
    meta: {
      authenticated: true // only logged in users can access this page
    }
  }, {
    path: '/notifications',
    name: 'notificationList',
    component: __WEBPACK_IMPORTED_MODULE_13__views_NotificationList___default.a,
    meta: {
      authenticated: true // only logged in users can access this page
    }
  }, {
    path: '/users',
    name: 'userList',
    component: __WEBPACK_IMPORTED_MODULE_15__views_UserList___default.a
  }, {
    path: '/users/:userUid',
    name: 'userDetails',
    component: __WEBPACK_IMPORTED_MODULE_14__views_UserDetails___default.a
  }, {
    path: '/account',
    name: 'account',
    component: __WEBPACK_IMPORTED_MODULE_16__views_Account___default.a,
    meta: {
      authenticated: true // only logged in users can access this page
    }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_17__views_Login___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      // Set path of previous route before accessing login route, used for redirects after successful authentication
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('setRedirect', { path: from.path });
      next();
    }
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_18__views_About___default.a
  }, {
    path: '/imprint',
    name: 'imprint',
    component: __WEBPACK_IMPORTED_MODULE_19__views_Imprint___default.a
  }, {
    path: '/privacy',
    name: 'privacy',
    component: __WEBPACK_IMPORTED_MODULE_20__views_Privacy___default.a
  }, {
    path: '/api',
    name: 'api',
    component: __WEBPACK_IMPORTED_MODULE_21__views_Api___default.a
  }],
  linkExactActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.loggedIn && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.pollingUnseenNotifications) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getUnseenNotificationCount', { autoRefresh: true });
  }

  next();
});

router.afterEach(function () {
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.showAlert && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.persistentAlert) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('clearAlert');
  }
});

/* harmony default export */ __webpack_exports__["a"] = router;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/* exports provided: default */
/* exports used: default */
/*!****************************!*\
  !*** ./src/store/index.js ***!
  \****************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_alert__ = __webpack_require__(/*! ./modules/alert */ 282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__(/*! ./modules/auth */ 283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_communities__ = __webpack_require__(/*! ./modules/communities */ 284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_missions__ = __webpack_require__(/*! ./modules/missions */ 286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_missionSlotTemplates__ = __webpack_require__(/*! ./modules/missionSlotTemplates */ 285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_notifications__ = __webpack_require__(/*! ./modules/notifications */ 287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_users__ = __webpack_require__(/*! ./modules/users */ 288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_util__ = __webpack_require__(/*! ./modules/util */ 289);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    alert: __WEBPACK_IMPORTED_MODULE_2__modules_alert__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["a" /* default */],
    communities: __WEBPACK_IMPORTED_MODULE_4__modules_communities__["a" /* default */],
    missions: __WEBPACK_IMPORTED_MODULE_5__modules_missions__["a" /* default */],
    missionSlotTemplates: __WEBPACK_IMPORTED_MODULE_6__modules_missionSlotTemplates__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_7__modules_notifications__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_8__modules_users__["a" /* default */],
    util: __WEBPACK_IMPORTED_MODULE_9__modules_util__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/* exports provided: pendingRequestCount, shouldRefreshToken */
/* all exports used */
/*!*************************!*\
  !*** ./src/api/util.js ***!
  \*************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(/*! ../store */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(/*! ../router */ 11);
/* harmony export (immutable) */ __webpack_exports__["pendingRequestCount"] = pendingRequestCount;
/* harmony export (immutable) */ __webpack_exports__["shouldRefreshToken"] = shouldRefreshToken;






__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = "https://api.slotlist.walthex.com";
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post['Content-Type'] = 'application/json';
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.patch['Content-Type'] = 'application/json';

var pendingRequests = 0;

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
  pendingRequests += 1;

  if (!__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.refreshingToken && shouldRefreshToken()) {
    console.info('Refreshing JWT before performing request');

    return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('refreshToken').then(function () {
      console.info('Done refreshing JWT, performing actual request');

      return config;
    }).catch(function (error) {
      return Promise.reject(error);
    });
  }

  console.debug('request', config.url, config);
  return config;
}, function (error) {
  var url = error && error.config ? error.config.url : 'unknown URL';
  console.debug('request error', url, error);

  return Promise.reject(error);
});

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (response) {
  pendingRequests -= 1;

  console.debug('response', response.config.url, response);

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.token)) {
    console.info('Received new JWT during request, updating local token');

    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setToken', response.data.token);
  }

  return response;
}, function (error) {
  if (error.response && error.response.status === 401) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('performLogout');

    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'login' });
  }

  var url = error && error.config ? error.config.url : 'unknown URL';
  console.debug('response error', url, error);

  return Promise.reject(error);
});

function pendingRequestCount() {
  return pendingRequests;
}

function shouldRefreshToken() {
  var decodedToken = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.decodedToken;
  if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](decodedToken)) {
    return false;
  }

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNumber"](decodedToken.exp)) {
    return false;
  }

  var expiry = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.unix(decodedToken.exp).utc();
  var now = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().utc().add(1, 'm');

  if (expiry <= now) {
    return true;
  }

  return false;
}

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./~/vue-quill-editor/src/editor.vue ***!
  \*******************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Quill, Quill) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

__webpack_require__(/*! quill/dist/quill.snow.css */ 303);
__webpack_require__(/*! quill/dist/quill.bubble.css */ 301);
__webpack_require__(/*! quill/dist/quill.core.css */ 302);
if (!__webpack_provided_window_dot_Quill) {
  __webpack_provided_window_dot_Quill = __webpack_require__(/*! quill/dist/quill.js */ 9);
}
/* harmony default export */ __webpack_exports__["default"] = {
  name: 'quill-editor',
  data: function data() {
    return {
      _content: '',
      defaultModules: {
        toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image', 'video']]
      }
    };
  },

  props: {
    content: String,
    value: String,
    disabled: Boolean,
    options: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
  },

  methods: {
    initialize: function initialize() {
      if (this.$el) {

        // options and instance
        var self = this;
        self.options.theme = self.options.theme || 'snow';
        self.options.boundary = self.options.boundary || document.body;
        self.options.modules = self.options.modules || self.defaultModules;
        self.options.modules.toolbar = self.options.modules.toolbar !== undefined ? self.options.modules.toolbar : self.defaultModules.toolbar;
        self.options.placeholder = self.options.placeholder || 'Insert text here ...';
        self.options.readOnly = self.options.readOnly !== undefined ? self.options.readOnly : false;
        self.quill = new Quill(self.$refs.editor, self.options);

        // set editor content
        if (self.value || self.content) {
          self.quill.pasteHTML(self.value || self.content);
        }

        // mark model as touched if editor lost focus
        self.quill.on('selection-change', function (range) {
          if (!range) {
            self.$emit('blur', self.quill);
          } else {
            self.$emit('focus', self.quill);
          }
        });

        // update model if text changes
        self.quill.on('text-change', function (delta, oldDelta, source) {
          var html = self.$refs.editor.children[0].innerHTML;
          var text = self.quill.getText();
          if (html === '<p><br></p>') html = '';
          self._content = html;
          self.$emit('input', self._content);
          self.$emit('change', {
            editor: self.quill,
            html: html,
            text: text
          });
        });

        // emit ready
        self.$emit('ready', self.quill);
      }
    }
  },
  watch: {
    'content': function content(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    'value': function value(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    'disabled': function disabled(newVal, oldVal) {
      if (this.quill) {
        this.quill.enable(!newVal);
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! quill/dist/quill.js */ 9), __webpack_require__(/*! quill/dist/quill.js */ 9)))

/***/ }),
/* 164 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \********************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util__ = __webpack_require__(/*! ../api/util */ 22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  beforeCreate: function beforeCreate() {
    var _this = this;

    var locale = this.$ls.get('locale');
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](locale) || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](locale) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](locale)) {
      console.info('Locale not defined, retrieving from browser language');

      var userLanguage = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
      locale = userLanguage.split('-')[0].trim();

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](locale) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](locale)) {
        console.info('Failed to get user language from browser, falling back to English');
        locale = 'en';
      }
    }

    this.$store.dispatch('setLocale', locale);

    var timezone = this.$ls.get('timezone');
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](timezone) || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](timezone) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](timezone)) {
      console.info('Timezone not defined, guessing from browser settings');

      timezone = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz.guess();

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](timezone) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](timezone)) {
        console.info('Failed to get user timezone from browser, falling back to UTC');
        timezone = 'Etc/UTC';
      }
    }

    this.$store.dispatch('setTimezone', timezone);

    var token = this.$ls.get('auth-token');
    if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](token)) {
      this.$store.dispatch('setTokenFromLocalStorage', token).then(function () {
        // need to check for token again since an expired token is cleared during the `setTokenFromLocalStorage` action,
        // leading to an instant authentication error if the users loads the app after the token expired
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](_this.$ls.get('auth-token'))) {
          var lastRefreshedAt = _this.$ls.get('auth-token-last-refreshed');
          if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](lastRefreshedAt) || __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(lastRefreshedAt) <= __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().subtract(1, 'hour')) {
            _this.performInitialTokenRefresh();
          }

          if (!_this.$store.getters.pollingUnseenNotifications) {
            _this.$store.dispatch('getUnseenNotificationCount', { autoRefresh: true });
          }
        }
      });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].clearTitle();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('clearMissions');
  },
  data: function data() {
    return {
      initialTokenRefresh: true
    };
  },

  computed: {
    alertDismissible: function alertDismissible() {
      return this.$store.getters.alertDismissible;
    },
    alertMessage: function alertMessage() {
      return this.$store.getters.alertMessage;
    },
    alertVariant: function alertVariant() {
      return this.$store.getters.alertVariant;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    selectedLanguage: function selectedLanguage() {
      var locale = this.$i18n.locale;

      switch (locale) {
        case 'en':
          return '<img src="/img/flags/gb.png"> English';
        case 'de':
          return '<img src="/img/flags/de.png"> Deutsch';
        case 'de-at':
          return '<img src="/img/flags/at.png"> Österreichisch';
        default:
          return '<i class="fa fa-language" aria-hidden="true"> Language';
      }
    },
    showAlert: function showAlert() {
      return this.$store.getters.showAlert;
    },
    unseenNotificationCount: function unseenNotificationCount() {
      return this.$store.getters.unseenNotificationCount;
    },
    working: function working() {
      return this.$store.getters.working;
    },
    year: function year() {
      return new Date().getFullYear();
    }
  },
  methods: {
    alertDismissCountDown: function alertDismissCountDown(val) {
      if (val === 1) {
        console.info('This is gonna look ugly...');
        this.$store.dispatch('clearAlert');
      }
    },
    alertDismissed: function alertDismissed() {
      this.$store.dispatch('clearAlert');
    },
    logout: function logout() {
      var _this2 = this;

      this.$store.dispatch('performLogout').then(function () {
        _this2.$router.push({ path: '/', query: { logout: true } });
      });
    },
    performInitialTokenRefresh: function performInitialTokenRefresh() {
      if (this.initialTokenRefresh) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_util__["pendingRequestCount"])() > 0) {
          setTimeout(this.performInitialTokenRefresh, 5000);
          return;
        }

        this.initialTokenRefresh = false;

        this.$store.dispatch('refreshToken', { silent: true });
      }
    },
    setLocale: function setLocale(locale) {
      this.$store.dispatch('setLocale', locale);
    }
  }
};

/***/ }),
/* 165 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Calendar.vue ***!
  \*************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_CalendarBody_vue__ = __webpack_require__(/*! ./calendar/CalendarBody.vue */ 357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar_CalendarBody_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calendar_CalendarBody_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_CalendarHeader_vue__ = __webpack_require__(/*! ./calendar/CalendarHeader.vue */ 359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar_CalendarHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__calendar_CalendarHeader_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CalendarBody: __WEBPACK_IMPORTED_MODULE_1__calendar_CalendarBody_vue___default.a,
    CalendarHeader: __WEBPACK_IMPORTED_MODULE_2__calendar_CalendarHeader_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    if (_.isNil(this.$store.getters.missionsForCalendar)) {
      this.$store.dispatch('changeMissionCalendarCurrentMonth', __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().startOf('month'));
    }
  },
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    timezone: function timezone() {
      return this.$store.getters.timezone;
    }
  }
};

/***/ }),
/* 166 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditorExplanation.vue ***!
  \**********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    editorExplanationContent: function editorExplanationContent() {
      var _this = this;

      var content = '<img src="https://slotlist-info.storage.googleapis.com/images/static/editor-explanation.png" style="border: 1px solid #000000; padding: 0;"><br><br><ol>';
      __WEBPACK_IMPORTED_MODULE_0_lodash__["times"](8, function (i) {
        content += '<li>' + _this.$t('editor.explanation.' + (i + 1)) + '</li>';
      });
      content += '</ol><div class="text-center">' + this.$t('editor.explanation.missing') + '</div>';
      return content;
    }
  }
};

/***/ }),
/* 167 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingOverlay.vue ***!
  \*******************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['message', 'size']
};

/***/ }),
/* 168 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Typeahead.vue ***!
  \**************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    limit: {
      type: Number,
      default: 10
    },
    action: {
      type: String
    },
    actionIndicator: {
      type: String
    },
    minCharacters: {
      type: Number,
      default: 3
    },
    onHit: {
      type: Function,
      default: function _default(items) {
        this.reset();
        this.value = items;
      }
    },
    placeholder: {
      type: String,
      default: null
    },
    initialValue: {
      type: String,
      default: null
    }
  },
  created: function created() {
    if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.initialValue)) {
      this.value = this.initialValue;
    }
  },
  data: function data() {
    return {
      showDropdown: false,
      current: 0,
      items: [],
      value: ''
    };
  },

  computed: {
    searchRunning: function searchRunning() {
      return this.$store.getters[this.actionIndicator];
    },
    searchStatus: function searchStatus() {
      return '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
    }
  },
  methods: {
    update: function update() {
      if (!this.value) {
        this.reset();
        return false;
      }

      if (this.value.length < this.minCharacters) {
        return;
      }

      this.query();
    },

    query: __WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"](function () {
      var _this = this;

      this.$store.dispatch(this.action, this.value).then(function (results) {
        _this.items = results.slice(0, _this.limit);
        _this.showDropdown = _this.items.length > 0;
      });
    }, 500),
    reset: function reset() {
      this.items = [];
      this.value = '';
      this.loading = false;
      this.showDropdown = false;
    },
    setActive: function setActive(index) {
      this.current = index;
    },
    isActive: function isActive(index) {
      return this.current === index;
    },
    hit: function hit(e) {
      e.preventDefault();
      this.value = this.items[this.current].title;
      this.onHit(this.items[this.current], this);
      this.showDropdown = false;
    },
    up: function up() {
      if (this.current > 0) this.current--;
    },
    down: function down() {
      if (this.current < this.items.length - 1) this.current++;
    },
    highlight: function highlight(title, val) {
      var escapedVal = val.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      return title.replace(new RegExp('(' + escapedVal + ')', 'gi'), '<strong>$1</strong>');
    }
  }
};

/***/ }),
/* 169 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/AccountMissions.vue ***!
  \****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountMissionsTable_vue__ = __webpack_require__(/*! ./AccountMissionsTable.vue */ 351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountMissionsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AccountMissionsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AccountMissionsTable: __WEBPACK_IMPORTED_MODULE_0__AccountMissionsTable_vue___default.a
  },
  methods: {
    refreshAccountMissions: function refreshAccountMissions() {
      this.$store.dispatch('getAccountDetails');
    }
  }
};

/***/ }),
/* 170 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/AccountMissionsRow.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['accountMission']
};

/***/ }),
/* 171 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/AccountMissionsTable.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountMissionsRow_vue__ = __webpack_require__(/*! ./AccountMissionsRow.vue */ 350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountMissionsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AccountMissionsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AccountMissionsRow: __WEBPACK_IMPORTED_MODULE_0__AccountMissionsRow_vue___default.a
  },
  computed: {
    accountMissions: function accountMissions() {
      return this.$store.getters.accountMissions;
    }
  }
};

/***/ }),
/* 172 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/AccountPermissions.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountPermissionsTable_vue__ = __webpack_require__(/*! ./AccountPermissionsTable.vue */ 354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountPermissionsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AccountPermissionsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AccountPermissionsTable: __WEBPACK_IMPORTED_MODULE_0__AccountPermissionsTable_vue___default.a
  },
  methods: {
    refreshAccountPermissions: function refreshAccountPermissions() {
      this.$store.dispatch('getAccountDetails');
    }
  }
};

/***/ }),
/* 173 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/AccountPermissionsRow.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['accountPermission']
};

/***/ }),
/* 174 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/AccountPermissionsTable.vue ***!
  \************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountPermissionsRow_vue__ = __webpack_require__(/*! ./AccountPermissionsRow.vue */ 353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccountPermissionsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AccountPermissionsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AccountPermissionsRow: __WEBPACK_IMPORTED_MODULE_0__AccountPermissionsRow_vue___default.a
  },
  computed: {
    accountPermissions: function accountPermissions() {
      return this.$store.getters.accountPermissions;
    }
  }
};

/***/ }),
/* 175 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/modals/AccountDeleteModal.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      accountDeleteData: {
        nickname: null
      }
    };
  },

  computed: {
    accountDetails: function accountDetails() {
      return this.$store.getters.accountDetails;
    },
    accountEditNicknameFeedback: function accountEditNicknameFeedback() {
      return this.accountDeleteData.nickname !== this.accountDetails.nickname ? this.$t('account.delete.feedback.nickname') : '';
    },
    accountEditNicknameState: function accountEditNicknameState() {
      return this.accountDeleteData.nickname !== this.accountDetails.nickname ? 'danger' : 'success';
    }
  },
  methods: {
    clearAccountDeleteData: function clearAccountDeleteData() {
      this.accountDeleteData = {
        nickname: null
      };
    },
    deleteAccount: function deleteAccount() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.accountDeleteData.nickname)) {
        return;
      }

      this.hideAccountDeleteModal();

      this.$store.dispatch('deleteAccount', { nickname: this.accountDeleteData.nickname });
    },
    hideAccountDeleteModal: function hideAccountDeleteModal() {
      this.$refs.accountDeleteModal.hide();
    }
  }
};

/***/ }),
/* 176 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/modals/AccountEditModal.vue ***!
  \************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      accountEditData: {
        nickname: null
      },
      accountEditTimezone: null
    };
  },

  computed: {
    accountDetails: function accountDetails() {
      return this.$store.getters.accountDetails;
    },
    accountEditNicknameFeedback: function accountEditNicknameFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.accountEditData.nickname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.accountEditData.nickname) ? this.$t('account.feedback.nickname') : '';
    },
    accountEditNicknameState: function accountEditNicknameState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.accountEditData.nickname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.accountEditData.nickname) ? 'danger' : 'success';
    },
    accountEditTimezoneOptions: function accountEditTimezoneOptions() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["map"](__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default.a.tz.names(), function (name) {
        return { value: name, text: name };
      });
    },
    timezone: function timezone() {
      return this.$store.getters.timezone;
    }
  },
  methods: {
    editAccount: function editAccount() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.accountEditData.nickname)) {
        return;
      }

      var updatedAccountDetails = {};
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.accountEditData, function (value, key) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, _this.accountDetails[key])) {
          updatedAccountDetails[key] = value;
        }
      });

      this.hideAccountEditModal();

      var timezoneUpdated = this.accountEditTimezone !== this.timezone;
      if (timezoneUpdated) {
        this.$store.dispatch('setTimezone', this.accountEditTimezone);
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](updatedAccountDetails) && !timezoneUpdated) {
        return this.$store.dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'warning',
          alertMessage: '<i class="fa fa-warning" aria-hidden="true"></i> ' + this.$t('account.noChanges')
        });
      } else if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](updatedAccountDetails)) {
        this.$store.dispatch('editAccount', {
          updatedAccountDetails: updatedAccountDetails
        });
      }
    },
    hideAccountEditModal: function hideAccountEditModal() {
      this.$refs.accountEditModal.hide();
    },
    setAccountEditData: function setAccountEditData() {
      this.accountEditData = {
        nickname: this.accountDetails.nickname
      };
      this.accountEditTimezone = this.timezone;
    }
  }
};

/***/ }),
/* 177 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar/CalendarBody.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarWeek_vue__ = __webpack_require__(/*! ./CalendarWeek.vue */ 361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarWeek_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CalendarWeek_vue__);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CalendarWeek: __WEBPACK_IMPORTED_MODULE_2__CalendarWeek_vue___default.a
  },
  computed: {
    currentMonth: function currentMonth() {
      return this.$store.getters.missionCalendarCurrentMonth;
    },
    firstDayOfWeek: function firstDayOfWeek() {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().locale(this.locale).localeData().firstDayOfWeek();
    },
    locale: function locale() {
      return this.$i18n.locale;
    },
    missions: function missions() {
      return this.$store.getters.missionsForCalendar;
    },
    weeks: function weeks() {
      var _this = this;

      var momentIterator = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.currentMonth).locale(this.locale);
      var startOfMonth = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(momentIterator.startOf('month'));

      momentIterator.subtract(startOfMonth.day(), 'days');

      if (startOfMonth.day() < this.firstDayOfWeek) {
        momentIterator.subtract(7, 'days');
      }

      momentIterator.add(this.firstDayOfWeek, 'days');

      var startDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(momentIterator);
      var daysInMonth = momentIterator.daysInMonth();

      var weeks = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash__["times"](5, function () {
        var week = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash__["times"](7, function (dayIndex) {
          var day = {
            isToday: momentIterator.isSame(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(), 'day'),
            isCurrentMonth: momentIterator.isSame(_this.currentMonth, 'month'),
            isWeekend: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(momentIterator).isoWeekday() >= 6,
            date: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(momentIterator)
          };

          week.push(day);
          momentIterator.add(1, 'day');
        });

        weeks.push(week);
      });

      var diff = daysInMonth - weeks[4][6].date.format('D');

      if (diff > 0 && diff < 3) {
        var week = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash__["times"](7, function (dayIndex) {
          var day = {
            isToday: momentIterator.isSame(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(), 'day'),
            isCurrentMonth: momentIterator.isSame(_this.currentMonth, 'month'),
            isWeekend: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(momentIterator).isoWeekday() >= 6,
            date: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(momentIterator)
          };

          week.push(day);
          momentIterator.add(1, 'day');
        });

        weeks.push(week);
      }

      var endDate = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(momentIterator.subtract(1, 'day').endOf('day'));

      if ((__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.missionsForCalendar) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.missionsForCalendarRefreshSetInterval)) && !this.$store.getters.refreshingMissionsForCalendar) {
        this.$store.dispatch('getMissionsForCalendar', {
          autoRefresh: true,
          startDate: startDate,
          endDate: endDate
        });
      }

      return weeks;
    }
  },
  methods: {
    getMissionsForDay: function getMissionsForDay(day) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missions) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missions)) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["filter"](this.missions, function (mission) {
        return day.isSame(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(mission.startTime), 'day');
      });
    },
    localizedWeekDay: function localizedWeekDay(day) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().locale(this.locale).localeData().weekdaysShort()[(this.firstDayOfWeek + day) % 7];
    }
  }
};

/***/ }),
/* 178 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar/CalendarDay.vue ***!
  \*************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarMission_vue__ = __webpack_require__(/*! ./CalendarMission.vue */ 360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarMission_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CalendarMission_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CalendarMission: __WEBPACK_IMPORTED_MODULE_0__CalendarMission_vue___default.a
  },
  props: ['day'],
  computed: {
    isDaySelected: function isDaySelected() {
      return false;
    },
    missions: function missions() {
      return this.$store.getters.missionsForCalendar;
    },
    missionsForDay: function missionsForDay() {
      var _this = this;

      if (_.isNil(this.missions) || _.isEmpty(this.missions)) {
        return [];
      }

      return _.filter(this.missions, function (mission) {
        return _this.day.date.isSame(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(mission.startTime), 'day');
      });
    }
  }
};

/***/ }),
/* 179 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar/CalendarHeader.vue ***!
  \****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    currentMonth: function currentMonth() {
      return this.$store.getters.missionCalendarCurrentMonth;
    },
    locale: function locale() {
      return this.$i18n.locale;
    },
    refreshingMissionsForCalendar: function refreshingMissionsForCalendar() {
      return this.$store.getters.refreshingMissionsForCalendar;
    }
  },
  methods: {
    changeMonth: function changeMonth(direction) {
      var payload = void 0;

      if (direction === 0) {
        payload = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().startOf('month');
      } else if (direction < 0) {
        payload = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.currentMonth).subtract(1, 'month').startOf('month');
      } else {
        payload = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.currentMonth).add(1, 'month').startOf('month');
      }

      this.$store.dispatch('changeMissionCalendarCurrentMonth', payload);
    },
    refreshCalendarMissions: function refreshCalendarMissions() {
      this.$store.dispatch('getMissionsForCalendar', {
        autoRefresh: true,
        startDate: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.currentMonth).startOf('month'),
        endDate: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.currentMonth).endOf('month')
      });
    }
  }
};

/***/ }),
/* 180 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar/CalendarMission.vue ***!
  \*****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['mission'],
  computed: {
    missionPopoverContent: function missionPopoverContent() {
      var content = '<span><strong>' + this.mission.title + '</strong><br>' + this.$t('mission.startTime') + ' ' + __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.mission.startTime).format('LT') + '<br>' + this.$t('mission.endTime') + ' ' + __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.mission.endTime).format('LT');
      if (!this.mission.isAssignedToAnySlot && this.mission.isRegisteredForAnySlot) {
        content += '<br>' + this.$t('mission.list.slot.status.registered') + '</span>';
      } else if (this.mission.isAssignedToAnySlot) {
        content += '<br>' + this.$t('mission.list.slot.status.assigned') + '</span>';
      } else {
        content += '</span>';
      }

      return content;
    }
  },
  methods: {
    redirectToMissionDetails: function redirectToMissionDetails() {
      this.$router.push({ name: 'missionDetails', params: { missionSlug: this.mission.slug } });
    }
  }
};

/***/ }),
/* 181 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar/CalendarWeek.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarDay_vue__ = __webpack_require__(/*! ./CalendarDay.vue */ 358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarDay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CalendarDay_vue__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CalendarDay: __WEBPACK_IMPORTED_MODULE_0__CalendarDay_vue___default.a
  },
  props: ['week']
};

/***/ }),
/* 182 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityApplications.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsTable_vue__ = __webpack_require__(/*! ./CommunityApplicationsTable.vue */ 364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityApplicationsTable: __WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsTable_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getCommunityApplications', { communitySlug: this.$route.params.communitySlug });
  },
  computed: {
    communityApplicationsPageCount: function communityApplicationsPageCount() {
      return this.$store.getters.communityApplicationsPageCount;
    }
  },
  methods: {
    paginateCommunityApplications: function paginateCommunityApplications(page) {
      this.$store.dispatch('getCommunityApplications', { communitySlug: this.$route.params.communitySlug, page: page });
    },
    refreshCommunityApplications: function refreshCommunityApplications() {
      this.$store.dispatch('getCommunityApplications', { communitySlug: this.$route.params.communitySlug });
    }
  }
};

/***/ }),
/* 183 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityApplicationsRow.vue ***!
  \*****************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['communityApplication'],
  computed: {
    formattedCommunityApplicationStatus: function formattedCommunityApplicationStatus() {
      switch (this.communityApplication.status.toLowerCase()) {
        case 'accepted':
          return '<i class="fa fa-check fa-lg text-success" aria-hidden="true"></i>';
        case 'denied':
          return '<i class="fa fa-close fa-lg text-danger" aria-hidden="true"></i>';
        default:
          return '<i class="fa fa-question-circle fa-lg text-muted" aria-hidden="true"></i>';
      }
    },
    isCommunityApplicationProcessed: function isCommunityApplicationProcessed() {
      return this.communityApplication.status.toLowerCase() !== 'submitted';
    }
  },
  methods: {
    processCommunityApplication: function processCommunityApplication(accepted) {
      this.$store.dispatch('processCommunityApplication', {
        communitySlug: this.$route.params.communitySlug,
        applicationUid: this.communityApplication.uid,
        applicationUserNickname: this.communityApplication.user.nickname,
        accepted: accepted
      });
    }
  }
};

/***/ }),
/* 184 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityApplicationsTable.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsRow_vue__ = __webpack_require__(/*! ./CommunityApplicationsRow.vue */ 363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityApplicationsRow: __WEBPACK_IMPORTED_MODULE_0__CommunityApplicationsRow_vue___default.a
  },
  computed: {
    communityApplications: function communityApplications() {
      return this.$store.getters.communityApplications;
    }
  }
};

/***/ }),
/* 185 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityListRow.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['community'],
  computed: {
    optionalCommunityWebsite: function optionalCommunityWebsite() {
      return _.isString(this.community.website) && !_.isEmpty(this.community.website) ? '<a href="' + this.community.website + '">' + this.community.website + '</a>' : '<span class="text-muted font-italic">' + this.$t('misc.notProvided') + '</span>';
    }
  }
};

/***/ }),
/* 186 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityListTable.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityListRow_vue__ = __webpack_require__(/*! ./CommunityListRow.vue */ 365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityListRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityListRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityListRow: __WEBPACK_IMPORTED_MODULE_0__CommunityListRow_vue___default.a
  },
  computed: {
    communities: function communities() {
      return this.$store.getters.communities;
    }
  }
};

/***/ }),
/* 187 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityMembers.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMembersTable_vue__ = __webpack_require__(/*! ./CommunityMembersTable.vue */ 369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMembersTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityMembersTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityMembersTable: __WEBPACK_IMPORTED_MODULE_0__CommunityMembersTable_vue___default.a
  },
  computed: {
    communityApplicationStatus: function communityApplicationStatus() {
      return this.$store.getters.communityApplicationStatus;
    },
    isCommunityMember: function isCommunityMember() {
      var user = this.$store.getters.user;

      if (_.isNil(user)) {
        return false;
      } else if (_.isNil(user.community)) {
        return false;
      }

      return user.community.slug === this.$route.params.communitySlug;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    }
  },
  methods: {
    applyToCommunity: function applyToCommunity() {
      this.$store.dispatch('applyToCommunity', this.$route.params.communitySlug);
    },
    refreshCommunityMembers: function refreshCommunityMembers() {
      this.$store.dispatch('getCommunityDetails', this.$route.params.communitySlug);
    }
  }
};

/***/ }),
/* 188 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityMembersRow.vue ***!
  \************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['communityMember'],
  computed: {
    isShawalla: function isShawalla() {
      return this.communityMember.nickname.toLowerCase() === 'shawalla';
    },
    formattedCommunityLeader: function formattedCommunityLeader() {
      return this.communityMember.leader ? '<i class="fa fa-check fa-lg text-success" aria-hidden="true"></i>' : '';
    },
    canEditCommunityMembers: function canEditCommunityMembers() {
      return this.$acl.can(['community.' + this.$route.params.communitySlug + '.founder', 'community.' + this.$route.params.communitySlug + '.leader', 'community.' + this.$route.params.communitySlug + '.recruitment']);
    }
  },
  methods: {
    removeCommunityMember: function removeCommunityMember() {
      this.$store.dispatch('removeCommunityMember', { communitySlug: this.$route.params.communitySlug, memberUid: this.communityMember.uid, memberNickname: this.communityMember.nickname });
    }
  }
};

/***/ }),
/* 189 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityMembersTable.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMembersRow_vue__ = __webpack_require__(/*! ./CommunityMembersRow.vue */ 368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMembersRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityMembersRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityMembersRow: __WEBPACK_IMPORTED_MODULE_0__CommunityMembersRow_vue___default.a
  },
  computed: {
    communityMembers: function communityMembers() {
      return this.$store.getters.communityMembers;
    }
  }
};

/***/ }),
/* 190 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityMissions.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMissionsTable_vue__ = __webpack_require__(/*! ./CommunityMissionsTable.vue */ 372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMissionsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityMissionsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityMissionsTable: __WEBPACK_IMPORTED_MODULE_0__CommunityMissionsTable_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getCommunityMissions', { communitySlug: this.$route.params.communitySlug });
  },
  computed: {
    communityMissionsPageCount: function communityMissionsPageCount() {
      return this.$store.getters.communityMissionsPageCount;
    }
  },
  methods: {
    paginateCommunityMissions: function paginateCommunityMissions(page) {
      this.$store.dispatch('getCommunityMissions', { communitySlug: this.$route.params.communitySlug, page: page });
    }
  }
};

/***/ }),
/* 191 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityMissionsRow.vue ***!
  \*************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['communityMission']
};

/***/ }),
/* 192 */
/* exports provided: default */
/* all exports used */
/*!***************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityMissionsTable.vue ***!
  \***************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMissionsRow_vue__ = __webpack_require__(/*! ./CommunityMissionsRow.vue */ 371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityMissionsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityMissionsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityMissionsRow: __WEBPACK_IMPORTED_MODULE_0__CommunityMissionsRow_vue___default.a
  },
  computed: {
    communityMissions: function communityMissions() {
      return this.$store.getters.communityMissions;
    }
  }
};

/***/ }),
/* 193 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityPermissions.vue ***!
  \*************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsTable_vue__ = __webpack_require__(/*! ./CommunityPermissionsTable.vue */ 375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityPermissionsTable: __WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsTable_vue___default.a
  },
  props: ['communityPermissions'],
  computed: {
    communityPermissionsPageCount: function communityPermissionsPageCount() {
      return this.$store.getters.communityPermissionsPageCount;
    }
  },
  methods: {
    paginateCommunityPermissions: function paginateCommunityPermissions(page) {
      this.$store.dispatch('getCommunityPermissions', { communitySlug: this.$route.params.communitySlug, page: page });
    },
    refreshCommunityPermissions: function refreshCommunityPermissions() {
      this.$store.dispatch('getCommunityPermissions', { communitySlug: this.$route.params.communitySlug });
    }
  }
};

/***/ }),
/* 194 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityPermissionsRow.vue ***!
  \****************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['communityPermission'],
  computed: {
    formattedCommunityPermission: function formattedCommunityPermission() {
      var permission = this.communityPermission.permission.toLowerCase();
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](permission, 'founder')) {
        return this.$t('community.permission.founder');
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](permission, 'leader')) {
        return this.$t('community.permission.leader');
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](permission, 'recruitment')) {
        return this.$t('community.permission.recruitment');
      } else {
        return '<span class="text-italic font-muted">' + this.communityPermission.permission + '</span>';
      }
    },
    isCommunityFounderPermission: function isCommunityFounderPermission() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](this.communityPermission.permission.toLowerCase(), 'founder');
    }
  },
  methods: {
    deleteCommunityPermission: function deleteCommunityPermission() {
      this.$store.dispatch('deleteCommunityPermission', {
        communitySlug: this.$route.params.communitySlug,
        permissionUid: this.communityPermission.uid
      });
    }
  }
};

/***/ }),
/* 195 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/CommunityPermissionsTable.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsRow_vue__ = __webpack_require__(/*! ./CommunityPermissionsRow.vue */ 374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityPermissionsRow: __WEBPACK_IMPORTED_MODULE_0__CommunityPermissionsRow_vue___default.a
  },
  props: ['communityPermissions']
};

/***/ }),
/* 196 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/modals/CommunityEditModal.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      communityEditData: {
        name: null,
        tag: null,
        website: null,
        gameServers: null,
        voiceComms: null
      },
      communityEditGameServer: {
        hostname: null,
        port: null,
        name: null,
        password: null
      },
      communityEditVoiceComms: {
        hostname: null,
        port: null,
        name: null,
        password: null
      }
    };
  },

  computed: {
    communityDetails: function communityDetails() {
      return this.$store.getters.communityDetails;
    },
    communityEditGameServerHostnameFeedback: function communityEditGameServerHostnameFeedback() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.port) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    communityEditGameServerHostnameState: function communityEditGameServerHostnameState() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.port) ? 'danger' : 'success';
    },
    communityEditGameServerPortFeedback: function communityEditGameServerPortFeedback() {
      var port = parseInt(this.communityEditGameServer.port);
      if (port < 0 || port > 65535) {
        return this.$t('mission.feedback.serverInfo.portRange');
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.hostname) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    communityEditGameServerPortState: function communityEditGameServerPortState() {
      var port = parseInt(this.communityEditGameServer.port);
      if (port < 0 || port > 65535) {
        return 'danger';
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.hostname) ? 'danger' : 'success';
    },
    communityEditNameFeedback: function communityEditNameFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.name) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.name) ? this.$t('community.creator.feedback.name') : '';
    },
    communityEditNameState: function communityEditNameState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.name) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.name) ? 'danger' : 'success';
    },
    communityEditTagFeedback: function communityEditTagFeedback(proerty) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.tag) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.tag) ? this.$t('community.creator.feedback.tag') : '';
    },
    communityEditTagState: function communityEditTagState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.tag) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.tag) ? 'danger' : 'success';
    },
    communityEditVoiceCommsHostnameFeedback: function communityEditVoiceCommsHostnameFeedback() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.port) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    communityEditVoiceCommsHostnameState: function communityEditVoiceCommsHostnameState() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.port) ? 'danger' : 'success';
    },
    communityEditVoiceCommsPortFeedback: function communityEditVoiceCommsPortFeedback() {
      var port = parseInt(this.communityEditVoiceComms.port);
      if (port < 0 || port > 65535) {
        return this.$t('mission.feedback.serverInfo.portRange');
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.hostname) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    communityEditVoiceCommsPortState: function communityEditVoiceCommsPortState() {
      var port = parseInt(this.communityEditVoiceComms.port);
      if (port < 0 || port > 65535) {
        return 'danger';
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.hostname) ? 'danger' : 'success';
    },
    communityEditWebsiteFeedback: function communityEditWebsiteFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.website) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.website)) {
        return '';
      }

      return this.isCommunityEditWebsiteValidUrl ? '' : this.$t('community.creator.feedback.website');
    },
    communityEditWebsiteState: function communityEditWebsiteState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.website) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.website)) {
        return 'success';
      }

      return this.isCommunityEditWebsiteValidUrl ? 'success' : 'danger';
    },
    isCommunityEditWebsiteValidUrl: function isCommunityEditWebsiteValidUrl() {
      // Taken from: https://stackoverflow.com/a/5717133 @ 2017-08-04 09:43
      var urlPattern = /^((https?|ftp):\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
      return urlPattern.test(this.communityEditData.website);
    }
  },
  methods: {
    addCommunityGameServer: function addCommunityGameServer() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditGameServer.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.port)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.gameServers)) {
        this.communityEditData.gameServers = [];
      }

      this.communityEditData.gameServers.push({
        hostname: this.communityEditGameServer.hostname,
        port: this.communityEditGameServer.port,
        name: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.name) ? null : this.communityEditGameServer.name,
        password: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditGameServer.password) ? null : this.communityEditGameServer.password
      });

      this.communityEditGameServer = {
        hostname: null,
        port: null,
        name: null,
        password: null
      };
    },
    addCommunityVoiceComms: function addCommunityVoiceComms() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditVoiceComms.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.port)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityEditData.voiceComms)) {
        this.communityEditData.voiceComms = [];
      }

      this.communityEditData.voiceComms.push({
        hostname: this.communityEditVoiceComms.hostname,
        port: this.communityEditVoiceComms.port,
        name: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.name) ? null : this.communityEditVoiceComms.name,
        password: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditVoiceComms.password) ? null : this.communityEditVoiceComms.password
      });

      this.communityEditVoiceComms = {
        hostname: null,
        port: null,
        name: null,
        password: null
      };
    },
    editCommunity: function editCommunity() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.name) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.tag)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityEditData.website)) {
        this.communityEditData.website = null;
      }

      var updatedCommunityDetails = {};
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.communityEditData, function (value, key) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, _this.communityDetails[key])) {
          updatedCommunityDetails[key] = value;
        }
      });

      this.hideCommunityEditModal();

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](updatedCommunityDetails)) {
        return this.$store.dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'warning',
          alertMessage: '<i class="fa fa-warning" aria-hidden="true"></i> ' + this.$t('community.noChanges')
        });
      }

      this.$store.dispatch('editCommunity', {
        communitySlug: this.$route.params.communitySlug,
        updatedCommunityDetails: updatedCommunityDetails
      });
    },
    hideCommunityEditModal: function hideCommunityEditModal() {
      this.$refs.communityEditModal.hide();
    },
    removeCommunityGameServer: function removeCommunityGameServer(index) {
      this.communityEditData.gameServers.splice(index, 1);
    },
    removeCommunityVoiceComms: function removeCommunityVoiceComms(index) {
      this.communityEditData.voiceComms.splice(index, 1);
    },
    setCommunityEditData: function setCommunityEditData() {
      this.communityEditData = {
        name: this.communityDetails.name,
        tag: this.communityDetails.tag,
        website: this.communityDetails.website,
        gameServers: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityDetails.gameServers) ? [] : __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.communityDetails.gameServers),
        voiceComms: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityDetails.voiceComms) ? [] : __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.communityDetails.voiceComms)
      };
    }
  }
};

/***/ }),
/* 197 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/modals/CommunityLogoModal.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      communityLogoData: {
        file: null,
        url: null
      },
      communityLogoFileTypeRegex: /image\/(jpeg|png|gif)/,
      communityLogoMaxSize: 2097152 // Allow max. upload size of 2 MiB
    };
  },

  computed: {
    communityLogoFeedback: function communityLogoFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityLogoData.file)) {
        return '';
      }

      if (this.communityLogoData.file.size > this.communityLogoMaxSize) {
        return this.$t('community.logo.feedback.size');
      } else if (!this.communityLogoData.file.type.match(this.communityLogoFileTypeRegex)) {
        return this.$t('community.logo.feedback.fileType');
      }

      return '';
    },
    communityLogoState: function communityLogoState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityLogoData.file)) {
        return 'success';
      }

      if (this.communityLogoData.file.size > this.communityLogoMaxSize) {
        return 'danger';
      } else if (!this.communityLogoData.file.type.match(this.communityLogoFileTypeRegex)) {
        return 'danger';
      }

      return 'success';
    },
    communityDetails: function communityDetails() {
      return this.$store.getters.communityDetails;
    }
  },
  methods: {
    deleteCommunityLogo: function deleteCommunityLogo() {
      this.hideCommunityLogoModal();

      this.$store.dispatch('deleteCommunityLogo', {
        communitySlug: this.$route.params.communitySlug
      });
    },
    hideCommunityLogoModal: function hideCommunityLogoModal() {
      this.$refs.communityLogoModal.hide();
    },
    setCommunityLogoData: function setCommunityLogoData() {
      this.communityLogoData = {
        file: null,
        url: this.communityDetails.logoUrl
      };

      this.$refs.communityLogoSelection.reset();
    },
    uploadCommunityLogo: function uploadCommunityLogo() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityLogoData.file) || this.communityLogoData.file.size > this.communityLogoMaxSize || !this.communityLogoData.file.type.match(this.communityLogoFileTypeRegex)) {
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.hideCommunityLogoModal();

        _this.$store.dispatch('uploadCommunityLogo', {
          communitySlug: _this.$route.params.communitySlug,
          imageType: _this.communityLogoData.file.type,
          imageData: fileReader.result
        });
      });

      fileReader.readAsDataURL(this.communityLogoData.file);
    }
  }
};

/***/ }),
/* 198 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/communities/modals/CommunityPermissionModal.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommunityPermissions_vue__ = __webpack_require__(/*! ../CommunityPermissions.vue */ 373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommunityPermissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CommunityPermissions_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityPermissions: __WEBPACK_IMPORTED_MODULE_1__CommunityPermissions_vue___default.a
  },
  data: function data() {
    return {
      communityPermissionCreate: {
        userUid: null,
        permission: null
      }
    };
  },

  computed: {
    communityPermissionCreatePermissionOptions: function communityPermissionCreatePermissionOptions() {
      return [{ value: 'leader', text: this.$t('community.permission.leader') }, { value: 'recruitment', text: this.$t('community.permission.recruitment') }];
    },
    communityPermissionCreatePermissionState: function communityPermissionCreatePermissionState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityPermissionCreate.permission) ? 'danger' : 'success';
    },
    communityPermissionCreateUserState: function communityPermissionCreateUserState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityPermissionCreate.userUid) ? 'danger' : 'success';
    },
    communityPermissions: function communityPermissions() {
      return this.$store.getters.communityPermissions;
    }
  },
  methods: {
    createCommunityPermission: function createCommunityPermission() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityPermissionCreate.userUid) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityPermissionCreate.permission)) {
        return;
      }

      var permission = 'community.' + this.$route.params.communitySlug + '.' + this.communityPermissionCreate.permission;
      var permissionDetails = {
        userUid: this.communityPermissionCreate.userUid,
        permission: permission
      };

      this.communityPermissionCreate = {
        userUid: null,
        permission: null
      };

      this.$refs.communityPermissionCreateUserTypeahead.reset();

      this.$store.dispatch('createCommunityPermission', {
        communitySlug: this.$route.params.communitySlug,
        permissionDetails: permissionDetails
      });
    },
    hideCommunityPermissionModal: function hideCommunityPermissionModal() {
      this.$refs.communityPermissionModal.hide();
    },
    permissionUserSelected: function permissionUserSelected(item) {
      this.communityPermissionCreate.userUid = item.value.uid;
    },
    setCommunityPermissions: function setCommunityPermissions() {
      this.$store.dispatch('getCommunityPermissions', { communitySlug: this.$route.params.communitySlug });

      this.communityPermissionCreate = {
        userUid: null,
        permission: null
      };

      this.$refs.communityPermissionCreateUserTypeahead.reset();
    }
  }
};

/***/ }),
/* 199 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateListRow.vue ***!
  \****************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['missionSlotTemplate']
};

/***/ }),
/* 200 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateListTable.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionSlotTemplateListRow_vue__ = __webpack_require__(/*! ./MissionSlotTemplateListRow.vue */ 379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionSlotTemplateListRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MissionSlotTemplateListRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotTemplateListRow: __WEBPACK_IMPORTED_MODULE_0__MissionSlotTemplateListRow_vue___default.a
  },
  computed: {
    missionSlotTemplates: function missionSlotTemplates() {
      return this.$store.getters.missionSlotTemplates;
    }
  }
};

/***/ }),
/* 201 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlist.vue ***!
  \*****************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroup_vue__ = __webpack_require__(/*! ./MissionSlotTemplateSlotlistGroup.vue */ 382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroup_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotTemplateSlotlistGroup: __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroup_vue___default.a
  },
  computed: {
    isMissionSlotTemplateCreator: function isMissionSlotTemplateCreator() {
      if (!this.loggedIn || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateDetails)) {
        return false;
      }

      return this.missionSlotTemplateDetails.creator.uid === this.$store.getters.user.uid;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    },
    missionSlotTemplateUnsavedChanges: function missionSlotTemplateUnsavedChanges() {
      return this.$store.getters.missionSlotTemplateUnsavedChanges;
    }
  },
  methods: {
    saveMissionSlotTemplateSlotlist: function saveMissionSlotTemplateSlotlist() {
      var _this = this;

      var updatedMissionSlotTemplateDetails = {
        slotGroups: this.missionSlotTemplateDetails.slotGroups
      };

      this.$store.dispatch('editMissionSlotTemplate', {
        missionSlotTemplateUid: this.$route.params.missionSlotTemplateUid,
        missionSlotTemplateTitle: this.missionSlotTemplateDetails.title,
        updatedMissionSlotTemplateDetails: updatedMissionSlotTemplateDetails
      }).then(function () {
        _this.$store.dispatch('setMissionSlotTemplateUnsavedChanges', false);
      });
    }
  }
};

/***/ }),
/* 202 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroup.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsTable_vue__ = __webpack_require__(/*! ./MissionSlotTemplateSlotlistGroupSlotsTable.vue */ 384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotTemplateSlotlistGroupSlotsTable: __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsTable_vue___default.a
  },
  props: ['index', 'missionSlotGroup', 'missionSlotGroupCount'],
  computed: {
    isMissionSlotTemplateCreator: function isMissionSlotTemplateCreator() {
      if (!this.loggedIn || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateDetails)) {
        return false;
      }

      return this.missionSlotTemplateDetails.creator.uid === this.$store.getters.user.uid;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    }
  },
  methods: {
    deleteMissionSlotTemplateSlotGroup: function deleteMissionSlotTemplateSlotGroup() {
      this.$store.dispatch('removeMissionSlotTemplateSlotGroup', { index: this.index });
    },
    duplicateMissionSlotTemplateSlotGroup: function duplicateMissionSlotTemplateSlotGroup() {
      var slotGroupDetails = {
        title: this.missionSlotGroup.title,
        description: this.missionSlotGroup.description,
        slots: __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.missionSlotGroup.slots),
        insertAfter: this.missionSlotGroup.orderNumber
      };

      this.$store.dispatch('addMissionSlotTemplateSlotGroup', slotGroupDetails);
    },
    moveMissionSlotTemplateSlotGroup: function moveMissionSlotTemplateSlotGroup(direction) {
      this.$store.dispatch('moveMissionSlotTemplateSlotGroup', { index: this.index, direction: direction });
    },
    setMissionSlotTemplateSlotGroupDetails: function setMissionSlotTemplateSlotGroupDetails() {
      this.$store.dispatch('setMissionSlotTemplateSlotGroupDetails', this.missionSlotGroup);
    }
  }
};

/***/ }),
/* 203 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroupSlotsRow.vue ***!
  \******************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['index', 'hasAnyMissionSlotDescription', 'missionSlotCount', 'missionSlotDetails', 'missionSlotGroup'],
  computed: {
    difficultyColor: function difficultyColor() {
      switch (this.missionSlotDetails.difficulty) {
        case 0:
          return 'text-muted';
        case 1:
          return 'text-info';
        case 2:
          return 'text-primary';
        case 3:
          return 'text-warning';
        case 4:
          return 'text-danger';
        default:
          return '';
      }
    },
    difficultyIcon: function difficultyIcon() {
      return this.difficultyColor + ' fa fa-thermometer-' + this.missionSlotDetails.difficulty + ' fa-lg';
    },
    formattedTitle: function formattedTitle() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        return '<i class="' + this.difficultyIcon + '" aria-hidden="true"></i> ' + this.missionSlotDetails.title;
      }

      return '<i class="' + this.difficultyIcon + '" aria-hidden="true"></i> ' + this.missionSlotDetails.title + ' - [' + this.missionSlotDetails.restrictedCommunity.tag + ']';
    },
    isMissionSlotTemplateCreator: function isMissionSlotTemplateCreator() {
      if (!this.loggedIn || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateDetails)) {
        return false;
      }

      return this.missionSlotTemplateDetails.creator.uid === this.$store.getters.user.uid;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    },
    titleColor: function titleColor() {
      if (this.missionSlotDetails.blocked || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        return 'text-primary';
      } else if (this.missionSlotDetails.reserve) {
        return 'text-muted font-italic';
      }
    },
    titlePopoverContent: function titlePopoverContent() {
      if (this.missionSlotDetails.blocked) {
        return this.$t('mission.slot.blocked.popover');
      } else if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        return this.$t('mission.slot.restricted.popover', { communityInfo: '[' + this.missionSlotDetails.restrictedCommunity.tag + '] ' + this.missionSlotDetails.restrictedCommunity.name });
      } else if (this.missionSlotDetails.reserve) {
        return this.$t('mission.slot.reserve.popover');
      }
    }
  },
  methods: {
    deleteMissionSlotTemplateMissionSlot: function deleteMissionSlotTemplateMissionSlot() {
      this.$store.dispatch('removeMissionSlotTemplateSlot', { index: this.index, slotGroupOrderNumber: this.missionSlotGroup.orderNumber });
    },
    prepareMissionSlotTemplateSlotDetails: function prepareMissionSlotTemplateSlotDetails() {
      this.$store.dispatch('setMissionSlotTemplateSlotDetails', this.missionSlotDetails);
      this.$store.dispatch('setMissionSlotTemplateSlotGroupDetails', this.missionSlotGroup);
    }
  }
};

/***/ }),
/* 204 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroupSlotsTable.vue ***!
  \********************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsRow_vue__ = __webpack_require__(/*! ./MissionSlotTemplateSlotlistGroupSlotsRow.vue */ 383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotTemplateSlotlistGroupSlotsRow: __WEBPACK_IMPORTED_MODULE_1__MissionSlotTemplateSlotlistGroupSlotsRow_vue___default.a
  },
  props: ['missionSlotGroup'],
  computed: {
    hasAnyMissionSlotDescription: function hasAnyMissionSlotDescription() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](this.missionSlotGroup.slots, function (slot) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](slot.description);
      });
    },
    missionSlotRoleStyle: function missionSlotRoleStyle() {
      if (this.hasAnyMissionSlotDescription) {
        return 'width: 34%';
      } else {
        return 'width: 84%';
      }
    }
  }
};

/***/ }),
/* 205 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateDuplicateModal.vue ***!
  \******************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotTemplateDuplicateData: {
        title: null,
        visibility: 'hidden'
      }
    };
  },

  computed: {
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    },
    missionSlotTemplateDuplicateVisibilityOptions: function missionSlotTemplateDuplicateVisibilityOptions() {
      var options = [{
        text: this.$t('mission.slotTemplate.visibility.hidden'),
        value: 'hidden'
      }, {
        text: this.$t('mission.slotTemplate.visibility.public'),
        value: 'public'
      }];

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.user.community)) {
        options = [{
          text: this.$t('mission.slotTemplate.visibility.community'),
          value: 'community'
        }].concat(_toConsumableArray(options));
      }

      return options;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    clearMissionSlotTemplateData: function clearMissionSlotTemplateData() {
      this.missionSlotTemplateDuplicateData = {
        title: null,
        visibility: 'hidden'
      };
    },
    duplicateMissionSlotTemplate: function duplicateMissionSlotTemplate() {
      var missionSlotTemplateDuplicatePayload = {
        visibility: this.missionSlotTemplateDuplicateData.visibility,
        slotGroups: __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.missionSlotTemplateDetails.slotGroups)
      };

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateDuplicateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateDuplicateData.title)) {
        missionSlotTemplateDuplicatePayload.title = this.missionSlotTemplateDuplicateData.title;
      } else {
        missionSlotTemplateDuplicatePayload.title = this.missionSlotTemplateDetails.title;
      }

      this.hideMissionSlotTemplateDuplicateModal();

      this.$store.dispatch('createMissionSlotTemplate', missionSlotTemplateDuplicatePayload);
    },
    hideMissionSlotTemplateDuplicateModal: function hideMissionSlotTemplateDuplicateModal() {
      this.$refs.missionSlotTemplateDuplicateModal.hide();
    }
  }
};

/***/ }),
/* 206 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateEditModal.vue ***!
  \*************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotTemplateEditData: {
        title: null,
        visibility: null
      }
    };
  },

  computed: {
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    },
    missionSlotTemplateEditTitleFeedback: function missionSlotTemplateEditTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateEditData.title) ? '' : this.$t('mission.slotTemplate.feedback.title');
    },
    missionSlotTemplateEditTitleState: function missionSlotTemplateEditTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateEditData.title) ? 'success' : 'danger';
    },
    missionSlotTemplateEditVisibilityFeedback: function missionSlotTemplateEditVisibilityFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateEditData.visibility) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateEditData.visibility) ? this.$t('mission.slotTemplate.feedback.visibility') : '';
    },
    missionSlotTemplateEditVisibilityState: function missionSlotTemplateEditVisibilityState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateEditData.visibility) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateEditData.visibility) ? 'danger' : 'success';
    },
    missionSlotTemplateEditVisibilityOptions: function missionSlotTemplateEditVisibilityOptions() {
      var options = [{
        text: this.$t('mission.slotTemplate.visibility.hidden'),
        value: 'hidden'
      }, {
        text: this.$t('mission.slotTemplate.visibility.public'),
        value: 'public'
      }];

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.user.community)) {
        options = [{
          text: this.$t('mission.slotTemplate.visibility.community'),
          value: 'community'
        }].concat(_toConsumableArray(options));
      }

      return options;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    editMissionSlotTemplate: function editMissionSlotTemplate() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateEditData.title)) {
        return;
      }

      var updatedMissionSlotTemplateDetails = {};
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotTemplateEditData, function (value, key) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, _this.missionSlotTemplateDetails[key])) {
          updatedMissionSlotTemplateDetails[key] = value;
        }
      });

      this.hideMissionSlotTemplateEditModal();

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](updatedMissionSlotTemplateDetails))) {
        return;
      }

      this.$store.dispatch('editMissionSlotTemplate', {
        missionSlotTemplateUid: this.$route.params.missionSlotTemplateUid,
        updatedMissionSlotTemplateDetails: updatedMissionSlotTemplateDetails,
        missionSlotTemplateTitle: this.missionSlotTemplateDetails.title
      });
    },
    hideMissionSlotTemplateEditModal: function hideMissionSlotTemplateEditModal() {
      this.$refs.missionSlotTemplateEditModal.hide();
    },
    setMissionSlotTemplateEditData: function setMissionSlotTemplateEditData() {
      this.missionSlotTemplateEditData = {
        title: this.missionSlotTemplateDetails.title,
        visibility: this.missionSlotTemplateDetails.visibility
      };
    }
  }
};

/***/ }),
/* 207 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotCreateModal.vue ***!
  \*******************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotTemplateSlotCreateData: {
        detailedDescription: null,
        difficulty: 0,
        insertAfter: 0,
        reserve: false,
        blocked: false,
        description: null,
        title: null
      },
      missionSlotTemplateSlotCreateDetailedDescriptionEditorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'align': [] }, { 'indent': '-1' }, { 'indent': '+1' }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      }
    };
  },

  computed: {
    missionSlotTemplateSlotCreateDifficultyOptions: function missionSlotTemplateSlotCreateDifficultyOptions() {
      return [{
        text: this.$t('mission.slot.difficulty.beginner'),
        value: 0
      }, {
        text: this.$t('mission.slot.difficulty.easy'),
        value: 1
      }, {
        text: this.$t('mission.slot.difficulty.medium'),
        value: 2
      }, {
        text: this.$t('mission.slot.difficulty.advanced'),
        value: 3
      }, {
        text: this.$t('mission.slot.difficulty.expert'),
        value: 4
      }];
    },
    missionSlotTemplateSlotCreateInsertAfterOptions: function missionSlotTemplateSlotCreateInsertAfterOptions() {
      var options = [{
        value: 0,
        text: this.$t('mission.slotGroup.insertAfter.top')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotGroupDetails) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotGroupDetails.slots)) {
        return options;
      }

      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotTemplateSlotGroupDetails.slots, function (slot) {
        options.push({
          value: slot.orderNumber,
          text: '#' + slot.orderNumber + ' ' + slot.title
        });
      });

      return options;
    },
    missionSlotTemplateSlotCreateRestrictedCommunityState: function missionSlotTemplateSlotCreateRestrictedCommunityState() {
      return this.missionSlotTemplateSlotCreateData.restricted && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotCreateData.restrictedCommunityUid) ? 'danger' : 'success';
    },
    missionSlotTemplateSlotCreateTitleFeedback: function missionSlotTemplateSlotCreateTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotCreateData.title) ? '' : this.$t('mission.feedback.title.slot');
    },
    missionSlotTemplateSlotCreateTitleState: function missionSlotTemplateSlotCreateTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotCreateData.title) ? 'success' : 'danger';
    },
    missionSlotTemplateSlotGroupDetails: function missionSlotTemplateSlotGroupDetails() {
      return this.$store.getters.missionSlotTemplateSlotGroupDetails;
    },
    slotCreateTitle: function slotCreateTitle() {
      return this.$t('mission.modal.slot.create') + ' #' + this.missionSlotTemplateSlotGroupDetails.orderNumber + ' ' + this.missionSlotTemplateSlotGroupDetails.title;
    }
  },
  methods: {
    clearMissionSlotTemplateSlotCreateData: function clearMissionSlotTemplateSlotCreateData() {
      this.missionSlotTemplateSlotCreateData = {
        detailedDescription: null,
        difficulty: 0,
        insertAfter: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotGroupDetails) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotGroupDetails.slots) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupDetails.slots) ? 0 : __WEBPACK_IMPORTED_MODULE_0_lodash__["last"](this.missionSlotTemplateSlotGroupDetails.slots).orderNumber,
        reserve: false,
        blocked: false,
        description: null,
        title: null
      };
    },
    addMissionSlotTemplateSlot: function addMissionSlotTemplateSlot() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotCreateData.title)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotCreateData.detailedDescription) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotCreateData.detailedDescription)) {
        this.missionSlotTemplateSlotCreateData.detailedDescription = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotCreateData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotCreateData.description)) {
        this.missionSlotTemplateSlotCreateData.description = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotCreateData.restrictedCommunityUid) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotCreateData.restrictedCommunityUid)) {
        this.missionSlotTemplateSlotCreateData.restrictedCommunityUid = null;
      }

      this.hideMissionSlotTemplateSlotCreateModal();

      this.$store.dispatch('addMissionSlotTemplateSlot', this.missionSlotTemplateSlotCreateData);
    },
    hideMissionSlotTemplateSlotCreateModal: function hideMissionSlotTemplateSlotCreateModal() {
      this.$refs.missionSlotTemplateSlotCreateModal.hide();
    }
  }
};

/***/ }),
/* 208 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotDetailsModal.vue ***!
  \********************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    difficultyColor: function difficultyColor() {
      switch (this.missionSlotTemplateSlotDetails.difficulty) {
        case 0:
          return 'text-muted';
        case 1:
          return 'text-info';
        case 2:
          return 'text-primary';
        case 3:
          return 'text-warning';
        case 4:
          return 'text-danger';
        default:
          return '';
      }
    },
    difficultyIcon: function difficultyIcon() {
      return this.difficultyColor + ' fa fa-thermometer-' + this.missionSlotTemplateSlotDetails.difficulty + ' fa-lg';
    },
    difficultyText: function difficultyText() {
      switch (this.missionSlotTemplateSlotDetails.difficulty) {
        case 0:
          return this.$t('mission.slot.difficulty.beginner');
        case 1:
          return this.$t('mission.slot.difficulty.easy');
        case 2:
          return this.$t('mission.slot.difficulty.medium');
        case 3:
          return this.$t('mission.slot.difficulty.advanced');
        case 4:
          return this.$t('mission.slot.difficulty.expert');
        default:
          return '';
      }
    },
    isMissionSlotTemplateCreator: function isMissionSlotTemplateCreator() {
      if (!this.loggedIn || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateDetails)) {
        return false;
      }

      return this.missionSlotTemplateDetails.creator.uid === this.$store.getters.user.uid;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    },
    missionSlotTemplateSlotDetails: function missionSlotTemplateSlotDetails() {
      return this.$store.getters.missionSlotTemplateSlotDetails;
    },
    slotDetailsTitle: function slotDetailsTitle() {
      return this.$t('mission.modal.slot.details') + ' - #' + this.missionSlotTemplateSlotDetails.orderNumber + ' ' + this.missionSlotTemplateSlotDetails.title;
    },
    slotReserve: function slotReserve() {
      if (this.missionSlotTemplateSlotDetails.reserve) {
        return '<span class="text-muted font-italic">' + this.$t('mission.slot.reserve') + '</span>';
      }

      return '<span>' + this.$t('mission.slot.reserve.regular') + '</span>';
    },
    slotRestricted: function slotRestricted() {
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotDetails.restrictedCommunity)) {
        return '<span class="text-primary">' + this.$t('mission.slot.restricted', { communityInfo: '[' + this.missionSlotTemplateSlotDetails.restrictedCommunity.tag + '] ' + this.missionSlotTemplateSlotDetails.restrictedCommunity.name }) + '</span>';
      }

      return '<span>' + this.$t('mission.slot.restricted.unrestricted') + '</span>';
    },
    slotStatus: function slotStatus() {
      if (this.missionSlotTemplateSlotDetails.blocked) {
        return '<span class="text-primary">' + this.$t('mission.slot.blocked') + '</span>';
      }

      return this.slotRestricted + ' - ' + this.slotReserve;
    }
  },
  methods: {
    duplicateMissionSlotTemplateSlot: function duplicateMissionSlotTemplateSlot() {
      var slotDetails = {
        title: this.missionSlotTemplateSlotDetails.title,
        difficulty: this.missionSlotTemplateSlotDetails.difficulty,
        description: this.missionSlotTemplateSlotDetails.description,
        detailedDescription: this.missionSlotTemplateSlotDetails.detailedDescription,
        reserve: this.missionSlotTemplateSlotDetails.reserve,
        blocked: this.missionSlotTemplateSlotDetails.blocked,
        insertAfter: __WEBPACK_IMPORTED_MODULE_0_lodash__["max"]([this.missionSlotTemplateSlotDetails.orderNumber - 1, 0])
      };

      this.hideMissionSlotTemplateSlotDetailsModal();

      this.$store.dispatch('addMissionSlotTemplateSlot', slotDetails);
    },
    hideMissionSlotTemplateSlotDetailsModal: function hideMissionSlotTemplateSlotDetailsModal() {
      this.$refs.missionSlotTemplateSlotDetailsModal.hide();
    }
  }
};

/***/ }),
/* 209 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotEditModal.vue ***!
  \*****************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotTemplateSlotEditData: {
        detailedDescription: null,
        difficulty: 0,
        reserve: false,
        blocked: false,
        description: null,
        title: null
      },
      missionSlotTemplateSlotEditDetailedDescriptionEditorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'align': [] }, { 'indent': '-1' }, { 'indent': '+1' }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      },
      missionSlotTemplateSlotEditMoveAfter: 0
    };
  },

  computed: {
    missionSlotTemplateSlotDetails: function missionSlotTemplateSlotDetails() {
      return this.$store.getters.missionSlotTemplateSlotDetails;
    },
    missionSlotTemplateSlotEditDifficultyOptions: function missionSlotTemplateSlotEditDifficultyOptions() {
      return [{
        text: this.$t('mission.slot.difficulty.beginner'),
        value: 0
      }, {
        text: this.$t('mission.slot.difficulty.easy'),
        value: 1
      }, {
        text: this.$t('mission.slot.difficulty.medium'),
        value: 2
      }, {
        text: this.$t('mission.slot.difficulty.advanced'),
        value: 3
      }, {
        text: this.$t('mission.slot.difficulty.expert'),
        value: 4
      }];
    },
    missionSlotTemplateSlotEditMoveAfterOptions: function missionSlotTemplateSlotEditMoveAfterOptions() {
      var _this = this;

      var options = [{
        value: this.missionSlotTemplateSlotDetails.orderNumber - 1,
        text: this.$t('mission.slot.moveAfter.keep')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotGroupDetails) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotGroupDetails.slots)) {
        return options;
      }

      if (this.missionSlotTemplateSlotEditMoveAfter !== 0) {
        options.push({
          value: -1,
          text: this.$t('mission.slot.insertAfter.top')
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotTemplateSlotGroupDetails.slots, function (slot) {
        if (_this.missionSlotTemplateSlotDetails.orderNumber !== slot.orderNumber && _this.missionSlotTemplateSlotDetails.orderNumber - 1 !== slot.orderNumber) {
          options.push({
            value: slot.orderNumber,
            text: '#' + slot.orderNumber + ' ' + slot.title
          });
        }
      });

      return options;
    },
    missionSlotTemplateSlotEditTitleFeedback: function missionSlotTemplateSlotEditTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotEditData.title) ? '' : this.$t('mission.feedback.title.slot');
    },
    missionSlotTemplateSlotEditTitleState: function missionSlotTemplateSlotEditTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotEditData.title) ? 'success' : 'danger';
    },
    missionSlotTemplateSlotGroupDetails: function missionSlotTemplateSlotGroupDetails() {
      return this.$store.getters.missionSlotTemplateSlotGroupDetails;
    }
  },
  methods: {
    setMissionSlotTemplateSlotEditData: function setMissionSlotTemplateSlotEditData() {
      this.missionSlotTemplateSlotEditData = {
        detailedDescription: this.missionSlotTemplateSlotDetails.detailedDescription,
        difficulty: this.missionSlotTemplateSlotDetails.difficulty,
        orderNumber: this.missionSlotTemplateSlotDetails.orderNumber,
        reserve: this.missionSlotTemplateSlotDetails.reserve,
        blocked: this.missionSlotTemplateSlotDetails.blocked,
        description: this.missionSlotTemplateSlotDetails.description,
        title: this.missionSlotTemplateSlotDetails.title
      };

      this.missionSlotTemplateSlotEditMoveAfter = this.missionSlotTemplateSlotDetails.orderNumber - 1;
    },
    editMissionSlotTemplateSlot: function editMissionSlotTemplateSlot() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotEditData.title)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotEditData.detailedDescription) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotEditData.detailedDescription)) {
        this.missionSlotTemplateSlotEditData.detailedDescription = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotEditData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotEditData.description)) {
        this.missionSlotTemplateSlotEditData.description = null;
      }

      this.hideMissionSlotTemplateSlotEditModal();

      this.$store.dispatch('editMissionSlotTemplateSlot', {
        slotOrderNumber: this.missionSlotTemplateSlotDetails.orderNumber,
        slotPayload: this.missionSlotTemplateSlotEditData,
        moveAfter: this.missionSlotTemplateSlotEditMoveAfter !== this.missionSlotTemplateSlotDetails.orderNumber - 1 ? this.missionSlotTemplateSlotEditMoveAfter : -2
      });
    },
    hideMissionSlotTemplateSlotEditModal: function hideMissionSlotTemplateSlotEditModal() {
      this.$refs.missionSlotTemplateSlotEditModal.hide();
    }
  }
};

/***/ }),
/* 210 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupCreateModal.vue ***!
  \************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotTemplateSlotGroupCreateData: {
        description: null,
        title: null,
        insertAfter: 0
      }
    };
  },

  computed: {
    missionSlotGroups: function missionSlotGroups() {
      return this.missionSlotTemplateDetails.slotGroups;
    },
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    },
    missionSlotTemplateSlotGroupCreateInsertAfterOptions: function missionSlotTemplateSlotGroupCreateInsertAfterOptions() {
      var options = [{
        value: 0,
        text: this.$t('mission.slotGroup.insertAfter.top')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups)) {
        return options;
      }

      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotGroups, function (slotGroup) {
        options.push({
          value: slotGroup.orderNumber,
          text: '#' + slotGroup.orderNumber + ' ' + slotGroup.title
        });
      });

      return options;
    },
    missionSlotTemplateSlotGroupCreateTitleFeedback: function missionSlotTemplateSlotGroupCreateTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotGroupCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupCreateData.title) ? '' : this.$t('mission.feedback.title.slotGroup');
    },
    missionSlotTemplateSlotGroupCreateTitleState: function missionSlotTemplateSlotGroupCreateTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotGroupCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupCreateData.title) ? 'success' : 'danger';
    }
  },
  methods: {
    clearMissionSlotTemplateSlotGroupCreateData: function clearMissionSlotTemplateSlotGroupCreateData() {
      this.missionSlotTemplateSlotGroupCreateData = {
        description: null,
        title: null,
        insertAfter: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroups) ? 0 : __WEBPACK_IMPORTED_MODULE_0_lodash__["last"](this.missionSlotGroups).orderNumber
      };
    },
    addMissionSlotTemplateSlotGroup: function addMissionSlotTemplateSlotGroup() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupCreateData.title)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotGroupCreateData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupCreateData.description)) {
        this.missionSlotTemplateSlotGroupCreateData.description = null;
      }

      this.hideMissionSlotTemplateSlotGroupCreateModal();

      this.$store.dispatch("addMissionSlotTemplateSlotGroup", this.missionSlotTemplateSlotGroupCreateData);
    },
    hideMissionSlotTemplateSlotGroupCreateModal: function hideMissionSlotTemplateSlotGroupCreateModal() {
      this.$refs.missionSlotTemplateSlotGroupCreateModal.hide();
    }
  }
};

/***/ }),
/* 211 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupEditModal.vue ***!
  \**********************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotTemplateSlotGroupEditData: {
        description: null,
        title: null
      },
      missionSlotTemplateSlotGroupEditMoveAfter: 0
    };
  },

  computed: {
    missionSlotTemplateSlotGroupDetails: function missionSlotTemplateSlotGroupDetails() {
      return this.$store.getters.missionSlotTemplateSlotGroupDetails;
    },
    missionSlotTemplateSlotGroupEditMoveAfterOptions: function missionSlotTemplateSlotGroupEditMoveAfterOptions() {
      var _this = this;

      var options = [{
        value: this.missionSlotTemplateSlotGroupDetails.orderNumber - 1,
        text: this.$t('mission.slotGroup.moveAfter.keep')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateSlotGroups)) {
        return options;
      }

      if (this.missionSlotTemplateSlotGroupEditMoveAfter !== 0) {
        options.push({
          value: -1,
          text: this.$t('mission.slotGroup.insertAfter.top')
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotTemplateSlotGroups, function (slotGroup) {
        if (_this.missionSlotTemplateSlotGroupDetails.orderNumber !== slotGroup.orderNumber && _this.missionSlotTemplateSlotGroupDetails.orderNumber - 1 !== slotGroup.orderNumber) {
          options.push({
            value: slotGroup.orderNumber,
            text: '#' + slotGroup.orderNumber + ' ' + slotGroup.title
          });
        }
      });

      return options;
    },
    missionSlotTemplateSlotGroupEditTitleFeedback: function missionSlotTemplateSlotGroupEditTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotGroupEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupEditData.title) ? '' : this.$t('mission.feedback.title.slotGroup');
    },
    missionSlotTemplateSlotGroupEditTitleState: function missionSlotTemplateSlotGroupEditTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotGroupEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupEditData.title) ? 'success' : 'danger';
    },
    missionSlotTemplateSlotGroups: function missionSlotTemplateSlotGroups() {
      return this.$store.getters.missionSlotTemplateDetails.slotGroups;
    }
  },
  methods: {
    setMissionSlotTemplateSlotGroupEditData: function setMissionSlotTemplateSlotGroupEditData() {
      this.missionSlotTemplateSlotGroupEditData = {
        description: this.missionSlotTemplateSlotGroupDetails.description,
        title: this.missionSlotTemplateSlotGroupDetails.title
      };

      this.missionSlotTemplateSlotGroupEditMoveAfter = this.missionSlotTemplateSlotGroupDetails.orderNumber - 1;
    },
    editMissionSlotTemplateSlotGroup: function editMissionSlotTemplateSlotGroup() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupEditData.title)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotTemplateSlotGroupEditData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateSlotGroupEditData.description)) {
        this.missionSlotTemplateSlotGroupEditData.description = null;
      }

      this.hideMissionSlotTemplateSlotGroupEditModal();

      this.$store.dispatch('editMissionSlotTemplateSlotGroup', {
        slotGroupOrderNumber: this.missionSlotTemplateSlotGroupDetails.orderNumber,
        slotGroupPayload: this.missionSlotTemplateSlotGroupEditData,
        moveAfter: this.missionSlotTemplateSlotGroupEditMoveAfter !== this.missionSlotTemplateSlotGroupDetails.orderNumber - 1 ? this.missionSlotTemplateSlotGroupEditMoveAfter : -2
      });
    },
    hideMissionSlotTemplateSlotGroupEditModal: function hideMissionSlotTemplateSlotGroupEditModal() {
      this.$refs.missionSlotTemplateSlotGroupEditModal.hide();
    }
  }
};

/***/ }),
/* 212 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionAccesses.vue ***!
  \*****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionAccessesTable_vue__ = __webpack_require__(/*! ./MissionAccessesTable.vue */ 394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionAccessesTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MissionAccessesTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionAccessesTable: __WEBPACK_IMPORTED_MODULE_0__MissionAccessesTable_vue___default.a
  },
  props: ['missionAccesses'],
  computed: {
    missionAccessesPageCount: function missionAccessesPageCount() {
      return this.$store.getters.missionAccessesPageCount;
    }
  },
  methods: {
    paginateMissionAccesses: function paginateMissionAccesses(page) {
      this.$store.dispatch('getMissionAccesses', { missionSlug: this.$route.params.missionSlug, page: page });
    },
    refreshMissionAccesses: function refreshMissionAccesses() {
      this.$store.dispatch('getMissionAccesses', { missionSlug: this.$route.params.missionSlug });
    }
  }
};

/***/ }),
/* 213 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionAccessesRow.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['missionAccess'],
  computed: {
    routerLinkTarget: function routerLinkTarget() {
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccess.community)) {
        return { name: 'communityDetails', params: { communitySlug: this.missionAccess.community.slug } };
      } else {
        return { name: 'userDetails', params: { userUid: this.missionAccess.user.uid } };
      }
    }
  },
  methods: {
    deleteMissionAccess: function deleteMissionAccess() {
      this.$store.dispatch('deleteMissionAccess', {
        missionSlug: this.$route.params.missionSlug,
        missionAccessUid: this.missionAccess.uid
      });
    }
  }
};

/***/ }),
/* 214 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionAccessesTable.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionAccessesRow_vue__ = __webpack_require__(/*! ./MissionAccessesRow.vue */ 393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionAccessesRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MissionAccessesRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionAccessesRow: __WEBPACK_IMPORTED_MODULE_0__MissionAccessesRow_vue___default.a
  },
  props: ['missionAccesses']
};

/***/ }),
/* 215 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionListRow.vue ***!
  \****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['mission'],
  computed: {
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.mission.slug + '.creator', 'mission.' + this.mission.slug + '.editor'], false, false);
    },
    isUserInCommunity: function isUserInCommunity() {
      var user = this.$store.getters.user;
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user)) {
        return false;
      }

      return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user.community);
    },
    missionRequiredDLCs: function missionRequiredDLCs() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.mission.requiredDLCs)) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["map"](this.mission.requiredDLCs, function (requiredDLC) {
        return 'https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/' + requiredDLC.toLowerCase() + '.png';
      });
    }
  }
};

/***/ }),
/* 216 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionListTable.vue ***!
  \******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionListRow_vue__ = __webpack_require__(/*! ./MissionListRow.vue */ 395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionListRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MissionListRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionListRow: __WEBPACK_IMPORTED_MODULE_0__MissionListRow_vue___default.a
  },
  computed: {
    missions: function missions() {
      return this.$store.getters.missions;
    }
  }
};

/***/ }),
/* 217 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionPermissions.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionPermissionsTable_vue__ = __webpack_require__(/*! ./MissionPermissionsTable.vue */ 399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionPermissionsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MissionPermissionsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionPermissionsTable: __WEBPACK_IMPORTED_MODULE_0__MissionPermissionsTable_vue___default.a
  },
  props: ['missionPermissions'],
  computed: {
    missionPermissionsPageCount: function missionPermissionsPageCount() {
      return this.$store.getters.missionPermissionsPageCount;
    }
  },
  methods: {
    paginateMissionPermissions: function paginateMissionPermissions(page) {
      this.$store.dispatch('getMissionPermissions', { missionSlug: this.$route.params.missionSlug, page: page });
    },
    refreshMissionPermissions: function refreshMissionPermissions() {
      this.$store.dispatch('getMissionPermissions', { missionSlug: this.$route.params.missionSlug });
    }
  }
};

/***/ }),
/* 218 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionPermissionsRow.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['missionPermission'],
  computed: {
    formattedMissionPermission: function formattedMissionPermission() {
      var permission = this.missionPermission.permission.toLowerCase();
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](permission, 'creator')) {
        return this.$t('mission.permission.creator');
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](permission, 'editor')) {
        return this.$t('mission.permission.editor');
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](permission, 'slotlist.community')) {
        return this.$t('mission.permission.slotlist.community');
      } else {
        return '<span class="text-italic font-muted">' + this.missionPermission.permission + '</span>';
      }
    },
    isMissionCreatorPermission: function isMissionCreatorPermission() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["endsWith"](this.missionPermission.permission.toLowerCase(), 'creator');
    }
  },
  methods: {
    deleteMissionPermission: function deleteMissionPermission() {
      this.$store.dispatch('deleteMissionPermission', {
        missionSlug: this.$route.params.missionSlug,
        permissionUid: this.missionPermission.uid
      });
    }
  }
};

/***/ }),
/* 219 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionPermissionsTable.vue ***!
  \*************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionPermissionsRow_vue__ = __webpack_require__(/*! ./MissionPermissionsRow.vue */ 398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionPermissionsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MissionPermissionsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionPermissionsRow: __WEBPACK_IMPORTED_MODULE_0__MissionPermissionsRow_vue___default.a
  },
  props: ['missionPermissions']
};

/***/ }),
/* 220 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionSlotRegistrations.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionSlotRegistrationsTable_vue__ = __webpack_require__(/*! ./MissionSlotRegistrationsTable.vue */ 402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MissionSlotRegistrationsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MissionSlotRegistrationsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotRegistrationsTable: __WEBPACK_IMPORTED_MODULE_0__MissionSlotRegistrationsTable_vue___default.a
  },
  props: ['missionSlotDetails'],
  data: function data() {
    return {
      missionSlotRegistrationSuppressNotifications: false
    };
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('setMissionSlotRegistrationSuppressNotifications', { suppressNotifications: false });
  },
  computed: {
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    }
  },
  methods: {
    refreshMissionSlotRegistrations: function refreshMissionSlotRegistrations() {
      this.$store.dispatch('getMissionSlotRegistrations', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });
    }
  },
  watch: {
    missionSlotRegistrationSuppressNotifications: function missionSlotRegistrationSuppressNotifications(val) {
      this.$store.dispatch('setMissionSlotRegistrationSuppressNotifications', { suppressNotifications: val });
    }
  }
};

/***/ }),
/* 221 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionSlotRegistrationsRow.vue ***!
  \*****************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['registration'],
  computed: {
    formattedComment: function formattedComment() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.registration.comment) ? '<span class="text-muted font-italic">' + this.$t('misc.notProvided') + '</span>' : this.registration.comment;
    },
    formattedConfirmation: function formattedConfirmation() {
      return this.registration.confirmed ? '<i class="fa fa-check fa-lg text-success" aria-hidden="true"></i>' : '<i class="fa fa-close fa-lg text-danger" aria-hidden="true"></i>';
    },
    hasMissionEnded: function hasMissionEnded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime));
    },
    hasMissionSlotlistCommunityPermission: function hasMissionSlotlistCommunityPermission() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.slotlist.community']);
    },
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    }
  },
  methods: {
    deleteMissionSlotRegistration: function deleteMissionSlotRegistration() {
      this.$store.dispatch('deleteMissionSlotRegistration', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.registration.slotUid,
        registrationUid: this.registration.uid,
        slotOrderNumber: this.$store.getters.missionSlotDetails.orderNumber,
        slotTitle: this.$store.getters.missionSlotDetails.title
      });
    },
    modifyMissionSlotRegistration: function modifyMissionSlotRegistration(confirm) {
      this.$store.dispatch('modifyMissionSlotRegistration', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.registration.slotUid,
        registrationUid: this.registration.uid,
        confirm: confirm
      });
    }
  }
};

/***/ }),
/* 222 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionSlotRegistrationsTable.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrationsRow_vue__ = __webpack_require__(/*! ./MissionSlotRegistrationsRow.vue */ 401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrationsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrationsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotRegistrationsRow: __WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrationsRow_vue___default.a
  },
  computed: {
    hasAnyMissionSlotRegistrationDetails: function hasAnyMissionSlotRegistrationDetails() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotRegistrations)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](this.missionSlotRegistrations, function (r) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](r.uid);
      });
    },
    hasMissionEnded: function hasMissionEnded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime));
    },
    hasMissionSlotlistCommunityPermission: function hasMissionSlotlistCommunityPermission() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.slotlist.community']);
    },
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionSlotRegistrations: function missionSlotRegistrations() {
      return this.$store.getters.missionSlotRegistrations;
    },
    playerColumnWidth: function playerColumnWidth() {
      return this.isMissionEditor ? 'width: 31%' : 'width: 61%';
    }
  }
};

/***/ }),
/* 223 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionSlotlist.vue ***!
  \*****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroup_vue__ = __webpack_require__(/*! ./MissionSlotlistGroup.vue */ 404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroup_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotlistGroup: __WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroup_vue___default.a
  },
  computed: {
    anyMissionSlotSelected: function anyMissionSlotSelected() {
      return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.$store.getters.missionSlotSelection);
    },
    hasMissionAnyRequiredDLCs: function hasMissionAnyRequiredDLCs() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDetails.requiredDLCs)) {
        return true;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](this.missionSlotGroups, function (slotGroup) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](slotGroup.slots, function (slot) {
          return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](slot.requiredDLCs);
        });
      });
    },
    hasMissionEnded: function hasMissionEnded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime));
    },
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionSlotGroups: function missionSlotGroups() {
      return this.$store.getters.missionSlotGroups;
    },
    missionSlotSelectionCount: function missionSlotSelectionCount() {
      return this.$store.getters.missionSlotSelection.length;
    }
  },
  methods: {
    clearMissionSlotSelection: function clearMissionSlotSelection() {
      this.$store.dispatch('clearMissionSlotSelection');
    },
    deleteSelectedMissionSlots: function deleteSelectedMissionSlots() {
      this.$store.dispatch('deleteSelectedMissionSlots', { missionSlug: this.$route.params.missionSlug });
    },
    getMissionSlotTemplates: function getMissionSlotTemplates() {
      this.$store.dispatch('getMissionSlotTemplates', { limit: 100 });
    },
    refreshMissionSlotlist: function refreshMissionSlotlist() {
      this.$store.dispatch('getMissionSlotlist', { missionSlug: this.$route.params.missionSlug });
    },
    unassignSelectedMissionSlots: function unassignSelectedMissionSlots() {
      this.$store.dispatch('unassignSelectedMissionSlots', { missionSlug: this.$route.params.missionSlug });
    }
  }
};

/***/ }),
/* 224 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionSlotlistGroup.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroupSlotsTable_vue__ = __webpack_require__(/*! ./MissionSlotlistGroupSlotsTable.vue */ 406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroupSlotsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroupSlotsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotlistGroupSlotsTable: __WEBPACK_IMPORTED_MODULE_2__MissionSlotlistGroupSlotsTable_vue___default.a
  },
  props: ['missionSlotGroup'],
  computed: {
    hasMissionEnded: function hasMissionEnded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime));
    },
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    }
  },
  methods: {
    duplicateMissionSlotGroup: function duplicateMissionSlotGroup() {
      this.$store.dispatch("duplicateMissionSlotGroup", { missionSlug: this.$route.params.missionSlug, missionSlotGroup: this.missionSlotGroup });
    },
    deleteMissionSlotGroup: function deleteMissionSlotGroup() {
      this.$store.dispatch('deleteMissionSlotGroup', {
        missionSlug: this.$route.params.missionSlug,
        slotGroupUid: this.missionSlotGroup.uid,
        slotGroupTitle: this.missionSlotGroup.title
      });
    },
    setMissionSlotGroupDetails: function setMissionSlotGroupDetails() {
      this.$store.dispatch('setMissionSlotGroupDetails', this.missionSlotGroup);
    }
  }
};

/***/ }),
/* 225 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionSlotlistGroupSlotsRow.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['hasAnyMissionSlotDescription', 'missionSlotDetails', 'missionSlotGroup'],
  computed: {
    anyMissionSlotSelected: function anyMissionSlotSelected() {
      return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.$store.getters.missionSlotSelection);
    },
    canRegisterForSlot: function canRegisterForSlot() {
      var user = this.$store.getters.user;
      var userCommunityUid = null;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user.community)) {
        userCommunityUid = user.community.uid;
      }

      var restrictedCommunityUid = null;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        restrictedCommunityUid = this.missionSlotDetails.restrictedCommunity.uid;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.assignee) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.externalAssignee) && (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](restrictedCommunityUid) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](userCommunityUid, restrictedCommunityUid));
    },
    difficultyColor: function difficultyColor() {
      switch (this.missionSlotDetails.difficulty) {
        case 0:
          return 'text-muted';
        case 1:
          return 'text-info';
        case 2:
          return 'text-primary';
        case 3:
          return 'text-warning';
        case 4:
          return 'text-danger';
        default:
          return '';
      }
    },
    difficultyIcon: function difficultyIcon() {
      return this.difficultyColor + ' fa fa-thermometer-' + this.missionSlotDetails.difficulty + ' fa-lg';
    },
    formattedTitle: function formattedTitle() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        return '<i class="' + this.difficultyIcon + '" aria-hidden="true"></i> ' + this.missionSlotDetails.title;
      }

      return '<i class="' + this.difficultyIcon + '" aria-hidden="true"></i> ' + this.missionSlotDetails.title + ' - [' + this.missionSlotDetails.restrictedCommunity.tag + ']';
    },
    hasMissionEnded: function hasMissionEnded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime));
    },
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionSlotRequiredDLCs: function missionSlotRequiredDLCs() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails)) {
        return [];
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotDetails.requiredDLCs)) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["map"](this.missionSlotDetails.requiredDLCs, function (requiredDLC) {
        return 'https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/' + requiredDLC.toLowerCase() + '.png';
      });
    },
    missionSlotSelected: function missionSlotSelected() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"](this.missionSlotSelection, this.missionSlotDetails.uid) >= 0;
    },
    missionSlotSelection: function missionSlotSelection() {
      return this.$store.getters.missionSlotSelection;
    },
    titleColor: function titleColor() {
      if (this.missionSlotDetails.blocked || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        return 'text-primary';
      } else if (this.missionSlotDetails.reserve) {
        return 'text-muted font-italic';
      }
    },
    titlePopoverContent: function titlePopoverContent() {
      if (this.missionSlotDetails.blocked) {
        return this.$t('mission.slot.blocked.popover');
      } else if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        return this.$t('mission.slot.restricted.popover', { communityInfo: '[' + this.missionSlotDetails.restrictedCommunity.tag + '] ' + this.missionSlotDetails.restrictedCommunity.name });
      } else if (this.missionSlotDetails.reserve) {
        return this.$t('mission.slot.reserve.popover');
      }
    }
  },
  methods: {
    deleteMissionSlot: function deleteMissionSlot() {
      this.$store.dispatch('deleteMissionSlot', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });
    },
    deleteMissionSlotRegistration: function deleteMissionSlotRegistration() {
      this.$store.dispatch('unregisterFromMissionSlot', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        registrationUid: this.missionSlotDetails.registrationUid,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });
    },
    prepareMissionSlotDetails: function prepareMissionSlotDetails() {
      this.$store.dispatch('getMissionSlotRegistrations', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });

      this.setMissionSlotDetails();
      this.setMissionSlotGroupDetails();
    },
    setMissionSlotDetails: function setMissionSlotDetails() {
      this.$store.dispatch('setMissionSlotDetails', this.missionSlotDetails);
    },
    setMissionSlotGroupDetails: function setMissionSlotGroupDetails() {
      this.$store.dispatch('setMissionSlotGroupDetails', this.missionSlotGroup);
    },
    toggleMissionSlotSelection: function toggleMissionSlotSelection() {
      if (!this.loggedIn || !this.isMissionEditor || this.hasMissionEnded) {
        return;
      }

      this.$store.dispatch('toggleMissionSlotSelection', { missionSlotUid: this.missionSlotDetails.uid });
    }
  }
};

/***/ }),
/* 226 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/MissionSlotlistGroupSlotsTable.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotlistGroupSlotsRow_vue__ = __webpack_require__(/*! ./MissionSlotlistGroupSlotsRow.vue */ 405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionSlotlistGroupSlotsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MissionSlotlistGroupSlotsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotlistGroupSlotsRow: __WEBPACK_IMPORTED_MODULE_1__MissionSlotlistGroupSlotsRow_vue___default.a
  },
  props: ['missionSlotGroup'],
  computed: {
    anyMissionSlotSelected: function anyMissionSlotSelected() {
      return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.$store.getters.missionSlotSelection);
    },
    hasAnyMissionSlotDescription: function hasAnyMissionSlotDescription() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](this.missionSlotGroup.slots, function (slot) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](slot.description);
      });
    },
    missionSlotPlayerStyle: function missionSlotPlayerStyle() {
      if (this.hasAnyMissionSlotDescription) {
        return 'width: 27%';
      } else {
        return 'width: 44%';
      }
    },
    missionSlotRoleStyle: function missionSlotRoleStyle() {
      if (this.hasAnyMissionSlotDescription) {
        return 'width: 27%';
      } else {
        return 'width: 40%';
      }
    }
  }
};

/***/ }),
/* 227 */
/* exports provided: default */
/* all exports used */
/*!***************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionAccessModal.vue ***!
  \***************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionAccesses_vue__ = __webpack_require__(/*! ../MissionAccesses.vue */ 392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionAccesses_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MissionAccesses_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionAccesses: __WEBPACK_IMPORTED_MODULE_1__MissionAccesses_vue___default.a
  },
  data: function data() {
    return {
      missionAccessAdd: {
        communityUid: null,
        userUid: null
      }
    };
  },

  computed: {
    missionAccessAddCommunityState: function missionAccessAddCommunityState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.communityUid) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.userUid) || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.communityUid) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.userUid)) {
        return 'danger';
      }

      return 'success';
    },
    missionAccessAddUserState: function missionAccessAddUserState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.communityUid) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.userUid) || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.communityUid) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.userUid)) {
        return 'danger';
      }

      return 'success';
    },
    missionAccesses: function missionAccesses() {
      return this.$store.getters.missionAccesses;
    }
  },
  methods: {
    addMissionAccess: function addMissionAccess() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.communityUid) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.userUid)) {
        return;
      }

      var missionAccessDetails = {
        communityUid: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.communityUid) ? undefined : this.missionAccessAdd.communityUid,
        userUid: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.userUid) ? undefined : this.missionAccessAdd.userUid
      };

      this.$refs.missionAccessAddCommunityTypeahead.reset();
      this.$refs.missionAccessAddUserTypeahead.reset();

      this.$store.dispatch('addMissionAccess', {
        missionSlug: this.$route.params.missionSlug,
        missionAccessDetails: missionAccessDetails
      });
    },
    hideMissionAccessModal: function hideMissionAccessModal() {
      this.$refs.missionAccessModal.hide();
    },
    permissionCommunitySelected: function permissionCommunitySelected(item) {
      this.missionAccessAdd.communityUid = item.value.uid;

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.userUid)) {
        this.missionAccessAdd.userUid = null;
        this.$refs.missionAccessAddUserTypeahead.reset();
      }
    },
    permissionUserSelected: function permissionUserSelected(item) {
      this.missionAccessAdd.userUid = item.value.uid;

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionAccessAdd.communityUid)) {
        this.missionAccessAdd.communityUid = null;
        this.$refs.missionAccessAddCommunityTypeahead.reset();
      }
    },
    setMissionAccesses: function setMissionAccesses() {
      this.$store.dispatch('getMissionAccesses', { missionSlug: this.$route.params.missionSlug });

      this.missionAccessAdd = {
        communityUid: null,
        userUid: null
      };

      this.$refs.missionAccessAddCommunityTypeahead.reset();
      this.$refs.missionAccessAddUserTypeahead.reset();
    }
  }
};

/***/ }),
/* 228 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionApplySlotTemplateModal.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotTemplateFilter: null,
      missionSlotTemplateInsertAfter: 0
    };
  },

  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getMissionSlotTemplates', { limit: 100 });
  },
  computed: {
    filteredMissionSlotTemplates: function filteredMissionSlotTemplates() {
      var _this = this;

      var missionSlotTemplates = this.missionSlotTemplates;
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateFilter) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotTemplateFilter)) {
        return missionSlotTemplates;
      }

      var filteredMissionSlotTemplates = __WEBPACK_IMPORTED_MODULE_0_lodash__["filter"](missionSlotTemplates, function (slotTemplate) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash__["includes"](__WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"](slotTemplate.title), __WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"](_this.missionSlotTemplateFilter)) || __WEBPACK_IMPORTED_MODULE_0_lodash__["includes"](__WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"](slotTemplate.creator.nickname), __WEBPACK_IMPORTED_MODULE_0_lodash__["toLower"](_this.missionSlotTemplateFilter));
      });

      return filteredMissionSlotTemplates;
    },
    missionSlotTemplateInsertAfterOptions: function missionSlotTemplateInsertAfterOptions() {
      var options = [{
        value: 0,
        text: this.$t('mission.slotGroup.insertAfter.top')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups)) {
        return options;
      }

      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotGroups, function (slotGroup) {
        options.push({
          value: slotGroup.orderNumber,
          text: '#' + slotGroup.orderNumber + ' ' + slotGroup.title
        });
      });

      return options;
    },
    missionSlotGroups: function missionSlotGroups() {
      return this.$store.getters.missionSlotGroups;
    },
    missionSlotTemplates: function missionSlotTemplates() {
      return this.$store.getters.missionSlotTemplates;
    }
  },
  methods: {
    applySlotTemplateToMission: function applySlotTemplateToMission(slotTemplateUid) {
      this.hideMissionConvertToSlotTemplateModal();

      this.$store.dispatch('applySlotTemplateToMission', { missionSlug: this.$route.params.missionSlug, slotTemplateUid: slotTemplateUid, insertAfter: this.missionSlotTemplateInsertAfter });
    },
    hideMissionConvertToSlotTemplateModal: function hideMissionConvertToSlotTemplateModal() {
      this.$refs.missionApplySlotTemplateModal.hide();
    },
    setMissionApplySlotTemplateData: function setMissionApplySlotTemplateData() {
      this.missionSlotTemplateFilter = null;
      this.missionSlotTemplateInsertAfter = __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroups) ? 0 : __WEBPACK_IMPORTED_MODULE_0_lodash__["last"](this.missionSlotGroups).orderNumber;
    }
  }
};

/***/ }),
/* 229 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionBannerImageModal.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionBannerImageData: {
        file: null,
        url: null
      },
      missionBannerImageFileTypeRegex: /image\/(jpeg|png|gif)/,
      missionBannerImageMaxSize: 2097152 // Allow max. upload size of 2 MiB
    };
  },

  computed: {
    missionBannerImageFeedback: function missionBannerImageFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionBannerImageData.file)) {
        return '';
      }

      if (this.missionBannerImageData.file.size > this.missionBannerImageMaxSize) {
        return this.$t('mission.bannerImage.feedback.size');
      } else if (!this.missionBannerImageData.file.type.match(this.missionBannerImageFileTypeRegex)) {
        return this.$t('mission.bannerImage.feedback.fileType');
      }

      return '';
    },
    missionBannerImageState: function missionBannerImageState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionBannerImageData.file)) {
        return 'success';
      }

      if (this.missionBannerImageData.file.size > this.missionBannerImageMaxSize) {
        return 'danger';
      } else if (!this.missionBannerImageData.file.type.match(this.missionBannerImageFileTypeRegex)) {
        return 'danger';
      }

      return 'success';
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    }
  },
  methods: {
    deleteMissionBannerImage: function deleteMissionBannerImage() {
      this.hideMissionBannerImageModal();

      this.$store.dispatch('deleteMissionBannerImage', {
        missionSlug: this.$route.params.missionSlug
      });
    },
    hideMissionBannerImageModal: function hideMissionBannerImageModal() {
      this.$refs.missionBannerImageModal.hide();
    },
    setMissionBannerImageData: function setMissionBannerImageData() {
      this.missionBannerImageData = {
        file: null,
        url: this.missionDetails.bannerImageUrl
      };

      this.$refs.missionBannerImageSelection.reset();
    },
    uploadMissionBannerImage: function uploadMissionBannerImage() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionBannerImageData.file) || this.missionBannerImageData.file.size > this.missionBannerImageMaxSize || !this.missionBannerImageData.file.type.match(this.missionBannerImageFileTypeRegex)) {
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.hideMissionBannerImageModal();

        _this.$store.dispatch('uploadMissionBannerImage', {
          missionSlug: _this.$route.params.missionSlug,
          imageType: _this.missionBannerImageData.file.type,
          imageData: fileReader.result
        });
      });

      fileReader.readAsDataURL(this.missionBannerImageData.file);
    }
  }
};

/***/ }),
/* 230 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionConvertToSlotTemplateModal.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionConvertToSlotTemplateData: {
        title: null,
        visibility: 'hidden'
      }
    };
  },

  computed: {
    missionConvertToSlotTemplateTitleFeedback: function missionConvertToSlotTemplateTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionConvertToSlotTemplateData.title) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionConvertToSlotTemplateData.title) ? this.$t('mission.slotTemplate.feedback.title') : '';
    },
    missionConvertToSlotTemplateTitleState: function missionConvertToSlotTemplateTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionConvertToSlotTemplateData.title) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionConvertToSlotTemplateData.title) ? 'danger' : 'success';
    },
    missionConvertToSlotTemplateVisibilityOptions: function missionConvertToSlotTemplateVisibilityOptions() {
      var options = [{
        text: this.$t('mission.slotTemplate.visibility.hidden'),
        value: 'hidden'
      }, {
        text: this.$t('mission.slotTemplate.visibility.public'),
        value: 'public'
      }];

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.user.community)) {
        options = [{
          text: this.$t('mission.slotTemplate.visibility.community'),
          value: 'community'
        }].concat(_toConsumableArray(options));
      }

      return options;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    clearMissionConvertToSlotTemplateData: function clearMissionConvertToSlotTemplateData() {
      this.missionConvertToSlotTemplateData = {
        title: null,
        visibility: 'hidden'
      };
    },
    convertMissionToSlotTemplate: function convertMissionToSlotTemplate() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionConvertToSlotTemplateData.title)) {
        return;
      }

      var slotGroups = __WEBPACK_IMPORTED_MODULE_0_lodash__["map"](this.$store.getters.unfilteredMissionSlotGroups, function (slotGroup) {
        return {
          orderNumber: slotGroup.orderNumber,
          title: slotGroup.title,
          slots: __WEBPACK_IMPORTED_MODULE_0_lodash__["map"](slotGroup.slots, function (slot) {
            return {
              orderNumber: slot.orderNumber,
              title: slot.title,
              description: slot.description,
              detailedDescription: slot.detailedDescription,
              difficulty: slot.difficulty,
              reserve: slot.reserve,
              blocked: slot.blocked
            };
          })
        };
      });

      var payload = {
        title: this.missionConvertToSlotTemplateData.title,
        visibility: this.missionConvertToSlotTemplateData.visibility,
        slotGroups: slotGroups
      };

      this.hideMissionConvertToSlotTemplateModal();

      this.$store.dispatch('createMissionSlotTemplate', payload);
    },
    hideMissionConvertToSlotTemplateModal: function hideMissionConvertToSlotTemplateModal() {
      this.$refs.missionConvertToSlotTemplateModal.hide();
    }
  }
};

/***/ }),
/* 231 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionDuplicateModal.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionDuplicateData: {
        addToCommunity: true,
        briefingTime: null,
        endTime: null,
        slottingTime: null,
        slug: null,
        startTime: null,
        title: null,
        visibility: 'hidden'
      }
    };
  },

  computed: {
    checkingMissionSlugAvailability: function checkingMissionSlugAvailability() {
      return this.$store.getters.checkingMissionSlugAvailability;
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionDuplicateAddToCommunityDescription: function missionDuplicateAddToCommunityDescription() {
      return this.$t('mission.creator.addToCommunity.description', { communityInfo: '[' + this.user.community.tag + '] ' + this.user.community.name });
    },
    missionDuplicateBriefingTimeFeedback: function missionDuplicateBriefingTimeFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.briefingTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.briefingTime)) {
        return '';
      }

      var briefingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.briefingTime);
      if (!briefingTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      return '';
    },
    missionDuplicateBriefingTimeState: function missionDuplicateBriefingTimeState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.briefingTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.briefingTime)) {
        return 'success';
      }

      var briefingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.briefingTime);
      if (!briefingTime.isValid()) {
        return 'danger';
      }

      return 'success';
    },
    missionDuplicateEndTimeFeedback: function missionDuplicateEndTimeFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.endTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.endTime)) {
        return '';
      }

      var endTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.endTime);
      if (!endTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.startTime);
      if (!startTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      if (endTime < startTime) {
        return this.$t('mission.feedback.dateTime.afterStart');
      }

      return '';
    },
    missionDuplicateEndTimeState: function missionDuplicateEndTimeState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.endTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.endTime)) {
        return 'success';
      }

      var endTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.endTime);
      if (!endTime.isValid()) {
        return 'danger';
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.startTime);
      if (!startTime.isValid()) {
        return 'danger';
      }

      if (endTime < startTime) {
        return 'danger';
      }

      return 'success';
    },
    missionDuplicateSlottingTimeFeedback: function missionDuplicateSlottingTimeFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.slottingTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.slottingTime)) {
        return '';
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.slottingTime);
      if (!slottingTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      return '';
    },
    missionDuplicateSlottingTimeState: function missionDuplicateSlottingTimeState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.slottingTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.slottingTime)) {
        return 'success';
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.slottingTime);
      if (!slottingTime.isValid()) {
        return 'danger';
      }

      return 'success';
    },
    missionDuplicateSlugAvailable: function missionDuplicateSlugAvailable() {
      if (this.checkingMissionSlugAvailability) {
        return '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
      } else if (this.missionSlugAvailable) {
        return '<i class="fa fa-check" aria-hidden="true"></i>';
      }

      return '<i class="fa fa-close" aria-hidden="true"></i>';
    },
    missionDuplicateSlugFeedback: function missionDuplicateSlugFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.slug) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.slug)) {
        return this.$t('mission.feedback.slug');
      } else if (this.checkingMissionSlugAvailability) {
        return this.$t('mission.feedback.slug.checking');
      } else if (!this.missionSlugAvailable) {
        return this.$t('mission.feedback.slug.notAvailable');
      }

      return '';
    },
    missionDuplicateSlugState: function missionDuplicateSlugState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.slug) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.slug)) {
        return 'danger';
      } else if (this.checkingMissionSlugAvailability) {
        return 'warning';
      } else if (!this.missionSlugAvailable) {
        return 'danger';
      }

      return 'success';
    },
    missionDuplicateStartTimeFeedback: function missionDuplicateStartTimeFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.startTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.startTime)) {
        return '';
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.startTime);
      if (!startTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.slottingTime);
      if (!slottingTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      if (startTime < slottingTime) {
        return this.$t('mission.feedback.dateTime.afterSlotting');
      }

      return '';
    },
    missionDuplicateStartTimeState: function missionDuplicateStartTimeState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.startTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.startTime)) {
        return 'success';
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.startTime);
      if (!startTime.isValid()) {
        return 'danger';
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.slottingTime);
      if (!slottingTime.isValid()) {
        return 'danger';
      }

      if (startTime < slottingTime) {
        return 'danger';
      }

      return 'success';
    },
    missionDuplicateVisibilityOptions: function missionDuplicateVisibilityOptions() {
      var options = [{
        text: this.$t('mission.visibility.hidden'),
        value: 'hidden'
      }, {
        text: this.$t('mission.visibility.private'),
        value: 'private'
      }, {
        text: this.$t('mission.visibility.public'),
        value: 'public'
      }];

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.user.community)) {
        options = [{
          text: this.$t('mission.visibility.community'),
          value: 'community'
        }].concat(_toConsumableArray(options));
      }

      return options;
    },
    missionSlugAvailable: function missionSlugAvailable() {
      return this.$store.getters.missionSlugAvailable;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    clearMissionData: function clearMissionData() {
      this.missionDuplicateData = {
        addToCommunity: true,
        briefingTime: null,
        endTime: null,
        slottingTime: null,
        slug: null,
        startTime: null,
        title: null,
        visibility: 'hidden'
      };
    },
    missionDuplicateSlugFormatter: function missionDuplicateSlugFormatter(val) {
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDuplicateData.slug) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.slug)) {
        this.$store.dispatch('checkMissionSlugAvailability', this.missionDuplicateData.slug);
      }

      return val;
    },
    duplicateMission: function duplicateMission() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.slug)) {
        return;
      }

      var missionDuplicatePayload = {
        addToCommunity: this.missionDuplicateData.addToCommunity,
        slug: this.missionDuplicateData.slug,
        visibility: this.missionDuplicateData.visibility
      };

      var updatedBriefingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.briefingTime);
      if (updatedBriefingTime.isValid()) {
        missionDuplicatePayload.briefingTime = updatedBriefingTime.utc().format();
      }
      var updatedEndTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.endTime);
      if (updatedEndTime.isValid()) {
        missionDuplicatePayload.endTime = updatedEndTime.utc().format();
      }
      var updatedSlottingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.slottingTime);
      if (updatedSlottingTime.isValid()) {
        missionDuplicatePayload.slottingTime = updatedSlottingTime.utc().format();
      }
      var updatedStartTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDuplicateData.startTime);
      if (updatedStartTime.isValid()) {
        missionDuplicatePayload.startTime = updatedStartTime.utc().format();
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionDuplicateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDuplicateData.title)) {
        missionDuplicatePayload.title = this.missionDuplicateData.title;
      }

      this.hideMissionDuplicateModal();

      this.$store.dispatch('duplicateMission', {
        missionSlug: this.$route.params.missionSlug,
        missionDuplicatePayload: missionDuplicatePayload
      });
    },
    hideMissionDuplicateModal: function hideMissionDuplicateModal() {
      this.$refs.missionDuplicateModal.hide();
    },
    missionDuplicateTimeFormatter: function missionDuplicateTimeFormatter(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(val).format('Y-MM-DD HH:mm');
    }
  }
};

/***/ }),
/* 232 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionEditModal.vue ***!
  \*************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionEditData: {
        briefingTime: null,
        collapsedDescription: null,
        detailedDescription: null,
        endTime: null,
        gameServer: {
          hostname: null,
          port: null,
          name: null,
          password: null
        },
        rules: null,
        description: null,
        slotsAutoAssignable: false,
        slottingTime: null,
        startTime: null,
        techSupport: null,
        title: null,
        visibility: null,
        voiceComms: {
          hostname: null,
          port: null,
          name: null,
          password: null
        }
      },
      missionEditCommunityGameServersSelected: null,
      missionEditCommunityVoiceCommsSelected: null,
      missionEditRequiredDLCs: {
        aow: false,
        apex: false,
        contact: false,
        csla: false,
        gm: false,
        helicopters: false,
        jets: false,
        karts: false,
        lawsofwar: false,
        marksmen: false,
        tacops: false,
        tanks: false,
        vn: false
      },
      missionEditSuppressNotifications: false,
      missionEditDetailedDescriptionQuillEditorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'align': [] }, { 'indent': '-1' }, { 'indent': '+1' }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link', 'image', 'video'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      },
      missionEditQuillEditorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      }
    };
  },

  computed: {
    communityGameServers: function communityGameServers() {
      return this.$store.getters.communityGameServers;
    },
    communityVoiceComms: function communityVoiceComms() {
      return this.$store.getters.communityVoiceComms;
    },
    editorExplanationContent: function editorExplanationContent() {
      var _this = this;

      var content = '<img src="https://slotlist-info.storage.googleapis.com/images/static/editor-explanation.png"><ol>';
      __WEBPACK_IMPORTED_MODULE_0_lodash__["times"](8, function (i) {
        content += '<li>' + _this.$t('editor.explanation.' + (i + 1)) + '</li>';
      });
      content += '</ol><div class="text-center">' + this.$t('editor.explanation.missing') + '</div>';
      return content;
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionEditBriefingTimeFeedback: function missionEditBriefingTimeFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.briefingTime) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.briefingTime) && __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.briefingTime).isValid ? '' : this.$t('mission.feedback.dateTime');
    },
    missionEditBriefingTimeState: function missionEditBriefingTimeState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.briefingTime) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.briefingTime) && __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.briefingTime).isValid ? 'success' : 'danger';
    },
    missionEditCommunityGameServers: function missionEditCommunityGameServers() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityGameServers) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityGameServers)) {
        return [];
      }

      var servers = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.communityGameServers, function (gameServer, index) {
        var name = __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](gameServer.name) ? '' : ' - ' + gameServer.name;
        servers.push({
          text: gameServer.hostname + ':' + gameServer.port + name,
          value: index
        });
      });

      return servers;
    },
    missionEditCommunityVoiceComms: function missionEditCommunityVoiceComms() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityVoiceComms) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityVoiceComms)) {
        return [];
      }

      var servers = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.communityVoiceComms, function (voiceComms, index) {
        var name = __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](voiceComms.name) ? '' : ' - ' + voiceComms.name;
        servers.push({
          text: voiceComms.hostname + ':' + voiceComms.port + name,
          value: index
        });
      });

      return servers;
    },
    missionEditDetailedDescriptionFeedback: function missionEditDetailedDescriptionFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.detailedDescription) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.detailedDescription) ? '' : this.$t('mission.feedback.detailedDescription');
    },
    missionEditDetailedDescriptionState: function missionEditDetailedDescriptionState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.detailedDescription) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.detailedDescription) ? 'success' : 'danger';
    },
    missionEditEndTimeFeedback: function missionEditEndTimeFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.endTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.endTime)) {
        return this.$t('mission.feedback.dateTime');
      }

      var endTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.endTime);
      if (!endTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.startTime);
      if (!startTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      if (endTime < startTime) {
        return this.$t('mission.feedback.dateTime.afterStart');
      }

      return '';
    },
    missionEditEndTimeState: function missionEditEndTimeState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.endTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.endTime)) {
        return 'danger';
      }

      var endTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.endTime);
      if (!endTime.isValid()) {
        return 'danger';
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.startTime);
      if (!startTime.isValid()) {
        return 'danger';
      }

      if (endTime < startTime) {
        return 'danger';
      }

      return 'success';
    },
    missionEditDescriptionFeedback: function missionEditDescriptionFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.description) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.description) ? '' : this.$t('mission.feedback.description');
    },
    missionEditDescriptionState: function missionEditDescriptionState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.description) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.description) ? 'success' : 'danger';
    },
    missionEditGameServerHostnameFeedback: function missionEditGameServerHostnameFeedback() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.port) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionEditGameServerHostnameState: function missionEditGameServerHostnameState() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.port) ? 'danger' : 'success';
    },
    missionEditGameServerPortFeedback: function missionEditGameServerPortFeedback() {
      var port = parseInt(this.missionEditData.gameServer.port);
      if (port < 0 || port > 65535) {
        return this.$t('mission.feedback.serverInfo.portRange');
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.hostname) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionEditGameServerPortState: function missionEditGameServerPortState() {
      var port = parseInt(this.missionEditData.gameServer.port);
      if (port < 0 || port > 65535) {
        return 'danger';
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.gameServer.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.gameServer.hostname) ? 'danger' : 'success';
    },
    missionEditSlottingTimeFeedback: function missionEditSlottingTimeFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.slottingTime) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.slottingTime) && __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.slottingTime).isValid ? '' : this.$t('mission.feedback.dateTime');
    },
    missionEditSlottingTimeState: function missionEditSlottingTimeState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.slottingTime) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.slottingTime) && __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.slottingTime).isValid ? 'success' : 'danger';
    },
    missionEditStartTimeFeedback: function missionEditStartTimeFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.startTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.startTime)) {
        return this.$t('mission.feedback.dateTime');
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.startTime);
      if (!startTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.slottingTime);
      if (!slottingTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      if (startTime < slottingTime) {
        return this.$t('mission.feedback.dateTime.afterSlotting');
      }

      return '';
    },
    missionEditStartTimeState: function missionEditStartTimeState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.startTime) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.startTime)) {
        return 'danger';
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.startTime);
      if (!startTime.isValid()) {
        return 'danger';
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionEditData.slottingTime);
      if (!slottingTime.isValid()) {
        return 'danger';
      }

      if (startTime < slottingTime) {
        return 'danger';
      }

      return 'success';
    },
    missionEditTitleFeedback: function missionEditTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.title) ? '' : this.$t('mission.feedback.title');
    },
    missionEditTitleState: function missionEditTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.title) ? 'success' : 'danger';
    },
    missionEditVisibilityOptions: function missionEditVisibilityOptions() {
      var options = [{
        text: this.$t('mission.visibility.hidden'),
        value: 'hidden'
      }, {
        text: this.$t('mission.visibility.private'),
        value: 'private'
      }, {
        text: this.$t('mission.visibility.public'),
        value: 'public'
      }];

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.user.community)) {
        options = [{
          text: this.$t('mission.visibility.community'),
          value: 'community'
        }].concat(_toConsumableArray(options));
      }

      return options;
    },
    missionEditVoiceCommsHostnameFeedback: function missionEditVoiceCommsHostnameFeedback() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.port) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionEditVoiceCommsHostnameState: function missionEditVoiceCommsHostnameState() {
      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.hostname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.hostname)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.port) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.port) ? 'danger' : 'success';
    },
    missionEditVoiceCommsPortFeedback: function missionEditVoiceCommsPortFeedback() {
      var port = parseInt(this.missionEditData.voiceComms.port);
      if (port < 0 || port > 65535) {
        return this.$t('mission.feedback.serverInfo.portRange');
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.hostname) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionEditVoiceCommsPortState: function missionEditVoiceCommsPortState() {
      var port = parseInt(this.missionEditData.voiceComms.port);
      if (port < 0 || port > 65535) {
        return 'danger';
      }

      return (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.port) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.port)) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionEditData.voiceComms.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.voiceComms.hostname) ? 'danger' : 'success';
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    editMission: function editMission() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.title)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.collapsedDescription) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.collapsedDescription)) {
        this.missionEditData.collapsedDescription = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.rules) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.rules)) {
        this.missionEditData.rules = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionEditData.techSupport) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionEditData.techSupport)) {
        this.missionEditData.techSupport = null;
      }

      var updatedMissionRequiredDLCs = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](this.missionEditRequiredDLCs), function (dlc) {
        if (!_this2.missionEditRequiredDLCs[dlc]) {
          return;
        }

        if (dlc === 'lawsofwar') {
          updatedMissionRequiredDLCs.push('laws-of-war');
        } else if (dlc === 'tacops') {
          updatedMissionRequiredDLCs.push('tac-ops');
        } else {
          updatedMissionRequiredDLCs.push(dlc);
        }
      });

      var updatedMissionDetails = {};
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionEditData, function (value, key) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, _this2.missionDetails[key])) {
          var skip = false;

          if (key.toLowerCase().indexOf('time') !== -1) {
            value = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(value).utc().format();

            if (__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(value).utc().isSame(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(_this2.missionDetails[key]).utc())) {
              skip = true;
            }
          } else if (key.toLowerCase().indexOf('gameserver') !== -1 || key.toLowerCase().indexOf('voicecomms') !== -1) {
            if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](value.hostname) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](value.hostname)) {
              value.hostname = null;
            }
            if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](value.port) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](value.port)) {
              value.port = null;
            }
            if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](value.name) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](value.name)) {
              value.name = null;
            }
            if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](value.password) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](value.password)) {
              value.password = null;
            }

            if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](value.hostname) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](value.port)) {
              value = null;
              skip = __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](_this2.missionDetails[key]);
            } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](value.hostname) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](value.port) || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](value.hostname) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](value.port)) {
              console.log(value.hostname, value.port);
              skip = true;
            }
          }

          if (!skip) {
            updatedMissionDetails[key] = value;
          }
        }
      });

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](this.missionDetails.requiredDLCs, updatedMissionRequiredDLCs)) {
        updatedMissionDetails.requiredDLCs = updatedMissionRequiredDLCs;
      }

      this.hideMissionEditModal();

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](updatedMissionDetails))) {
        return;
      }

      this.$store.dispatch('editMission', {
        missionSlug: this.$route.params.missionSlug,
        updatedMissionDetails: updatedMissionDetails,
        missionTitle: this.missionDetails.title,
        suppressNotifications: this.missionEditSuppressNotifications
      });
    },
    hasMissionRequiredDLC: function hasMissionRequiredDLC(dlc) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDetails.requiredDLCs)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"](this.missionDetails.requiredDLCs, dlc) >= 0;
    },
    hideMissionEditModal: function hideMissionEditModal() {
      this.$refs.missionEditModal.hide();
    },
    missionEditTimeFormatter: function missionEditTimeFormatter(val) {
      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(val).format('Y-MM-DD HH:mm');
    },
    setMissionData: function setMissionData() {
      this.missionEditData = {
        briefingTime: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.briefingTime).format('Y-MM-DD HH:mm'),
        collapsedDescription: this.missionDetails.collapsedDescription,
        detailedDescription: this.missionDetails.detailedDescription,
        endTime: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime).format('Y-MM-DD HH:mm'),
        rules: this.missionDetails.rules,
        description: this.missionDetails.description,
        gameServer: {
          hostname: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.gameServer) ? null : this.missionDetails.gameServer.hostname,
          port: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.gameServer) ? null : '' + this.missionDetails.gameServer.port,
          name: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.gameServer) ? null : this.missionDetails.gameServer.name,
          password: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.gameServer) ? null : this.missionDetails.gameServer.password
        },
        slotsAutoAssignable: this.missionDetails.slotsAutoAssignable,
        slottingTime: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.slottingTime).format('Y-MM-DD HH:mm'),
        startTime: __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.startTime).format('Y-MM-DD HH:mm'),
        techSupport: this.missionDetails.techSupport,
        title: this.missionDetails.title,
        visibility: this.missionDetails.visibility,
        voiceComms: {
          hostname: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.voiceComms) ? null : this.missionDetails.voiceComms.hostname,
          port: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.voiceComms) ? null : '' + this.missionDetails.voiceComms.port,
          name: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.voiceComms) ? null : this.missionDetails.voiceComms.name,
          password: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.voiceComms) ? null : this.missionDetails.voiceComms.password
        }
      };

      this.missionEditRequiredDLCs = {
        aow: this.hasMissionRequiredDLC('aow'),
        apex: this.hasMissionRequiredDLC('apex'),
        contact: this.hasMissionRequiredDLC('contact'),
        csla: this.hasMissionRequiredDLC('csla'),
        gm: this.hasMissionRequiredDLC('gm'),
        helicopters: this.hasMissionRequiredDLC('helicopters'),
        jets: this.hasMissionRequiredDLC('jets'),
        karts: this.hasMissionRequiredDLC('karts'),
        lawsofwar: this.hasMissionRequiredDLC('laws-of-war'),
        marksmen: this.hasMissionRequiredDLC('marksmen'),
        tacops: this.hasMissionRequiredDLC('tac-ops'),
        tanks: this.hasMissionRequiredDLC('tanks'),
        vn: this.hasMissionRequiredDLC('vn')
      };

      this.missionEditCommunityGameServersSelected = null;
      this.missionEditCommunityVoiceCommsSelected = null;
      this.missionEditSuppressNotifications = false;
    }
  },
  watch: {
    missionEditCommunityGameServersSelected: function missionEditCommunityGameServersSelected(val) {
      var server = this.communityGameServers[val];
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](server)) {
        return;
      }

      this.missionEditData.gameServer.hostname = server.hostname;
      this.missionEditData.gameServer.port = '' + server.port;
      this.missionEditData.gameServer.name = server.name;
      this.missionEditData.gameServer.password = server.password;
    },
    missionEditCommunityVoiceCommsSelected: function missionEditCommunityVoiceCommsSelected(val) {
      var server = this.communityVoiceComms[val];
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](server)) {
        return;
      }

      this.missionEditData.voiceComms.hostname = server.hostname;
      this.missionEditData.voiceComms.port = '' + server.port;
      this.missionEditData.voiceComms.name = server.name;
      this.missionEditData.voiceComms.password = server.password;
    }
  }
};

/***/ }),
/* 233 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionEmbedModal.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    formattedMissionToken: function formattedMissionToken() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionToken) ? '<code><em>' + this.$t('mission.token.notGeneratedYet') + '</em></code>' : '<code>' + this.missionToken + '</code>';
    },
    missionToken: function missionToken() {
      return this.$store.getters.missionToken;
    }
  },
  methods: {
    deleteMissionToken: function deleteMissionToken() {
      this.$store.dispatch('deleteMissionToken', { missionSlug: this.$route.params.missionSlug });
    },
    generateMissionToken: function generateMissionToken() {
      this.$store.dispatch('generateMissionToken', { missionSlug: this.$route.params.missionSlug });
    },
    hideMissionEmbedModal: function hideMissionEmbedModal() {
      this.$refs.missionEmbedModal.hide();
    },
    setMissionEmbedInformation: function setMissionEmbedInformation() {
      this.$store.dispatch('getMissionToken', { missionSlug: this.$route.params.missionSlug });
    }
  }
};

/***/ }),
/* 234 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionPermissionModal.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionPermissions_vue__ = __webpack_require__(/*! ../MissionPermissions.vue */ 397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MissionPermissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MissionPermissions_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionPermissions: __WEBPACK_IMPORTED_MODULE_1__MissionPermissions_vue___default.a
  },
  data: function data() {
    return {
      missionPermissionAdd: {
        userUid: null,
        permission: null
      },
      missionPermissionAddSuppressNotifications: false
    };
  },

  computed: {
    missionPermissionAddPermissionOptions: function missionPermissionAddPermissionOptions() {
      return [{ value: 'editor', text: this.$t('mission.permission.editor') }, { value: 'slotlist.community', text: this.$t('mission.permission.slotlist.community') }];
    },
    missionPermissionAddPermissionState: function missionPermissionAddPermissionState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionPermissionAdd.permission) ? 'danger' : 'success';
    },
    missionPermissionAddUserState: function missionPermissionAddUserState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionPermissionAdd.userUid) ? 'danger' : 'success';
    },
    missionPermissions: function missionPermissions() {
      return this.$store.getters.missionPermissions;
    }
  },
  methods: {
    addMissionPermission: function addMissionPermission() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionPermissionAdd.userUid) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionPermissionAdd.permission)) {
        return;
      }

      var permission = 'mission.' + this.$route.params.missionSlug + '.' + this.missionPermissionAdd.permission;
      var permissionDetails = {
        userUid: this.missionPermissionAdd.userUid,
        permission: permission
      };
      var suppressNotifications = this.missionPermissionAddSuppressNotifications;

      this.missionPermissionAdd = {
        userUid: null,
        permission: null
      };

      this.missionPermissionAddSuppressNotifications = false;

      this.$refs.missionPermissionAddUserTypeahead.reset();

      this.$store.dispatch('addMissionPermission', {
        missionSlug: this.$route.params.missionSlug,
        permissionDetails: permissionDetails,
        suppressNotifications: suppressNotifications
      });
    },
    hideMissionPermissionModal: function hideMissionPermissionModal() {
      this.$refs.missionPermissionModal.hide();
    },
    permissionUserSelected: function permissionUserSelected(item) {
      this.missionPermissionAdd.userUid = item.value.uid;
    },
    setMissionPermissions: function setMissionPermissions() {
      this.$store.dispatch('getMissionPermissions', { missionSlug: this.$route.params.missionSlug });

      this.missionPermissionAdd = {
        userUid: null,
        permission: null
      };

      this.missionPermissionAddSuppressNotifications = false;

      this.$refs.missionPermissionAddUserTypeahead.reset();
    }
  }
};

/***/ }),
/* 235 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotAssignModal.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotAssign: {
        userUid: null,
        force: true
      },
      missionSlotAssignSuppressNotifications: false
    };
  },

  computed: {
    missionSlotAssignTitle: function missionSlotAssignTitle() {
      return this.$t('mission.modal.slot.assign', { slotInfo: '#' + this.missionSlotDetails.orderNumber + ' ' + this.missionSlotDetails.title });
    },
    missionSlotAssignUserState: function missionSlotAssignUserState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotAssign.userUid) ? 'danger' : 'success';
    },
    missionSlotDetails: function missionSlotDetails() {
      return this.$store.getters.missionSlotDetails;
    }
  },
  methods: {
    assignMissionSlot: function assignMissionSlot() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotAssign.userUid)) {
        return;
      }

      this.hideMissionSlotAssignModal();

      this.$store.dispatch('assignMissionSlot', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        userUid: this.missionSlotAssign.userUid,
        force: this.missionSlotAssign.force,
        suppressNotifications: this.missionSlotAssignSuppressNotifications
      });
    },
    assignUserSelected: function assignUserSelected(item) {
      this.missionSlotAssign.userUid = item.value.uid;
    },
    clearMissionSlotAssignData: function clearMissionSlotAssignData() {
      this.missionSlotAssign = {
        userUid: null,
        force: true
      };

      this.missionSlotAssignSuppressNotifications = false;

      this.$refs.missionSlotAssignUserTypeahead.reset();
    },
    hideMissionSlotAssignModal: function hideMissionSlotAssignModal() {
      this.$refs.missionSlotAssignModal.hide();
    }
  }
};

/***/ }),
/* 236 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotCreateModal.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotCreateData: {
        autoAssignable: false,
        detailedDescription: null,
        difficulty: 0,
        insertAfter: 0,
        reserve: false,
        blocked: false,
        restricted: false,
        restrictedCommunityUid: null,
        description: null,
        title: null
      },
      missionSlotCreateRequiredDLCs: {
        aow: false,
        apex: false,
        contact: false,
        csla: false,
        gm: false,
        helicopters: false,
        jets: false,
        karts: false,
        lawsofwar: false,
        marksmen: false,
        tacops: false,
        tanks: false,
        vn: false
      },
      missionSlotCreateDetailedDescriptionEditorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'align': [] }, { 'indent': '-1' }, { 'indent': '+1' }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      },
      missionSlotCreateDifficultyOptions: [{
        text: this.$t('mission.slot.difficulty.beginner'),
        value: 0
      }, {
        text: this.$t('mission.slot.difficulty.easy'),
        value: 1
      }, {
        text: this.$t('mission.slot.difficulty.medium'),
        value: 2
      }, {
        text: this.$t('mission.slot.difficulty.advanced'),
        value: 3
      }, {
        text: this.$t('mission.slot.difficulty.expert'),
        value: 4
      }]
    };
  },

  computed: {
    areMissionSlotAutoAssignable: function areMissionSlotAutoAssignable() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return this.missionDetails.slotsAutoAssignable;
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionSlotCreateAutoAssignableFeedback: function missionSlotCreateAutoAssignableFeedback() {
      if (!this.areMissionSlotAutoAssignable) {
        return '';
      }

      return this.$t('mission.feedback.slot.autoAssignable.mission');
    },
    missionSlotCreateInsertAfterOptions: function missionSlotCreateInsertAfterOptions() {
      var options = [{
        value: 0,
        text: this.$t('mission.slotGroup.insertAfter.top')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroupDetails) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroupDetails.slots)) {
        return options;
      }

      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotGroupDetails.slots, function (slot) {
        options.push({
          value: slot.orderNumber,
          text: '#' + slot.orderNumber + ' ' + slot.title
        });
      });

      return options;
    },
    missionSlotCreateRestrictedCommunityState: function missionSlotCreateRestrictedCommunityState() {
      return this.missionSlotCreateData.restricted && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotCreateData.restrictedCommunityUid) ? 'danger' : 'success';
    },
    missionSlotCreateTitleFeedback: function missionSlotCreateTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotCreateData.title) ? '' : this.$t('mission.feedback.title.slot');
    },
    missionSlotCreateTitleState: function missionSlotCreateTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotCreateData.title) ? 'success' : 'danger';
    },
    missionSlotGroupDetails: function missionSlotGroupDetails() {
      return this.$store.getters.missionSlotGroupDetails;
    },
    slotCreateTitle: function slotCreateTitle() {
      return this.$t('mission.modal.slot.create') + ' #' + this.missionSlotGroupDetails.orderNumber + ' ' + this.missionSlotGroupDetails.title;
    }
  },
  methods: {
    clearMissionSlotCreateData: function clearMissionSlotCreateData() {
      this.missionSlotCreateData = {
        autoAssignable: this.areMissionSlotAutoAssignable,
        detailedDescription: null,
        difficulty: 0,
        insertAfter: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroupDetails) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroupDetails.slots) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupDetails.slots) ? 0 : __WEBPACK_IMPORTED_MODULE_0_lodash__["last"](this.missionSlotGroupDetails.slots).orderNumber,
        reserve: false,
        blocked: false,
        restricted: false,
        restrictedCommunityUid: null,
        description: null,
        title: null
      };

      this.missionSlotCreateRequiredDLCs = {
        aow: false,
        apex: false,
        contact: false,
        csla: false,
        gm: false,
        helicopters: false,
        jets: false,
        karts: false,
        lawsofwar: false,
        marksmen: false,
        tacops: false,
        tanks: false,
        vn: false
      };
    },
    createMissionSlot: function createMissionSlot() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotCreateData.title)) {
        return;
      } else if (this.missionSlotCreateData.restricted && (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotCreateData.restrictedCommunityUid) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotCreateData.restrictedCommunityUid))) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotCreateData.detailedDescription) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotCreateData.detailedDescription)) {
        this.missionSlotCreateData.detailedDescription = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotCreateData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotCreateData.description)) {
        this.missionSlotCreateData.description = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotCreateData.restrictedCommunityUid) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotCreateData.restrictedCommunityUid)) {
        this.missionSlotCreateData.restrictedCommunityUid = null;
      }

      var missionSlotRequiredDLCs = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](this.missionSlotCreateRequiredDLCs), function (dlc) {
        if (!_this.missionSlotCreateRequiredDLCs[dlc]) {
          return;
        }

        if (dlc === 'lawsofwar') {
          missionSlotRequiredDLCs.push('laws-of-war');
        } else if (dlc === 'tacops') {
          missionSlotRequiredDLCs.push('tac-ops');
        } else {
          missionSlotRequiredDLCs.push(dlc);
        }
      });

      var payload = __WEBPACK_IMPORTED_MODULE_0_lodash__["assign"]({ slotGroupUid: this.missionSlotGroupDetails.uid, requiredDLCs: missionSlotRequiredDLCs }, __WEBPACK_IMPORTED_MODULE_0_lodash__["omit"](this.missionSlotCreateData, 'restricted'));

      this.hideMissionSlotCreateModal();

      this.$store.dispatch('createMissionSlot', { missionSlug: this.$route.params.missionSlug, slotDetails: payload });
    },
    hideMissionSlotCreateModal: function hideMissionSlotCreateModal() {
      this.$refs.missionSlotCreateModal.hide();
    },
    restrictedSlotCommunitySelected: function restrictedSlotCommunitySelected(item) {
      this.missionSlotCreateData.restrictedCommunityUid = item.value.uid;
    }
  }
};

/***/ }),
/* 237 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotDetailsModal.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrations_vue__ = __webpack_require__(/*! ../MissionSlotRegistrations.vue */ 400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrations_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotRegistrations: __WEBPACK_IMPORTED_MODULE_2__MissionSlotRegistrations_vue___default.a
  },
  computed: {
    canRegisterForSlot: function canRegisterForSlot() {
      var user = this.$store.getters.user;
      var userCommunityUid = null;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user.community)) {
        userCommunityUid = user.community.uid;
      }

      var restrictedCommunityUid = null;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        restrictedCommunityUid = this.missionSlotDetails.restrictedCommunity.uid;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.assignee) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.externalAssignee) && (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](restrictedCommunityUid) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](userCommunityUid, restrictedCommunityUid));
    },
    difficultyColor: function difficultyColor() {
      switch (this.missionSlotDetails.difficulty) {
        case 0:
          return 'text-muted';
        case 1:
          return 'text-info';
        case 2:
          return 'text-primary';
        case 3:
          return 'text-warning';
        case 4:
          return 'text-danger';
        default:
          return '';
      }
    },
    difficultyIcon: function difficultyIcon() {
      return this.difficultyColor + ' fa fa-thermometer-' + this.missionSlotDetails.difficulty + ' fa-lg';
    },
    difficultyText: function difficultyText() {
      switch (this.missionSlotDetails.difficulty) {
        case 0:
          return this.$t('mission.slot.difficulty.beginner');
        case 1:
          return this.$t('mission.slot.difficulty.easy');
        case 2:
          return this.$t('mission.slot.difficulty.medium');
        case 3:
          return this.$t('mission.slot.difficulty.advanced');
        case 4:
          return this.$t('mission.slot.difficulty.expert');
        default:
          return '';
      }
    },
    hasMissionEnded: function hasMissionEnded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime));
    },
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionSlotDetails: function missionSlotDetails() {
      return this.$store.getters.missionSlotDetails;
    },
    slotDetailsTitle: function slotDetailsTitle() {
      return this.$t('mission.modal.slot.details') + ' - #' + this.missionSlotDetails.orderNumber + ' ' + this.missionSlotDetails.title;
    },
    slotReserve: function slotReserve() {
      if (this.missionSlotDetails.reserve) {
        return '<span class="text-muted font-italic">' + this.$t('mission.slot.reserve') + '</span>';
      }

      return '<span>' + this.$t('mission.slot.reserve.regular') + '</span>';
    },
    slotRestricted: function slotRestricted() {
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity)) {
        return '<span class="text-primary">' + this.$t('mission.slot.restricted', { communityInfo: '[' + this.missionSlotDetails.restrictedCommunity.tag + '] ' + this.missionSlotDetails.restrictedCommunity.name }) + '</span>';
      }

      return '<span>' + this.$t('mission.slot.restricted.unrestricted') + '</span>';
    },
    slotStatus: function slotStatus() {
      if (this.missionSlotDetails.blocked) {
        return '<span class="text-primary">' + this.$t('mission.slot.blocked') + '</span>';
      }

      return this.slotRestricted + ' - ' + this.slotReserve;
    }
  },
  methods: {
    deleteMissionSlot: function deleteMissionSlot() {
      this.$store.dispatch('deleteMissionSlot', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });
    },
    deleteMissionSlotRegistration: function deleteMissionSlotRegistration() {
      this.$store.dispatch('unregisterFromMissionSlot', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        registrationUid: this.missionSlotDetails.registrationUid,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });
    },
    duplicateMissionSlot: function duplicateMissionSlot() {
      var slotDetails = {
        title: this.missionSlotDetails.title,
        difficulty: this.missionSlotDetails.difficulty,
        description: this.missionSlotDetails.description,
        detailedDescription: this.missionSlotDetails.detailedDescription,
        restrictedCommunityUid: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity) ? null : this.missionSlotDetails.restrictedCommunity.uid,
        reserve: this.missionSlotDetails.reserve,
        blocked: this.missionSlotDetails.blocked,
        autoAssignable: this.missionSlotDetails.autoAssignable,
        requiredDLCs: this.missionSlotDetails.requiredDLCs,
        insertAfter: this.missionSlotDetails.orderNumber,
        slotGroupUid: this.missionSlotDetails.slotGroupUid,
        duplicate: true
      };

      this.hideMissionSlotDetailsModal();

      this.$store.dispatch('createMissionSlot', { missionSlug: this.$route.params.missionSlug, slotDetails: slotDetails });
    },
    hideMissionSlotDetailsModal: function hideMissionSlotDetailsModal() {
      this.$refs.missionSlotDetailsModal.hide();
    }
  }
};

/***/ }),
/* 238 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotEditModal.vue ***!
  \*****************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotEditData: {
        autoAssignable: false,
        detailedDescription: null,
        difficulty: 0,
        reserve: false,
        blocked: false,
        restricted: false,
        restrictedCommunityUid: null,
        description: null,
        title: null,
        externalAssignee: null
      },
      missionSlotEditRequiredDLCs: {
        aow: false,
        apex: false,
        contact: false,
        csla: false,
        gm: false,
        helicopters: false,
        jets: false,
        karts: false,
        lawsofwar: false,
        marksmen: false,
        tacops: false,
        tanks: false,
        vn: false
      },
      missionSlotEditDetailedDescriptionEditorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'align': [] }, { 'indent': '-1' }, { 'indent': '+1' }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      },
      missionSlotEditMoveAfter: 0
    };
  },

  computed: {
    missionSlotDetails: function missionSlotDetails() {
      return this.$store.getters.missionSlotDetails;
    },
    missionSlotEditDifficultyOptions: function missionSlotEditDifficultyOptions() {
      return [{
        text: this.$t('mission.slot.difficulty.beginner'),
        value: 0
      }, {
        text: this.$t('mission.slot.difficulty.easy'),
        value: 1
      }, {
        text: this.$t('mission.slot.difficulty.medium'),
        value: 2
      }, {
        text: this.$t('mission.slot.difficulty.advanced'),
        value: 3
      }, {
        text: this.$t('mission.slot.difficulty.expert'),
        value: 4
      }];
    },
    missionSlotEditMoveAfterOptions: function missionSlotEditMoveAfterOptions() {
      var _this = this;

      var options = [{
        value: this.missionSlotDetails.orderNumber - 1,
        text: this.$t('mission.slot.moveAfter.keep')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroupDetails) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroupDetails.slots)) {
        return options;
      }

      if (this.missionSlotGroupEditMoveAfter !== 0) {
        options.push({
          value: -1,
          text: this.$t('mission.slot.insertAfter.top')
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotGroupDetails.slots, function (slot) {
        if (_this.missionSlotDetails.orderNumber !== slot.orderNumber && _this.missionSlotDetails.orderNumber - 1 !== slot.orderNumber) {
          options.push({
            value: slot.orderNumber,
            text: '#' + slot.orderNumber + ' ' + slot.title
          });
        }
      });

      return options;
    },
    missionSlotEditRestrictedCommunityState: function missionSlotEditRestrictedCommunityState() {
      return this.missionSlotEditData.restricted && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotEditData.restrictedCommunityUid) ? 'danger' : 'success';
    },
    missionSlotEditTitleFeedback: function missionSlotEditTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotEditData.title) ? '' : this.$t('mission.feedback.title.slot');
    },
    missionSlotEditTitleState: function missionSlotEditTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotEditData.title) ? 'success' : 'danger';
    },
    missionSlotGroupDetails: function missionSlotGroupDetails() {
      return this.$store.getters.missionSlotGroupDetails;
    },
    restrictedSlotTypeaheadInitialValue: function restrictedSlotTypeaheadInitialValue() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity) ? null : this.missionSlotDetails.restrictedCommunity.name;
    }
  },
  methods: {
    setMissionSlotEditData: function setMissionSlotEditData() {
      this.missionSlotEditData = {
        autoAssignable: this.missionSlotDetails.autoAssignable,
        detailedDescription: this.missionSlotDetails.detailedDescription,
        difficulty: this.missionSlotDetails.difficulty,
        orderNumber: this.missionSlotDetails.orderNumber,
        reserve: this.missionSlotDetails.reserve,
        blocked: this.missionSlotDetails.blocked,
        restricted: !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity),
        restrictedCommunityUid: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails.restrictedCommunity) ? null : this.missionSlotDetails.restrictedCommunity.uid,
        description: this.missionSlotDetails.description,
        title: this.missionSlotDetails.title,
        externalAssignee: this.missionSlotDetails.externalAssignee
      };

      this.missionSlotEditRequiredDLCs = {
        aow: this.hasSlotRequiredDLC('aow'),
        apex: this.hasSlotRequiredDLC('apex'),
        contact: this.hasSlotRequiredDLC('contact'),
        csla: this.hasSlotRequiredDLC('csla'),
        gm: this.hasSlotRequiredDLC('gm'),
        helicopters: this.hasSlotRequiredDLC('helicopters'),
        jets: this.hasSlotRequiredDLC('jets'),
        karts: this.hasSlotRequiredDLC('karts'),
        lawsofwar: this.hasSlotRequiredDLC('laws-of-war'),
        marksmen: this.hasSlotRequiredDLC('marksmen'),
        tacops: this.hasSlotRequiredDLC('tac-ops'),
        tanks: this.hasSlotRequiredDLC('tanks'),
        vn: this.hasSlotRequiredDLC('vn')
      };

      this.missionSlotEditMoveAfter = this.missionSlotDetails.orderNumber - 1;
    },
    editMissionSlot: function editMissionSlot() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotEditData.title)) {
        return;
      } else if (this.missionSlotEditData.restricted && (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotEditData.restrictedCommunityUid) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotEditData.restrictedCommunityUid))) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotEditData.detailedDescription) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotEditData.detailedDescription)) {
        this.missionSlotEditData.detailedDescription = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotEditData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotEditData.description)) {
        this.missionSlotEditData.description = null;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotEditData.externalAssignee) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotEditData.externalAssignee)) {
        this.missionSlotEditData.externalAssignee = null;
      }

      var updatedMissionSlotRequiredDLCs = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](this.missionSlotEditRequiredDLCs), function (dlc) {
        if (!_this2.missionSlotEditRequiredDLCs[dlc]) {
          return;
        }

        if (dlc === 'lawsofwar') {
          updatedMissionSlotRequiredDLCs.push('laws-of-war');
        } else if (dlc === 'tacops') {
          updatedMissionSlotRequiredDLCs.push('tac-ops');
        } else {
          updatedMissionSlotRequiredDLCs.push(dlc);
        }
      });

      var updatedMissionSlotDetails = {};
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotEditData, function (value, key) {
        if (key.toLowerCase() === 'restricted') {
          if (!value && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](_this2.missionSlotDetails.restrictedCommunity)) {
            updatedMissionSlotDetails.restrictedCommunityUid = null;
          }
          return;
        } else if (key.toLowerCase() === 'restrictedcommunityuid') {
          var oldRestrictedCommunityUid = __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](_this2.missionSlotDetails.restrictedCommunity) ? null : _this2.missionSlotDetails.restrictedCommunity.uid;
          if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, oldRestrictedCommunityUid)) {
            updatedMissionSlotDetails.restrictedCommunityUid = value;
          }
          return;
        } else if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, _this2.missionSlotDetails[key])) {
          updatedMissionSlotDetails[key] = value;
        }
      });

      if (this.missionSlotEditMoveAfter !== this.missionSlotDetails.orderNumber - 1) {
        updatedMissionSlotDetails.moveAfter = __WEBPACK_IMPORTED_MODULE_0_lodash__["max"]([this.missionSlotEditMoveAfter, 0]);
      }

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](this.missionSlotDetails.requiredDLCs, updatedMissionSlotRequiredDLCs)) {
        updatedMissionSlotDetails.requiredDLCs = updatedMissionSlotRequiredDLCs;
      }

      this.hideMissionSlotEditModal();

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](updatedMissionSlotDetails))) {
        return;
      }

      this.$store.dispatch('editMissionSlot', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        updatedSlotDetails: updatedMissionSlotDetails,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });
    },
    hasSlotRequiredDLC: function hasSlotRequiredDLC(dlc) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotDetails)) {
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotDetails.requiredDLCs)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"](this.missionSlotDetails.requiredDLCs, dlc) >= 0;
    },
    hideMissionSlotEditModal: function hideMissionSlotEditModal() {
      this.$refs.missionSlotEditModal.hide();
    },
    restrictedSlotCommunitySelected: function restrictedSlotCommunitySelected(item) {
      this.missionSlotEditData.restrictedCommunityUid = item.value.uid;
    }
  }
};

/***/ }),
/* 239 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotGroupCreateModal.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotGroupCreateData: {
        description: null,
        title: null,
        insertAfter: 0
      }
    };
  },

  computed: {
    missionSlotGroupCreateInsertAfterOptions: function missionSlotGroupCreateInsertAfterOptions() {
      var options = [{
        value: 0,
        text: this.$t('mission.slotGroup.insertAfter.top')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups)) {
        return options;
      }

      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotGroups, function (slotGroup) {
        options.push({
          value: slotGroup.orderNumber,
          text: '#' + slotGroup.orderNumber + ' ' + slotGroup.title
        });
      });

      return options;
    },
    missionSlotGroupCreateTitleFeedback: function missionSlotGroupCreateTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotGroupCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupCreateData.title) ? '' : this.$t('mission.feedback.title.slotGroup');
    },
    missionSlotGroupCreateTitleState: function missionSlotGroupCreateTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotGroupCreateData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupCreateData.title) ? 'success' : 'danger';
    },
    missionSlotGroups: function missionSlotGroups() {
      return this.$store.getters.missionSlotGroups;
    }
  },
  methods: {
    clearMissionSlotGroupCreateData: function clearMissionSlotGroupCreateData() {
      this.missionSlotGroupCreateData = {
        description: null,
        title: null,
        insertAfter: __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroups) ? 0 : __WEBPACK_IMPORTED_MODULE_0_lodash__["last"](this.missionSlotGroups).orderNumber
      };
    },
    createMissionSlotGroup: function createMissionSlotGroup() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupCreateData.title)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotGroupCreateData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupCreateData.description)) {
        this.missionSlotGroupCreateData.description = null;
      }

      this.hideMissionSlotGroupCreateModal();

      this.$store.dispatch("createMissionSlotGroup", { missionSlug: this.$route.params.missionSlug, slotGroupDetails: this.missionSlotGroupCreateData });
    },
    hideMissionSlotGroupCreateModal: function hideMissionSlotGroupCreateModal() {
      this.$refs.missionSlotGroupCreateModal.hide();
    }
  }
};

/***/ }),
/* 240 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotGroupEditModal.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotGroupEditData: {
        description: null,
        title: null
      },
      missionSlotGroupEditMoveAfter: 0
    };
  },

  computed: {
    missionSlotGroupDetails: function missionSlotGroupDetails() {
      return this.$store.getters.missionSlotGroupDetails;
    },
    missionSlotGroupEditMoveAfterOptions: function missionSlotGroupEditMoveAfterOptions() {
      var _this = this;

      var options = [{
        value: this.missionSlotGroupDetails.orderNumber - 1,
        text: this.$t('mission.slotGroup.moveAfter.keep')
      }];

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups)) {
        return options;
      }

      if (this.missionSlotGroupEditMoveAfter !== 0) {
        options.push({
          value: -1,
          text: this.$t('mission.slotGroup.insertAfter.top')
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotGroups, function (slotGroup) {
        if (_this.missionSlotGroupDetails.orderNumber !== slotGroup.orderNumber && _this.missionSlotGroupDetails.orderNumber - 1 !== slotGroup.orderNumber) {
          options.push({
            value: slotGroup.orderNumber,
            text: '#' + slotGroup.orderNumber + ' ' + slotGroup.title
          });
        }
      });

      return options;
    },
    missionSlotGroupEditTitleFeedback: function missionSlotGroupEditTitleFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotGroupEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupEditData.title) ? '' : this.$t('mission.feedback.title.slotGroup');
    },
    missionSlotGroupEditTitleState: function missionSlotGroupEditTitleState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotGroupEditData.title) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupEditData.title) ? 'success' : 'danger';
    },
    missionSlotGroups: function missionSlotGroups() {
      return this.$store.getters.missionSlotGroups;
    }
  },
  methods: {
    setMissionSlotGroupEditData: function setMissionSlotGroupEditData() {
      this.missionSlotGroupEditData = {
        description: this.missionSlotGroupDetails.description,
        title: this.missionSlotGroupDetails.title
      };

      this.missionSlotGroupEditMoveAfter = this.missionSlotGroupDetails.orderNumber - 1;
    },
    editMissionSlotGroup: function editMissionSlotGroup() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupEditData.title)) {
        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotGroupEditData.description) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotGroupEditData.description)) {
        this.missionSlotGroupEditData.description = null;
      }

      var updatedMissionSlotGroupDetails = {};
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.missionSlotGroupEditData, function (value, key) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, _this2.missionSlotGroupDetails[key])) {
          updatedMissionSlotGroupDetails[key] = value;
        }
      });

      if (this.missionSlotGroupEditMoveAfter !== this.missionSlotGroupDetails.orderNumber - 1) {
        updatedMissionSlotGroupDetails.moveAfter = __WEBPACK_IMPORTED_MODULE_0_lodash__["max"]([this.missionSlotGroupEditMoveAfter, 0]);
      }

      this.hideMissionSlotGroupEditModal();

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](updatedMissionSlotGroupDetails))) {
        return;
      }

      this.$store.dispatch('editMissionSlotGroup', {
        missionSlug: this.$route.params.missionSlug,
        slotGroupUid: this.missionSlotGroupDetails.uid,
        updatedSlotGroupDetails: updatedMissionSlotGroupDetails
      });
    },
    hideMissionSlotGroupEditModal: function hideMissionSlotGroupEditModal() {
      this.$refs.missionSlotGroupEditModal.hide();
    }
  }
};

/***/ }),
/* 241 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotRegistrationModal.vue ***!
  \*************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotRegistrationData: {
        comment: null
      }
    };
  },

  computed: {
    missionSlotDetails: function missionSlotDetails() {
      return this.$store.getters.missionSlotDetails;
    },
    translatedModalText: function translatedModalText() {
      return this.$t('mission.modal.slot.register.text', { slotInfo: '<span class="font-weight-bold">#' + this.missionSlotDetails.orderNumber + ' ' + this.missionSlotDetails.title + '</span>' });
    }
  },
  methods: {
    clearMissionSlotRegistrationModalData: function clearMissionSlotRegistrationModalData() {
      this.missionSlotRegistrationData = {
        comment: null
      };
    },
    hideMissionSlotRegistrationModal: function hideMissionSlotRegistrationModal() {
      this.$refs.missionSlotRegistrationModal.hide();
    },
    registerForMissionSlot: function registerForMissionSlot() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.missionSlotRegistrationData.comment) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotRegistrationData.comment)) {
        this.missionSlotRegistrationData.comment = null;
      }

      this.hideMissionSlotRegistrationModal();

      this.$store.dispatch('registerForMissionSlot', {
        missionSlug: this.$route.params.missionSlug,
        slotUid: this.missionSlotDetails.uid,
        comment: this.missionSlotRegistrationData.comment,
        slotOrderNumber: this.missionSlotDetails.orderNumber,
        slotTitle: this.missionSlotDetails.title
      });
    }
  }
};

/***/ }),
/* 242 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/missions/modals/MissionSlotSelectionEditModal.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      missionSlotSelectionEditData: {
        autoAssignable: false,
        blocked: false,
        description: null,
        difficulty: -1,
        reserve: false,
        restricted: false,
        restrictedCommunityUid: null
      }
    };
  },

  computed: {
    missionSlotDetails: function missionSlotDetails() {
      return this.$store.getters.missionSlotDetails;
    },
    missionSlotEditDifficultyOptions: function missionSlotEditDifficultyOptions() {
      return [{
        text: this.$t('mission.slot.difficulty.beginner'),
        value: 0
      }, {
        text: this.$t('mission.slot.difficulty.easy'),
        value: 1
      }, {
        text: this.$t('mission.slot.difficulty.medium'),
        value: 2
      }, {
        text: this.$t('mission.slot.difficulty.advanced'),
        value: 3
      }, {
        text: this.$t('mission.slot.difficulty.expert'),
        value: 4
      }];
    },
    missionSlotEditRestrictedCommunityState: function missionSlotEditRestrictedCommunityState() {
      return this.missionSlotSelectionEditData.restricted && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotSelectionEditData.restrictedCommunityUid) ? 'danger' : 'success';
    },
    selectedMissionSlots: function selectedMissionSlots() {
      return this.$store.getters.selectedMissionSlots;
    }
  },
  methods: {
    clearMissionSlotSelectionEditData: function clearMissionSlotSelectionEditData() {
      this.missionSlotSelectionEditData = {
        autoAssignable: false,
        blocked: false,
        description: null,
        difficulty: -1,
        reserve: false,
        restricted: false,
        restrictedCommunityUid: null
      };
    },
    editMissionSlotSelection: function editMissionSlotSelection() {
      if (this.missionSlotSelectionEditData.restricted && (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotSelectionEditData.restrictedCommunityUid) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotSelectionEditData.restrictedCommunityUid))) {
        return;
      }

      var updatedMissionSlotDetails = {};
      if (this.missionSlotSelectionEditData.autoAssignable) {
        updatedMissionSlotDetails.autoAssignable = this.missionSlotSelectionEditData.autoAssignable;
      }
      if (this.missionSlotSelectionEditData.blocked) {
        updatedMissionSlotDetails.blocked = this.missionSlotSelectionEditData.blocked;
      }
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotSelectionEditData.description) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotSelectionEditData.description)) {
        updatedMissionSlotDetails.description = this.missionSlotSelectionEditData.description;
      }
      if (this.missionSlotSelectionEditData.difficulty >= 0) {
        updatedMissionSlotDetails.difficulty = this.missionSlotSelectionEditData.difficulty;
      }
      if (this.missionSlotSelectionEditData.reserve) {
        updatedMissionSlotDetails.reserve = this.missionSlotSelectionEditData.reserve;
      }
      if (this.missionSlotSelectionEditData.restricted && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotSelectionEditData.restrictedCommunityUid) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionSlotSelectionEditData.restrictedCommunityUid)) {
        updatedMissionSlotDetails.restrictedCommunityUid = this.missionSlotSelectionEditData.restrictedCommunityUid;
      }

      this.hideMissionSlotSelectionEditModal();

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](updatedMissionSlotDetails))) {
        return;
      }

      this.$store.dispatch('editSelectedMissionSlots', { missionSlug: this.$route.params.missionSlug, updatedMissionSlotDetails: updatedMissionSlotDetails });
    },
    hideMissionSlotSelectionEditModal: function hideMissionSlotSelectionEditModal() {
      this.$refs.missionSlotSelectionEditModal.hide();
    },
    restrictedSlotCommunitySelected: function restrictedSlotCommunitySelected(item) {
      this.missionSlotSelectionEditData.restrictedCommunityUid = item.value.uid;
    }
  }
};

/***/ }),
/* 243 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/notifications/NotificationListRow.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['notification'],
  created: function created() {
    var notificationsRequiringRefresh = ['community.application.accepted', 'community.application.removed', 'community.deleted', 'community.permission.granted', 'community.permission.revoked', 'mission.permission.granted', 'mission.permission.revoked'];
    if (_.isNil(this.notification.seenAt) && _.indexOf(notificationsRequiringRefresh, this.notification.notificationType) >= 0) {
      this.$store.dispatch('refreshToken', { silent: true });
    }
  },
  computed: {
    notificationTarget: function notificationTarget() {
      switch (this.notification.notificationType) {
        case 'community.application.accepted':
        case 'community.application.denied':
        case 'community.application.new':
        case 'community.application.removed':
        case 'community.permission.granted':
        case 'community.permission.revoked':
          return { name: 'communityDetails', params: { communitySlug: this.notification.data.communitySlug } };
        case 'community.application.deleted':
          return { name: 'userDetails', params: { userUid: this.notification.data.userUid } };
        case 'mission.permission.granted':
        case 'mission.permission.revoked':
        case 'mission.slot.assigned':
        case 'mission.slot.registration.new':
        case 'mission.slot.unassigned':
        case 'mission.slot.unregistered':
        case 'mission.updated':
          return { name: 'missionDetails', params: { missionSlug: this.notification.data.missionSlug } };
        default:
          return null;
      }
    },
    notificationText: function notificationText() {
      switch (this.notification.notificationType) {
        case 'community.permission.granted':
        case 'community.permission.revoked':
        case 'mission.permission.granted':
        case 'mission.permission.revoked':
          var notificationDataPermission = _.clone(this.notification.data);
          notificationDataPermission.translatedPermission = this.translatePermission(this.notification.data.permission);
          return this.$t('notification.type.' + this.notification.notificationType, notificationDataPermission);
        case 'generic':
          return this.notification.data.message;
        case 'mission.slot.registration.new':
        case 'mission.slot.unregistered':
          var notificationDataUserNickname = _.clone(this.notification.data);
          notificationDataUserNickname.userNicknameWithTag = _.isNil(this.notification.data.userCommunityTag) ? this.notification.data.userNickname : '[' + this.notification.data.userCommunityTag + '] ' + this.notification.data.userNickname;
          return this.$t('notification.type.' + this.notification.notificationType, notificationDataUserNickname);
        default:
          return this.$t('notification.type.' + this.notification.notificationType, this.notification.data);
      }
    }
  },
  methods: {
    translatePermission: function translatePermission(permission) {
      var perm = permission.toLowerCase();

      if (_.startsWith(perm, 'community')) {
        if (_.endsWith(perm, 'founder')) {
          return this.$t('community.permission.founder');
        } else if (_.endsWith(perm, 'leader')) {
          return this.$t('community.permission.leader');
        } else if (_.endsWith(perm, 'recruitment')) {
          return this.$t('community.permission.recruitment');
        }
      } else if (_.startsWith(perm, 'mission')) {
        if (_.endsWith(perm, 'creator')) {
          return this.$t('mission.permission.creator');
        } else if (_.endsWith(perm, 'editor')) {
          return this.$t('mission.permission.editor');
        } else if (_.endsWith(perm, 'slotlist.community')) {
          return this.$t('mission.permission.slotlist.community');
        }
      }

      return permission;
    }
  }
};

/***/ }),
/* 244 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/notifications/NotificationListTable.vue ***!
  \****************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationListRow_vue__ = __webpack_require__(/*! ./NotificationListRow.vue */ 423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationListRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NotificationListRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    NotificationListRow: __WEBPACK_IMPORTED_MODULE_0__NotificationListRow_vue___default.a
  },
  computed: {
    notifications: function notifications() {
      return this.$store.getters.notifications;
    }
  }
};

/***/ }),
/* 245 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/UserListRow.vue ***!
  \**********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['user']
};

/***/ }),
/* 246 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/UserListTable.vue ***!
  \************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserListRow_vue__ = __webpack_require__(/*! ./UserListRow.vue */ 425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserListRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserListRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    UserListRow: __WEBPACK_IMPORTED_MODULE_0__UserListRow_vue___default.a
  },
  computed: {
    users: function users() {
      return this.$store.getters.users;
    }
  }
};

/***/ }),
/* 247 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/UserMissions.vue ***!
  \***********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserMissionsTable_vue__ = __webpack_require__(/*! ./UserMissionsTable.vue */ 429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserMissionsTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserMissionsTable_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    UserMissionsTable: __WEBPACK_IMPORTED_MODULE_0__UserMissionsTable_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getUserMissions', { userUid: this.$route.params.userUid });
  },
  computed: {
    userMissionsPageCount: function userMissionsPageCount() {
      return this.$store.getters.userMissionsPageCount;
    }
  },
  methods: {
    paginateUserMissions: function paginateUserMissions(page) {
      this.$store.dispatch('getUserMissions', { userUid: this.$route.params.userUid, page: page });
    }
  }
};

/***/ }),
/* 248 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/UserMissionsRow.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['userMission']
};

/***/ }),
/* 249 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/UserMissionsTable.vue ***!
  \****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserMissionsRow_vue__ = __webpack_require__(/*! ./UserMissionsRow.vue */ 428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserMissionsRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserMissionsRow_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    UserMissionsRow: __WEBPACK_IMPORTED_MODULE_0__UserMissionsRow_vue___default.a
  },
  computed: {
    userMissions: function userMissions() {
      return this.$store.getters.userMissions;
    }
  }
};

/***/ }),
/* 250 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/users/modals/UserEditModal.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      userEditData: {
        nickname: null
      }
    };
  },

  computed: {
    userDetails: function userDetails() {
      return this.$store.getters.userDetails;
    },
    userEditNicknameFeedback: function userEditNicknameFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.userEditData.nickname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.userEditData.nickname) ? this.$t('account.feedback.nickname') : '';
    },
    userEditNicknameState: function userEditNicknameState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.userEditData.nickname) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.userEditData.nickname) ? 'danger' : 'success';
    }
  },
  methods: {
    editUser: function editUser() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.userEditData.nickname)) {
        return;
      }

      var updatedUserDetails = {};
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.userEditData, function (value, key) {
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEqual"](value, _this.userDetails[key])) {
          updatedUserDetails[key] = value;
        }
      });

      this.hideUserEditModal();

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](updatedUserDetails)) {
        this.$store.dispatch('editUser', {
          userUid: this.$route.params.userUid,
          updatedUserDetails: updatedUserDetails
        });
      }
    },
    hideUserEditModal: function hideUserEditModal() {
      this.$refs.userEditModal.hide();
    },
    setUserEditData: function setUserEditData() {
      this.userEditData = {
        nickname: this.userDetails.nickname
      };
    }
  }
};

/***/ }),
/* 251 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/i18n/views/About.de.vue ***!
  \*************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    backendVersion: function backendVersion() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.backendVersion)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["startsWith"](this.$store.getters.backendVersion, 'v') ? this.$store.getters.backendVersion : 'v' + this.$store.getters.backendVersion;
    },
    frontendVersion: function frontendVersion() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["startsWith"]("1.1.1", 'v') ? "1.1.1" : 'v' + "1.1.1";
    }
  }
};

/***/ }),
/* 252 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/i18n/views/About.en.vue ***!
  \*************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    backendVersion: function backendVersion() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.backendVersion)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["startsWith"](this.$store.getters.backendVersion, 'v') ? this.$store.getters.backendVersion : 'v' + this.$store.getters.backendVersion;
    },
    frontendVersion: function frontendVersion() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["startsWith"]("1.1.1", 'v') ? "1.1.1" : 'v' + "1.1.1";
    }
  }
};

/***/ }),
/* 253 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/i18n/views/Login.de.vue ***!
  \*************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    loginRedirectUrl: function loginRedirectUrl() {
      return this.$store.getters.loginRedirectUrl;
    },
    working: function working() {
      return this.$store.getters.working;
    }
  }
};

/***/ }),
/* 254 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/i18n/views/Login.en.vue ***!
  \*************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    loginRedirectUrl: function loginRedirectUrl() {
      return this.$store.getters.loginRedirectUrl;
    },
    working: function working() {
      return this.$store.getters.working;
    }
  }
};

/***/ }),
/* 255 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/About.vue ***!
  \*****************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_About_de_vue__ = __webpack_require__(/*! ../i18n/views/About.de.vue */ 431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_About_de_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__i18n_views_About_de_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_About_en_vue__ = __webpack_require__(/*! ../i18n/views/About.en.vue */ 432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_About_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_views_About_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AboutDe: __WEBPACK_IMPORTED_MODULE_0__i18n_views_About_de_vue___default.a,
    AboutEn: __WEBPACK_IMPORTED_MODULE_1__i18n_views_About_en_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getBackendVersion');
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(this.$t('nav.about'));
  }
};

/***/ }),
/* 256 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/Account.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_modals_AccountDeleteModal_vue__ = __webpack_require__(/*! ../components/account/modals/AccountDeleteModal.vue */ 355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_modals_AccountDeleteModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_account_modals_AccountDeleteModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_modals_AccountEditModal_vue__ = __webpack_require__(/*! ../components/account/modals/AccountEditModal.vue */ 356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_modals_AccountEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_account_modals_AccountEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_AccountMissions_vue__ = __webpack_require__(/*! ../components/account/AccountMissions.vue */ 349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_AccountMissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_account_AccountMissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_AccountPermissions_vue__ = __webpack_require__(/*! ../components/account/AccountPermissions.vue */ 352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_AccountPermissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_account_AccountPermissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AccountDeleteModal: __WEBPACK_IMPORTED_MODULE_2__components_account_modals_AccountDeleteModal_vue___default.a,
    AccountEditModal: __WEBPACK_IMPORTED_MODULE_3__components_account_modals_AccountEditModal_vue___default.a,
    AccountMissions: __WEBPACK_IMPORTED_MODULE_4__components_account_AccountMissions_vue___default.a,
    AccountPermissions: __WEBPACK_IMPORTED_MODULE_5__components_account_AccountPermissions_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getAccountDetails');
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* default */].setTitle(this.$t('nav.account'));

    this.currentTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().format('L LTS');
    this.currentTimeSetInterval = setInterval(function () {
      _this.currentTime = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().format('L LTS');
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearAccountDetails');

    if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.currentTimeSetInterval)) {
      clearInterval(this.currentTimeSetInterval);
    }
  },
  data: function data() {
    return {
      currentTime: null,
      currentTimeSetInterval: null
    };
  },

  computed: {
    accountDetails: function accountDetails() {
      return this.$store.getters.accountDetails;
    },
    timezone: function timezone() {
      return this.$store.getters.timezone;
    }
  },
  methods: {
    refreshAuthentication: function refreshAuthentication() {
      var _this2 = this;

      this.$store.dispatch("refreshToken").then(function () {
        _this2.$store.dispatch("getAccountDetails");
      });
    }
  }
};

/***/ }),
/* 257 */
/* exports provided: default */
/* all exports used */
/*!***************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/Api.vue ***!
  \***************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].setTitle(this.$t('nav.api'));
  }
};

/***/ }),
/* 258 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/CommunityCreator.vue ***!
  \****************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].setTitle(this.$t('community.creator.title.browser'));
  },
  data: function data() {
    return {
      communityCreate: {
        name: null,
        slug: null,
        tag: null,
        website: null
      }
    };
  },

  computed: {
    checkingCommunitySlugAvailability: function checkingCommunitySlugAvailability() {
      return this.$store.getters.checkingCommunitySlugAvailability;
    },
    communityCreateNameFeedback: function communityCreateNameFeedback() {
      return _.isNil(this.communityCreate.name) || _.isEmpty(this.communityCreate.name) ? this.$t('community.creator.feedback.name') : '';
    },
    communityCreateNameState: function communityCreateNameState() {
      return _.isNil(this.communityCreate.name) || _.isEmpty(this.communityCreate.name) ? 'danger' : 'success';
    },
    communityCreateSlugState: function communityCreateSlugState() {
      if (_.isNil(this.communityCreate.slug) || _.isEmpty(this.communityCreate.slug)) {
        return 'danger';
      } else if (this.checkingCommunitySlugAvailability) {
        return 'warning';
      } else if (!this.communitySlugAvailable) {
        return 'danger';
      }

      return 'success';
    },
    communityCreateSlugFeedback: function communityCreateSlugFeedback() {
      if (_.isNil(this.communityCreate.slug) || _.isEmpty(this.communityCreate.slug)) {
        return this.$t('community.creator.feedback.slug');
      } else if (this.checkingCommunitySlugAvailability) {
        return this.$t('community.creator.feedback.slug.checking');
      } else if (!this.communitySlugAvailable) {
        return this.$t('community.creator.feedback.slug.notAvailable');
      }

      return '';
    },
    communityCreateSlugAvailable: function communityCreateSlugAvailable() {
      if (this.checkingCommunitySlugAvailability) {
        return '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
      } else if (this.communitySlugAvailable) {
        return '<i class="fa fa-check" aria-hidden="true"></i>';
      }

      return '<i class="fa fa-close" aria-hidden="true"></i>';
    },
    communityCreateTagFeedback: function communityCreateTagFeedback(proerty) {
      return _.isNil(this.communityCreate.tag) || _.isEmpty(this.communityCreate.tag) ? this.$t('community.creator.feedback.tag') : '';
    },
    communityCreateTagState: function communityCreateTagState() {
      return _.isNil(this.communityCreate.tag) || _.isEmpty(this.communityCreate.tag) ? 'danger' : 'success';
    },
    communityCreateWebsiteFeedback: function communityCreateWebsiteFeedback() {
      if (_.isNil(this.communityCreate.website) || _.isEmpty(this.communityCreate.website)) {
        return '';
      }

      return this.isCommunityCreateWebsiteValidUrl ? '' : this.$t('community.creator.feedback.website');
    },
    communityCreateWebsiteState: function communityCreateWebsiteState() {
      if (_.isNil(this.communityCreate.website) || _.isEmpty(this.communityCreate.website)) {
        return 'success';
      }

      return this.isCommunityCreateWebsiteValidUrl ? 'success' : 'danger';
    },
    communitySlugAvailable: function communitySlugAvailable() {
      return this.$store.getters.communitySlugAvailable;
    },
    isCommunityCreateWebsiteValidUrl: function isCommunityCreateWebsiteValidUrl() {
      // Taken from: https://stackoverflow.com/a/5717133 @ 2017-08-04 09:43
      var urlPattern = /^((https?|ftp):\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
      return urlPattern.test(this.communityCreate.website);
    }
  },
  methods: {
    communityCreateNameFormatter: function communityCreateNameFormatter(val) {
      if (_.isNil(this.communityCreate.slug) || _.isEmpty(this.communityCreate.slug)) {
        this.communityCreate.slug = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].slug(val);
        this.$store.dispatch('checkCommunitySlugAvailability', this.communityCreate.slug);
      }
      return val;
    },
    communityCreateSlugFormatter: function communityCreateSlugFormatter(val) {
      if (!_.isNil(this.communityCreate.slug) && !_.isEmpty(this.communityCreate.slug)) {
        this.$store.dispatch('checkCommunitySlugAvailability', this.communityCreate.slug);
      }

      return val;
    },
    createCommunity: function createCommunity() {
      if (_.isEmpty(this.communityCreate.name) || _.isEmpty(this.communityCreate.slug) || _.isEmpty(this.communityCreate.tag)) {
        return;
      }

      if (_.isEmpty(this.communityCreate.website)) {
        this.communityCreate.website = null;
      }

      this.$store.dispatch('createCommunity', this.communityCreate);
    }
  }
};

/***/ }),
/* 259 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/CommunityDetails.vue ***!
  \****************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communities_CommunityApplications_vue__ = __webpack_require__(/*! ../components/communities/CommunityApplications.vue */ 362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_communities_CommunityApplications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_communities_CommunityApplications_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_communities_modals_CommunityEditModal_vue__ = __webpack_require__(/*! ../components/communities/modals/CommunityEditModal.vue */ 376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_communities_modals_CommunityEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_communities_modals_CommunityEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_communities_modals_CommunityLogoModal_vue__ = __webpack_require__(/*! ../components/communities/modals/CommunityLogoModal.vue */ 377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_communities_modals_CommunityLogoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_communities_modals_CommunityLogoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_communities_CommunityMembers_vue__ = __webpack_require__(/*! ../components/communities/CommunityMembers.vue */ 367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_communities_CommunityMembers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_communities_CommunityMembers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_communities_CommunityMissions_vue__ = __webpack_require__(/*! ../components/communities/CommunityMissions.vue */ 370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_communities_CommunityMissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_communities_CommunityMissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_communities_modals_CommunityPermissionModal_vue__ = __webpack_require__(/*! ../components/communities/modals/CommunityPermissionModal.vue */ 378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_communities_modals_CommunityPermissionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_communities_modals_CommunityPermissionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityApplications: __WEBPACK_IMPORTED_MODULE_1__components_communities_CommunityApplications_vue___default.a,
    CommunityEditModal: __WEBPACK_IMPORTED_MODULE_2__components_communities_modals_CommunityEditModal_vue___default.a,
    CommunityLogoModal: __WEBPACK_IMPORTED_MODULE_3__components_communities_modals_CommunityLogoModal_vue___default.a,
    CommunityMembers: __WEBPACK_IMPORTED_MODULE_4__components_communities_CommunityMembers_vue___default.a,
    CommunityMissions: __WEBPACK_IMPORTED_MODULE_5__components_communities_CommunityMissions_vue___default.a,
    CommunityPermissionModal: __WEBPACK_IMPORTED_MODULE_6__components_communities_modals_CommunityPermissionModal_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getCommunityDetails', this.$route.params.communitySlug);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearCommunityDetails');
  },
  created: function created() {
    if (this.loggedIn && !this.isCommunityMember) {
      this.$store.dispatch('getCommunityApplicationStatus', this.$route.params.communitySlug);
    }
  },
  data: function data() {
    return {
      communityApplicationsFilter: [],
      communityEdit: {
        name: null,
        tag: null,
        website: null
      },
      communityRepositoryCreateData: {
        name: null,
        kind: null,
        url: null,
        notes: null
      },
      communityRepositoryCreateKindOptions: [{ text: this.$t('mission.repository.kind.arma3sync'), value: 'arma3sync' }, { text: this.$t('mission.repository.kind.other'), value: 'other' }]
    };
  },

  computed: {
    canEditCommunity: function canEditCommunity() {
      return this.$acl.can(['community.' + this.$route.params.communitySlug + '.founder', 'community.' + this.$route.params.communitySlug + '.leader']);
    },
    canEditCommunityMembers: function canEditCommunityMembers() {
      return this.$acl.can(['community.' + this.$route.params.communitySlug + '.founder', 'community.' + this.$route.params.communitySlug + '.leader', 'community.' + this.$route.params.communitySlug + '.recruitment']);
    },
    communityDetails: function communityDetails() {
      return this.$store.getters.communityDetails;
    },
    communityRepositoryChunks: function communityRepositoryChunks() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityDetails)) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["chunk"](this.communityDetails.repositories, 2);
    },
    communityRepositoryCreateKindFeedback: function communityRepositoryCreateKindFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.kind) ? this.$t('mission.feedback.repository.kind') : '';
    },
    communityRepositoryCreateKindState: function communityRepositoryCreateKindState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.kind) ? 'danger' : 'success';
    },
    communityRepositoryCreateNameFeedback: function communityRepositoryCreateNameFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.name) ? this.$t('mission.feedback.repository.name') : '';
    },
    communityRepositoryCreateNameState: function communityRepositoryCreateNameState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.name) ? 'danger' : 'success';
    },
    communityRepositoryCreateNotesFeedback: function communityRepositoryCreateNotesFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.notes)) {
        return this.$t('mission.feedback.repository.urlOrNotes');
      }

      return '';
    },
    communityRepositoryCreateNotesState: function communityRepositoryCreateNotesState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.notes)) {
        return 'danger';
      }

      return 'success';
    },
    communityRepositoryCreateUrlFeedback: function communityRepositoryCreateUrlFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.notes)) {
        return this.$t('mission.feedback.repository.urlOrNotes');
      } else if (this.communityRepositoryCreateData.kind === 'arma3sync' && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url)) {
        return this.$t('mission.feedback.repository.url.arma3sync');
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url)) {
        return '';
      }

      return this.isCommunityRepositoryUrlValid ? '' : this.$t('mission.feedback.repository.url');
    },
    communityRepositoryCreateUrlState: function communityRepositoryCreateUrlState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.notes)) {
        return 'danger';
      } else if (this.communityRepositoryCreateData.kind === 'arma3sync' && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url)) {
        return 'danger';
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url)) {
        return 'success';
      }

      return this.isCommunityRepositoryUrlValid ? 'success' : 'danger';
    },
    isCommunityAdmin: function isCommunityAdmin() {
      return this.$acl.can(['admin.community']);
    },
    isCommunityFounder: function isCommunityFounder() {
      return this.$acl.can(['community.' + this.$route.params.communitySlug + '.founder']);
    },
    isCommunityMember: function isCommunityMember() {
      var user = this.$store.getters.user;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user)) {
        return false;
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](user.community)) {
        return false;
      }

      return user.community.slug === this.$route.params.communitySlug;
    },
    isCommunityRepositoryUrlValid: function isCommunityRepositoryUrlValid() {
      // Taken from: https://stackoverflow.com/a/5717133 @ 2017-08-04 09:43
      var urlPattern = /^((https?|ftp):\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
      return urlPattern.test(this.communityRepositoryCreateData.url);
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    optionalCommunityWebsite: function optionalCommunityWebsite() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](this.communityDetails.website) && !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityDetails.website) ? '<a href="' + this.communityDetails.website + '">' + this.communityDetails.website + '</a>' : '<span class="text-muted font-italic">' + this.$t('misc.notProvided') + '</span>';
    }
  },
  methods: {
    createCommunityRepository: function createCommunityRepository() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.kind) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.name)) {
        return;
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.notes)) {
        return;
      }

      var repositories = __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.communityDetails.repositories);
      repositories.push({
        name: this.communityRepositoryCreateData.name,
        kind: this.communityRepositoryCreateData.kind,
        url: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.url) ? null : this.communityRepositoryCreateData.url,
        notes: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositoryCreateData.notes) ? null : this.communityRepositoryCreateData.notes
      });

      this.$store.dispatch('editCommunity', {
        communitySlug: this.$route.params.communitySlug,
        updatedCommunityDetails: {
          repositories: repositories
        }
      });

      this.communityRepositoryCreateData = {
        name: null,
        kind: null,
        url: null,
        notes: null
      };
    },
    deleteCommunity: function deleteCommunity() {
      this.$store.dispatch('deleteCommunity', { communitySlug: this.$route.params.communitySlug, communityName: this.communityDetails.name });
    },
    removeCommunityRepository: function removeCommunityRepository(index) {
      var repositories = __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.communityDetails.repositories);
      repositories.splice(index, 1);

      this.$store.dispatch('editCommunity', {
        communitySlug: this.$route.params.communitySlug,
        updatedCommunityDetails: {
          repositories: repositories
        }
      });
    }
  },
  watch: {
    communityApplicationsFilter: function communityApplicationsFilter(val) {
      this.$store.dispatch('filterCommunityApplications', { filter: val, communitySlug: this.$route.params.communitySlug });
    }
  }
};

/***/ }),
/* 260 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/CommunityList.vue ***!
  \*************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_communities_CommunityListTable_vue__ = __webpack_require__(/*! ../components/communities/CommunityListTable.vue */ 366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_communities_CommunityListTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_communities_CommunityListTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    CommunityListTable: __WEBPACK_IMPORTED_MODULE_0__components_communities_CommunityListTable_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getCommunities');
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].setTitle(this.$t('nav.communities'));
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearCommunities');
  },
  computed: {
    communities: function communities() {
      return this.$store.getters.communities;
    },
    communityListPageCount: function communityListPageCount() {
      return this.$store.getters.communityListPageCount;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    }
  },
  methods: {
    communityListPaginate: function communityListPaginate(page) {
      this.$store.dispatch('getCommunities', { page: page });
    },
    communitySelected: function communitySelected(item) {
      this.$router.push({ name: 'communityDetails', params: { communitySlug: item.value.slug } });
    }
  }
};

/***/ }),
/* 261 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home.vue ***!
  \****************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Calendar_vue__ = __webpack_require__(/*! ../components/Calendar.vue */ 345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Calendar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Calendar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_FAQ_de_vue__ = __webpack_require__(/*! ../i18n/views/FAQ.de.vue */ 433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_FAQ_de_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_views_FAQ_de_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_views_FAQ_en_vue__ = __webpack_require__(/*! ../i18n/views/FAQ.en.vue */ 434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_views_FAQ_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__i18n_views_FAQ_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_views_Home_de_vue__ = __webpack_require__(/*! ../i18n/views/Home.de.vue */ 435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_views_Home_de_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__i18n_views_Home_de_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_views_Home_en_vue__ = __webpack_require__(/*! ../i18n/views/Home.en.vue */ 436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_views_Home_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__i18n_views_Home_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_0__components_Calendar_vue___default.a,
    FaqDe: __WEBPACK_IMPORTED_MODULE_1__i18n_views_FAQ_de_vue___default.a,
    FaqEn: __WEBPACK_IMPORTED_MODULE_2__i18n_views_FAQ_en_vue___default.a,
    HomeDe: __WEBPACK_IMPORTED_MODULE_3__i18n_views_Home_de_vue___default.a,
    HomeEn: __WEBPACK_IMPORTED_MODULE_4__i18n_views_Home_en_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].clearTitle();
  }
};

/***/ }),
/* 262 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/Imprint.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_Imprint_de_vue__ = __webpack_require__(/*! ../i18n/views/Imprint.de.vue */ 437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_Imprint_de_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__i18n_views_Imprint_de_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_Imprint_en_vue__ = __webpack_require__(/*! ../i18n/views/Imprint.en.vue */ 438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_Imprint_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_views_Imprint_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ImprintDe: __WEBPACK_IMPORTED_MODULE_0__i18n_views_Imprint_de_vue___default.a,
    ImprintEn: __WEBPACK_IMPORTED_MODULE_1__i18n_views_Imprint_en_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(this.$t('nav.imprint'));
  }
};

/***/ }),
/* 263 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/Login.vue ***!
  \*****************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_Login_de_vue__ = __webpack_require__(/*! ../i18n/views/Login.de.vue */ 439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_Login_de_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__i18n_views_Login_de_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_Login_en_vue__ = __webpack_require__(/*! ../i18n/views/Login.en.vue */ 440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_Login_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_views_Login_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    LoginDe: __WEBPACK_IMPORTED_MODULE_0__i18n_views_Login_de_vue___default.a,
    LoginEn: __WEBPACK_IMPORTED_MODULE_1__i18n_views_Login_en_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getLoginRedirectUrl');

    if (__WEBPACK_IMPORTED_MODULE_2_lodash__["has"](this.$route.query, 'openid.claimed_id')) {
      var url = "https://slotlist.walthex.com" + this.$route.fullPath;
      this.$store.dispatch('performLogin', url);
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].setTitle(this.$t('nav.login'));
  }
};

/***/ }),
/* 264 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/MissionCreator.vue ***!
  \**************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(/*! ../utils */ 3);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      descriptionEditorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'align': [] }, { 'indent': '-1' }, { 'indent': '+1' }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link', 'image', 'video'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      },
      editorOptions: {
        modules: {
          toolbar: [[{ 'size': ['small', false, 'large', 'huge'] }, { 'header': 1 }, { 'header': 2 }, { 'color': [] }], ['bold', 'italic'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link'], ['clean']],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageResize: {
            modules: ['Resize', 'DisplaySize']
          }
        },
        theme: 'snow'
      },
      missionCreateTitle: null,
      missionCreateSlug: null,
      missionCreateDescription: null,
      missionCreatecollapsedDescription: null,
      missionCreateDetailedDescription: null,
      missionCreateSlottingTime: null,
      missionCreateStartTime: null,
      missionCreateEndTime: null,
      missionCreateBriefingTime: null,
      missionCreateTechSupport: null,
      missionCreateRules: null,
      missionCreateGameServerHostname: null,
      missionCreateGameServerName: null,
      missionCreateGameServerPort: null,
      missionCreateGameServerPassword: null,
      missionCreateVoiceCommsHostname: null,
      missionCreateVoiceCommsName: null,
      missionCreateVoiceCommsPort: null,
      missionCreateVoiceCommsPassword: null,
      missionCreateCommunityGameServersSelected: null,
      missionCreateCommunityVoiceCommsSelected: null,
      missionCreateAddToCommunity: true,
      missionCreateSlotsAutoAssignable: false,
      missionCreateRequiredDLCs: {
        aow: false,
        apex: false,
        contact: false,
        csla: false,
        gm: false,
        helicopters: false,
        jets: false,
        karts: false,
        lawsofwar: false,
        marksmen: false,
        tacops: false,
        tanks: false,
        vn: false
      },
      missionCreateVisibility: 'hidden'
    };
  },

  computed: {
    communityGameServers: function communityGameServers() {
      return this.$store.getters.communityGameServers;
    },
    communityVoiceComms: function communityVoiceComms() {
      return this.$store.getters.communityVoiceComms;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    missionCreateTitleState: function missionCreateTitleState() {
      return _.isNil(this.missionCreateTitle) || _.isEmpty(this.missionCreateTitle) ? 'danger' : 'success';
    },
    missionCreateTitleFeedback: function missionCreateTitleFeedback() {
      return _.isNil(this.missionCreateTitle) || _.isEmpty(this.missionCreateTitle) ? this.$t('mission.feedback.title') : '';
    },
    missionCreateSlugState: function missionCreateSlugState() {
      if (_.isNil(this.missionCreateSlug) || _.isEmpty(this.missionCreateSlug)) {
        return 'danger';
      } else if (this.checkingMissionSlugAvailability) {
        return 'warning';
      } else if (!this.missionSlugAvailable) {
        return 'danger';
      }

      return 'success';
    },
    missionCreateSlugFeedback: function missionCreateSlugFeedback() {
      if (_.isNil(this.missionCreateSlug) || _.isEmpty(this.missionCreateSlug)) {
        return this.$t('mission.feedback.slug');
      } else if (this.checkingMissionSlugAvailability) {
        return this.$t('mission.feedback.slug.checking');
      } else if (!this.missionSlugAvailable) {
        return this.$t('mission.feedback.slug.notAvailable');
      }

      return '';
    },
    missionCreateSlugAvailable: function missionCreateSlugAvailable() {
      if (this.checkingMissionSlugAvailability) {
        return '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
      } else if (this.missionSlugAvailable) {
        return '<i class="fa fa-check" aria-hidden="true"></i>';
      }

      return '<i class="fa fa-close" aria-hidden="true"></i>';
    },
    checkingMissionSlugAvailability: function checkingMissionSlugAvailability() {
      return this.$store.getters.checkingMissionSlugAvailability;
    },
    missionSlugAvailable: function missionSlugAvailable() {
      return this.$store.getters.missionSlugAvailable;
    },
    missionCreateAddToCommunityDescription: function missionCreateAddToCommunityDescription() {
      return this.$t('mission.creator.addToCommunity.description', { communityInfo: '[' + this.user.community.tag + '] ' + this.user.community.name });
    },
    missionCreateDescriptionState: function missionCreateDescriptionState() {
      return _.isNil(this.missionCreateDescription) || _.isEmpty(this.missionCreateDescription) ? 'danger' : 'success';
    },
    missionCreateDescriptionFeedback: function missionCreateDescriptionFeedback() {
      return _.isNil(this.missionCreateDescription) || _.isEmpty(this.missionCreateDescription) ? this.$t('mission.feedback.description') : '';
    },
    missionCreateDetailedDescriptionState: function missionCreateDetailedDescriptionState() {
      return _.isNil(this.missionCreateDetailedDescription) || _.isEmpty(this.missionCreateDetailedDescription) ? 'danger' : 'success';
    },
    missionCreateDetailedDescriptionFeedback: function missionCreateDetailedDescriptionFeedback() {
      return _.isNil(this.missionCreateDetailedDescription) || _.isEmpty(this.missionCreateDetailedDescription) ? this.$t('mission.feedback.detailedDescription') : '';
    },
    missionCreateCommunityGameServers: function missionCreateCommunityGameServers() {
      if (_.isNil(this.communityGameServers) || _.isEmpty(this.communityGameServers)) {
        return [];
      }

      var servers = [];
      _.each(this.communityGameServers, function (gameServer, index) {
        var name = _.isNil(gameServer.name) ? '' : ' - ' + gameServer.name;
        servers.push({
          text: gameServer.hostname + ':' + gameServer.port + name,
          value: index
        });
      });

      return servers;
    },
    missionCreateGameServerHostnameFeedback: function missionCreateGameServerHostnameFeedback() {
      return (_.isNil(this.missionCreateGameServerHostname) || _.isEmpty(this.missionCreateGameServerHostname)) && !_.isNil(this.missionCreateGameServerPort) && !_.isEmpty(this.missionCreateGameServerPort) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionCreateGameServerHostnameState: function missionCreateGameServerHostnameState() {
      return (_.isNil(this.missionCreateGameServerHostname) || _.isEmpty(this.missionCreateGameServerHostname)) && !_.isNil(this.missionCreateGameServerPort) && !_.isEmpty(this.missionCreateGameServerPort) ? 'danger' : 'success';
    },
    missionCreateGameServerPortFeedback: function missionCreateGameServerPortFeedback() {
      var port = parseInt(this.missionCreateGameServerPort);
      if (port < 0 || port > 65535) {
        return this.$t('mission.feedback.serverInfo.portRange');
      }

      return (_.isNil(this.missionCreateGameServerPort) || _.isEmpty(this.missionCreateGameServerPort)) && !_.isNil(this.missionCreateGameServerHostname) && !_.isEmpty(this.missionCreateGameServerHostname) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionCreateGameServerPortState: function missionCreateGameServerPortState() {
      var port = parseInt(this.missionCreateGameServerPort);
      if (port < 0 || port > 65535) {
        return 'danger';
      }

      return (_.isNil(this.missionCreateGameServerPort) || _.isEmpty(this.missionCreateGameServerPort)) && !_.isNil(this.missionCreateGameServerHostname) && !_.isEmpty(this.missionCreateGameServerHostname) ? 'danger' : 'success';
    },
    missionCreateCommunityVoiceComms: function missionCreateCommunityVoiceComms() {
      if (_.isNil(this.communityVoiceComms) || _.isEmpty(this.communityVoiceComms)) {
        return [];
      }

      var servers = [];
      _.each(this.communityVoiceComms, function (voiceComms, index) {
        var name = _.isNil(voiceComms.name) ? '' : ' - ' + voiceComms.name;
        servers.push({
          text: voiceComms.hostname + ':' + voiceComms.port + name,
          value: index
        });
      });

      return servers;
    },
    missionCreateVoiceCommsHostnameFeedback: function missionCreateVoiceCommsHostnameFeedback() {
      return (_.isNil(this.missionCreateVoiceCommsHostname) || _.isEmpty(this.missionCreateVoiceCommsHostname)) && !_.isNil(this.missionCreateVoiceCommsPort) && !_.isEmpty(this.missionCreateVoiceCommsPort) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionCreateVoiceCommsHostnameState: function missionCreateVoiceCommsHostnameState() {
      return (_.isNil(this.missionCreateVoiceCommsHostname) || _.isEmpty(this.missionCreateVoiceCommsHostname)) && !_.isNil(this.missionCreateVoiceCommsPort) && !_.isEmpty(this.missionCreateVoiceCommsPort) ? 'danger' : 'success';
    },
    missionCreateVoiceCommsPortFeedback: function missionCreateVoiceCommsPortFeedback() {
      var port = parseInt(this.missionCreateVoiceCommsPort);
      if (port < 0 || port > 65535) {
        return this.$t('mission.feedback.serverInfo.portRange');
      }

      return (_.isNil(this.missionCreateVoiceCommsPort) || _.isEmpty(this.missionCreateVoiceCommsPort)) && !_.isNil(this.missionCreateVoiceCommsHostname) && !_.isEmpty(this.missionCreateVoiceCommsHostname) ? this.$t('mission.feedback.serverInfo.hostnamePort') : '';
    },
    missionCreateVoiceCommsPortState: function missionCreateVoiceCommsPortState() {
      var port = parseInt(this.missionCreateVoiceCommsPort);
      if (port < 0 || port > 65535) {
        return 'danger';
      }

      return (_.isNil(this.missionCreateVoiceCommsPort) || _.isEmpty(this.missionCreateVoiceCommsPort)) && !_.isNil(this.missionCreateVoiceCommsHostname) && !_.isEmpty(this.missionCreateVoiceCommsHostname) ? 'danger' : 'success';
    },
    missionCreateSlottingTimeState: function missionCreateSlottingTimeState() {
      return _.isNil(this.missionCreateSlottingTime) || _.isEmpty(this.missionCreateSlottingTime) || !__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateSlottingTime).isValid() ? 'danger' : 'success';
    },
    missionCreateSlottingTimeFeedback: function missionCreateSlottingTimeFeedback() {
      return _.isNil(this.missionCreateSlottingTime) || _.isEmpty(this.missionCreateSlottingTime) || !__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateSlottingTime).isValid() ? this.$t('mission.feedback.dateTime') : '';
    },
    missionCreateStartTimeState: function missionCreateStartTimeState() {
      if (_.isNil(this.missionCreateStartTime) || _.isEmpty(this.missionCreateStartTime)) {
        return 'danger';
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateStartTime);
      if (!startTime.isValid()) {
        return 'danger';
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateSlottingTime);
      if (!slottingTime.isValid()) {
        return 'danger';
      }

      if (startTime < slottingTime) {
        return 'danger';
      }

      return 'success';
    },
    missionCreateStartTimeFeedback: function missionCreateStartTimeFeedback() {
      if (_.isNil(this.missionCreateStartTime) || _.isEmpty(this.missionCreateStartTime)) {
        return this.$t('mission.feedback.dateTime');
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateStartTime);
      if (!startTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      var slottingTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateSlottingTime);
      if (!slottingTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      if (startTime < slottingTime) {
        return this.$t('mission.feedback.dateTime.afterSlotting');
      }

      return '';
    },
    missionCreateEndTimeState: function missionCreateEndTimeState() {
      if (_.isNil(this.missionCreateEndTime) || _.isEmpty(this.missionCreateEndTime)) {
        return 'danger';
      }

      var endTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateEndTime);
      if (!endTime.isValid()) {
        return 'danger';
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateStartTime);
      if (!startTime.isValid()) {
        return 'danger';
      }

      if (endTime < startTime) {
        return 'danger';
      }

      return 'success';
    },
    missionCreateEndTimeFeedback: function missionCreateEndTimeFeedback() {
      if (_.isNil(this.missionCreateEndTime) || _.isEmpty(this.missionCreateEndTime)) {
        return this.$t('mission.feedback.dateTime');
      }

      var endTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateEndTime);
      if (!endTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateStartTime);
      if (!startTime.isValid()) {
        return this.$t('mission.feedback.dateTime');
      }

      if (endTime < startTime) {
        return this.$t('mission.feedback.dateTime.afterStart');
      }

      return '';
    },
    missionCreateBriefingTimeState: function missionCreateBriefingTimeState() {
      return _.isNil(this.missionCreateBriefingTime) || _.isEmpty(this.missionCreateBriefingTime) || !__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateBriefingTime).isValid() ? 'danger' : 'success';
    },
    missionCreateBriefingTimeFeedback: function missionCreateBriefingTimeFeedback() {
      return _.isNil(this.missionCreateBriefingTime) || _.isEmpty(this.missionCreateBriefingTime) || !__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateBriefingTime).isValid() ? this.$t('mission.feedback.dateTime') : '';
    },
    missionCreateTechSupportState: function missionCreateTechSupportState() {
      return 'success';
    },
    missionCreateTechSupportFeedback: function missionCreateTechSupportFeedback() {
      return '';
    },
    missionCreateRulesState: function missionCreateRulesState() {
      return 'success';
    },
    missionCreateRulesFeedback: function missionCreateRulesFeedback() {
      return '';
    },
    missionCreateAddToCommunityState: function missionCreateAddToCommunityState() {
      return 'success';
    },
    missionCreateAddToCommunityFeedback: function missionCreateAddToCommunityFeedback() {
      return '';
    },
    missionCreateVisibilityState: function missionCreateVisibilityState() {
      return _.isNil(this.missionCreateVisibility) || _.isEmpty(this.missionCreateVisibility) ? 'danger' : 'success';
    },
    missionCreateVisibilityFeedback: function missionCreateVisibilityFeedback() {
      return _.isNil(this.missionCreateVisibility) || _.isEmpty(this.missionCreateVisibility) ? this.$t('mission.feedback.visibility') : '';
    },
    missionCreateVisibilityOptions: function missionCreateVisibilityOptions() {
      var options = [{
        text: this.$t('mission.visibility.hidden'),
        value: 'hidden'
      }, {
        text: this.$t('mission.visibility.private'),
        value: 'private'
      }, {
        text: this.$t('mission.visibility.public'),
        value: 'public'
      }];

      if (!_.isNil(this.user.community)) {
        options = [{
          text: this.$t('mission.visibility.community'),
          value: 'community'
        }].concat(_toConsumableArray(options));
      }

      return options;
    }
  },
  methods: {
    missionCreateTitleFormatter: function missionCreateTitleFormatter(val) {
      if (_.isNil(this.missionCreateSlug) || _.isEmpty(this.missionCreateSlug)) {
        this.missionCreateSlug = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].slug(val);
        this.$store.dispatch('checkMissionSlugAvailability', this.missionCreateSlug);
      }
      return val;
    },
    missionCreateSlottingTimeBlur: function missionCreateSlottingTimeBlur() {
      if (_.isNil(this.missionCreateSlottingTime)) {
        return;
      }

      if (_.isNil(this.missionCreateStartTime)) {
        this.missionCreateStartTime = this.missionCreateSlottingTime;
      }
      if (_.isNil(this.missionCreateEndTime)) {
        this.missionCreateEndTime = this.missionCreateSlottingTime;
      }
      if (_.isNil(this.missionCreateBriefingTime)) {
        this.missionCreateBriefingTime = this.missionCreateSlottingTime;
      }
    },
    missionCreateSlugFormatter: function missionCreateSlugFormatter(val) {
      if (!_.isNil(this.missionCreateSlug) && !_.isEmpty(this.missionCreateSlug)) {
        this.$store.dispatch('checkMissionSlugAvailability', this.missionCreateSlug);
      }

      return val;
    },
    missionCreateTimeFormatter: function missionCreateTimeFormatter(val) {
      return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(val).format('Y-MM-DD HH:mm');
    },
    submitMissionCreate: function submitMissionCreate() {
      var _this = this;

      var gameServer = null;
      var gameServerPort = parseInt(this.missionCreateGameServerPort);
      if (_.isString(this.missionCreateGameServerHostname) && !_.isEmpty(this.missionCreateGameServerHostname) && _.isFinite(gameServerPort) && gameServerPort >= 0 && gameServerPort <= 65535) {
        gameServer = {
          hostname: this.missionCreateGameServerHostname,
          port: gameServerPort,
          name: _.isString(this.missionCreateGameServerName) && !_.isEmpty(this.missionCreateGameServerName) ? this.missionCreateGameServerName : null,
          password: _.isString(this.missionCreateGameServerPassword) && !_.isEmpty(this.missionCreateGameServerPassword) ? this.missionCreateGameServerPassword : null
        };
      }

      var voiceComms = null;
      var voiceCommsPort = parseInt(this.missionCreateVoiceCommsPort);
      if (_.isString(this.missionCreateVoiceCommsHostname) && !_.isEmpty(this.missionCreateVoiceCommsHostname) && _.isFinite(voiceCommsPort) && voiceCommsPort >= 0 && voiceCommsPort <= 65535) {
        voiceComms = {
          hostname: this.missionCreateVoiceCommsHostname,
          port: voiceCommsPort,
          name: _.isString(this.missionCreateVoiceCommsName) && !_.isEmpty(this.missionCreateVoiceCommsName) ? this.missionCreateVoiceCommsName : null,
          password: _.isString(this.missionCreateVoiceCommsPassword) && !_.isEmpty(this.missionCreateVoiceCommsPassword) ? this.missionCreateVoiceCommsPassword : null
        };
      }

      var missionRequiredDLCs = [];
      _.each(_.keys(this.missionCreateRequiredDLCs), function (dlc) {
        if (!_this.missionCreateRequiredDLCs[dlc]) {
          return;
        }

        if (dlc === 'lawsofwar') {
          missionRequiredDLCs.push('laws-of-war');
        } else if (dlc === 'tacops') {
          missionRequiredDLCs.push('tac-ops');
        } else {
          missionRequiredDLCs.push(dlc);
        }
      });

      var missionDetails = {
        title: this.missionCreateTitle,
        slug: this.missionCreateSlug,
        description: this.missionCreateDescription,
        collapsedDescription: this.missionCreatecollapsedDescription,
        detailedDescription: this.missionCreateDetailedDescription,
        slottingTime: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateSlottingTime).utc().format(),
        startTime: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateStartTime).utc().format(),
        endTime: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateEndTime).utc().format(),
        briefingTime: __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(this.missionCreateBriefingTime).utc().format(),
        techSupport: this.missionCreateTechSupport,
        rules: this.missionCreateRules,
        gameServer: gameServer,
        voiceComms: voiceComms,
        addToCommunity: this.missionCreateAddToCommunity,
        slotsAutoAssignable: this.missionCreateSlotsAutoAssignable,
        requiredDLCs: missionRequiredDLCs,
        visibility: this.missionCreateVisibility
      };

      if (_.isEmpty(missionDetails.collapsedDescription)) {
        missionDetails.collapsedDescription = null;
      }
      if (_.isEmpty(missionDetails.techSupport)) {
        missionDetails.techSupport = null;
      }
      if (_.isEmpty(missionDetails.rules)) {
        missionDetails.rules = null;
      }

      this.$store.dispatch('createMission', missionDetails);
    }
  },
  watch: {
    missionCreateCommunityGameServersSelected: function missionCreateCommunityGameServersSelected(val) {
      var server = this.communityGameServers[val];
      if (_.isNil(server)) {
        return;
      }

      this.missionCreateGameServerHostname = server.hostname;
      this.missionCreateGameServerPort = '' + server.port;
      this.missionCreateGameServerName = server.name;
      this.missionCreateGameServerPassword = server.password;
    },
    missionCreateCommunityVoiceCommsSelected: function missionCreateCommunityVoiceCommsSelected(val) {
      var server = this.communityVoiceComms[val];
      if (_.isNil(server)) {
        return;
      }

      this.missionCreateVoiceCommsHostname = server.hostname;
      this.missionCreateVoiceCommsPort = '' + server.port;
      this.missionCreateVoiceCommsName = server.name;
      this.missionCreateVoiceCommsPassword = server.password;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].setTitle(this.$t('mission.creator.title.browser'));

    if (!_.isNil(this.user) && !_.isNil(this.user.community)) {
      this.$store.dispatch('getCommunityServers', { communitySlug: this.user.community.slug });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearCommunityServers');
  }
};

/***/ }),
/* 265 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/MissionDetails.vue ***!
  \**************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(/*! file-saver */ 315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_missions_modals_MissionAccessModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionAccessModal.vue */ 407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_missions_modals_MissionAccessModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_missions_modals_MissionAccessModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_missions_modals_MissionApplySlotTemplateModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionApplySlotTemplateModal.vue */ 408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_missions_modals_MissionApplySlotTemplateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_missions_modals_MissionApplySlotTemplateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_missions_modals_MissionBannerImageModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionBannerImageModal.vue */ 409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_missions_modals_MissionBannerImageModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_missions_modals_MissionBannerImageModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_missions_modals_MissionConvertToSlotTemplateModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionConvertToSlotTemplateModal.vue */ 410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_missions_modals_MissionConvertToSlotTemplateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_missions_modals_MissionConvertToSlotTemplateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_missions_modals_MissionDuplicateModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionDuplicateModal.vue */ 411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_missions_modals_MissionDuplicateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_missions_modals_MissionDuplicateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_missions_modals_MissionEditModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionEditModal.vue */ 412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_missions_modals_MissionEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_missions_modals_MissionEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_missions_modals_MissionPermissionModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionPermissionModal.vue */ 414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_missions_modals_MissionPermissionModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_missions_modals_MissionPermissionModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_missions_modals_MissionSlotAssignModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotAssignModal.vue */ 415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_missions_modals_MissionSlotAssignModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_missions_modals_MissionSlotAssignModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_missions_modals_MissionSlotCreateModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotCreateModal.vue */ 416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_missions_modals_MissionSlotCreateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_missions_modals_MissionSlotCreateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_missions_modals_MissionSlotDetailsModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotDetailsModal.vue */ 417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_missions_modals_MissionSlotDetailsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_missions_modals_MissionSlotDetailsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_missions_modals_MissionSlotEditModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotEditModal.vue */ 418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_missions_modals_MissionSlotEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_missions_modals_MissionSlotEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_missions_modals_MissionSlotGroupCreateModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotGroupCreateModal.vue */ 419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_missions_modals_MissionSlotGroupCreateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_missions_modals_MissionSlotGroupCreateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_missions_modals_MissionSlotGroupEditModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotGroupEditModal.vue */ 420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_missions_modals_MissionSlotGroupEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_missions_modals_MissionSlotGroupEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_missions_MissionSlotlist_vue__ = __webpack_require__(/*! components/missions/MissionSlotlist.vue */ 403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_missions_MissionSlotlist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_missions_MissionSlotlist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_missions_modals_MissionSlotRegistrationModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotRegistrationModal.vue */ 421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_missions_modals_MissionSlotRegistrationModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_missions_modals_MissionSlotRegistrationModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_missions_modals_MissionSlotSelectionEditModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionSlotSelectionEditModal.vue */ 422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_missions_modals_MissionSlotSelectionEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_missions_modals_MissionSlotSelectionEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_missions_modals_MissionEmbedModal_vue__ = __webpack_require__(/*! components/missions/modals/MissionEmbedModal.vue */ 413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_missions_modals_MissionEmbedModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_missions_modals_MissionEmbedModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionAccessModal: __WEBPACK_IMPORTED_MODULE_3_components_missions_modals_MissionAccessModal_vue___default.a,
    MissionApplySlotTemplateModal: __WEBPACK_IMPORTED_MODULE_4_components_missions_modals_MissionApplySlotTemplateModal_vue___default.a,
    MissionBannerImageModal: __WEBPACK_IMPORTED_MODULE_5_components_missions_modals_MissionBannerImageModal_vue___default.a,
    MissionConvertToSlotTemplateModal: __WEBPACK_IMPORTED_MODULE_6_components_missions_modals_MissionConvertToSlotTemplateModal_vue___default.a,
    MissionDuplicateModal: __WEBPACK_IMPORTED_MODULE_7_components_missions_modals_MissionDuplicateModal_vue___default.a,
    MissionEditModal: __WEBPACK_IMPORTED_MODULE_8_components_missions_modals_MissionEditModal_vue___default.a,
    MissionPermissionModal: __WEBPACK_IMPORTED_MODULE_9_components_missions_modals_MissionPermissionModal_vue___default.a,
    MissionSlotAssignModal: __WEBPACK_IMPORTED_MODULE_10_components_missions_modals_MissionSlotAssignModal_vue___default.a,
    MissionSlotCreateModal: __WEBPACK_IMPORTED_MODULE_11_components_missions_modals_MissionSlotCreateModal_vue___default.a,
    MissionSlotDetailsModal: __WEBPACK_IMPORTED_MODULE_12_components_missions_modals_MissionSlotDetailsModal_vue___default.a,
    MissionSlotEditModal: __WEBPACK_IMPORTED_MODULE_13_components_missions_modals_MissionSlotEditModal_vue___default.a,
    MissionSlotGroupCreateModal: __WEBPACK_IMPORTED_MODULE_14_components_missions_modals_MissionSlotGroupCreateModal_vue___default.a,
    MissionSlotGroupEditModal: __WEBPACK_IMPORTED_MODULE_15_components_missions_modals_MissionSlotGroupEditModal_vue___default.a,
    MissionSlotlist: __WEBPACK_IMPORTED_MODULE_16_components_missions_MissionSlotlist_vue___default.a,
    MissionSlotRegistrationModal: __WEBPACK_IMPORTED_MODULE_17_components_missions_modals_MissionSlotRegistrationModal_vue___default.a,
    MissionSlotSelectionEditModal: __WEBPACK_IMPORTED_MODULE_18_components_missions_modals_MissionSlotSelectionEditModal_vue___default.a,
    MissionEmbedModal: __WEBPACK_IMPORTED_MODULE_19_components_missions_modals_MissionEmbedModal_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getMissionDetails', { missionSlug: this.$route.params.missionSlug });
    this.$store.dispatch('getMissionSlotlist', { missionSlug: this.$route.params.missionSlug });
  },
  created: function created() {
    this.missionSlotlistFilter = this.$store.getters.missionSlotlistFilter;
    this.missionSlotlistRequiredDLCsFilter = this.$store.getters.missionSlotlistRequiredDLCsFilter;
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearMissionDetails');
    this.$store.dispatch('clearCommunityServers');
    this.$store.dispatch('clearCommunityRepositories');
  },
  data: function data() {
    return {
      missionRepositoryCreateData: {
        name: null,
        kind: null,
        url: null,
        notes: null
      },
      missionRepositoryCreateKindOptions: [{ text: this.$t('mission.repository.kind.arma3sync'), value: 'arma3sync' }, { text: this.$t('mission.repository.kind.other'), value: 'other' }],
      missionSlotlistFilter: [],
      missionSlotlistRequiredDLCsFilter: [],
      communityRepositoriesSelected: null,
      missionCollapsedDescriptionExtended: false,
      missionRepositoriesExtended: false
    };
  },

  computed: {
    communityRepositories: function communityRepositories() {
      return this.$store.getters.communityRepositories;
    },
    communityRepositoryOptions: function communityRepositoryOptions() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.communityRepositories) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.communityRepositories)) {
        return [];
      }

      var repositories = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](this.communityRepositories, function (repository, index) {
        var kind = repository.kind === 'arma3sync' ? _this.$t('mission.repository.kind.arma3sync') : _this.$t('mission.repository.kind.other');
        repositories.push({
          text: kind + ' - ' + repository.name + ' - ' + (repository.url ? repository.url : _this.$t('mission.repository.url.empty')),
          value: index
        });
      });

      return repositories;
    },
    formattedMissionVisibility: function formattedMissionVisibility() {
      switch (this.missionDetails.visibility) {
        case 'community':
          return '<span class="text-primary"><i class="fa fa-users" aria-hidden="true"></i> ' + this.$t('mission.visibility.community') + '</span>';
        case 'hidden':
          return '<span class="text-danger"><i class="fa fa-edit" aria-hidden="true"></i> ' + this.$t('mission.visibility.hidden') + '</span>';
        case 'private':
          return '<span class="text-warning"><i class="fa fa-user-secret" aria-hidden="true"></i> ' + this.$t('mission.visibility.private') + '</span>';
        case 'public':
          return '<span class="text-success"><i class="fa fa-globe" aria-hidden="true"></i> ' + this.$t('mission.visibility.public') + '</span>';
        default:
          return '<span class="text-muted font-italic"><i class="fa fa-question-circle" aria-hidden="true"></i> ' + this.$t('mission.visibility.default') + '</span>';
      }
    },
    gameServerHostnamePort: function gameServerHostnamePort() {
      return this.missionDetails.gameServer.hostname + ':' + this.missionDetails.gameServer.port;
    },
    hasMissionEnded: function hasMissionEnded() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime));
    },
    haveMissionSlotsAnyRequiredDLCs: function haveMissionSlotsAnyRequiredDLCs() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotGroups)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](this.missionSlotGroups, function (slotGroup) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](slotGroup.slots, function (slot) {
          return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](slot.requiredDLCs);
        });
      });
    },
    isCommunityMember: function isCommunityMember() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.user)) {
        return false;
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.user.community)) {
        return false;
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails.community)) {
        return false;
      }

      return this.user.community.slug === this.missionDetails.community.slug;
    },
    isMissionCreator: function isMissionCreator() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator']);
    },
    isMissionEditor: function isMissionEditor() {
      return this.$acl.can(['mission.' + this.$route.params.missionSlug + '.creator', 'mission.' + this.$route.params.missionSlug + '.editor']);
    },
    isMissionRepositoryUrlValid: function isMissionRepositoryUrlValid() {
      // Taken from: https://stackoverflow.com/a/5717133 @ 2017-08-04 09:43
      var urlPattern = /^((https?|ftp):\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
      return urlPattern.test(this.missionRepositoryCreateData.url);
    },
    isMissionCollapsedDescriptionExtended: function isMissionCollapsedDescriptionExtended() {
      return this.missionCollapsedDescriptionExtended;
    },
    isPrivateMission: function isPrivateMission() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return false;
      }

      return this.missionDetails.visibility === 'private';
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionDetails: function missionDetails() {
      return this.$store.getters.missionDetails;
    },
    missionRepositoryChunks: function missionRepositoryChunks() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["chunk"](this.missionDetails.repositories, 2);
    },
    missionRepositoryCreateKindFeedback: function missionRepositoryCreateKindFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.kind) ? this.$t('mission.feedback.repository.kind') : '';
    },
    missionRepositoryCreateKindState: function missionRepositoryCreateKindState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.kind) ? 'danger' : 'success';
    },
    missionRepositoryCreateNameFeedback: function missionRepositoryCreateNameFeedback() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.name) ? this.$t('mission.feedback.repository.name') : '';
    },
    missionRepositoryCreateNameState: function missionRepositoryCreateNameState() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.name) ? 'danger' : 'success';
    },
    missionRepositoryCreateNotesFeedback: function missionRepositoryCreateNotesFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.notes)) {
        return this.$t('mission.feedback.repository.urlOrNotes');
      }

      return '';
    },
    missionRepositoryCreateNotesState: function missionRepositoryCreateNotesState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.notes)) {
        return 'danger';
      }

      return 'success';
    },
    missionRepositoryCreateUrlFeedback: function missionRepositoryCreateUrlFeedback() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.notes)) {
        return this.$t('mission.feedback.repository.urlOrNotes');
      } else if (this.missionRepositoryCreateData.kind === 'arma3sync' && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url)) {
        return this.$t('mission.feedback.repository.url.arma3sync');
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url)) {
        return '';
      }

      return this.isMissionRepositoryUrlValid ? '' : this.$t('mission.feedback.repository.url');
    },
    missionRepositoryCreateUrlState: function missionRepositoryCreateUrlState() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.notes)) {
        return 'danger';
      } else if (this.missionRepositoryCreateData.kind === 'arma3sync' && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url)) {
        return 'danger';
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url)) {
        return 'success';
      }

      return this.isMissionRepositoryUrlValid ? 'success' : 'danger';
    },
    missionRequiredDLCs: function missionRequiredDLCs() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionDetails)) {
        return [];
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionDetails.requiredDLCs)) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["map"](this.missionDetails.requiredDLCs, function (requiredDLC) {
        return 'https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/' + requiredDLC.toLowerCase() + '.png';
      });
    },
    missionSlotGroups: function missionSlotGroups() {
      return this.$store.getters.missionSlotGroups;
    },
    optionalRules: function optionalRules() {
      return this.missionDetails.rules || '<div class=\'text-muted font-italic\'>' + this.$t('misc.notSpecified') + '</div>';
    },
    optionalTechSupport: function optionalTechSupport() {
      return this.missionDetails.techSupport || '<div class=\'text-muted font-italic\'>' + this.$t('misc.notProvided') + '</div>';
    },
    user: function user() {
      return this.$store.getters.user;
    },
    timezone: function timezone() {
      return this.$store.getters.timezone;
    },
    voiceCommsHostnamePort: function voiceCommsHostnamePort() {
      return this.missionDetails.voiceComms.hostname + ':' + this.missionDetails.voiceComms.port;
    }
  },
  methods: {
    createMissionRepository: function createMissionRepository() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.kind) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.name)) {
        return;
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url) && __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.notes)) {
        return;
      }

      var repositories = __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.missionDetails.repositories);
      repositories.push({
        name: this.missionRepositoryCreateData.name,
        kind: this.missionRepositoryCreateData.kind,
        url: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.url) ? null : this.missionRepositoryCreateData.url,
        notes: __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.missionRepositoryCreateData.notes) ? null : this.missionRepositoryCreateData.notes
      });

      this.$store.dispatch('editMission', {
        missionSlug: this.$route.params.missionSlug,
        updatedMissionDetails: {
          repositories: repositories
        },
        missionTitle: this.missionDetails.title
      });

      this.missionRepositoryCreateData = {
        name: null,
        kind: null,
        url: null,
        notes: null
      };

      this.communityRepositoriesSelected = null;
    },
    deleteMission: function deleteMission() {
      this.$store.dispatch('deleteMission', {
        missionSlug: this.$route.params.missionSlug,
        missionTitle: this.missionDetails.title
      });
    },
    downloadICalFile: function downloadICalFile(beginTime) {
      var data = 'BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//slotlist.info//slotlist-frontend v' + "1.1.1" + '//EN\r\n';
      data += 'CALSCALE:GREGORIAN\r\nMETHOD:PUBLIC\r\nX-WR-CALNAME:slotlist.info\r\nX-ORIGINAL-URL:' + "https://slotlist.walthex.com" + '\r\n';
      data += 'X-WR-CALDESC:' + this.$t('title.browser') + '\r\nBEGIN:VEVENT\r\n';
      data += 'UID:' + this.missionDetails.slug + '@' + "https://slotlist.walthex.com" + '\r\n';
      data += 'DTSTART;TZID=' + this.$store.getters.timezone + ':' + __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(beginTime).format('YMMDD[T]HHmmss') + '\r\n';
      data += 'DTEND;TZID=' + this.$store.getters.timezone + ':' + __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime).format('YMMDD[T]HHmmss') + '\r\n';
      data += 'DTSTAMP:' + __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().format('YMMDD[T]HHmmss') + '\r\n';
      data += 'SUMMARY:' + this.missionDetails.title + '\r\n';
      data += 'DESCRIPTION:' + this.$t('mission.details') + ': ' + "https://slotlist.walthex.com" + '/missions/' + this.missionDetails.slug + ' \\n \\n';
      data += this.$t('mission.times.ical', {
        start: this.formatDateTime(this.missionDetails.startTime),
        briefing: this.formatDateTime(this.missionDetails.briefingTime),
        slotting: this.formatDateTime(this.missionDetails.slottingTime),
        end: this.formatDateTime(this.missionDetails.endTime)
      }) + ' \\n \\n';
      data += this.missionDetails.description + '\r\n';
      data += 'URL:' + "https://slotlist.walthex.com" + '/missions/' + this.missionDetails.slug + '\r\n';
      data += 'END:VEVENT\r\nEND:VCALENDAR';

      var blob = new Blob([data], { type: 'text/calendar' });

      __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(blob, this.missionDetails.title + '.ics');
    },
    fetchCommunityRepositories: function fetchCommunityRepositories() {
      this.missionRepositoriesExtended = !this.missionRepositoriesExtended;

      if (this.missionRepositoriesExtended && this.isCommunityMember && __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.communityRepositories)) {
        this.$store.dispatch('getCommunityRepositories', { communitySlug: this.user.community.slug });
      }

      this.communityRepositoriesSelected = null;
    },
    fetchCommunityServers: function fetchCommunityServers() {
      if (this.isCommunityMember && (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.communityGameServers) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.communityVoiceComms))) {
        this.$store.dispatch('getCommunityServers', { communitySlug: this.user.community.slug });
      }
    },
    googleCalendarLink: function googleCalendarLink(beginTime) {
      var link = 'https://www.google.com/calendar/event?action=TEMPLATE';
      link += '&text=' + this.missionDetails.title;
      link += '&dates=' + __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(beginTime).format('YMMDD[T]HHmmss') + '/' + __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(this.missionDetails.endTime).format('YMMDD[T]HHmmss');
      link += '&details=' + this.$t('mission.details') + ': ' + "https://slotlist.walthex.com" + '/missions/' + this.missionDetails.slug + ' \n \n';
      link += this.$t('mission.times', {
        start: this.formatDateTime(this.missionDetails.startTime),
        briefing: this.formatDateTime(this.missionDetails.briefingTime),
        slotting: this.formatDateTime(this.missionDetails.slottingTime),
        end: this.formatDateTime(this.missionDetails.endTime)
      }) + ' \n \n';
      link += '' + this.missionDetails.description;
      link += '&location&trp=false&ctx=' + this.$store.getters.timezone;

      return encodeURI(link);
    },
    removeMissionRepository: function removeMissionRepository(index) {
      var repositories = __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](this.missionDetails.repositories);
      repositories.splice(index, 1);

      this.$store.dispatch('editMission', {
        missionSlug: this.$route.params.missionSlug,
        updatedMissionDetails: {
          repositories: repositories
        },
        missionTitle: this.missionDetails.title
      });
    },
    toggleMissioncollapsedDescription: function toggleMissioncollapsedDescription() {
      this.missionCollapsedDescriptionExtended = !this.missionCollapsedDescriptionExtended;
    }
  },
  watch: {
    missionSlotlistFilter: function missionSlotlistFilter(val) {
      this.$store.dispatch('filterMissionSlotlist', val);
    },
    missionSlotlistRequiredDLCsFilter: function missionSlotlistRequiredDLCsFilter(val) {
      this.$store.dispatch('filterMissionSlotlistRequiredDLCs', val);
    },
    communityRepositoriesSelected: function communityRepositoriesSelected(val) {
      var repository = this.communityRepositories[val];
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](repository)) {
        return;
      }

      this.missionRepositoryCreateData.name = repository.name;
      this.missionRepositoryCreateData.kind = repository.kind;
      this.missionRepositoryCreateData.url = repository.url;
      this.missionRepositoryCreateData.notes = repository.notes;
    }
  }
};

/***/ }),
/* 266 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/MissionList.vue ***!
  \***********************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_missions_MissionListTable_vue__ = __webpack_require__(/*! ../components/missions/MissionListTable.vue */ 396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_missions_MissionListTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_missions_MissionListTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionListTable: __WEBPACK_IMPORTED_MODULE_1__components_missions_MissionListTable_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.missions) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.$store.getters.missions)) {
      this.$store.dispatch('getMissions', { autoRefresh: true });
    }
  },
  created: function created() {
    this.missionListFilter = this.$store.getters.missionListFilter;
    this.missionListRequiredDLCsFilter = this.$store.getters.missionListRequiredDLCsFilter;

    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(this.$t('nav.missions'));
  },
  data: function data() {
    return {
      missionListFilter: [],
      missionListRequiredDLCsFilter: []
    };
  },

  computed: {
    haveMissionsAnyRequiredDLCs: function haveMissionsAnyRequiredDLCs() {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missions)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](this.missions, function (mission) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](mission.requiredDLCs);
      });
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missions: function missions() {
      return this.$store.getters.missions;
    },
    missionsPageCount: function missionsPageCount() {
      return this.$store.getters.missionsPageCount;
    },
    refreshingMissions: function refreshingMissions() {
      return this.$store.getters.refreshingMissions;
    },
    timezone: function timezone() {
      return this.$store.getters.timezone;
    }
  },
  methods: {
    missionSelected: function missionSelected(item) {
      this.$router.push({ name: 'missionDetails', params: { missionSlug: item.value.slug } });
    },
    missionsPaginate: function missionsPaginate(page) {
      this.$store.dispatch('getMissions', { page: page, autoRefresh: true });
    }
  },
  watch: {
    missionListFilter: function missionListFilter(val) {
      this.$store.dispatch('filterMissionList', val);
    },
    missionListRequiredDLCsFilter: function missionListRequiredDLCsFilter(val) {
      this.$store.dispatch('filterMissionListRequiredDLCs', val);
    }
  }
};

/***/ }),
/* 267 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/MissionSlotTemplateCreator.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(/*! ../utils */ 3);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].setTitle(this.$t('mission.slotTemplate.creator.title.browser'));
  },
  data: function data() {
    return {
      missionSlotTemplateCreateData: {
        title: null,
        visibility: 'hidden'
      }
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    missionSlotTemplateCreateTitleFeedback: function missionSlotTemplateCreateTitleFeedback() {
      return _.isNil(this.missionSlotTemplateCreateData.title) || _.isEmpty(this.missionSlotTemplateCreateData.title) ? this.$t('mission.slotTemplate.feedback.title') : '';
    },
    missionSlotTemplateCreateTitleState: function missionSlotTemplateCreateTitleState() {
      return _.isNil(this.missionSlotTemplateCreateData.title) || _.isEmpty(this.missionSlotTemplateCreateData.title) ? 'danger' : 'success';
    },
    missionSlotTemplateCreateVisibilityState: function missionSlotTemplateCreateVisibilityState() {
      return _.isNil(this.missionSlotTemplateCreateData.visibility) || _.isEmpty(this.missionSlotTemplateCreateData.visibility) ? 'danger' : 'success';
    },
    missionSlotTemplateCreateVisibilityFeedback: function missionSlotTemplateCreateVisibilityFeedback() {
      return _.isNil(this.missionSlotTemplateCreateData.visibility) || _.isEmpty(this.missionSlotTemplateCreateData.visibility) ? this.$t('mission.slotTemplate.feedback.visibility') : '';
    },
    missionSlotTemplateCreateVisibilityOptions: function missionSlotTemplateCreateVisibilityOptions() {
      var options = [{
        text: this.$t('mission.slotTemplate.visibility.hidden'),
        value: 'hidden'
      }, {
        text: this.$t('mission.slotTemplate.visibility.public'),
        value: 'public'
      }];

      if (!_.isNil(this.user.community)) {
        options = [{
          text: this.$t('mission.slotTemplate.visibility.community'),
          value: 'community'
        }].concat(_toConsumableArray(options));
      }

      return options;
    }
  },
  methods: {
    createMissionSlotTemplate: function createMissionSlotTemplate() {
      if (_.isEmpty(this.missionSlotTemplateCreateData.title)) {
        return;
      }

      var missionSlotTemplateDetails = {
        title: this.missionSlotTemplateCreateData.title,
        visibility: this.missionSlotTemplateCreateData.visibility,
        slotGroups: []
      };

      this.$store.dispatch('createMissionSlotTemplate', missionSlotTemplateDetails);
    }
  }
};

/***/ }),
/* 268 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/MissionSlotTemplateDetails.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_missionSlotTemplates_modals_MissionSlotTemplateDuplicateModal_vue__ = __webpack_require__(/*! components/missionSlotTemplates/modals/MissionSlotTemplateDuplicateModal.vue */ 385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_missionSlotTemplates_modals_MissionSlotTemplateDuplicateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_missionSlotTemplates_modals_MissionSlotTemplateDuplicateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_missionSlotTemplates_modals_MissionSlotTemplateEditModal_vue__ = __webpack_require__(/*! components/missionSlotTemplates/modals/MissionSlotTemplateEditModal.vue */ 386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_missionSlotTemplates_modals_MissionSlotTemplateEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_missionSlotTemplates_modals_MissionSlotTemplateEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_missionSlotTemplates_modals_MissionSlotTemplateSlotCreateModal_vue__ = __webpack_require__(/*! components/missionSlotTemplates/modals/MissionSlotTemplateSlotCreateModal.vue */ 387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_missionSlotTemplates_modals_MissionSlotTemplateSlotCreateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_missionSlotTemplates_modals_MissionSlotTemplateSlotCreateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_missionSlotTemplates_modals_MissionSlotTemplateSlotDetailsModal_vue__ = __webpack_require__(/*! components/missionSlotTemplates/modals/MissionSlotTemplateSlotDetailsModal.vue */ 388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_missionSlotTemplates_modals_MissionSlotTemplateSlotDetailsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_missionSlotTemplates_modals_MissionSlotTemplateSlotDetailsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_missionSlotTemplates_modals_MissionSlotTemplateSlotEditModal_vue__ = __webpack_require__(/*! components/missionSlotTemplates/modals/MissionSlotTemplateSlotEditModal.vue */ 389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_missionSlotTemplates_modals_MissionSlotTemplateSlotEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_missionSlotTemplates_modals_MissionSlotTemplateSlotEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupCreateModal_vue__ = __webpack_require__(/*! components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupCreateModal.vue */ 390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupCreateModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupCreateModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupEditModal_vue__ = __webpack_require__(/*! components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupEditModal.vue */ 391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_missionSlotTemplates_MissionSlotTemplateSlotlist_vue__ = __webpack_require__(/*! components/missionSlotTemplates/MissionSlotTemplateSlotlist.vue */ 381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_missionSlotTemplates_MissionSlotTemplateSlotlist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_missionSlotTemplates_MissionSlotTemplateSlotlist_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotTemplateDuplicateModal: __WEBPACK_IMPORTED_MODULE_1_components_missionSlotTemplates_modals_MissionSlotTemplateDuplicateModal_vue___default.a,
    MissionSlotTemplateEditModal: __WEBPACK_IMPORTED_MODULE_2_components_missionSlotTemplates_modals_MissionSlotTemplateEditModal_vue___default.a,
    MissionSlotTemplateSlotCreateModal: __WEBPACK_IMPORTED_MODULE_3_components_missionSlotTemplates_modals_MissionSlotTemplateSlotCreateModal_vue___default.a,
    MissionSlotTemplateSlotDetailsModal: __WEBPACK_IMPORTED_MODULE_4_components_missionSlotTemplates_modals_MissionSlotTemplateSlotDetailsModal_vue___default.a,
    MissionSlotTemplateSlotEditModal: __WEBPACK_IMPORTED_MODULE_5_components_missionSlotTemplates_modals_MissionSlotTemplateSlotEditModal_vue___default.a,
    MissionSlotTemplateSlotGroupCreateModal: __WEBPACK_IMPORTED_MODULE_6_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupCreateModal_vue___default.a,
    MissionSlotTemplateSlotGroupEditModal: __WEBPACK_IMPORTED_MODULE_7_components_missionSlotTemplates_modals_MissionSlotTemplateSlotGroupEditModal_vue___default.a,
    MissionSlotTemplateSlotlist: __WEBPACK_IMPORTED_MODULE_8_components_missionSlotTemplates_MissionSlotTemplateSlotlist_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getMissionSlotTemplateDetails', { missionSlotTemplateUid: this.$route.params.missionSlotTemplateUid });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearMissionSlotTemplateDetails');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.missionSlotTemplateUnsavedChanges) {
      var answer = window.confirm(this.$t('mission.slotTemplate.confirm.unsavedChanges'));
      if (answer) {
        next();
      } else {
        window.scrollTo(0, document.body.scrollHeight);
        next(false);
      }
    } else {
      next();
    }
  },
  computed: {
    formattedMissionSlotTemplateVisibility: function formattedMissionSlotTemplateVisibility() {
      switch (this.missionSlotTemplateDetails.visibility) {
        case 'community':
          return '<span class="text-primary"><i class="fa fa-users" aria-hidden="true"></i> ' + this.$t('mission.slotTemplate.visibility.community') + '</span>';
        case 'hidden':
          return '<span class="text-danger"><i class="fa fa-edit" aria-hidden="true"></i> ' + this.$t('mission.slotTemplate.visibility.hidden') + '</span>';
        case 'private':
          return '<span class="text-warning"><i class="fa fa-user-secret" aria-hidden="true"></i> ' + this.$t('mission.slotTemplate.visibility.private') + '</span>';
        case 'public':
          return '<span class="text-success"><i class="fa fa-globe" aria-hidden="true"></i> ' + this.$t('mission.slotTemplate.visibility.public') + '</span>';
        default:
          return '<span class="text-muted font-italic"><i class="fa fa-question-circle" aria-hidden="true"></i> ' + this.$t('mission.slotTemplate.visibility.default') + '</span>';
      }
    },
    isMissionSlotTemplateCreator: function isMissionSlotTemplateCreator() {
      if (!this.loggedIn || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.missionSlotTemplateDetails)) {
        return false;
      }

      return this.missionSlotTemplateDetails.creator.uid === this.$store.getters.user.uid;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters.loggedIn;
    },
    missionSlotTemplateDetails: function missionSlotTemplateDetails() {
      return this.$store.getters.missionSlotTemplateDetails;
    },
    missionSlotTemplateUnsavedChanges: function missionSlotTemplateUnsavedChanges() {
      return this.$store.getters.missionSlotTemplateUnsavedChanges;
    }
  },
  methods: {
    deleteMissionSlotTemplate: function deleteMissionSlotTemplate() {
      this.$store.dispatch('deleteMissionSlotTemplate', {
        missionSlotTemplateUid: this.$route.params.missionSlotTemplateUid,
        missionSlotTemplateTitle: this.missionSlotTemplateDetails.title
      });
    }
  }
};

/***/ }),
/* 269 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/MissionSlotTemplateList.vue ***!
  \***********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_missionSlotTemplates_MissionSlotTemplateListTable_vue__ = __webpack_require__(/*! ../components/missionSlotTemplates/MissionSlotTemplateListTable.vue */ 380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_missionSlotTemplates_MissionSlotTemplateListTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_missionSlotTemplates_MissionSlotTemplateListTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    MissionSlotTemplateListTable: __WEBPACK_IMPORTED_MODULE_1__components_missionSlotTemplates_MissionSlotTemplateListTable_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.missionSlotTemplates) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.$store.getters.missionSlotTemplates) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.missionSlotTemplatesRefreshSetInterval)) {
      this.$store.dispatch('getMissionSlotTemplates', { autoRefresh: true });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(this.$t('nav.missionSlotTemplates'));
  },
  computed: {
    missionSlotTemplates: function missionSlotTemplates() {
      return this.$store.getters.missionSlotTemplates;
    },
    missionSlotTemplatesPageCount: function missionSlotTemplatesPageCount() {
      return this.$store.getters.missionSlotTemplatesPageCount;
    },
    refreshingMissionSlotTemplates: function refreshingMissionSlotTemplates() {
      return this.$store.getters.refreshingMissionSlotTemplates;
    }
  },
  methods: {
    missionSlotTemplatesPaginate: function missionSlotTemplatesPaginate(page) {
      this.$store.dispatch('getMissionSlotTemplates', { page: page, autoRefresh: true });
    }
  }
};

/***/ }),
/* 270 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/NotificationList.vue ***!
  \****************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_notifications_NotificationListTable_vue__ = __webpack_require__(/*! ../components/notifications/NotificationListTable.vue */ 424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_notifications_NotificationListTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_notifications_NotificationListTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    NotificationListTable: __WEBPACK_IMPORTED_MODULE_1__components_notifications_NotificationListTable_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$store.dispatch('getNotifications').then(function () {
      _this.$store.dispatch('getUnseenNotificationCount', { autoRefresh: true });
    });
  },
  created: function created() {
    this.notificationListFilter = this.$store.getters.notificationListFilter;

    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(this.$t('nav.notifications'));
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearNotifications');
  },
  data: function data() {
    return {
      notificationListFilter: []
    };
  },

  computed: {
    notifications: function notifications() {
      return this.$store.getters.notifications;
    },
    notificationsPageCount: function notificationsPageCount() {
      return this.$store.getters.notificationsPageCount;
    },
    refreshingNotifications: function refreshingNotifications() {
      return this.$store.getters.refreshingNotifications;
    }
  },
  methods: {
    notificationsPaginate: function notificationsPaginate(page) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["indexOf"](this.notificationListFilter, 'seen') >= 0) {
        this.$store.dispatch('getNotifications', { page: page });
      } else {
        this.$store.dispatch('paginateNotifications', { page: page });
      }
    },
    refreshNotifications: function refreshNotifications() {
      var _this2 = this;

      this.$store.dispatch('getNotifications', { silent: true }).then(function () {
        _this2.$store.dispatch('getUnseenNotificationCount', { autoRefresh: true });
      });
    }
  },
  watch: {
    notificationListFilter: function notificationListFilter(val) {
      this.$store.dispatch('filterNotificationList', val);
    }
  }
};

/***/ }),
/* 271 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/Privacy.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_Privacy_de_vue__ = __webpack_require__(/*! ../i18n/views/Privacy.de.vue */ 441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_views_Privacy_de_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__i18n_views_Privacy_de_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_Privacy_en_vue__ = __webpack_require__(/*! ../i18n/views/Privacy.en.vue */ 442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_views_Privacy_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_views_Privacy_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    PrivacyDe: __WEBPACK_IMPORTED_MODULE_0__i18n_views_Privacy_de_vue___default.a,
    PrivacyEn: __WEBPACK_IMPORTED_MODULE_1__i18n_views_Privacy_en_vue___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(this.$t('nav.privacy'));
  }
};

/***/ }),
/* 272 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/UserDetails.vue ***!
  \***********************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_users_modals_UserEditModal_vue__ = __webpack_require__(/*! ../components/users/modals/UserEditModal.vue */ 430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_users_modals_UserEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_users_modals_UserEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_UserMissions_vue__ = __webpack_require__(/*! ../components/users/UserMissions.vue */ 427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_UserMissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_users_UserMissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    UserEditModal: __WEBPACK_IMPORTED_MODULE_0__components_users_modals_UserEditModal_vue___default.a,
    UserMissions: __WEBPACK_IMPORTED_MODULE_1__components_users_UserMissions_vue___default.a
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('getUserDetails', this.$route.params.userUid);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('clearUserDetails');
  },
  computed: {
    isUserAdmin: function isUserAdmin() {
      return this.$acl.can(['admin.user'], true);
    },
    userDetails: function userDetails() {
      return this.$store.getters.userDetails;
    }
  },
  methods: {
    deleteUser: function deleteUser() {
      this.$store.dispatch('deleteUser', { userUid: this.$route.params.userUid });
    },
    modifyUserStatus: function modifyUserStatus(active) {
      this.$store.dispatch('editUser', {
        userUid: this.$route.params.userUid,
        updatedUserDetails: {
          active: active
        }
      });
    }
  }
};

/***/ }),
/* 273 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/UserList.vue ***!
  \********************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_UserListTable_vue__ = __webpack_require__(/*! ../components/users/UserListTable.vue */ 426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_UserListTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_users_UserListTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    UserListTable: __WEBPACK_IMPORTED_MODULE_1__components_users_UserListTable_vue___default.a
  },
  data: function data() {
    return {
      userSearch: null
    };
  },

  beforeCreate: function beforeCreate() {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.users) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](this.$store.getters.users) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](this.$store.getters.usersRefreshSetInterval)) {
      this.$store.dispatch('getUsers', { autoRefresh: true });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(this.$t('nav.users'));
  },
  computed: {
    refreshingUsers: function refreshingUsers() {
      return this.$store.getters.refreshingUsers;
    },
    users: function users() {
      return this.$store.getters.users;
    },
    usersPageCount: function usersPageCount() {
      return this.$store.getters.usersPageCount;
    }
  },
  methods: {
    userSelected: function userSelected(item) {
      this.$router.push({ name: 'userDetails', params: { userUid: item.value.uid } });
    },
    usersPaginate: function usersPaginate(page) {
      this.$store.dispatch('getUsers', { page: page, autoRefresh: true });
    }
  }
};

/***/ }),
/* 274 */
/* exports provided: v1, default */
/* exports used: default */
/*!*************************!*\
  !*** ./src/api/auth.js ***!
  \*************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* unused harmony export v1 */


var v1 = {
  deleteAccount: function deleteAccount(nickname) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/auth/account/delete', { nickname: nickname });
  },
  getLoginRedirectUrl: function getLoginRedirectUrl() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/auth/steam');
  },
  performLogin: function performLogin(url) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/auth/steam', { url: url });
  },
  refreshToken: function refreshToken() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/auth/refresh');
  },
  getAccountDetails: function getAccountDetails() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/auth/account');
  },
  editAccount: function editAccount(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/auth/account', payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = v1;

/***/ }),
/* 275 */
/* exports provided: v1, default */
/* exports used: default */
/*!********************************!*\
  !*** ./src/api/communities.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* unused harmony export v1 */


var v1 = {
  applyToCommunity: function applyToCommunity(communitySlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/communities/' + communitySlug + '/applications');
  },
  checkCommunitySlugAvailability: function checkCommunitySlugAvailability(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/slugAvailable?slug=' + missionSlug);
  },
  createCommunity: function createCommunity(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/communities', payload);
  },
  createCommunityPermission: function createCommunityPermission(communitySlug, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/communities/' + communitySlug + '/permissions', payload);
  },
  deleteCommunity: function deleteCommunity(communitySlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/communities/' + communitySlug);
  },
  deleteCommunityLogo: function deleteCommunityLogo(communitySlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/communities/' + communitySlug + '/logo');
  },
  deleteCommunityPermission: function deleteCommunityPermission(communitySlug, permissionUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/communities/' + communitySlug + '/permissions/' + permissionUid);
  },
  editCommunity: function editCommunity(communitySlug, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/communities/' + communitySlug, payload);
  },
  getCommunities: function getCommunities() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities?limit=' + limit + '&offset=' + offset);
  },
  getCommunityApplications: function getCommunityApplications(communitySlug) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var includeProcessed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/' + communitySlug + '/applications?limit=' + limit + '&offset=' + offset + '&includeProcessed=' + includeProcessed);
  },
  getCommunityApplicationStatus: function getCommunityApplicationStatus(communitySlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/' + communitySlug + '/applications/status');
  },
  getCommunityDetails: function getCommunityDetails(communitySlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/' + communitySlug);
  },
  getCommunityMissions: function getCommunityMissions(communitySlug) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var includeEnded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/' + communitySlug + '/missions?limit=' + limit + '&offset=' + offset + '&includeEnded=' + includeEnded);
  },
  getCommunityPermissions: function getCommunityPermissions(communitySlug) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/' + communitySlug + '/permissions?limit=' + limit + '&offset=' + offset);
  },
  getCommunityRepositories: function getCommunityRepositories(communitySlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/' + communitySlug + '/repositories');
  },
  getCommunityServers: function getCommunityServers(communitySlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities/' + communitySlug + '/servers');
  },
  processCommunityApplication: function processCommunityApplication(communitySlug, applicationUid, accepted) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/communities/' + communitySlug + '/applications/' + applicationUid, { status: accepted ? 'accepted' : 'denied' });
  },
  removeCommunityMember: function removeCommunityMember(communitySlug, memberUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/communities/' + communitySlug + '/members/' + memberUid);
  },
  searchCommunities: function searchCommunities(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/communities?search=' + payload);
  },
  uploadCommunityLogo: function uploadCommunityLogo(communitySlug, imageType, imageData) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/v1/communities/' + communitySlug + '/logo', { imageType: imageType, image: imageData });
  }
};

/* harmony default export */ __webpack_exports__["a"] = v1;

/***/ }),
/* 276 */
/* exports provided: v1, default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./src/api/missionSlotTemplates.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* unused harmony export v1 */


var v1 = {
  createMissionSlotTemplate: function createMissionSlotTemplate(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missionSlotTemplates', payload);
  },
  deleteMissionSlotTemplate: function deleteMissionSlotTemplate(missionSlotTemplateUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missionSlotTemplates/' + missionSlotTemplateUid);
  },
  editMissionSlotTemplate: function editMissionSlotTemplate(missionSlotTemplateUid, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/missionSlotTemplates/' + missionSlotTemplateUid, payload);
  },
  getMissionSlotTemplateDetails: function getMissionSlotTemplateDetails(missionSlotTemplateUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missionSlotTemplates/' + missionSlotTemplateUid);
  },
  getMissionSlotTemplates: function getMissionSlotTemplates() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missionSlotTemplates?limit=' + limit + '&offset=' + offset);
  }
};

/* harmony default export */ __webpack_exports__["a"] = v1;

/***/ }),
/* 277 */
/* exports provided: v1, default */
/* exports used: default */
/*!*****************************!*\
  !*** ./src/api/missions.js ***!
  \*****************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* unused harmony export v1 */



var v1 = {
  addMissionAccess: function addMissionAccess(missionSlug, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/accesses', payload);
  },
  addMissionPermission: function addMissionPermission(missionSlug, payload, suppressNotifications) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/permissions', __WEBPACK_IMPORTED_MODULE_1_lodash__["defaults"](payload, { suppressNotifications: suppressNotifications }));
  },
  applySlotTemplateToMission: function applySlotTemplateToMission(missionSlug, slotTemplateUid, insertAfter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/slotTemplates/' + slotTemplateUid, { insertAfter: insertAfter });
  },
  assignMissionSlot: function assignMissionSlot(missionSlug, slotUid, userUid, force, suppressNotifications) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/slots/' + slotUid + '/assign', { userUid: userUid, force: force, suppressNotifications: suppressNotifications });
  },
  checkMissionSlugAvailability: function checkMissionSlugAvailability(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions/slugAvailable?slug=' + missionSlug);
  },
  createMission: function createMission(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions', payload);
  },
  createMissionSlot: function createMissionSlot(missionSlug, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/slots', __WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](payload) ? payload : [payload]);
  },
  createMissionSlotGroup: function createMissionSlotGroup(missionSlug, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/slotGroups', payload);
  },
  deleteMission: function deleteMission(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug);
  },
  deleteMissionAccess: function deleteMissionAccess(missionSlug, missionAccessUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug + '/accesses/' + missionAccessUid);
  },
  deleteMissionBannerImage: function deleteMissionBannerImage(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug + '/bannerImage');
  },
  deleteMissionPermission: function deleteMissionPermission(missionSlug, permissionUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug + '/permissions/' + permissionUid);
  },
  deleteMissionSlot: function deleteMissionSlot(missionSlug, slotUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug + '/slots/' + slotUid);
  },
  deleteMissionSlotGroup: function deleteMissionSlotGroup(missionSlug, slotGroupUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug + '/slotGroups/' + slotGroupUid);
  },
  deleteMissionToken: function deleteMissionToken(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug + '/token');
  },
  duplicateMission: function duplicateMission(missionSlug, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/duplicate', payload);
  },
  editMission: function editMission(missionSlug, payload, suppressNotifications) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/missions/' + missionSlug, __WEBPACK_IMPORTED_MODULE_1_lodash__["defaults"](payload, { suppressNotifications: suppressNotifications }));
  },
  editMissionSlot: function editMissionSlot(missionSlug, slotUid, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/missions/' + missionSlug + '/slots/' + slotUid, payload);
  },
  editMissionSlotGroup: function editMissionSlotGroup(missionSlug, slotGroupUid, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/missions/' + missionSlug + '/slotGroups/' + slotGroupUid, payload);
  },
  generateMissionToken: function generateMissionToken(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/token');
  },
  getMissionAccesses: function getMissionAccesses(missionSlug) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions/' + missionSlug + '/accesses?limit=' + limit + '&offset=' + offset);
  },
  getMissionDetails: function getMissionDetails(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions/' + missionSlug);
  },
  getMissionPermissions: function getMissionPermissions(missionSlug) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions/' + missionSlug + '/permissions?limit=' + limit + '&offset=' + offset);
  },
  getMissions: function getMissions() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var includeEnded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions?limit=' + limit + '&offset=' + offset + '&includeEnded=' + includeEnded);
  },
  getMissionsForCalendar: function getMissionsForCalendar(startDate, endDate) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions?startDate=' + startDate + '&endDate=' + endDate);
  },
  getMissionSlotlist: function getMissionSlotlist(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions/' + missionSlug + '/slots');
  },
  getMissionSlotRegistrations: function getMissionSlotRegistrations(missionSlug, slotUid) {
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions/' + missionSlug + '/slots/' + slotUid + '/registrations?limit=' + limit + '&offset=' + offset);
  },
  getMissionToken: function getMissionToken(missionSlug) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions/' + missionSlug + '/token');
  },
  modifyMissionSlotRegistration: function modifyMissionSlotRegistration(missionSlug, slotUid, registrationUid, confirm, suppressNotifications) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/missions/' + missionSlug + '/slots/' + slotUid + '/registrations/' + registrationUid, { confirmed: confirm, suppressNotifications: suppressNotifications });
  },
  registerForMissionSlot: function registerForMissionSlot(missionSlug, slotUid, comment) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/slots/' + slotUid + '/registrations', { comment: comment });
  },
  searchMissions: function searchMissions(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/missions?search=' + payload);
  },
  unassignMissionSlot: function unassignMissionSlot(missionSlug, slotUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/v1/missions/' + missionSlug + '/slots/' + slotUid + '/unassign');
  },
  unregisterFromMissionSlot: function unregisterFromMissionSlot(missionSlug, slotUid, registrationUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/missions/' + missionSlug + '/slots/' + slotUid + '/registrations/' + registrationUid);
  },
  uploadMissionBannerImage: function uploadMissionBannerImage(missionSlug, imageType, imageData) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/v1/missions/' + missionSlug + '/bannerImage', { imageType: imageType, image: imageData });
  }
};

/* harmony default export */ __webpack_exports__["a"] = v1;

/***/ }),
/* 278 */
/* exports provided: v1, default */
/* exports used: default */
/*!**********************************!*\
  !*** ./src/api/notifications.js ***!
  \**********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* unused harmony export v1 */


var v1 = {
  getNotifications: function getNotifications() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var includeSeen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/notifications?limit=' + limit + '&offset=' + offset + '&includeSeen=' + includeSeen);
  },
  getUnseenNotificationCount: function getUnseenNotificationCount() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/notifications/unseen');
  }
};

/* harmony default export */ __webpack_exports__["a"] = v1;

/***/ }),
/* 279 */
/* exports provided: v1, default */
/* exports used: default */
/*!***************************!*\
  !*** ./src/api/status.js ***!
  \***************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* unused harmony export v1 */


var v1 = {
  getStatus: function getStatus() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/status');
  }
};

/* harmony default export */ __webpack_exports__["a"] = v1;

/***/ }),
/* 280 */
/* exports provided: v1, default */
/* exports used: default */
/*!**************************!*\
  !*** ./src/api/users.js ***!
  \**************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* unused harmony export v1 */


var v1 = {
  deleteUser: function deleteUser(userUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/v1/users/' + userUid);
  },
  editUser: function editUser(userUid, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/v1/users/' + userUid, payload);
  },
  getUserDetails: function getUserDetails(userUid) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/users/' + userUid);
  },
  getUserMissions: function getUserMissions(userUid) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var includeEnded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/users/' + userUid + '/missions?limit=' + limit + '&offset=' + offset + '&includeEnded=' + includeEnded);
  },
  getUsers: function getUsers() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/users?limit=' + limit + '&offset=' + offset);
  },
  searchUsers: function searchUsers(payload) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/v1/users?search=' + payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = v1;

/***/ }),
/* 281 */
/* exports provided: default */
/* exports used: default */
/*!****************************!*\
  !*** ./src/plugins/acl.js ***!
  \****************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ACL = function () {
  function ACL() {
    _classCallCheck(this, ACL);
  }

  _createClass(ACL, [{
    key: 'can',
    value: function can(permission) {
      var _this = this;

      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var includeSuperadmin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](this.permissions).length <= 0) {
        return false;
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash__["has"](this.permissions, '*') && includeSuperadmin) {
        return true;
      }

      var perms = permission;
      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"](permission)) {
        perms = [permission];
      }

      var foundPermissions = __WEBPACK_IMPORTED_MODULE_0_lodash__["filter"](perms, function (perm) {
        return _this._hasPermission(_this.permissions, perm);
      });

      return strict ? foundPermissions.length === perms.length : foundPermissions.length > 0;
    }
  }, {
    key: 'parsePermissions',
    value: function parsePermissions(permissions) {
      var _this2 = this;

      this._permissions = {};
      this._authenticated = true;

      if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"](permissions) || __WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"](permissions)) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0_lodash__["each"](permissions, function (permission) {
        var permissionParts = permission.toLowerCase().split('.');

        var previous = _this2._permissions;
        var part = permissionParts.shift();
        while (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](part)) {
          if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](previous[part])) {
            previous[part] = {};
          }

          previous = previous[part];
          part = permissionParts.shift();
        }
      });
    }
  }, {
    key: 'clearPermissions',
    value: function clearPermissions() {
      this._permissions = {};
      this._authenticated = false;
    }
  }, {
    key: '_hasPermission',
    value: function _hasPermission(perms, perm) {
      var _this3 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](perms) || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isObject"](perms) || __WEBPACK_IMPORTED_MODULE_0_lodash__["keys"](perms).length <= 0) {
        return false;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["has"](perms, perm)) {
        return true;
      }

      var found = __WEBPACK_IMPORTED_MODULE_0_lodash__["some"](perms, function (next, current) {
        var permParts = __WEBPACK_IMPORTED_MODULE_0_lodash__["isString"](perm) ? perm.toLowerCase().split('.') : perm;

        var permPart = permParts.shift();
        if (current === '*' || current === permPart) {
          if (permParts.length <= 0) {
            return true;
          }

          return _this3._hasPermission(next, __WEBPACK_IMPORTED_MODULE_0_lodash__["clone"](permParts));
        }

        return false;
      });

      return found;
    }
  }, {
    key: 'permissions',
    get: function get() {
      return this._permissions || {};
    }
  }, {
    key: 'authenticated',
    get: function get() {
      return this._authenticated || false;
    }
  }, {
    key: 'router',
    set: function set(router) {
      var _this4 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](router) || !__WEBPACK_IMPORTED_MODULE_0_lodash__["isFunction"](router.beforeEach)) {
        return;
      }

      router.beforeEach(function (to, from, next) {
        if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isObject"](to.meta)) {
          if (to.meta.authenticated === true && !_this4.authenticated) {
            return next(false);
          }

          if (!__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](to.meta.permissions)) {
            var strict = __WEBPACK_IMPORTED_MODULE_0_lodash__["isBoolean"](to.meta.strictPermissions) ? to.meta.strictPermissions : false;

            if (!_this4.can(to.meta.permissions, strict)) {
              return next(false);
            }
          }
        }

        return next();
      });
    }
  }]);

  return ACL;
}();

var acl = new ACL();

ACL.install = function (Vue, _ref) {
  var router = _ref.router;

  acl.clearPermissions();
  acl.router = router;

  Vue.acl = acl;
  Vue.prototype.$acl = acl;
};

/* harmony default export */ __webpack_exports__["a"] = ACL;

/***/ }),
/* 282 */
/* exports provided: default */
/* exports used: default */
/*!************************************!*\
  !*** ./src/store/modules/alert.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var state = {
  showAlert: false,
  alertVariant: 'info',
  alertDismissible: true,
  alertMessage: null,
  persistentAlert: false
};

var getters = {
  showAlert: function showAlert() {
    return state.showAlert;
  },
  alertVariant: function alertVariant() {
    return state.alertVariant;
  },
  alertDismissible: function alertDismissible() {
    return state.alertDismissible;
  },
  alertMessage: function alertMessage() {
    return state.alertMessage;
  },
  persistentAlert: function persistentAlert() {
    return state.persistentAlert;
  }
};

var actions = {
  showAlert: function showAlert(_ref, payload) {
    var commit = _ref.commit;

    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](payload.showAlert)) {
      console.error('Showing alert without showAlert doesn\'t make much sense...');
      return;
    }
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](payload.alertMessage)) {
      console.error('Showing alert without alertMessage doesn\'t make much sense...');
      return;
    }

    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](payload.alertVariant)) {
      payload.alertVariant = 'info';
    }
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](payload.alertDismissible)) {
      payload.alertDismissible = true;
    }
    if (__WEBPACK_IMPORTED_MODULE_0_lodash__["isNil"](payload.scrollToTop)) {
      payload.scrollToTop = false;
    }

    commit({
      type: 'showAlert',
      showAlert: payload.showAlert,
      alertVariant: payload.alertVariant,
      alertDismissible: payload.alertDismissible,
      alertMessage: payload.alertMessage,
      persistentAlert: payload.persistentAlert
    });

    if (payload.scrollToTop || payload.alertVariant.toLowerCase() === 'warning' || payload.alertVariant.toLowerCase() === 'danger') {
      window.scrollTo(0, 0);
    }
  },
  clearAlert: function clearAlert(_ref2) {
    var commit = _ref2.commit;

    commit({
      type: 'clearAlert'
    });
  }
};

var mutations = {
  showAlert: function showAlert(state, payload) {
    state.alertVariant = payload.alertVariant;
    state.alertDismissible = payload.alertDismissible;
    state.alertMessage = payload.alertMessage;
    state.showAlert = payload.showAlert;
    state.persistentAlert = payload.persistentAlert;
  },
  clearAlert: function clearAlert(state) {
    state.showAlert = false;
    state.alertVariant = 'info';
    state.alertDismissible = true;
    state.alertMessage = null;
    state.persistentAlert = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 283 */
/* exports provided: default */
/* exports used: default */
/*!***********************************!*\
  !*** ./src/store/modules/auth.js ***!
  \***********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ../../app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(/*! jwt-decode */ 323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(/*! axios */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(/*! ../../router */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_auth__ = __webpack_require__(/*! ../../api/auth */ 274);











var state = {
  loggedIn: false,
  loginRedirectUrl: null,
  redirect: null,
  refreshingToken: false,
  token: null,
  decodedToken: null,
  accountDetails: null,
  accountMissions: null,
  accountPermissions: null
};

var getters = {
  loginRedirectUrl: function loginRedirectUrl() {
    return state.loginRedirectUrl;
  },
  loggedIn: function loggedIn() {
    return state.loggedIn;
  },
  decodedToken: function decodedToken() {
    return state.decodedToken;
  },
  user: function user() {
    return __WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](state.decodedToken) ? {} : state.decodedToken.user;
  },
  accountDetails: function accountDetails() {
    return state.accountDetails;
  },
  accountMissions: function accountMissions() {
    return state.accountMissions;
  },
  accountPermissions: function accountPermissions() {
    return state.accountPermissions;
  },
  refreshingToken: function refreshingToken() {
    return state.refreshingToken;
  }
};

var actions = {
  deleteAccount: function deleteAccount(_ref, payload) {
    var dispatch = _ref.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.deleteAccount'));

    return __WEBPACK_IMPORTED_MODULE_8__api_auth__["a" /* default */].deleteAccount(payload.nickname).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Deleting account failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (!response.data.success) {
        console.error(response);
        throw "Received invalid account deletion response";
      }

      dispatch('performLogout');

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.deleteAccount.success'),
        persistentAlert: true
      });

      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'home' });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.deleteAccount'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.deleteAccount'));

      if (error.response) {
        console.error('deleteAccount', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.deleteAccount.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'deleteAccount' } }) : null;
        console.error('deleteAccount', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.deleteAccount.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'deleteAccount' } }) : null;
        console.error('deleteAccount', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.deleteAccount.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getLoginRedirectUrl: function getLoginRedirectUrl(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](state.loginRedirectUrl) && !__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](state.loginRedirectUrl)) {
      return;
    }

    return __WEBPACK_IMPORTED_MODULE_8__api_auth__["a" /* default */].getLoginRedirectUrl().then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving login redirect URL failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (!__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](response.data.url) || __WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data.url)) {
        console.error(response);
        throw "Missing login redirect URL";
      }

      commit({
        type: 'setLoginRedirectUrl',
        url: response.data.url
      });
    }).catch(function (error) {
      if (error.response) {
        console.error('getLoginRedirectUrl', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getLoginRedirectUrl.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'getLoginRedirectUrl' } }) : null;
        console.error('getLoginRedirectUrl', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getLoginRedirectUrl.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'getLoginRedirectUrl' } }) : null;
        console.error('getLoginRedirectUrl', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getLoginRedirectUrl.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  performLogin: function performLogin(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.performLogin'));

    return __WEBPACK_IMPORTED_MODULE_8__api_auth__["a" /* default */].performLogin(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Performing login failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (!__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](response.data.token) || __WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data.token)) {
        console.error(response);
        throw "Missing JWT";
      }

      var decodedToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(response.data.token);

      commit({
        type: "setToken",
        token: response.data.token,
        decodedToken: decodedToken
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.performLogin'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.performLogin'));

      if (error.response) {
        console.error('performLogin', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.performLogin.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'performLogin' } }) : null;
        console.error('performLogin', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.performLogin.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'performLogin' } }) : null;
        console.error('performLogin', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.performLogin.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  performLogout: function performLogout(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    dispatch('stopNotificationPolling');

    commit({
      type: "logout"
    });
  },
  setToken: function setToken(_ref5, payload) {
    var commit = _ref5.commit;

    var decodedToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(payload);

    commit({
      type: "setToken",
      token: payload,
      decodedToken: decodedToken
    });
  },
  setTokenFromLocalStorage: function setTokenFromLocalStorage(_ref6, payload) {
    var commit = _ref6.commit;

    var decodedToken = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.get('auth-decodedToken');
    if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](decodedToken)) {
      decodedToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(payload);
    }

    var expiry = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(decodedToken.exp * 1000);
    var now = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().utc();
    if (expiry <= now) {
      console.info('JWT from localStorage is expired, clearing stored data');

      return commit({
        type: 'logout'
      });
    }

    commit({
      type: "setToken",
      token: payload,
      decodedToken: decodedToken
    });
  },
  refreshToken: function refreshToken(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    commit({
      type: "refreshingToken",
      refreshing: true
    });

    if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](payload)) {
      payload = { silent: false };
    } else if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.refreshToken'));
    }

    return __WEBPACK_IMPORTED_MODULE_8__api_auth__["a" /* default */].refreshToken().then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Refreshing token failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (!__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](response.data.token) || __WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data.token)) {
        console.error(response);
        throw "Missing JWT";
      }

      var decodedToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(response.data.token);

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.set('auth-token-last-refreshed', __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().utc());

      commit({
        type: "setToken",
        token: response.data.token,
        decodedToken: decodedToken
      });

      commit({
        type: "refreshingToken",
        refreshing: false
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.refreshToken'));
      }
    }).catch(function (error) {
      commit({
        type: "refreshingToken",
        refreshing: false
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.refreshToken'));
      }

      dispatch('performLogout');

      if (error.response) {
        console.error('refreshToken', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.refreshToken.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'refreshToken' } }) : null;
        console.error('refreshToken', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.refreshToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'refreshToken' } }) : null;
        console.error('refreshToken', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.refreshToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  setRedirect: function setRedirect(_ref8, payload) {
    var commit = _ref8.commit;

    commit({
      type: "setRedirect",
      redirect: payload
    });
  },
  getAccountDetails: function getAccountDetails(_ref9) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getAccountDetails'));

    return __WEBPACK_IMPORTED_MODULE_8__api_auth__["a" /* default */].getAccountDetails().then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving account details failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](response.data.user) || !__WEBPACK_IMPORTED_MODULE_2_lodash__["isObject"](response.data.user)) {
        console.error(response);
        throw "Received invalid user";
      }

      commit({
        type: 'setAccountDetails',
        accountDetails: response.data.user
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getAccountDetails'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getAccountDetails'));

      if (error.response) {
        console.error('getAccountDetails', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getAccountDetails.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'getAccountDetails' } }) : null;
        console.error('getAccountDetails', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getAccountDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'getAccountDetails' } }) : null;
        console.error('getAccountDetails', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.getAccountDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  clearAccountDetails: function clearAccountDetails(_ref10) {
    var commit = _ref10.commit;

    commit({
      type: 'clearAccountDetails'
    });
  },
  editAccount: function editAccount(_ref11, payload) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.editAccount'));

    return __WEBPACK_IMPORTED_MODULE_8__api_auth__["a" /* default */].editAccount(payload.updatedAccountDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Updating account details failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](response.data.user) || !__WEBPACK_IMPORTED_MODULE_2_lodash__["isObject"](response.data.user)) {
        console.error(response);
        throw "Received invalid user";
      }

      commit({
        type: 'setAccountDetails',
        accountDetails: response.data.user
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.editAccount.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.editAccount'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.editAccount'));

      if (error.response) {
        console.error('editAccount', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.editAccount.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'editAccount' } }) : null;
        console.error('editAccount', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.editAccount.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.captureException(error, { extra: { module: 'auth', function: 'editAccount' } }) : null;
        console.error('editAccount', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('store.editAccount.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  }
};

var mutations = {
  setLoginRedirectUrl: function setLoginRedirectUrl(state, payload) {
    state.loginRedirectUrl = payload.url;
  },
  refreshingToken: function refreshingToken(state, payload) {
    state.refreshingToken = payload.refreshing;
  },
  setToken: function setToken(state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.set('auth-token', payload.token);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.set('auth-decodedToken', payload.decodedToken);

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].acl.parsePermissions(payload.decodedToken.permissions);

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['Authorization'] = 'JWT ' + payload.token;

    state.token = payload.token;
    state.decodedToken = payload.decodedToken;
    state.loggedIn = true;

    __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.setUserContext(state.decodedToken);

    var redirect = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.get('auth-redirect');
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](redirect)) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('auth-redirect');
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push(redirect);
    }
  },
  logout: function logout(state) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('auth-token');
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('auth-decodedToken');

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].acl.clearPermissions();

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['Authorization'] = undefined;
    delete __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common['Authorization'];

    state.token = null;
    state.decodedToken = null;
    state.loggedIn = false;

    __WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.setUserContext();
  },
  setRedirect: function setRedirect(state, payload) {
    if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.get('auth-redirect'))) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.set('auth-redirect', payload.redirect);
    }
  },
  setAccountDetails: function setAccountDetails(state, payload) {
    state.accountDetails = payload.accountDetails;
    state.accountMissions = payload.accountDetails.missions;
    state.accountPermissions = payload.accountDetails.permissions;
  },
  clearAccountDetails: function clearAccountDetails(state) {
    state.accountDetails = null;
    state.accountMissions = null;
    state.accountPermissions = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 284 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./src/store/modules/communities.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(/*! ../../app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../../utils */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ../../router */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_communities__ = __webpack_require__(/*! ../../api/communities */ 275);








var limits = {
  communities: 10,
  communityApplications: 10,
  communityMissions: 10,
  communityPermissions: 10
};

var state = {
  checkingCommunitySlugAvalability: false,
  communities: null,
  communityApplications: null,
  communityApplicationsFilter: {},
  communityApplicationStatus: null,
  communityDetails: null,
  communityGameServers: null,
  communityMembers: null,
  communityMissions: null,
  communityPermissions: null,
  communityRepositories: null,
  communitySlugAvailable: false,
  communityVoiceComms: null,
  searchingCommunities: false,
  totalCommunities: 0,
  totalCommunityApplications: 0,
  totalCommunityMissions: 0,
  totalCommunityPermissions: 0
};

var getters = {
  checkingCommunitySlugAvalability: function checkingCommunitySlugAvalability() {
    return state.checkingCommunitySlugAvalability;
  },
  communities: function communities() {
    return state.communities;
  },
  communityApplications: function communityApplications() {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.communityApplicationsFilter)) || __WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.communityApplicationsFilter).length === 1 && __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.communityApplicationsFilter, 'processed')) {
      return state.communityApplications;
    }

    var filteredApplications = [];
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](state.communityApplications, function (application) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.communityApplicationsFilter, 'accepted') && application.status === 'accepted') {
        filteredApplications.push(application);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.communityApplicationsFilter, 'denied') && application.status === 'denied') {
        filteredApplications.push(application);
      }
    });

    return filteredApplications;
  },
  communityApplicationsPageCount: function communityApplicationsPageCount() {
    return Math.ceil(state.totalCommunityApplications / limits.communityApplications);
  },
  communityApplicationStatus: function communityApplicationStatus() {
    return state.communityApplicationStatus;
  },
  communityDetails: function communityDetails() {
    return state.communityDetails;
  },
  communityGameServers: function communityGameServers() {
    return state.communityGameServers;
  },
  communityListPageCount: function communityListPageCount() {
    return Math.ceil(state.totalCommunities / limits.communities);
  },
  communityMembers: function communityMembers() {
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.communityMembers)) {
      return state.communityMembers;
    }

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.communityDetails)) {
      return null;
    }
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](state.communityDetails.members) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](state.communityDetails.leaders)) {
      return null;
    }

    var members = [];
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](state.communityDetails.leaders, function (leader) {
      members.push(__WEBPACK_IMPORTED_MODULE_1_lodash__["defaults"](leader, { leader: true }));
    });
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](state.communityDetails.members, function (member) {
      members.push(member);
    });

    state.communityMembers = __WEBPACK_IMPORTED_MODULE_1_lodash__["sortBy"](members, [function (m) {
      return m.nickname.toUpperCase();
    }]);

    return state.communityMembers;
  },
  communityMissions: function communityMissions() {
    return state.communityMissions;
  },
  communityMissionsPageCount: function communityMissionsPageCount() {
    return Math.ceil(state.totalCommunityMissions / limits.communityMissions);
  },
  communityPermissions: function communityPermissions() {
    return state.communityPermissions;
  },
  communityPermissionsPageCount: function communityPermissionsPageCount() {
    return Math.ceil(state.totalCommunityPermissions / limits.communityPermissions);
  },
  communityRepositories: function communityRepositories() {
    return state.communityRepositories;
  },
  communitySlugAvailable: function communitySlugAvailable() {
    return state.communitySlugAvailable;
  },
  communityVoiceComms: function communityVoiceComms() {
    return state.communityVoiceComms;
  },
  searchingCommunities: function searchingCommunities() {
    return state.searchingCommunities;
  }
};

var actions = {
  applyToCommunity: function applyToCommunity(_ref, payload) {
    var dispatch = _ref.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applyToCommunity'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].applyToCommunity(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Processing community application failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (response.data.status !== "submitted") {
        console.error(response);
        throw "Received invalid community application status";
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applyToCommunity.success'),
        scrollToTop: true
      });

      dispatch('getCommunityApplicationStatus', payload);

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applyToCommunity'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applyToCommunity'));

      if (error.response) {
        console.error('applyToCommunity', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applyToCommunity.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'applyToCommunity' } }) : null;
        console.error('applyToCommunity', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applyToCommunity.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'applyToCommunity' } }) : null;
        console.error('applyToCommunity', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applyToCommunity.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  checkCommunitySlugAvailability: function checkCommunitySlugAvailability(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit({
      type: 'startCheckingCommunitySlugAvailability'
    });

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].checkCommunitySlugAvailability(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Checking community slug availability failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.available)) {
        console.error(response);
        throw "Received invalid community slug availability status";
      }

      commit({
        type: 'setCommunitySlugAvailability',
        available: response.data.available
      });
    }).catch(function (error) {
      commit({
        type: 'setCommunitySlugAvailability',
        available: false
      });

      if (error.response) {
        console.error('checkingCommunitySlugAvalability', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.checkCommunitySlugAvailability.error') + ' <strong>' + payload + '</strong> - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'checkCommunitySlugAvailability' } }) : null;
        console.error('checkingCommunitySlugAvalability', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.checkCommunitySlugAvailability.error') + ' <strong>' + payload + '</strong> - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'checkCommunitySlugAvailability' } }) : null;
        console.error('checkingCommunitySlugAvalability', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.checkCommunitySlugAvailability.error') + ' <strong>' + payload + '</strong> - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  clearCommunities: function clearCommunities(_ref3) {
    var commit = _ref3.commit;

    commit({
      type: 'clearCommunities'
    });
  },
  clearCommunityDetails: function clearCommunityDetails(_ref4) {
    var commit = _ref4.commit;

    commit({
      type: 'clearCommunityDetails'
    });
  },
  clearCommunityRepositories: function clearCommunityRepositories(_ref5) {
    var commit = _ref5.commit;

    commit({
      type: 'clearCommunityRepositories'
    });
  },
  clearCommunityServers: function clearCommunityServers(_ref6) {
    var commit = _ref6.commit;

    commit({
      type: 'clearCommunityServers'
    });
  },
  clearCommunitySlugAvailability: function clearCommunitySlugAvailability(_ref7) {
    var commit = _ref7.commit;

    commit({
      type: 'clearCommunitySlugAvailability'
    });
  },
  createCommunity: function createCommunity(_ref8, payload) {
    var dispatch = _ref8.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunity'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].createCommunity(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Creatomg community failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.community) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.community)) {
        console.error(response);
        throw "Received invalid community";
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunity.success'),
        persistentAlert: true
      });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        name: 'communityDetails',
        params: { communitySlug: response.data.community.slug }
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunity'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunity'));

      if (error.response) {
        console.error('createCommunity', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunity.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'createCommunity' } }) : null;
        console.error('createCommunity', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunity.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'createCommunity' } }) : null;
        console.error('createCommunity', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunity.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  createCommunityPermission: function createCommunityPermission(_ref9, payload) {
    var dispatch = _ref9.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunityPermission'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].createCommunityPermission(payload.communitySlug, payload.permissionDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating community permission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.permission) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.permission)) {
        console.error(response);
        throw 'Received invalid community permission';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunityPermission.success')
      });

      dispatch('getCommunityPermissions', { communitySlug: payload.communitySlug });
      dispatch('getCommunityDetails', payload.communitySlug);

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunityPermission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunityPermission'));

      if (error.response) {
        console.error('createCommunityPermission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunityPermission.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'createCommunityPermission' } }) : null;
        console.error('createCommunityPermission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunityPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'createCommunityPermission' } }) : null;
        console.error('createCommunityPermission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createCommunityPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteCommunity: function deleteCommunity(_ref10, payload) {
    var dispatch = _ref10.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunity'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].deleteCommunity(payload.communitySlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Deleting community failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (response.data.success !== true) {
        console.error(response);
        throw "Received invalid community deletion";
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunity.success') + ' <strong>' + payload.communityName + '</strong>',
        persistentAlert: true
      });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'communityList' });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunity'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunity'));

      if (error.response) {
        console.error('deleteCommunity', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunity.error') + ' <strong>' + payload.communityName + '</strong> - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'deleteCommunity' } }) : null;
        console.error('deleteCommunity', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunity.error') + ' <strong>' + payload.communityName + '</strong> - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'deleteCommunity' } }) : null;
        console.error('deleteCommunity', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunity.error') + ' <strong>' + payload.communityName + '</strong> - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteCommunityLogo: function deleteCommunityLogo(_ref11, payload) {
    var dispatch = _ref11.dispatch,
        commit = _ref11.commit,
        state = _ref11.state;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityLogo'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].deleteCommunityLogo(payload.communitySlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting community logo failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid community logo deletion';
      }

      var updatedCommunityDetails = state.communityDetails;
      updatedCommunityDetails.logoUrl = null;

      commit({
        type: 'setCommunityDetails',
        communityDetails: updatedCommunityDetails
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityLogo.success'),
        scrollToTop: true
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityLogo'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityLogo'));

      if (error.response) {
        console.error('deleteCommunityLogo', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityLogo.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'deleteCommunityLogo' } }) : null;
        console.error('deleteCommunityLogo', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityLogo.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'deleteCommunityLogo' } }) : null;
        console.error('deleteCommunityLogo', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityLogo.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteCommunityPermission: function deleteCommunityPermission(_ref12, payload) {
    var dispatch = _ref12.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityPermission'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].deleteCommunityPermission(payload.communitySlug, payload.permissionUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting community permission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid community permission deletion';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityPermission.success')
      });

      dispatch('getCommunityPermissions', { communitySlug: payload.communitySlug });
      dispatch('getCommunityDetails', payload.communitySlug);

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityPermission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityPermission'));

      if (error.response) {
        console.error('deleteCommunityPermission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityPermission.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'deleteCommunityPermission' } }) : null;
        console.error('deleteCommunityPermission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'deleteCommunityPermission' } }) : null;
        console.error('deleteCommunityPermission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteCommunityPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editCommunity: function editCommunity(_ref13, payload) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editCommunity'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].editCommunity(payload.communitySlug, payload.updatedCommunityDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Updating community details failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.community) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.community)) {
        console.error(response);
        throw "Received invalid community";
      }

      commit({
        type: 'setCommunityDetails',
        communityDetails: response.data.community
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editCommunity.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editCommunity'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editCommunity'));

      if (error.response) {
        console.error('editCommunity', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editCommunity.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'editCommunity' } }) : null;
        console.error('editCommunity', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editCommunity.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'editCommunity' } }) : null;
        console.error('editCommunity', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editCommunity.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  filterCommunityApplications: function filterCommunityApplications(_ref14, payload) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch,
        state = _ref14.state;

    var hadProcessFilter = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.communityApplicationsFilter, 'processed');

    if (!hadProcessFilter && (__WEBPACK_IMPORTED_MODULE_1_lodash__["indexOf"](payload.filter, 'accepted') >= 0 || __WEBPACK_IMPORTED_MODULE_1_lodash__["indexOf"](payload.filter, 'denied') >= 0)) {
      payload.filter.push('processed');
    }

    commit({
      type: 'setCommunityApplicationsFilter',
      communityApplicationsFilter: payload.filter
    });

    var hasProcessFilter = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.communityApplicationsFilter, 'processed');
    if (hadProcessFilter && !hasProcessFilter || !hadProcessFilter && hasProcessFilter) {
      dispatch('getCommunityApplications', { communitySlug: payload.communitySlug });
    }
  },
  getCommunities: function getCommunities(_ref15, payload) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunities'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload)) {
      payload = { page: 1 };
    } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunities(limits.communities, (payload.page - 1) * limits.communities).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving communities failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.communities) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.communities)) {
        console.error(response);
        throw "Received invalid communities";
      }

      commit({
        type: 'setCommunities',
        communities: response.data.communities,
        total: response.data.total
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunities'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunities'));

      if (error.response) {
        console.error('getCommunities', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunities.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunities' } }) : null;
        console.error('getCommunities', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunities.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunities' } }) : null;
        console.error('getCommunities', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunities.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getCommunityApplications: function getCommunityApplications(_ref16, payload) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplications'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }

    var includeProcessed = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.communityApplicationsFilter, 'processed');

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunityApplications(payload.communitySlug, limits.communityApplications, (payload.page - 1) * limits.communityApplications, includeProcessed).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving community applications failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.applications) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.applications)) {
        console.error(response);
        throw "Received invalid community applications";
      }

      commit({
        type: 'setCommunityApplications',
        communityApplications: response.data.applications,
        total: response.data.total
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplications'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplications'));

      if (error.response) {
        console.error('getCommunityApplications', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplications.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityApplications' } }) : null;
        console.error('getCommunityApplications', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplications.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityApplications' } }) : null;
        console.error('getCommunityApplications', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplications.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getCommunityApplicationStatus: function getCommunityApplicationStatus(_ref17, payload) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplicationStatus'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunityApplicationStatus(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving community application status failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.application) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.application)) {
        console.error(response);
        throw "Received invalid community application status";
      }

      commit({
        type: 'setCommunityApplicationStatus',
        application: response.data.application
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplicationStatus'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplicationStatus'));

      // Extra check for error response if no application has been sent in
      if (error.response && error.response.status === 404 && error.response.data && error.response.data.message === 'Community application not found') {
        commit({
          type: 'setCommunityApplicationStatus',
          application: null
        });
      } else if (error.response) {
        console.error('getCommunityApplicationStatus', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplicationStatus.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityApplicationStatus' } }) : null;
        console.error('getCommunityApplicationStatus', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplicationStatus.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityApplicationStatus' } }) : null;
        console.error('getCommunityApplicationStatus', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityApplicationStatus.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getCommunityDetails: function getCommunityDetails(_ref18, payload) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityDetails'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunityDetails(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving community details failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.community) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.community)) {
        console.error(response);
        throw "Received invalid community";
      }

      commit({
        type: 'setCommunityDetails',
        communityDetails: response.data.community
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityDetails'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityDetails'));

      if (error.response) {
        console.error('getCommunityDetails', error.response);

        if (error.response.status === 404) {
          dispatch('showAlert', {
            showAlert: true,
            alertVariant: 'warning',
            alertMessage: '<i class="fa fa-question" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityDetails.error.notFound', { slug: payload }),
            persistentAlert: true
          });

          return __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'communityList' });
        }

        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityDetails.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityDetails' } }) : null;
        console.error('getCommunityDetails', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityDetails' } }) : null;
        console.error('getCommunityDetails', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getCommunityMissions: function getCommunityMissions(_ref19, payload) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityMissions'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }

    // TODO remove default value once filter has been implemented
    var includeEnded = false;

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunityMissions(payload.communitySlug, limits.communityMissions, (payload.page - 1) * limits.communityMissions, includeEnded).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving community missions failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.missions) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.missions)) {
        console.error(response);
        throw "Received invalid community missions";
      }

      commit({
        type: 'setCommunityMissions',
        communityMissions: response.data.missions,
        total: response.data.total
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityMissions'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityMissions'));

      if (error.response) {
        console.error('getCommunityMissions', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityMissions.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityMissions' } }) : null;
        console.error('getCommunityMissions', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityMissions' } }) : null;
        console.error('getCommunityMissions', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getCommunityPermissions: function getCommunityPermissions(_ref20, payload) {
    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityPermissions'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunityPermissions(payload.communitySlug, limits.communityPermissions, (payload.page - 1) * limits.communityPermissions).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving community permissions failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.permissions) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.permissions)) {
        console.error(response);
        throw 'Received invalid mission permissions';
      }

      commit({
        type: 'setCommunityPermissions',
        permissions: response.data.permissions,
        total: response.data.total
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityPermissions'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityPermissions'));

      if (error.response) {
        console.error('getCommunityPermissions', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityPermissions.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityPermissions' } }) : null;
        console.error('getCommunityPermissions', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityPermissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityPermissions' } }) : null;
        console.error('getCommunityPermissions', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityPermissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getCommunityRepositories: function getCommunityRepositories(_ref21, payload) {
    var commit = _ref21.commit,
        dispatch = _ref21.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityRepositories'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunityRepositories(payload.communitySlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving community repositories failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.repositories) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.repositories)) {
        console.error(response);
        throw "Received invalid community repositories";
      }

      commit({
        type: 'setCommunityRepositories',
        repositories: response.data.repositories
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityRepositories'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityRepositories'));

      if (error.response) {
        console.error('getCommunityRepositories', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityRepositories.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityRepositories' } }) : null;
        console.error('getCommunityRepositories', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityRepositories.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityRepositories' } }) : null;
        console.error('getCommunityRepositories', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityRepositories.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getCommunityServers: function getCommunityServers(_ref22, payload) {
    var commit = _ref22.commit,
        dispatch = _ref22.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityServers'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].getCommunityServers(payload.communitySlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving community servers failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.gameServers) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.gameServers) || __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.voiceComms) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.voiceComms)) {
        console.error(response);
        throw "Received invalid community servers";
      }

      commit({
        type: 'setCommunityServers',
        gameServers: response.data.gameServers,
        voiceComms: response.data.voiceComms
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityServers'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityServers'));

      if (error.response) {
        console.error('getCommunityServers', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityServers.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityServers' } }) : null;
        console.error('getCommunityServers', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityServers.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'getCommunityServers' } }) : null;
        console.error('getCommunityServers', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getCommunityServers.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  processCommunityApplication: function processCommunityApplication(_ref23, payload) {
    var dispatch = _ref23.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].processCommunityApplication(payload.communitySlug, payload.applicationUid, payload.accepted).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Processing community application failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.application) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.application)) {
        console.error(response);
        throw "Received invalid community application";
      }

      dispatch('getCommunityDetails', payload.communitySlug);
      dispatch('getCommunityApplications', { communitySlug: payload.communitySlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.success', { action: payload.accepted ? __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.accepted') : __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.denied'), nickname: payload.applicationUserNickname })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication'));

      if (error.response) {
        console.error('processCommunityApplication', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.error', { action: payload.accepted ? __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.accept') : __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.deny'), nickname: payload.applicationUserNickname }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'processCommunityApplication' } }) : null;
        console.error('processCommunityApplication', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.error', { action: payload.accepted ? __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.accept') : __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.deny'), nickname: payload.applicationUserNickname }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'processCommunityApplication' } }) : null;
        console.error('processCommunityApplication', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.error', { action: payload.accepted ? __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.accept') : __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.processCommunityApplication.deny'), nickname: payload.applicationUserNickname }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  removeCommunityMember: function removeCommunityMember(_ref24, payload) {
    var dispatch = _ref24.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.removeCommunityMember'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].removeCommunityMember(payload.communitySlug, payload.memberUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Removing community member failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (response.data.success !== true) {
        console.error(response);
        throw "Received invalid community member removal";
      }

      dispatch('getCommunityDetails', payload.communitySlug);

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.removeCommunityMember.success', { nickname: payload.memberNickname }) + '</strong>'
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.removeCommunityMember'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.removeCommunityMember'));

      if (error.response) {
        console.error('removeCommunityMember', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.removeCommunityMember.error', { nickname: payload.memberNickname }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'removeCommunityMember' } }) : null;
        console.error('removeCommunityMember', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.removeCommunityMember.error', { nickname: payload.memberNickname }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'removeCommunityMember' } }) : null;
        console.error('removeCommunityMember', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.removeCommunityMember.error', { nickname: payload.memberNickname }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  searchCommunities: function searchCommunities(_ref25, payload) {
    var dispatch = _ref25.dispatch,
        commit = _ref25.commit;

    commit({
      type: 'searchingCommunities',
      searching: true
    });

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].searchCommunities(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Searching communities failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.communities) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.communities)) {
        console.error(response);
        throw "Received invalid communities";
      }

      commit({
        type: 'searchingCommunities',
        searching: false
      });

      var communities = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"](response.data.communities, function (community) {
        return {
          title: '[' + community.tag + '] ' + community.name,
          value: community
        };
      });

      return communities;
    }).catch(function (error) {
      commit({
        type: 'searchingCommunities',
        searching: false
      });

      if (error.response) {
        console.error('searchCommunities', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchCommunities.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'searchCommunities' } }) : null;
        console.error('searchCommunities', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchCommunities.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'searchCommunities' } }) : null;
        console.error('searchCommunities', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchCommunities.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  uploadCommunityLogo: function uploadCommunityLogo(_ref26, payload) {
    var dispatch = _ref26.dispatch,
        commit = _ref26.commit;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadCommunityLogo'));

    return __WEBPACK_IMPORTED_MODULE_5__api_communities__["a" /* default */].uploadCommunityLogo(payload.communitySlug, payload.imageType, payload.imageData).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Uploading community logo failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.community) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.community)) {
        console.error(response);
        throw 'Received invalid community logo upload';
      }

      commit({
        type: 'setCommunityDetails',
        communityDetails: response.data.community
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadCommunityLogo.success'),
        scrollToTop: true
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadCommunityLogo'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadCommunityLogo'));

      if (error.response) {
        console.error('uploadCommunityLogo', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadCommunityLogo.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'uploadCommunityLogo' } }) : null;
        console.error('uploadCommunityLogo', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadCommunityLogo.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'communities', function: 'uploadCommunityLogo' } }) : null;
        console.error('uploadCommunityLogo', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadCommunityLogo.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  }
};

var mutations = {
  clearCommunities: function clearCommunities(state) {
    state.communities = null;
    state.totalCommunities = 0;
  },
  clearCommunityDetails: function clearCommunityDetails(state) {
    state.communityApplications = null;
    state.communityDetails = null;
    state.communityMembers = null;
    state.communityMissions = null;
    state.communityPermissions = null;
    state.totalCommunityApplications = 0;
    state.totalCommunityMissions = 0;
    state.totalCommunityPermissions = 0;
  },
  clearCommunityRepositories: function clearCommunityRepositories(state) {
    state.communityRepositories = null;
  },
  clearCommunityServers: function clearCommunityServers(state) {
    state.communityGameServers = null;
    state.communityVoiceComms = null;
  },
  clearCommunitySlugAvailability: function clearCommunitySlugAvailability(state) {
    state.checkingCommunitySlugAvalability = false;
    state.communitySlug = false;
  },
  searchingCommunities: function searchingCommunities(state, payload) {
    state.searchingCommunities = payload.searching;
  },
  setCommunities: function setCommunities(state, payload) {
    state.communities = payload.communities;
    state.totalCommunities = payload.total;
  },
  setCommunityApplications: function setCommunityApplications(state, payload) {
    state.communityApplications = payload.communityApplications;
    state.totalCommunityApplications = payload.total;
  },
  setCommunityApplicationsFilter: function setCommunityApplicationsFilter(state, payload) {
    var filter = {};
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](payload.communityApplicationsFilter, function (f) {
      filter[f] = true;
    });

    state.communityApplicationsFilter = filter;
  },
  setCommunityApplicationStatus: function setCommunityApplicationStatus(state, payload) {
    state.communityApplicationStatus = payload.application;
  },
  setCommunityDetails: function setCommunityDetails(state, payload) {
    state.communityDetails = payload.communityDetails;
    state.communityMembers = null; // force community member refresh

    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(__WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('mission.community') + ' ' + state.communityDetails.name);
  },
  setCommunityMissions: function setCommunityMissions(state, payload) {
    state.communityMissions = payload.communityMissions;
    state.totalCommunityMissions = payload.total;
  },
  setCommunityPermissions: function setCommunityPermissions(state, payload) {
    state.communityPermissions = payload.permissions;
    state.totalCommunityPermissions = payload.total;
  },
  setCommunityRepositories: function setCommunityRepositories(state, payload) {
    state.communityRepositories = payload.repositories;
  },
  setCommunityServers: function setCommunityServers(state, payload) {
    state.communityGameServers = payload.gameServers;
    state.communityVoiceComms = payload.voiceComms;
  },
  setCommunitySlugAvailability: function setCommunitySlugAvailability(state, payload) {
    state.checkCommunitySlugAvailability = false;
    state.communitySlugAvailable = payload.available;
  },
  startCheckingCommunitySlugAvailability: function startCheckingCommunitySlugAvailability(state) {
    state.checkingCommunitySlugAvalability = true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 285 */
/* exports provided: default */
/* exports used: default */
/*!***************************************************!*\
  !*** ./src/store/modules/missionSlotTemplates.js ***!
  \***************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(/*! ../../app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../../utils */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ../../router */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_missionSlotTemplates__ = __webpack_require__(/*! ../../api/missionSlotTemplates */ 276);








var limits = {
  missionSlotTemplates: 10
};

var intervals = {
  missionSlotTemplatesRefresh: 300000
};

var state = {
  missionSlotTemplateDetails: null,
  missionSlotTemplates: null,
  missionSlotTemplateSlotDetails: null,
  missionSlotTemplateSlotGroupDetails: null,
  missionSlotTemplatesRefreshSetInterval: null,
  missionSlotTemplateUnsavedChanges: false,
  refreshingMissionSlotTemplates: false,
  totalMissionSlotTemplates: 0
};

var getters = {
  missionSlotTemplateDetails: function missionSlotTemplateDetails() {
    return state.missionSlotTemplateDetails;
  },
  missionSlotTemplates: function missionSlotTemplates() {
    return state.missionSlotTemplates;
  },
  missionSlotTemplateSlotDetails: function missionSlotTemplateSlotDetails() {
    return state.missionSlotTemplateSlotDetails;
  },
  missionSlotTemplateSlotGroupDetails: function missionSlotTemplateSlotGroupDetails() {
    return state.missionSlotTemplateSlotGroupDetails;
  },
  missionSlotTemplatesPageCount: function missionSlotTemplatesPageCount() {
    return Math.ceil(state.totalMissionSlotTemplates / limits.missionSlotTemplates);
  },
  missionSlotTemplatesRefreshSetInterval: function missionSlotTemplatesRefreshSetInterval() {
    return state.missionSlotTemplatesRefreshSetInterval;
  },
  missionSlotTemplateUnsavedChanges: function missionSlotTemplateUnsavedChanges() {
    return state.missionSlotTemplateUnsavedChanges;
  },
  refreshingMissionSlotTemplates: function refreshingMissionSlotTemplates() {
    return state.refreshingMissionSlotTemplates;
  }
};

var actions = {
  addMissionSlotTemplateSlot: function addMissionSlotTemplateSlot(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    var slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](state.missionSlotTemplateDetails.slotGroups);
    var slotGroupIndex = __WEBPACK_IMPORTED_MODULE_1_lodash__["findIndex"](slotGroups, function (g) {
      return g.orderNumber === state.missionSlotTemplateSlotGroupDetails.orderNumber;
    });
    if (slotGroupIndex < 0) {
      console.error('Did not find mission slot template slot group with order number ' + state.missionSlotTemplateSlotGroupDetails.orderNumber + ', aborting slot addition');
      return;
    }
    var slotGroup = slotGroups[slotGroupIndex];

    var slotsToIncrement = __WEBPACK_IMPORTED_MODULE_1_lodash__["slice"](slotGroup.slots, payload.insertAfter);
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](slotsToIncrement, function (slot) {
      slot.orderNumber += 1;
    });

    slotGroup.slots.splice(payload.insertAfter, 0, {
      orderNumber: payload.insertAfter + 1,
      title: payload.title,
      description: payload.description,
      detailedDescription: payload.detailedDescription,
      difficulty: payload.difficulty,
      blocked: payload.blocked,
      reserve: payload.reserve
    });

    commit({
      type: 'setMissionSlotTemplateSlotlist',
      slotGroups: slotGroups
    });
  },
  addMissionSlotTemplateSlotGroup: function addMissionSlotTemplateSlotGroup(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](state.missionSlotTemplateDetails.slotGroups);

    var slotGroupsToIncrement = __WEBPACK_IMPORTED_MODULE_1_lodash__["slice"](slotGroups, payload.insertAfter);
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](slotGroupsToIncrement, function (slotGroup) {
      slotGroup.orderNumber += 1;
    });

    slotGroups.splice(payload.insertAfter, 0, {
      orderNumber: payload.insertAfter + 1,
      title: payload.title,
      description: payload.description,
      slots: __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.slots) ? [] : payload.slots
    });

    commit({
      type: 'setMissionSlotTemplateSlotlist',
      slotGroups: slotGroups
    });
  },
  clearMissionSlotTemplateDetails: function clearMissionSlotTemplateDetails(_ref3) {
    var commit = _ref3.commit;

    commit({
      type: 'clearMissionSlotTemplateDetails'
    });
  },
  clearMissionSlotTemplates: function clearMissionSlotTemplates(_ref4) {
    var commit = _ref4.commit;

    commit({
      type: 'clearMissionSlotTemplates'
    });
  },
  createMissionSlotTemplate: function createMissionSlotTemplate(_ref5, payload) {
    var dispatch = _ref5.dispatch,
        commit = _ref5.commit;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotTemplate'));

    return __WEBPACK_IMPORTED_MODULE_5__api_missionSlotTemplates__["a" /* default */].createMissionSlotTemplate(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating mission slot template failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotTemplate) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slotTemplate)) {
        console.error(response);
        throw 'Received invalid mission slot template';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotTemplate.success', { title: payload.title }),
        persistentAlert: true
      });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        name: 'missionSlotTemplateDetails',
        params: { missionSlotTemplateUid: response.data.slotTemplate.uid }
      });

      commit({
        type: 'setMissionSlotTemplateDetails',
        slotTemplate: response.data.slotTemplate
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotTemplate'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotTemplate'));

      if (error.response) {
        console.error('createMissionSlotTemplate', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotTemplate.error', { title: payload.title }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'createMissionSlotTemplate' } }) : null;
        console.error('createMissionSlotTemplate', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotTemplate.error', { title: payload.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'createMissionSlotTemplate' } }) : null;
        console.error('createMissionSlotTemplate', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotTemplate.error', { title: payload.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionSlotTemplate: function deleteMissionSlotTemplate(_ref6, payload) {
    var dispatch = _ref6.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotTemplate'));

    return __WEBPACK_IMPORTED_MODULE_5__api_missionSlotTemplates__["a" /* default */].deleteMissionSlotTemplate(payload.missionSlotTemplateUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission slot template failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission slot template deletion';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotTemplate.success', { title: payload.missionSlotTemplateTitle }),
        persistentAlert: true
      });

      dispatch('getMissionSlotTemplates', { autoRefresh: true });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'missionSlotTemplateList' });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotTemplate'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotTemplate'));

      if (error.response) {
        console.error('deleteMissionSlotTemplate', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotTemplate.error', { title: payload.missionSlotTemplateTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'deleteMissionSlotTemplate' } }) : null;
        console.error('deleteMissionSlotTemplate', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotTemplate.error', { title: payload.missionSlotTemplateTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'deleteMissionSlotTemplate' } }) : null;
        console.error('deleteMissionSlotTemplate', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotTemplate.error', { title: payload.missionSlotTemplateTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editMissionSlotTemplate: function editMissionSlotTemplate(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotTemplate'));
    }

    return __WEBPACK_IMPORTED_MODULE_5__api_missionSlotTemplates__["a" /* default */].editMissionSlotTemplate(payload.missionSlotTemplateUid, payload.updatedMissionSlotTemplateDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Editing mission slot template failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotTemplate) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slotTemplate)) {
        console.error(response);
        throw 'Received invalid mission slot template ';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotTemplate.success', { title: payload.missionSlotTemplateTitle })
      });

      commit({
        type: 'setMissionSlotTemplateDetails',
        slotTemplate: response.data.slotTemplate
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotTemplate'));
      }
    }).catch(function (error) {
      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotTemplate'));
      }

      if (error.response) {
        console.error('editMissionSlotTemplate', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotTemplate.error', { title: payload.missionSlotTemplateTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'editMissionSlotTemplate' } }) : null;
        console.error('editMissionSlotTemplate', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotTemplate.error', { title: payload.missionSlotTemplateTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'editMissionSlotTemplate' } }) : null;
        console.error('editMissionSlotTemplate', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotTemplate.error', { title: payload.missionSlotTemplateTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editMissionSlotTemplateSlot: function editMissionSlotTemplateSlot(_ref8, payload) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](state.missionSlotTemplateDetails.slotGroups);
    var slotGroupIndex = __WEBPACK_IMPORTED_MODULE_1_lodash__["findIndex"](slotGroups, function (g) {
      return g.orderNumber === state.missionSlotTemplateSlotGroupDetails.orderNumber;
    });
    if (slotGroupIndex < 0) {
      console.error('Did not find mission slot template slot group with order number ' + state.missionSlotTemplateSlotGroupDetails.orderNumber + ', aborting slot editing');
      return;
    }
    var slotGroup = slotGroups[slotGroupIndex];

    var slotIndex = __WEBPACK_IMPORTED_MODULE_1_lodash__["findIndex"](slotGroup.slots, function (s) {
      return s.orderNumber === payload.slotOrderNumber;
    });
    if (slotGroupIndex < 0) {
      console.error('Did not find mission slot template slot with order number ' + payload.slotOrderNumber + ', aborting slot editing');
      return;
    }

    slotGroup.slots[slotIndex] = payload.slotPayload;

    if (payload.moveAfter >= -1) {
      var oldOrderNumber = slotGroup.slots[slotIndex].orderNumber;
      var increment = payload.moveAfter < oldOrderNumber;
      var orderNumber = increment ? payload.moveAfter + 1 : payload.moveAfter;

      __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](slotGroup.slots, function (slot) {
        if (slot.orderNumber === oldOrderNumber) {
          return;
        }

        if (increment && slot.orderNumber >= orderNumber && slot.orderNumber < oldOrderNumber) {
          slot.orderNumber += 1;
        } else if (!increment && slot.orderNumber <= orderNumber && slot.orderNumber > oldOrderNumber) {
          slot.orderNumber -= 1;
        }
      });

      slotGroup.slots[slotIndex].orderNumber = orderNumber;
    }

    commit({
      type: 'setMissionSlotTemplateSlotlist',
      slotGroups: slotGroups
    });
  },
  editMissionSlotTemplateSlotGroup: function editMissionSlotTemplateSlotGroup(_ref9, payload) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](state.missionSlotTemplateDetails.slotGroups);
    var slotGroupIndex = __WEBPACK_IMPORTED_MODULE_1_lodash__["findIndex"](slotGroups, function (g) {
      return g.orderNumber === state.missionSlotTemplateSlotGroupDetails.orderNumber;
    });
    if (slotGroupIndex < 0) {
      console.error('Did not find mission slot template slot group with order number ' + state.missionSlotTemplateSlotGroupDetails.orderNumber + ', aborting slot editing');
      return;
    }

    slotGroups[slotGroupIndex].title = payload.slotGroupPayload.title;
    slotGroups[slotGroupIndex].description = payload.slotGroupPayload.description;

    if (payload.moveAfter >= -1) {
      var oldOrderNumber = slotGroups[slotGroupIndex].orderNumber;
      var increment = payload.moveAfter < oldOrderNumber;
      var orderNumber = increment ? payload.moveAfter + 1 : payload.moveAfter;

      __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](slotGroups, function (slotGroup) {
        if (slotGroup.orderNumber === oldOrderNumber) {
          return;
        }

        if (increment && slotGroup.orderNumber >= orderNumber && slotGroup.orderNumber < oldOrderNumber) {
          slotGroup.orderNumber += 1;
        } else if (!increment && slotGroup.orderNumber <= orderNumber && slotGroup.orderNumber > oldOrderNumber) {
          slotGroup.orderNumber -= 1;
        }
      });

      slotGroups[slotGroupIndex].orderNumber = orderNumber;
    }

    commit({
      type: 'setMissionSlotTemplateSlotlist',
      slotGroups: slotGroups
    });
  },
  getMissionSlotTemplateDetails: function getMissionSlotTemplateDetails(_ref10, payload) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplateDetails'));

    return __WEBPACK_IMPORTED_MODULE_5__api_missionSlotTemplates__["a" /* default */].getMissionSlotTemplateDetails(payload.missionSlotTemplateUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission slot template details failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotTemplate) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slotTemplate)) {
        console.error(response);
        throw 'Received invalid mission slot template';
      }

      commit({
        type: 'setMissionSlotTemplateDetails',
        slotTemplate: response.data.slotTemplate
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplateDetails'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplateDetails'));

      if (error.response) {
        console.error('getMissionSlotTemplateDetails', error.response);

        if (error.response.status === 404) {
          dispatch('showAlert', {
            showAlert: true,
            alertVariant: 'warning',
            alertMessage: '<i class="fa fa-question" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplateDetails.error.notFound', { slug: payload.missionSlug })
          });

          return __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'missionSlotTemplateList' });
        }

        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplateDetails.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'getMissionSlotTemplateDetails' } }) : null;
        console.error('getMissionSlotTemplateDetails', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplateDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'getMissionSlotTemplateDetails' } }) : null;
        console.error('getMissionSlotTemplateDetails', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplateDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionSlotTemplates: function getMissionSlotTemplates(_ref11, payload) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch,
        state = _ref11.state;

    commit({
      type: 'refreshingMissionSlotTemplates',
      refreshing: true
    });

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload)) {
      payload = { page: 1, limit: limits.missionSlotTemplates, silent: false, autoRefresh: false };
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.limit)) {
      payload.limit = limits.missionSlotTemplates;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.autoRefresh)) {
      payload.autoRefresh = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplates'));
    }

    return __WEBPACK_IMPORTED_MODULE_5__api_missionSlotTemplates__["a" /* default */].getMissionSlotTemplates(payload.limit, (payload.page - 1) * payload.limit).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission slot templates failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotTemplates) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.slotTemplates)) {
        console.error(response);
        throw 'Received invalid mission slot templates';
      }

      commit({
        type: 'setMissionSlotTemplates',
        slotTemplates: response.data.slotTemplates,
        total: response.data.total
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplates'));
      }

      commit({
        type: 'refreshingMissionSlotTemplates',
        refreshing: false
      });

      if (payload.autoRefresh) {
        if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionSlotTemplatesRefreshSetInterval)) {
          clearInterval(state.missionSlotTemplatesRefreshSetInterval);
        }

        state.missionSlotTemplatesRefreshSetInterval = setInterval(function () {
          dispatch('getMissionSlotTemplates', { silent: true });
        }, intervals.missionSlotTemplatesRefresh);
      }
    }).catch(function (error) {
      commit({
        type: 'refreshingMissionSlotTemplates',
        refreshing: false
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplates'));
      }

      if (error.response) {
        console.error('getMissionSlotTemplates', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplates.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'getMissionSlotTemplates' } }) : null;
        console.error('getMissionSlotTemplates', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplates.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missionSlotTemplates', function: 'getMissionSlotTemplates' } }) : null;
        console.error('getMissionSlotTemplates', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotTemplates.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  moveMissionSlotTemplateSlotGroup: function moveMissionSlotTemplateSlotGroup(_ref12, payload) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](state.missionSlotTemplateDetails.slotGroups);
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slotGroups[payload.index])) {
      console.error('Did not find mission slot template slot group at index ' + payload.index + ', aborting move');
      return;
    }

    var destinationIndex = payload.index + payload.direction;
    if (destinationIndex >= slotGroups.length || destinationIndex < 0) {
      console.error('Destination index ' + destinationIndex + ' for mission slot template slot group at index ' + payload.index + ' is invalid, aborting move');
      return;
    }

    var tmpGroup = slotGroups[destinationIndex];
    slotGroups[destinationIndex] = slotGroups[payload.index];
    slotGroups[payload.index] = tmpGroup;
    var tmpOrderNumber = slotGroups[destinationIndex].orderNumber;
    slotGroups[destinationIndex].orderNumber = slotGroups[payload.index].orderNumber;
    slotGroups[payload.index].orderNumber = tmpOrderNumber;

    commit({
      type: 'setMissionSlotTemplateSlotlist',
      slotGroups: slotGroups
    });
  },
  removeMissionSlotTemplateSlot: function removeMissionSlotTemplateSlot(_ref13, payload) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](state.missionSlotTemplateDetails.slotGroups);
    var slotGroupIndex = __WEBPACK_IMPORTED_MODULE_1_lodash__["findIndex"](slotGroups, function (g) {
      return g.orderNumber === payload.slotGroupOrderNumber;
    });
    if (slotGroupIndex < 0) {
      console.error('Did not find mission slot template slot group with order number ' + payload.slotGroupOrderNumber + ', aborting slot deletion');
      return;
    }
    var slotGroup = slotGroups[slotGroupIndex];

    slotGroup.slots.splice(payload.index, 1);

    commit({
      type: 'setMissionSlotTemplateSlotlist',
      slotGroups: slotGroups
    });
  },
  removeMissionSlotTemplateSlotGroup: function removeMissionSlotTemplateSlotGroup(_ref14, payload) {
    var commit = _ref14.commit,
        state = _ref14.state;

    var slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["clone"](state.missionSlotTemplateDetails.slotGroups);

    slotGroups.splice(payload.index, 1);

    commit({
      type: 'setMissionSlotTemplateSlotlist',
      slotGroups: slotGroups
    });
  },
  setMissionSlotTemplateSlotDetails: function setMissionSlotTemplateSlotDetails(_ref15, payload) {
    var commit = _ref15.commit;

    commit({
      type: 'setMissionSlotTemplateSlotDetails',
      slotDetails: payload
    });
  },
  setMissionSlotTemplateSlotGroupDetails: function setMissionSlotTemplateSlotGroupDetails(_ref16, payload) {
    var commit = _ref16.commit;

    commit({
      type: 'setMissionSlotTemplateSlotGroupDetails',
      slotGroupDetails: payload
    });
  },
  setMissionSlotTemplateUnsavedChanges: function setMissionSlotTemplateUnsavedChanges(_ref17, payload) {
    var commit = _ref17.commit;

    commit({
      type: 'setMissionSlotTemplateUnsavedChanges',
      unsavedChanges: payload
    });
  }
};

var mutations = {
  clearMissionSlotTemplateDetails: function clearMissionSlotTemplateDetails(state) {
    state.missionSlotTemplateDetails = null;
    state.missionSlotTemplateSlotDetails = null;
    state.missionSlotTemplateSlotGroupDetails = null;
    state.missionSlotTemplateUnsavedChanges = false;
  },
  clearMissionSlotTemplates: function clearMissionSlotTemplates(state) {
    state.missionSlotTemplates = null;
    state.totalMissionSlotTemplates = 0;
    state.refreshingMissionSlotTemplates = false;

    if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionSlotTemplatesRefreshSetInterval)) {
      clearInterval(state.missionSlotTemplatesRefreshSetInterval);
    }
    state.missionSlotTemplatesRefreshSetInterval = null;
  },
  refreshingMissionSlotTemplates: function refreshingMissionSlotTemplates(state, payload) {
    state.refreshingMissionSlotTemplates = payload.refreshing;
  },
  setMissionSlotTemplateDetails: function setMissionSlotTemplateDetails(state, payload) {
    state.missionSlotTemplateDetails = payload.slotTemplate;
    state.missionSlotTemplateUnsavedChanges = false;
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(__WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('mission.slotTemplate') + ' ' + state.missionSlotTemplateDetails.title);
  },
  setMissionSlotTemplates: function setMissionSlotTemplates(state, payload) {
    state.missionSlotTemplates = payload.slotTemplates;
    state.totalMissionSlotTemplates = payload.total;
  },
  setMissionSlotTemplateSlotDetails: function setMissionSlotTemplateSlotDetails(state, payload) {
    state.missionSlotTemplateSlotDetails = payload.slotDetails;
  },
  setMissionSlotTemplateSlotGroupDetails: function setMissionSlotTemplateSlotGroupDetails(state, payload) {
    state.missionSlotTemplateSlotGroupDetails = payload.slotGroupDetails;
  },
  setMissionSlotTemplateSlotlist: function setMissionSlotTemplateSlotlist(state, payload) {
    payload.slotGroups = __WEBPACK_IMPORTED_MODULE_1_lodash__["orderBy"](payload.slotGroups, ['orderNumber'], ['asc']);

    var slotGroupOrderNumber = 1;
    var slotOrderNumber = 1;
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](payload.slotGroups, function (slotGroup) {
      slotGroup.orderNumber = slotGroupOrderNumber;
      slotGroup.slots = __WEBPACK_IMPORTED_MODULE_1_lodash__["orderBy"](slotGroup.slots, ['orderNumber'], ['asc']);

      __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](slotGroup.slots, function (slot) {
        slot.orderNumber = slotOrderNumber;

        slotOrderNumber += 1;
      });

      slotGroupOrderNumber += 1;
    });

    state.missionSlotTemplateDetails.slotGroups = payload.slotGroups;
    state.missionSlotTemplateUnsavedChanges = true;
  },
  setMissionSlotTemplateUnsavedChanges: function setMissionSlotTemplateUnsavedChanges(state, payload) {
    state.missionSlotTemplateUnsavedChanges = payload.unsavedChanges;
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 286 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/store/modules/missions.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(/*! ../../app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../../utils */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ../../router */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_missions__ = __webpack_require__(/*! ../../api/missions */ 277);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










var limits = {
  missionAccesses: 10,
  missionPermissions: 10,
  missions: 10,
  missionSlotRegistrations: 10
};

var intervals = {
  missionsRefresh: 300000,
  missionsForCalendarRefresh: 300000
};

var state = {
  checkingMissionSlugAvailability: false,
  missionAccesses: null,
  missionCalendarCurrentMonth: null,
  missionDetails: null,
  missionListFilter: {},
  missionListRequiredDLCsFilter: [],
  missionPermissions: null,
  missionToken: null,
  missions: null,
  missionsForCalendar: null,
  missionsForCalendarRefreshSetInterval: null,
  missionSlotDetails: null,
  missionSlotGroupDetails: null,
  missionSlotGroups: null,
  missionSlotlistFilter: {},
  missionSlotlistRequiredDLCsFilter: [],
  missionSlotRegistrationDetails: null,
  missionSlotRegistrations: null,
  missionSlotRegistrationSuppressNotifications: false,
  missionSlotSelection: [],
  missionSlugAvailable: false,
  missionsRefreshSetInterval: null,
  refreshingMissions: false,
  refreshingMissionsForCalendar: false,
  searchingMissions: false,
  totalMissionAccesses: 0,
  totalMissionPermissions: 0,
  totalMissions: 0,
  totalMissionSlotRegistrations: 0
};

var getters = {
  checkingMissionSlugAvailability: function checkingMissionSlugAvailability() {
    return state.checkingMissionSlugAvailability;
  },
  missionAccesses: function missionAccesses() {
    return state.missionAccesses;
  },
  missionAccessesPageCount: function missionAccessesPageCount() {
    return Math.ceil(state.totalMissionAccesses / limits.missionAccesses);
  },
  missionCalendarCurrentMonth: function missionCalendarCurrentMonth() {
    return state.missionCalendarCurrentMonth;
  },
  missionDetails: function missionDetails() {
    return state.missionDetails;
  },
  missionListFilter: function missionListFilter() {
    return __WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionListFilter);
  },
  missionListRequiredDLCsFilter: function missionListRequiredDLCsFilter() {
    return state.missionListRequiredDLCsFilter;
  },
  missionPermissions: function missionPermissions() {
    return state.missionPermissions;
  },
  missionPermissionsPageCount: function missionPermissionsPageCount() {
    return Math.ceil(state.totalMissionPermissions / limits.missionPermissions);
  },
  missions: function missions() {
    if ((__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionListFilter)) || __WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionListFilter).length === 1 && __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionListFilter, 'ended')) && __WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](state.missionListRequiredDLCsFilter)) {
      return state.missions;
    }

    function missionListFilter(mission) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionListFilter)) || __WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionListFilter).length === 1 && __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionListFilter, 'ended')) {
        return true;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionListFilter, 'assigned') && mission.isAssignedToAnySlot) {
        return true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionListFilter, 'registered') && mission.isRegisteredForAnySlot) {
        return true;
      }

      return false;
    }

    function missionListRequiredDLCsFilter(mission) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](state.missionListRequiredDLCsFilter)) {
        return true;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](mission.requiredDLCs)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_lodash__["every"](state.missionListRequiredDLCsFilter, function (filter) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash__["indexOf"](mission.requiredDLCs, filter) >= 0;
      });
    }

    var filteredMissions = [];
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](state.missions, function (mission) {
      if (missionListFilter(mission) && missionListRequiredDLCsFilter(mission)) {
        filteredMissions.push(mission);
      }
    });

    return filteredMissions;
  },
  missionsForCalendar: function missionsForCalendar() {
    return state.missionsForCalendar;
  },
  missionsForCalendarRefreshSetInterval: function missionsForCalendarRefreshSetInterval() {
    return state.missionsForCalendarRefreshSetInterval;
  },
  missionSlotDetails: function missionSlotDetails() {
    return state.missionSlotDetails;
  },
  missionSlotGroupDetails: function missionSlotGroupDetails() {
    return state.missionSlotGroupDetails;
  },
  missionSlotGroups: function missionSlotGroups() {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionSlotlistFilter)) && __WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](state.missionSlotlistRequiredDLCsFilter)) {
      return state.missionSlotGroups;
    }

    function slotlistFilter(slot) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](__WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionSlotlistFilter))) {
        return true;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionSlotlistFilter, 'assigned') && (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.assignee) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.externalAssignee))) {
        return true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionSlotlistFilter, 'hasRegistrations') && __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.assignee) && slot.registrationCount > 0) {
        return true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionSlotlistFilter, 'open') && __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.assignee) && slot.registrationCount <= 0 && !slot.blocked) {
        return true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionSlotlistFilter, 'blocked') && slot.blocked) {
        return true;
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionSlotlistFilter, 'restricted') && !__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.restrictedCommunity)) {
        return true;
      }

      return false;
    }

    function slotlistRequiredDLCsFilter(slot) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](state.missionSlotlistRequiredDLCsFilter)) {
        return true;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](slot.requiredDLCs)) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_lodash__["every"](state.missionSlotlistRequiredDLCsFilter, function (filter) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash__["indexOf"](slot.requiredDLCs, filter) >= 0;
      });
    }

    var filteredSlotGroups = [];
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](state.missionSlotGroups, function (slotGroup) {
      var filteredSlots = [];

      __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](slotGroup.slots, function (slot) {
        if (slotlistFilter(slot) && slotlistRequiredDLCsFilter(slot)) {
          filteredSlots.push(slot);
        }
      });

      filteredSlotGroups.push(__WEBPACK_IMPORTED_MODULE_1_lodash__["defaults"]({
        slots: filteredSlots
      }, slotGroup));
    });

    return filteredSlotGroups;
  },
  missionSlotlistFilter: function missionSlotlistFilter() {
    return __WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.missionSlotlistFilter);
  },
  missionSlotlistRequiredDLCsFilter: function missionSlotlistRequiredDLCsFilter() {
    return state.missionSlotlistRequiredDLCsFilter;
  },
  missionSlotRegistrationDetails: function missionSlotRegistrationDetails() {
    return state.missionSlotRegistrationDetails;
  },
  missionSlotRegistrations: function missionSlotRegistrations() {
    return state.missionSlotRegistrations;
  },
  missionSlotRegistrationsPageCount: function missionSlotRegistrationsPageCount() {
    return Math.ceil(state.totalMissionSlotRegistrations / limits.missionSlotRegistrations);
  },
  missionSlotRegistrationSuppressNotifications: function missionSlotRegistrationSuppressNotifications() {
    return state.missionSlotRegistrationSuppressNotifications;
  },
  missionSlotSelection: function missionSlotSelection() {
    return state.missionSlotSelection;
  },
  missionSlugAvailable: function missionSlugAvailable() {
    return state.missionSlugAvailable;
  },
  missionsPageCount: function missionsPageCount() {
    return Math.ceil(state.totalMissions / limits.missions);
  },
  missionToken: function missionToken() {
    return state.missionToken;
  },
  refreshingMissions: function refreshingMissions() {
    return state.refreshingMissions;
  },
  refreshingMissionsForCalendar: function refreshingMissionsForCalendar() {
    return state.refreshingMissionsForCalendar;
  },
  searchingMissions: function searchingMissions() {
    return state.searchingMissions;
  },
  selectedMissionSlots: function selectedMissionSlots() {
    var slots = [];

    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](state.missionSlotGroups, function (slotGroup) {
      var matchedSlots = __WEBPACK_IMPORTED_MODULE_1_lodash__["filter"](slotGroup.slots, function (slot) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash__["indexOf"](state.missionSlotSelection, slot.uid) >= 0;
      });

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](matchedSlots)) {
        slots.push.apply(slots, _toConsumableArray(matchedSlots));
      }
    });

    return slots;
  },
  unfilteredMissionSlotGroups: function unfilteredMissionSlotGroups() {
    return state.missionSlotGroups;
  }
};

var actions = {
  addMissionAccess: function addMissionAccess(_ref, payload) {
    var dispatch = _ref.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionAccess'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].addMissionAccess(payload.missionSlug, payload.missionAccessDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating mission access failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.access) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.access)) {
        console.error(response);
        throw 'Received invalid mission access';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionAccess.success')
      });

      dispatch('getMissionAccesses', { missionSlug: payload.missionSlug });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionAccess'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionAccess'));

      if (error.response) {
        console.error('addMissionAccess', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionAccess.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'addMissionAccess' } }) : null;
        console.error('addMissionAccess', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionAccess.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'addMissionAccess' } }) : null;
        console.error('addMissionAccess', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionAccess.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  addMissionPermission: function addMissionPermission(_ref2, payload) {
    var dispatch = _ref2.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionPermission'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.suppressNotifications)) {
      payload.suppressNotifications = false;
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].addMissionPermission(payload.missionSlug, payload.permissionDetails, payload.suppressNotifications).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating mission permission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.permission) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.permission)) {
        console.error(response);
        throw 'Received invalid mission permission';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionPermission.success')
      });

      dispatch('getMissionPermissions', { missionSlug: payload.missionSlug });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionPermission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionPermission'));

      if (error.response) {
        console.error('addMissionPermission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionPermission.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'addMissionPermission' } }) : null;
        console.error('addMissionPermission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'addMissionPermission' } }) : null;
        console.error('addMissionPermission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.addMissionPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  applySlotTemplateToMission: function applySlotTemplateToMission(_ref3, payload) {
    var dispatch = _ref3.dispatch,
        commit = _ref3.commit;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applySlotTemplateToMission'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].applySlotTemplateToMission(payload.missionSlug, payload.slotTemplateUid, payload.insertAfter).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Applying slot template to mission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotGroups) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.slotGroups)) {
        console.error(response);
        throw 'Received invalid slot template application';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applySlotTemplateToMission.success')
      });

      commit({
        type: 'setMissionSlotlist',
        slotGroups: response.data.slotGroups
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applySlotTemplateToMission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applySlotTemplateToMission'));

      if (error.response) {
        console.error('applySlotTemplateToMission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applySlotTemplateToMission.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'applySlotTemplateToMission' } }) : null;
        console.error('applySlotTemplateToMission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applySlotTemplateToMission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'applySlotTemplateToMission' } }) : null;
        console.error('applySlotTemplateToMission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.applySlotTemplateToMission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  assignMissionSlot: function assignMissionSlot(_ref4, payload) {
    var dispatch = _ref4.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.assignMissionSlot'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.suppressNotifications)) {
      payload.suppressNotifications = false;
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].assignMissionSlot(payload.missionSlug, payload.slotUid, payload.userUid, payload.force, payload.suppressNotifications).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Assigning mission slot failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slot) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slot)) {
        console.error(response);
        throw 'Received invalid mission slot assignment';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.assignMissionSlot.success')
      });

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.assignMissionSlot'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.assignMissionSlot'));

      if (error.response) {
        console.error('assignMissionSlot', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.assignMissionSlot.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'assignMissionSlot' } }) : null;
        console.error('assignMissionSlot', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.assignMissionSlot.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'assignMissionSlot' } }) : null;
        console.error('assignMissionSlot', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.assignMissionSlot.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  changeMissionCalendarCurrentMonth: function changeMissionCalendarCurrentMonth(_ref5, payload) {
    var commit = _ref5.commit;

    commit({
      type: 'setMissionCalendarCurrentMonth',
      currentMonth: payload
    });
  },
  checkMissionSlugAvailability: function checkMissionSlugAvailability(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    commit({
      type: 'startCheckingMissionSlugAvailability'
    });

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].checkMissionSlugAvailability(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Checking mission slug availability failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.available)) {
        console.error(response);
        throw 'Received invalid mission slug availability status';
      }

      commit({
        type: 'setMissionSlugAvailability',
        available: response.data.available
      });
    }).catch(function (error) {
      commit({
        type: 'setMissionSlugAvailability',
        available: false
      });

      if (error.response) {
        console.error('checkMissionSlugAvailability', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.checkMissionSlugAvailability', { slug: payload }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'setMissionSlugAvailability' } }) : null;
        console.error('checkMissionSlugAvailability', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.checkMissionSlugAvailability', { slug: payload }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'setMissionSlugAvailability' } }) : null;
        console.error('checkMissionSlugAvailability', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.checkMissionSlugAvailability', { slug: payload }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  clearMissionDetails: function clearMissionDetails(_ref7) {
    var commit = _ref7.commit;

    commit({
      type: 'clearMissionDetails'
    });
  },
  clearMissions: function clearMissions(_ref8) {
    var commit = _ref8.commit;

    commit({
      type: 'clearMissions'
    });
  },
  clearMissionSlotDetails: function clearMissionSlotDetails(_ref9) {
    var commit = _ref9.commit;

    commit({
      type: 'clearMissionSlotDetails'
    });
  },
  clearMissionSlotGroupDetails: function clearMissionSlotGroupDetails(_ref10) {
    var commit = _ref10.commit;

    commit({
      type: 'clearMissionSlotGroupDetails'
    });
  },
  clearMissionSlotSelection: function clearMissionSlotSelection(_ref11) {
    var commit = _ref11.commit;

    commit({
      type: 'clearMissionSlotSelection'
    });
  },
  createMission: function createMission(_ref12, payload) {
    var dispatch = _ref12.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMission'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].createMission(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating mission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.mission) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.mission)) {
        console.error(response);
        throw 'Received invalid mission';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMission.success', { title: payload.title }),
        persistentAlert: true
      });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        name: 'missionDetails',
        params: { missionSlug: response.data.mission.slug }
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMission'));

      if (error.response) {
        console.error('createMission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMission.error', { title: payload.title }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'createMission' } }) : null;
        console.error('createMission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMission.error', { title: payload.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'createMission' } }) : null;
        console.error('createMission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMission.error', { title: payload.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  createMissionSlot: function createMissionSlot(_ref13, payload) {
    var dispatch = _ref13.dispatch;

    var slotCount = __WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](payload.slotDetails) ? payload.slotDetails.length : 1;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.createMissionSlot', slotCount, { count: slotCount }));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].createMissionSlot(payload.missionSlug, payload.slotDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating mission slot failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slots) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.slots) || __WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data.slots)) {
        console.error(response);
        throw 'Received invalid mission slot';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.createMissionSlot.success', slotCount, { count: slotCount })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.createMissionSlot', slotCount, { count: slotCount }));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.createMissionSlot', slotCount, { count: slotCount }));

      if (error.response) {
        console.error('createMissionSlot', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.createMissionSlot.error', slotCount, { count: slotCount }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'createMissionSlot' } }) : null;
        console.error('createMissionSlot', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.createMissionSlot.error', slotCount, { count: slotCount }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'createMissionSlot' } }) : null;
        console.error('createMissionSlot', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.createMissionSlot.error', slotCount, { count: slotCount }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  createMissionSlotGroup: function createMissionSlotGroup(_ref14, payload) {
    var dispatch = _ref14.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotGroup'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].createMissionSlotGroup(payload.missionSlug, payload.slotGroupDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating mission slot group failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotGroup) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slotGroup)) {
        console.error(response);
        throw 'Received invalid mission slot group';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotGroup.success', { slotInfo: '#' + payload.slotGroupDetails.orderNumber + ' ' + payload.slotGroupDetails.title })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotGroup'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotGroup'));

      if (error.response) {
        console.error('createMissionSlotGroup', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotGroup.error', { slotInfo: '#' + payload.slotGroupDetails.orderNumber + ' ' + payload.slotGroupDetails.title }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'createMissionSlotGroup' } }) : null;
        console.error('createMissionSlotGroup', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotGroup.error', { slotInfo: '#' + payload.slotGroupDetails.orderNumber + ' ' + payload.slotGroupDetails.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'createMissionSlotGroup' } }) : null;
        console.error('createMissionSlotGroup', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.createMissionSlotGroup.error', { slotInfo: '#' + payload.slotGroupDetails.orderNumber + ' ' + payload.slotGroupDetails.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMission: function deleteMission(_ref15, payload) {
    var dispatch = _ref15.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMission'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMission(payload.missionSlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission deletion';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMission.success', { title: payload.missionTitle }),
        persistentAlert: true
      });

      dispatch('getMissions', { autoRefresh: true });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'missionList' });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMission'));

      if (error.response) {
        console.error('deleteMission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMission.error', { title: payload.missionTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMission' } }) : null;
        console.error('deleteMission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMission.error', { title: payload.missionTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMission' } }) : null;
        console.error('deleteMission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMission.error', { title: payload.missionTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionAccess: function deleteMissionAccess(_ref16, payload) {
    var dispatch = _ref16.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionAccess'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMissionAccess(payload.missionSlug, payload.missionAccessUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission access failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission access deletion';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionAccess.success')
      });

      dispatch('getMissionAccesses', { missionSlug: payload.missionSlug });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionAccess'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionAccess'));

      if (error.response) {
        console.error('deleteMissionAccess', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionAccess.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionAccess' } }) : null;
        console.error('deleteMissionAccess', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionAccess.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionAccess' } }) : null;
        console.error('deleteMissionAccess', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionAccess.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionBannerImage: function deleteMissionBannerImage(_ref17, payload) {
    var dispatch = _ref17.dispatch,
        commit = _ref17.commit,
        state = _ref17.state;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionBannerImage'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMissionBannerImage(payload.missionSlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission banner image failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission banner image deletion';
      }

      var updatedMissionDetails = state.missionDetails;
      updatedMissionDetails.bannerImageUrl = null;

      commit({
        type: 'setMissionDetails',
        mission: updatedMissionDetails
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionBannerImage.success'),
        scrollToTop: true
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionBannerImage'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionBannerImage'));

      if (error.response) {
        console.error('deleteMissionBannerImage', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionBannerImage.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionBannerImage' } }) : null;
        console.error('deleteMissionBannerImage', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionBannerImage.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionBannerImage' } }) : null;
        console.error('deleteMissionBannerImage', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionBannerImage.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionPermission: function deleteMissionPermission(_ref18, payload) {
    var dispatch = _ref18.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionPermission'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMissionPermission(payload.missionSlug, payload.permissionUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission permission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission permission deletion';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionPermission.success')
      });

      dispatch('getMissionPermissions', { missionSlug: payload.missionSlug });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionPermission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionPermission'));

      if (error.response) {
        console.error('deleteMissionPermission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionPermission.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionPermission' } }) : null;
        console.error('deleteMissionPermission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionPermission' } }) : null;
        console.error('deleteMissionPermission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionPermission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionSlot: function deleteMissionSlot(_ref19, payload) {
    var dispatch = _ref19.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlot'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMissionSlot(payload.missionSlug, payload.slotUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission slot failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission slot deletion';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlot.success', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlot'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlot'));

      if (error.response) {
        console.error('deleteMissionSlot', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionSlot' } }) : null;
        console.error('deleteMissionSlot', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionSlot' } }) : null;
        console.error('deleteMissionSlot', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionSlotGroup: function deleteMissionSlotGroup(_ref20, payload) {
    var dispatch = _ref20.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotGroup'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMissionSlotGroup(payload.missionSlug, payload.slotGroupUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission slot group failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission slot group deletion';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotGroup.success', { title: payload.slotGroupTitle })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotGroup'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotGroup'));

      if (error.response) {
        console.error('deleteMissionSlotGroup', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotGroup.error', { title: payload.slotGroupTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionSlotGroup' } }) : null;
        console.error('deleteMissionSlotGroup', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotGroup.error', { title: payload.slotGroupTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionSlotGroup' } }) : null;
        console.error('deleteMissionSlotGroup', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotGroup.error', { title: payload.slotGroupTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionToken: function deleteMissionToken(_ref21, payload) {
    var dispatch = _ref21.dispatch,
        commit = _ref21.commit;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionToken'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMissionToken(payload.missionSlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission token failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission token deletion';
      }

      commit({
        type: 'clearMissionToken'
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionToken.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionToken'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionToken'));

      if (error.response) {
        console.error('deleteMissionToken', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionToken.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionToken' } }) : null;
        console.error('deleteMissionToken', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionToken' } }) : null;
        console.error('deleteMissionToken', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteSelectedMissionSlots: function deleteSelectedMissionSlots(_ref22, payload) {
    var dispatch = _ref22.dispatch,
        state = _ref22.state;

    var selectedSlotCount = state.missionSlotSelection.length;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.deleteSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));

    return Promise.each(state.missionSlotSelection, function (slotUid) {
      return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].deleteMissionSlot(payload.missionSlug, slotUid).then(function (response) {
        if (response.status !== 200) {
          console.error(response);
          throw 'Deleting mission slot failed';
        }

        if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
          console.error(response);
          throw 'Received empty response';
        }

        if (response.data.success !== true) {
          console.error(response);
          throw 'Received invalid mission slot deletion';
        }
      });
    }).then(function () {
      dispatch('clearMissionSlotSelection');

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.deleteSelectedMissionSlots.success', selectedSlotCount, { count: selectedSlotCount })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.deleteSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.deleteSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));

      if (error.response) {
        console.error('deleteSelectedMissionSlots', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteSelectedMissionSlots.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteSelectedMissionSlots' } }) : null;
        console.error('deleteSelectedMissionSlots', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteSelectedMissionSlots.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteSelectedMissionSlots' } }) : null;
        console.error('deleteSelectedMissionSlots', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteSelectedMissionSlots.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  duplicateMission: function duplicateMission(_ref23, payload) {
    var dispatch = _ref23.dispatch,
        commit = _ref23.commit;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMission'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].duplicateMission(payload.missionSlug, payload.missionDuplicatePayload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Duplicating mission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.mission) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.mission)) {
        console.error(response);
        throw 'Received invalid mission';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMission.success'),
        scrollToTop: true,
        persistentAlert: true
      });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        name: 'missionDetails',
        params: { missionSlug: response.data.mission.slug }
      });

      commit({
        type: 'setMissionDetails',
        mission: response.data.mission
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMission'));

      if (error.response) {
        console.error('duplicateMission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMission.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'duplicateMission' } }) : null;
        console.error('duplicateMission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'duplicateMission' } }) : null;
        console.error('duplicateMission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMission.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  duplicateMissionSlotGroup: function duplicateMissionSlotGroup(_ref24, payload) {
    var dispatch = _ref24.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMissionSlotGroup'));

    var slotGroupDetails = {
      description: payload.missionSlotGroup.description,
      title: payload.missionSlotGroup.title,
      insertAfter: payload.missionSlotGroup.orderNumber
    };

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].createMissionSlotGroup(payload.missionSlug, slotGroupDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Creating mission slot group failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotGroup) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slotGroup)) {
        console.error(response);
        throw 'Received invalid mission slot group';
      }

      var slotGroupUid = response.data.slotGroup.uid;

      var slotDetails = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"](payload.missionSlotGroup.slots, function (slot) {
        return {
          detailedDescription: slot.detailedDescription,
          difficulty: slot.difficulty,
          reserve: slot.reserve,
          blocked: slot.blocked,
          restrictedCommunityUid: __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.restrictedCommunity) ? null : slot.restrictedCommunity.uid,
          description: slot.description,
          title: slot.title,
          autoAssignable: slot.autoAssignable,
          requiredDLCs: slot.requiredDLCs,
          insertAfter: __WEBPACK_IMPORTED_MODULE_1_lodash__["max"]([slot.orderNumber - 1, 0]),
          slotGroupUid: slotGroupUid,
          duplicate: true
        };
      });

      return dispatch('createMissionSlot', { missionSlug: payload.missionSlug, slotDetails: slotDetails });
    }).then(function () {
      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMissionSlotGroup.success', { slotGroupInfo: '#' + payload.missionSlotGroup.orderNumber + ' ' + payload.missionSlotGroup.title })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMissionSlotGroup'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMissionSlotGroup'));

      if (error.response) {
        console.error('duplicateMissionSlotGroup', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMissionSlotGroup.error', { slotGroupInfo: '#' + payload.missionSlotGroup.orderNumber + ' ' + payload.missionSlotGroup.title }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'duplicateMissionSlotGroup' } }) : null;
        console.error('duplicateMissionSlotGroup', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMissionSlotGroup.error', { slotGroupInfo: '#' + payload.missionSlotGroup.orderNumber + ' ' + payload.missionSlotGroup.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'duplicateMissionSlotGroup' } }) : null;
        console.error('duplicateMissionSlotGroup', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.duplicateMissionSlotGroup.error', { slotGroupInfo: '#' + payload.missionSlotGroup.orderNumber + ' ' + payload.missionSlotGroup.title }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  deleteMissionSlotRegistration: function deleteMissionSlotRegistration(_ref25, payload) {
    var dispatch = _ref25.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotRegistration'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].unregisterFromMissionSlot(payload.missionSlug, payload.slotUid, payload.registrationUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Deleting mission slot registration failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission slot registration deletion';
      }

      dispatch('getMissionSlotRegistrations', {
        missionSlug: payload.missionSlug,
        slotUid: payload.slotUid,
        slotOrderNumber: payload.slotOrderNumber,
        slotTitle: payload.slotTitle
      });

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotRegistration.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotRegistration'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotRegistration'));

      if (error.response) {
        console.error('deleteMissionSlotRegistration', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotRegistration.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionSlotRegistration' } }) : null;
        console.error('deleteMissionSlotRegistration', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotRegistration.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'deleteMissionSlotRegistration' } }) : null;
        console.error('deleteMissionSlotRegistration', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteMissionSlotRegistration.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editMission: function editMission(_ref26, payload) {
    var commit = _ref26.commit,
        dispatch = _ref26.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMission'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.suppressNotifications)) {
      payload.suppressNotifications = false;
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].editMission(payload.missionSlug, payload.updatedMissionDetails, payload.suppressNotifications).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Editing mission failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.mission) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.mission)) {
        console.error(response);
        throw 'Received invalid mission';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMission.success', { title: payload.missionTitle })
      });

      commit({
        type: 'setMissionDetails',
        mission: response.data.mission
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMission'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMission'));

      if (error.response) {
        console.error('editMission', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMission.error', { title: payload.missionTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editMission' } }) : null;
        console.error('editMission', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMission.error', { title: payload.missionTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editMission' } }) : null;
        console.error('editMission', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMission.error', { title: payload.missionTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editMissionSlot: function editMissionSlot(_ref27, payload) {
    var dispatch = _ref27.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlot'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].editMissionSlot(payload.missionSlug, payload.slotUid, payload.updatedSlotDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Editing mission slot failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slot) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slot)) {
        console.error(response);
        throw 'Received invalid mission slot';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlot.success', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlot'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlot'));

      if (error.response) {
        console.error('editMissionSlot', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editMissionSlot' } }) : null;
        console.error('editMissionSlot', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editMissionSlot' } }) : null;
        console.error('editMissionSlot', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editMissionSlotGroup: function editMissionSlotGroup(_ref28, payload) {
    var dispatch = _ref28.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotGroup'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].editMissionSlotGroup(payload.missionSlug, payload.slotGroupUid, payload.updatedSlotGroupDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Editing mission slot group failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotGroup) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slotGroup)) {
        console.error(response);
        throw 'Received invalid mission slot group';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotGroup.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotGroup'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotGroup'));

      if (error.response) {
        console.error('editMissionSlotGroup', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotGroup.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editMissionSlotGroup' } }) : null;
        console.error('editMissionSlotGroup', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotGroup.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editMissionSlotGroup' } }) : null;
        console.error('editMissionSlotGroup', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editMissionSlotGroup.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editSelectedMissionSlots: function editSelectedMissionSlots(_ref29, payload) {
    var dispatch = _ref29.dispatch,
        state = _ref29.state;

    var selectedSlotCount = state.missionSlotSelection.length;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.editSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));

    return Promise.each(state.missionSlotSelection, function (slotUid) {
      return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].editMissionSlot(payload.missionSlug, slotUid, payload.updatedMissionSlotDetails).then(function (response) {
        if (response.status !== 200) {
          console.error(response);
          throw 'Editing mission slot failed';
        }

        if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
          console.error(response);
          throw 'Received empty response';
        }

        if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slot) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slot)) {
          console.error(response);
          throw 'Received invalid mission slot';
        }
      });
    }).then(function () {
      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.editSelectedMissionSlots.success', selectedSlotCount, { count: selectedSlotCount })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.editSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.editSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));

      if (error.response) {
        console.error('editSelectedMissionSlots', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editSelectedMissionSlots.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editSelectedMissionSlots' } }) : null;
        console.error('editSelectedMissionSlots', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editSelectedMissionSlots.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'editSelectedMissionSlots' } }) : null;
        console.error('editSelectedMissionSlots', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editSelectedMissionSlots.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  filterMissionList: function filterMissionList(_ref30, payload) {
    var commit = _ref30.commit,
        dispatch = _ref30.dispatch,
        state = _ref30.state;

    var hadEndedFilter = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionListFilter, 'ended');

    commit({
      type: 'setMissionListFilter',
      missionListFilter: payload
    });

    var hasEndedFilter = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionListFilter, 'ended');
    if (hadEndedFilter && !hasEndedFilter || !hadEndedFilter && hasEndedFilter) {
      dispatch('getMissions');
    }
  },
  filterMissionListRequiredDLCs: function filterMissionListRequiredDLCs(_ref31, payload) {
    var commit = _ref31.commit;

    commit({
      type: 'setMissionListRequiredDLCsFilter',
      missionListRequiredDLCsFilter: payload
    });
  },
  filterMissionSlotlist: function filterMissionSlotlist(_ref32, payload) {
    var commit = _ref32.commit;

    commit({
      type: 'setMissionSlotlistFilter',
      missionSlotlistFilter: payload
    });
  },
  filterMissionSlotlistRequiredDLCs: function filterMissionSlotlistRequiredDLCs(_ref33, payload) {
    var commit = _ref33.commit;

    commit({
      type: 'setMissionSlotlistRequiredDLCsFilter',
      missionSlotlistRequiredDLCsFilter: payload
    });
  },
  generateMissionToken: function generateMissionToken(_ref34, payload) {
    var commit = _ref34.commit,
        dispatch = _ref34.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.generateMissionToken'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].generateMissionToken(payload.missionSlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Generating mission token failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.missionToken) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isString"](response.data.missionToken)) {
        console.error(response);
        throw 'Received invalid mission token';
      }

      commit({
        type: 'setMissionToken',
        missionToken: response.data.missionToken
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.generateMissionToken.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.generateMissionToken'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.generateMissionToken'));

      if (error.response) {
        console.error('generateMissionToken', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.generateMissionToken.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'generateMissionToken' } }) : null;
        console.error('generateMissionToken', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.generateMissionToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'generateMissionToken' } }) : null;
        console.error('generateMissionToken', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.generateMissionToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionAccesses: function getMissionAccesses(_ref35, payload) {
    var commit = _ref35.commit,
        dispatch = _ref35.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionAccesses'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissionAccesses(payload.missionSlug, limits.missionAccesses, (payload.page - 1) * limits.missionAccesses).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission accesses failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.accesses) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.accesses)) {
        console.error(response);
        throw 'Received invalid mission accesses';
      }

      commit({
        type: 'setMissionAccesses',
        accesses: response.data.accesses,
        total: response.data.total
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionAccesses'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionAccesses'));

      if (error.response) {
        console.error('getMissionAccesses', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionAccesses.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionAccesses' } }) : null;
        console.error('getMissionAccesses', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionAccesses.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionAccesses' } }) : null;
        console.error('getMissionAccesses', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionAccesses.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionDetails: function getMissionDetails(_ref36, payload) {
    var commit = _ref36.commit,
        dispatch = _ref36.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionDetails'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissionDetails(payload.missionSlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission details failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.mission) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.mission)) {
        console.error(response);
        throw 'Received invalid mission';
      }

      commit({
        type: 'setMissionDetails',
        mission: response.data.mission
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionDetails'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionDetails'));

      if (error.response) {
        console.error('getMissionDetails', error.response);

        if (error.response.status === 404) {
          dispatch('showAlert', {
            showAlert: true,
            alertVariant: 'warning',
            alertMessage: '<i class="fa fa-question" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionDetails.error.notFound', { slug: payload.missionSlug }),
            persistentAlert: true
          });

          return __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'missionList' });
        }

        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionDetails.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionDetails' } }) : null;
        console.error('getMissionDetails', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionDetails' } }) : null;
        console.error('getMissionDetails', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionPermissions: function getMissionPermissions(_ref37, payload) {
    var commit = _ref37.commit,
        dispatch = _ref37.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionPermissions'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissionPermissions(payload.missionSlug, limits.missionPermissions, (payload.page - 1) * limits.missionPermissions).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission permissions failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.permissions) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.permissions)) {
        console.error(response);
        throw 'Received invalid mission permissions';
      }

      commit({
        type: 'setMissionPermissions',
        permissions: response.data.permissions,
        total: response.data.total
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionPermissions'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionPermissions'));

      if (error.response) {
        console.error('getMissionPermissions', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionPermissions.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionPermissions' } }) : null;
        console.error('getMissionPermissions', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionPermissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionPermissions' } }) : null;
        console.error('getMissionPermissions', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionPermissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissions: function getMissions(_ref38, payload) {
    var commit = _ref38.commit,
        dispatch = _ref38.dispatch,
        state = _ref38.state;

    commit({
      type: 'refreshingMissions',
      refreshing: true
    });

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload)) {
      payload = { page: 1, silent: false, autoRefresh: false };
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.autoRefresh)) {
      payload.autoRefresh = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissions'));
    }

    var includeEnded = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.missionListFilter, 'ended');

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissions(limits.missions, (payload.page - 1) * limits.missions, includeEnded).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving missions failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.missions) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.missions)) {
        console.error(response);
        throw 'Received invalid missions';
      }

      commit({
        type: 'setMissions',
        missions: response.data.missions,
        total: response.data.total
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissions'));
      }

      commit({
        type: 'refreshingMissions',
        refreshing: false
      });

      if (payload.autoRefresh) {
        if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionsRefreshSetInterval)) {
          clearInterval(state.missionsRefreshSetInterval);
        }

        state.missionsRefreshSetInterval = setInterval(function () {
          dispatch('getMissions', { silent: true });
        }, intervals.missionsRefresh);
      }
    }).catch(function (error) {
      commit({
        type: 'refreshingMissions',
        refreshing: false
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissions'));
      }

      if (error.response) {
        console.error('getMissions', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissions.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissions' } }) : null;
        console.error('getMissions', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissions' } }) : null;
        console.error('getMissions', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionsForCalendar: function getMissionsForCalendar(_ref39, payload) {
    var commit = _ref39.commit,
        dispatch = _ref39.dispatch,
        state = _ref39.state;

    commit({
      type: 'refreshingMissionsForCalendar',
      refreshing: true
    });

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload)) {
      payload = { autoRefresh: false, startDate: __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().startOf('month'), endDate: __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().endOf('month') };
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.autoRefresh)) {
      payload.autoRefresh = false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.startDate)) {
      payload.startDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().startOf('month');
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.endDate)) {
      payload.endDate = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().endOf('month');
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissionsForCalendar(payload.startDate.valueOf(), payload.endDate.valueOf()).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving missions for calendar failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.missions) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.missions)) {
        console.error(response);
        throw 'Received invalid missions';
      }

      commit({
        type: 'setMissionsForCalendar',
        missions: response.data.missions
      });

      commit({
        type: 'refreshingMissionsForCalendar',
        refreshing: false
      });

      if (payload.autoRefresh) {
        if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionsForCalendarRefreshSetInterval)) {
          clearInterval(state.missionsForCalendarRefreshSetInterval);
        }

        state.missionsForCalendarRefreshSetInterval = setInterval(function () {
          dispatch('getMissionsForCalendar', { startDate: payload.startDate, endDate: payload.endDate });
        }, intervals.missionsForCalendarRefresh);
      }
    }).catch(function (error) {
      commit({
        type: 'refreshingMissionsForCalendar',
        refreshing: false
      });

      if (error.response) {
        console.error('getMissionsForCalendar', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionsForCalendar.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionsForCalendar' } }) : null;
        console.error('getMissionsForCalendar', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionsForCalendar.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionsForCalendar' } }) : null;
        console.error('getMissionsForCalendar', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionsForCalendar.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionSlotlist: function getMissionSlotlist(_ref40, payload) {
    var commit = _ref40.commit,
        dispatch = _ref40.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotlist'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissionSlotlist(payload.missionSlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission slotlist failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slotGroups) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.slotGroups)) {
        console.error(response);
        throw 'Received invalid mission slotlist';
      }

      commit({
        type: 'setMissionSlotlist',
        slotGroups: response.data.slotGroups
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotlist'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotlist'));

      if (error.response) {
        console.error('getMissionSlotlist', error.response);

        if (error.response.status === 404) {
          // Redirect + alert is handled by getMissionDetails endpoint
          return;
        }

        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotlist.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionSlotlist' } }) : null;
        console.error('getMissionSlotlist', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotlist.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionSlotlist' } }) : null;
        console.error('getMissionSlotlist', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotlist.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionSlotRegistrations: function getMissionSlotRegistrations(_ref41, payload) {
    var commit = _ref41.commit,
        dispatch = _ref41.dispatch;

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    } else if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotRegistrations'));
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissionSlotRegistrations(payload.missionSlug, payload.slotUid, limits.missionSlotRegistrations, (payload.page - 1) * limits.missionSlotRegistrations).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission slot registrations failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.registrations) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.registrations)) {
        console.error(response);
        throw 'Received invalid mission slot registrations';
      }

      commit({
        type: 'setMissionSlotRegistrations',
        registrations: response.data.registrations,
        total: response.data.total
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotRegistrations'));
      }
    }).catch(function (error) {
      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotRegistrations'));
      }

      if (error.response) {
        console.error('getMissionSlotRegistrations', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotRegistrations.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionSlotRegistrations' } }) : null;
        console.error('getMissionSlotRegistrations', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotRegistrations.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionSlotRegistrations' } }) : null;
        console.error('getMissionSlotRegistrations', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionSlotRegistrations.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getMissionToken: function getMissionToken(_ref42, payload) {
    var commit = _ref42.commit,
        dispatch = _ref42.dispatch;

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionToken'));
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].getMissionToken(payload.missionSlug).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving mission token failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isString"](response.data.missionToken) && !__WEBPACK_IMPORTED_MODULE_1_lodash__["isNull"](response.data.missionToken)) {
        console.error(response);
        throw 'Received invalid mission token';
      }

      commit({
        type: 'setMissionToken',
        missionToken: response.data.missionToken
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionToken'));
      }
    }).catch(function (error) {
      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionToken'));
      }

      if (error.response) {
        console.error('getMissionToken', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionToken.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionToken' } }) : null;
        console.error('getMissionToken', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'getMissionToken' } }) : null;
        console.error('getMissionToken', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getMissionToken.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  modifyMissionSlotRegistration: function modifyMissionSlotRegistration(_ref43, payload) {
    var dispatch = _ref43.dispatch,
        state = _ref43.state;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.modifyMissionSlotRegistration'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.suppressNotifications)) {
      payload.suppressNotifications = __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionSlotRegistrationSuppressNotifications) ? false : state.missionSlotRegistrationSuppressNotifications;
    }

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].modifyMissionSlotRegistration(payload.missionSlug, payload.slotUid, payload.registrationUid, payload.confirm, payload.suppressNotifications).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Modifying mission slot registration failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.registration) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.registration)) {
        console.error(response);
        throw 'Received invalid mission slot registration';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });
      dispatch('getMissionSlotRegistrations', {
        missionSlug: payload.missionSlug,
        slotUid: state.missionSlotDetails.uid,
        slotOrderNumber: state.missionSlotDetails.orderNumber,
        slotTitle: state.missionSlotDetails.title
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.modifyMissionSlotRegistration.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.modifyMissionSlotRegistration'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.modifyMissionSlotRegistration'));

      if (error.response) {
        console.error('modifyMissionSlotRegistration', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.modifyMissionSlotRegistration.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'modifyMissionSlotRegistration' } }) : null;
        console.error('modifyMissionSlotRegistration', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.modifyMissionSlotRegistration.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'modifyMissionSlotRegistration' } }) : null;
        console.error('modifyMissionSlotRegistration', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.modifyMissionSlotRegistration.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  registerForMissionSlot: function registerForMissionSlot(_ref44, payload) {
    var dispatch = _ref44.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.registerForMissionSlot'));

    var comment = __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.comment) || __WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](payload.comment) ? null : payload.comment;

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].registerForMissionSlot(payload.missionSlug, payload.slotUid, comment).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Registering for mission slot failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.registration) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.registration)) {
        console.error(response);
        throw 'Received invalid mission slot registration';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.registerForMissionSlot.success', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }),
        scrollToTop: true
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.registerForMissionSlot'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.registerForMissionSlot'));

      if (error.response) {
        console.error('registerForMissionSlot', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.registerForMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'registerForMissionSlot' } }) : null;
        console.error('registerForMissionSlot', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.registerForMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'registerForMissionSlot' } }) : null;
        console.error('registerForMissionSlot', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.registerForMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  searchMissions: function searchMissions(_ref45, payload) {
    var dispatch = _ref45.dispatch,
        commit = _ref45.commit;

    commit({
      type: 'searchingMissions',
      searching: true
    });

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].searchMissions(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Searching missions failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.missions) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.missions)) {
        console.error(response);
        throw "Received invalid missions";
      }

      commit({
        type: 'searchingMissions',
        searching: false
      });

      var missions = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"](response.data.missions, function (mission) {
        return {
          title: '[' + __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(mission.startTime).format('L LT') + '] ' + mission.title + ' (' + mission.creator.nickname + ')',
          value: mission
        };
      });

      return missions;
    }).catch(function (error) {
      commit({
        type: 'searchingMissions',
        searching: false
      });

      if (error.response) {
        console.error('searchMissions', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchMissions.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'searchMissions' } }) : null;
        console.error('searchMissions', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'searchMissions' } }) : null;
        console.error('searchMissions', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  setMissionSlotDetails: function setMissionSlotDetails(_ref46, payload) {
    var commit = _ref46.commit;

    commit({
      type: 'setMissionSlotDetails',
      slotDetails: payload
    });
  },
  setMissionSlotGroupDetails: function setMissionSlotGroupDetails(_ref47, payload) {
    var commit = _ref47.commit;

    commit({
      type: 'setMissionSlotGroupDetails',
      slotGroupDetails: payload
    });
  },
  setMissionSlotRegistrationSuppressNotifications: function setMissionSlotRegistrationSuppressNotifications(_ref48, payload) {
    var commit = _ref48.commit;

    commit({
      type: 'setMissionSlotRegistrationSuppressNotifications',
      suppressNotifications: payload.suppressNotifications
    });
  },
  toggleMissionSlotSelection: function toggleMissionSlotSelection(_ref49, payload) {
    var commit = _ref49.commit;

    commit({
      type: 'toggleMissionSlotSelection',
      missionSlotUid: payload.missionSlotUid
    });
  },
  unassignSelectedMissionSlots: function unassignSelectedMissionSlots(_ref50, payload) {
    var dispatch = _ref50.dispatch,
        state = _ref50.state;

    var selectedSlotCount = state.missionSlotSelection.length;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.unassignSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));

    return Promise.each(state.missionSlotSelection, function (slotUid) {
      var missionSlot = null;

      __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](state.missionSlotGroups, function (missionSlotGroup) {
        var slot = __WEBPACK_IMPORTED_MODULE_1_lodash__["find"](missionSlotGroup.slots, { uid: slotUid });
        if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot)) {
          if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.assignee) && __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](slot.externalAssignee)) {
            return;
          }

          missionSlot = slot;
          return false;
        }

        return;
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](missionSlot)) {
        return Promise.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].unassignMissionSlot(payload.missionSlug, slotUid).then(function (response) {
        if (response.status !== 200) {
          console.error(response);
          throw 'Unassigning mission slot failed';
        }

        if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
          console.error(response);
          throw 'Received empty response';
        }

        if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.slot) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.slot)) {
          console.error(response);
          throw 'Received invalid mission slot';
        }
      });
    }).then(function () {
      dispatch('clearMissionSlotSelection');

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.unassignSelectedMissionSlots.success', selectedSlotCount, { count: selectedSlotCount })
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.unassignSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].tc('store.unassignSelectedMissionSlots', selectedSlotCount, { count: selectedSlotCount }));

      if (error.response) {
        console.error('unassignSelectedMissionSlots', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unassignSelectedMissionSlots.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'unassignSelectedMissionSlots' } }) : null;
        console.error('unassignSelectedMissionSlots', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unassignSelectedMissionSlots.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'unassignSelectedMissionSlots' } }) : null;
        console.error('unassignSelectedMissionSlots', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unassignSelectedMissionSlots.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  unregisterFromMissionSlot: function unregisterFromMissionSlot(_ref51, payload) {
    var dispatch = _ref51.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unregisterFromMissionSlot'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].unregisterFromMissionSlot(payload.missionSlug, payload.slotUid, payload.registrationUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Unregistering from mission slot failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid mission slot registration deletion';
      }

      dispatch('getMissionSlotlist', { missionSlug: payload.missionSlug });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unregisterFromMissionSlot.success', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }),
        scrollToTop: true
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unregisterFromMissionSlot'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unregisterFromMissionSlot'));

      if (error.response) {
        console.error('unregisterFromMissionSlot', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unregisterFromMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'unregisterFromMissionSlot' } }) : null;
        console.error('unregisterFromMissionSlot', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unregisterFromMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'unregisterFromMissionSlot' } }) : null;
        console.error('unregisterFromMissionSlot', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.unregisterFromMissionSlot.error', { slotInfo: '#' + payload.slotOrderNumber + ' ' + payload.slotTitle }) + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  uploadMissionBannerImage: function uploadMissionBannerImage(_ref52, payload) {
    var dispatch = _ref52.dispatch,
        commit = _ref52.commit;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadMissionBannerImage'));

    return __WEBPACK_IMPORTED_MODULE_6__api_missions__["a" /* default */].uploadMissionBannerImage(payload.missionSlug, payload.imageType, payload.imageData).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Uploading mission banner image failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.mission) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.mission)) {
        console.error(response);
        throw 'Received invalid mission banner image upload';
      }

      commit({
        type: 'setMissionDetails',
        mission: response.data.mission
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadMissionBannerImage.success'),
        scrollToTop: true
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadMissionBannerImage'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadMissionBannerImage'));

      if (error.response) {
        console.error('uploadMissionBannerImage', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadMissionBannerImage.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'uploadMissionBannerImage' } }) : null;
        console.error('uploadMissionBannerImage', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadMissionBannerImage.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'missions', function: 'uploadMissionBannerImage' } }) : null;
        console.error('uploadMissionBannerImage', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.uploadMissionBannerImage.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  }
};

var mutations = {
  clearMissions: function clearMissions(state) {
    state.missions = null;
    state.totalMissions = 0;
    state.refreshingMissions = false;

    if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionsRefreshSetInterval)) {
      clearInterval(state.missionsRefreshSetInterval);
    }
    state.missionsRefreshSetInterval = null;
  },
  clearMissionDetails: function clearMissionDetails(state) {
    state.missionAccesses = null;
    state.missionDetails = null;
    state.missionPermissions = null;
    state.missionSlotDetails = null;
    state.missionSlotGroupDetails = null;
    state.missionSlotGroups = null;
    state.missionSlotRegistrations = null;
    state.missionSlotRegistrationSuppressNotifications = false;
    state.missionSlotSelection = [];
    state.missionToken = null;
    state.totalMissionAccesses = 0;
    state.totalMissionPermissions = 0;
    state.totalMissionSlotRegistrations = 0;
  },
  clearMissionSlotDetails: function clearMissionSlotDetails(state) {
    state.missionSlotDetails = null;
  },
  clearMissionSlotGroupDetails: function clearMissionSlotGroupDetails(state) {
    state.missionSlotGroupDetails = null;
  },
  clearMissionSlotSelection: function clearMissionSlotSelection(state) {
    state.missionSlotSelection = [];
  },
  clearMissionToken: function clearMissionToken(state) {
    state.missionToken = null;
  },
  refreshingMissions: function refreshingMissions(state, payload) {
    state.refreshingMissions = payload.refreshing;
  },
  refreshingMissionsForCalendar: function refreshingMissionsForCalendar(state, payload) {
    state.refreshingMissionsForCalendar = payload.refreshing;
  },
  searchingMissions: function searchingMissions(state, payload) {
    state.searchingMissions = payload.searching;
  },
  setMissionAccesses: function setMissionAccesses(state, payload) {
    state.missionAccesses = payload.accesses;
    state.totalMissionAccesses = payload.total;
  },
  setMissionBannerImageUrl: function setMissionBannerImageUrl(state, payload) {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionDetails)) {
      console.warn('setMissionBannerImageUrl', 'Somehow lost mission details while uploading banner image... Oh well');
      return;
    }

    state.missionDetails.bannerImageUrl = payload.bannerImageUrl;
  },
  setMissionCalendarCurrentMonth: function setMissionCalendarCurrentMonth(state, payload) {
    state.missionCalendarCurrentMonth = payload.currentMonth;
    state.missionsForCalendar = null;
    state.refreshingMissionsForCalendar = false;

    if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.missionsForCalendarRefreshSetInterval)) {
      clearInterval(state.missionsForCalendarRefreshSetInterval);
    }
  },
  setMissionDetails: function setMissionDetails(state, payload) {
    state.missionDetails = payload.mission;
    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(__WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('mission') + ' ' + state.missionDetails.title);
  },
  setMissionPermissions: function setMissionPermissions(state, payload) {
    state.missionPermissions = payload.permissions;
    state.totalMissionPermissions = payload.total;
  },
  setMissions: function setMissions(state, payload) {
    state.missions = payload.missions;
    state.totalMissions = payload.total;
  },
  setMissionsForCalendar: function setMissionsForCalendar(state, payload) {
    state.missionsForCalendar = payload.missions;
  },
  setMissionSlugAvailability: function setMissionSlugAvailability(state, payload) {
    state.checkingMissionSlugAvailability = false;
    state.missionSlugAvailable = payload.available;
  },
  setMissionSlotDetails: function setMissionSlotDetails(state, payload) {
    state.missionSlotDetails = payload.slotDetails;
  },
  setMissionSlotGroupDetails: function setMissionSlotGroupDetails(state, payload) {
    state.missionSlotGroupDetails = payload.slotGroupDetails;
  },
  setMissionSlotlist: function setMissionSlotlist(state, payload) {
    state.missionSlotGroups = payload.slotGroups;
  },
  setMissionListFilter: function setMissionListFilter(state, payload) {
    var filter = {};
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](payload.missionListFilter, function (f) {
      filter[f] = true;
    });

    state.missionListFilter = filter;
  },
  setMissionListRequiredDLCsFilter: function setMissionListRequiredDLCsFilter(state, payload) {
    state.missionListRequiredDLCsFilter = payload.missionListRequiredDLCsFilter;
  },
  setMissionSlotlistFilter: function setMissionSlotlistFilter(state, payload) {
    var filter = {};
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](payload.missionSlotlistFilter, function (f) {
      filter[f] = true;
    });

    state.missionSlotlistFilter = filter;
  },
  setMissionSlotlistRequiredDLCsFilter: function setMissionSlotlistRequiredDLCsFilter(state, payload) {
    state.missionSlotlistRequiredDLCsFilter = payload.missionSlotlistRequiredDLCsFilter;
  },
  setMissionSlotRegistrations: function setMissionSlotRegistrations(state, payload) {
    state.missionSlotRegistrations = payload.registrations;
    state.totalMissionSlotRegistrations = payload.total;
  },
  setMissionSlotRegistrationSuppressNotifications: function setMissionSlotRegistrationSuppressNotifications(state, payload) {
    state.missionSlotRegistrationSuppressNotifications = payload.suppressNotifications;
  },
  setMissionToken: function setMissionToken(state, payload) {
    state.missionToken = payload.missionToken;
  },
  startCheckingMissionSlugAvailability: function startCheckingMissionSlugAvailability(state) {
    state.checkingMissionSlugAvailability = true;
  },
  toggleMissionSlotSelection: function toggleMissionSlotSelection(state, payload) {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["indexOf"](state.missionSlotSelection, payload.missionSlotUid) >= 0) {
      state.missionSlotSelection = __WEBPACK_IMPORTED_MODULE_1_lodash__["without"](state.missionSlotSelection, payload.missionSlotUid);
    } else {
      state.missionSlotSelection.push(payload.missionSlotUid);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 287 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./src/store/modules/notifications.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(/*! ../../app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_notifications__ = __webpack_require__(/*! ../../api/notifications */ 278);






var limits = {
  notifications: 10
};

var intervals = {
  unseenNotificationCountRefresh: 60000
};

var state = {
  notificationListFilter: {},
  notifications: null,
  notificationsPage: 1,
  refreshingNotifications: false,
  totalNotifications: 0,
  unseenNotificationCount: 0,
  unseenNotificationCountSetInterval: null
};

var getters = {
  notificationListFilter: function notificationListFilter() {
    return __WEBPACK_IMPORTED_MODULE_1_lodash__["keys"](state.notificationListFilter);
  },
  notificationsPageCount: function notificationsPageCount() {
    return Math.ceil(state.totalNotifications / limits.notifications);
  },
  notifications: function notifications() {
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](state.notifications)) {
      return null;
    }

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.notificationListFilter, 'seen')) {
      return state.notifications;
    }

    var start = __WEBPACK_IMPORTED_MODULE_1_lodash__["min"]([(state.notificationsPage - 1) * limits.notifications, state.notifications.length]);
    var end = __WEBPACK_IMPORTED_MODULE_1_lodash__["min"]([start + limits.notifications, state.notifications.length]);

    return __WEBPACK_IMPORTED_MODULE_1_lodash__["slice"](state.notifications, start, end);
  },
  pollingUnseenNotifications: function pollingUnseenNotifications() {
    return !__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.unseenNotificationCountSetInterval);
  },
  refreshingNotifications: function refreshingNotifications() {
    return state.refreshingNotifications;
  },
  unseenNotificationCount: function unseenNotificationCount() {
    return state.unseenNotificationCount;
  }
};

var actions = {
  clearNotifications: function clearNotifications(_ref) {
    var commit = _ref.commit;

    commit({
      type: 'clearNotifications'
    });
  },
  filterNotificationList: function filterNotificationList(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;

    var hadSeenFilter = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.notificationListFilter, 'seen');

    commit({
      type: 'setNotificationListFilter',
      notificationListFilter: payload
    });

    var hasSeenFilter = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.notificationListFilter, 'seen');
    if (hadSeenFilter && !hasSeenFilter || !hadSeenFilter && hasSeenFilter) {
      dispatch('getNotifications');
    }
  },
  getNotifications: function getNotifications(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        state = _ref3.state;

    commit({
      type: 'refreshingNotifications',
      refreshing: true
    });

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload)) {
      payload = { page: 1, limit: limits.notifications, silent: false };
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.limit)) {
      payload.limit = limits.notifications;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getNotifications'));
    }

    var includeSeen = __WEBPACK_IMPORTED_MODULE_1_lodash__["has"](state.notificationListFilter, 'seen');

    return __WEBPACK_IMPORTED_MODULE_3__api_notifications__["a" /* default */].getNotifications(payload.limit, (payload.page - 1) * payload.limit, includeSeen).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving notifications failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.notifications) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.notifications)) {
        console.error(response);
        throw 'Received invalid notifications';
      }

      commit({
        type: 'setNotifications',
        notifications: response.data.notifications,
        total: __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.total) ? response.data.notifications.length : response.data.total
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getNotifications'));
      }

      commit({
        type: 'refreshingNotifications',
        refreshing: false
      });
    }).catch(function (error) {
      commit({
        type: 'refreshingNotifications',
        refreshing: false
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getNotifications'));
      }

      if (error.response) {
        console.error('getNotifications', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getNotifications.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(error, { extra: { module: 'notifications', function: 'getNotifications' } }) : null;
        console.error('getNotifications', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getNotifications.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(error, { extra: { module: 'notifications', function: 'getNotifications' } }) : null;
        console.error('getNotifications', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getNotifications.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getUnseenNotificationCount: function getUnseenNotificationCount(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload)) {
      payload = { autoRefresh: false };
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.autoRefresh)) {
      payload.autoRefresh = false;
    }

    return __WEBPACK_IMPORTED_MODULE_3__api_notifications__["a" /* default */].getUnseenNotificationCount().then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving unseen notification count failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.unseen) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isFinite"](response.data.unseen)) {
        console.error(response);
        throw 'Received invalid unseen notification count';
      }

      commit({
        type: 'setUnseenNotificationCount',
        unseen: response.data.unseen
      });

      if (payload.autoRefresh) {
        if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.unseenNotificationCountSetInterval)) {
          clearInterval(state.unseenNotificationCountSetInterval);
        }

        state.unseenNotificationCountSetInterval = setInterval(function () {
          dispatch('getUnseenNotificationCount');
        }, intervals.unseenNotificationCountRefresh);
      }
    }).catch(function (error) {
      if (error.response) {
        console.error('getUnseenNotificationCount', error.response);

        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUnseenNotificationCount.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(error, { extra: { module: 'notifications', function: 'getUnseenNotificationCount' } }) : null;
        console.error('getUnseenNotificationCount', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUnseenNotificationCount.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(error, { extra: { module: 'notifications', function: 'getUnseenNotificationCount' } }) : null;
        console.error('getUnseenNotificationCount', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUnseenNotificationCount.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  paginateNotifications: function paginateNotifications(_ref5, payload) {
    var commit = _ref5.commit;

    commit({
      type: 'setNotificationsPage',
      page: payload.page
    });
  },
  stopNotificationPolling: function stopNotificationPolling(_ref6) {
    var state = _ref6.state;

    if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.unseenNotificationCountSetInterval)) {
      clearInterval(state.unseenNotificationCountSetInterval);
    }
  }
};

var mutations = {
  clearNotifications: function clearNotifications(state) {
    state.notifications = null;
    state.notificationsPage = 1;
    state.refreshingNotifications = false;
    state.totalNotifications = 0;
  },
  refreshingNotifications: function refreshingNotifications(state, payload) {
    state.refreshingNotifications = payload.refreshing;
  },
  setNotificationListFilter: function setNotificationListFilter(state, payload) {
    var filter = {};
    __WEBPACK_IMPORTED_MODULE_1_lodash__["each"](payload.notificationListFilter, function (f) {
      filter[f] = true;
    });

    state.notificationListFilter = filter;
  },
  setNotifications: function setNotifications(state, payload) {
    state.notifications = payload.notifications;
    state.totalNotifications = payload.total;
  },
  setNotificationsPage: function setNotificationsPage(state, payload) {
    state.notificationsPage = payload.page;
  },
  setUnseenNotificationCount: function setUnseenNotificationCount(state, payload) {
    state.unseenNotificationCount = payload.unseen;
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 288 */
/* exports provided: default */
/* exports used: default */
/*!************************************!*\
  !*** ./src/store/modules/users.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(/*! ../../app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../../utils */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ../../router */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_users__ = __webpack_require__(/*! ../../api/users */ 280);








var limits = {
  userMissions: 10,
  users: 10
};

var intervals = {
  usersRefresh: 300000
};

var state = {
  refreshingUsers: false,
  searchingUsers: false,
  totalUserMissions: 0,
  totalUsers: 0,
  userDetails: null,
  userMissions: null,
  users: null,
  usersRefreshSetInterval: null
};

var getters = {
  searchingUsers: function searchingUsers() {
    return state.searchingUsers;
  },
  userDetails: function userDetails() {
    return state.userDetails;
  },
  userMissions: function userMissions() {
    return state.userMissions;
  },
  userMissionsPageCount: function userMissionsPageCount() {
    return Math.ceil(state.totalUserMissions / limits.users);
  },
  users: function users() {
    return state.users;
  },
  usersPageCount: function usersPageCount() {
    return Math.ceil(state.totalUsers / limits.users);
  },
  refreshingUsers: function refreshingUsers() {
    return state.refreshingUsers;
  }
};

var actions = {
  clearUserDetails: function clearUserDetails(_ref) {
    var commit = _ref.commit;

    commit({
      type: 'clearUserDetails'
    });
  },
  deleteUser: function deleteUser(_ref2, payload) {
    var dispatch = _ref2.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteUser'));

    return __WEBPACK_IMPORTED_MODULE_5__api_users__["a" /* default */].deleteUser(payload.userUid).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Deleting user failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (response.data.success !== true) {
        console.error(response);
        throw 'Received invalid user deletion';
      }

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteUser.success'),
        persistentAlert: true
      });

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'home' });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteUser'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteUser'));

      if (error.response) {
        console.error('deleteUser', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteUser.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'deleteUser' } }) : null;
        console.error('deleteUser', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteUser.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'deleteUser' } }) : null;
        console.error('deleteUser', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.deleteUser.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  editUser: function editUser(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editUser'));

    return __WEBPACK_IMPORTED_MODULE_5__api_users__["a" /* default */].editUser(payload.userUid, payload.updatedUserDetails).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Updating user details failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.user) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.user)) {
        console.error(response);
        throw "Received invalid user";
      }

      commit({
        type: 'setUserDetails',
        userDetails: response.data.user
      });

      dispatch('showAlert', {
        showAlert: true,
        alertVariant: 'success',
        alertMessage: '<i class="fa fa-check" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editUser.success')
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editUser'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editUser'));

      if (error.response) {
        console.error('editUser', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editUser.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'editUser' } }) : null;
        console.error('editUser', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editUser.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'editUser' } }) : null;
        console.error('editUser', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.editUser.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getUserDetails: function getUserDetails(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserDetails'));

    return __WEBPACK_IMPORTED_MODULE_5__api_users__["a" /* default */].getUserDetails(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving user details failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.user) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isObject"](response.data.user)) {
        console.error(response);
        throw "Received invalid user";
      }

      commit({
        type: 'setUserDetails',
        userDetails: response.data.user
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserDetails'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserDetails'));

      if (error.response) {
        console.error('getUserDetails', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserDetails.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'getUserDetails' } }) : null;
        console.error('getUserDetails', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'getUserDetails' } }) : null;
        console.error('getUserDetails', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserDetails.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getUsers: function getUsers(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    commit({
      type: 'refreshingUsers',
      refreshing: true
    });

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload)) {
      payload = { page: 1, limit: limits.users, silent: false, autoRefresh: false };
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.limit)) {
      payload.limit = limits.users;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.silent)) {
      payload.silent = false;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.autoRefresh)) {
      payload.autoRefresh = false;
    }

    if (!payload.silent) {
      dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUsers'));
    }

    return __WEBPACK_IMPORTED_MODULE_5__api_users__["a" /* default */].getUsers(payload.limit, (payload.page - 1) * payload.limit).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw 'Retrieving users failed';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw 'Received empty response';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.users) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.users)) {
        console.error(response);
        throw 'Received invalid users';
      }

      commit({
        type: 'setUsers',
        users: response.data.users,
        total: response.data.total
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUsers'));
      }

      commit({
        type: 'refreshingUsers',
        refreshing: false
      });

      if (payload.autoRefresh) {
        if (!__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](state.usersRefreshSetInterval)) {
          clearInterval(state.usersRefreshSetInterval);
        }

        state.usersRefreshSetInterval = setInterval(function () {
          dispatch('getUsers', { silent: true });
        }, intervals.usersRefresh);
      }
    }).catch(function (error) {
      commit({
        type: 'refreshingUsers',
        refreshing: false
      });

      if (!payload.silent) {
        dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUsers'));
      }

      if (error.response) {
        console.error('getUsers', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUsers.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'getUsers' } }) : null;
        console.error('getUsers', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUsers.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'getUsers' } }) : null;
        console.error('getUsers', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUsers.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  getUserMissions: function getUserMissions(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    dispatch('startWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserMissions'));

    if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](payload.page)) {
      payload.page = 1;
    }

    // TODO remove default value once filter has been implemented
    var includeEnded = false;

    return __WEBPACK_IMPORTED_MODULE_5__api_users__["a" /* default */].getUserMissions(payload.userUid, limits.userMissions, (payload.page - 1) * limits.userMissions, includeEnded).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving user missions failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.missions) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.missions)) {
        console.error(response);
        throw "Received invalid user missions";
      }

      commit({
        type: 'setUserMissions',
        userMissions: response.data.missions,
        total: response.data.total
      });

      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserMissions'));
    }).catch(function (error) {
      dispatch('stopWorking', __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserMissions'));

      if (error.response) {
        console.error('getUserMissions', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserMissions.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'getUserMissions' } }) : null;
        console.error('getUserMissions', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'getUserMissions' } }) : null;
        console.error('getUserMissions', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.getUserMissions.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  },
  searchUsers: function searchUsers(_ref7, payload) {
    var dispatch = _ref7.dispatch,
        commit = _ref7.commit;

    commit({
      type: 'searchingUsers',
      searching: true
    });

    return __WEBPACK_IMPORTED_MODULE_5__api_users__["a" /* default */].searchUsers(payload).then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Searching users failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](response.data.users) || !__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"](response.data.users)) {
        console.error(response);
        throw "Received invalid users";
      }

      commit({
        type: 'searchingUsers',
        searching: false
      });

      var users = __WEBPACK_IMPORTED_MODULE_1_lodash__["map"](response.data.users, function (user) {
        return {
          title: __WEBPACK_IMPORTED_MODULE_1_lodash__["isNil"](user.community) ? user.nickname : '[' + user.community.tag + '] ' + user.nickname,
          value: user
        };
      });

      return users;
    }).catch(function (error) {
      commit({
        type: 'searchingUsers',
        searching: false
      });

      if (error.response) {
        console.error('searchUsers', error.response);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchUsers.error') + ' - ' + error.response.data.message
        });
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'searchUsers' } }) : null;
        console.error('searchUsers', error.request);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchUsers.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.request')
        });
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'users', function: 'searchUsers' } }) : null;
        console.error('searchUsers', error.message);
        dispatch('showAlert', {
          showAlert: true,
          alertVariant: 'danger',
          alertMessage: '<i class="fa fa-bolt" aria-hidden="true"></i> ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('store.searchUsers.error') + ' - ' + __WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('failed.something')
        });
      }
    });
  }
};

var mutations = {
  clearUserDetails: function clearUserDetails(state) {
    state.totalUserMissions = 0;
    state.userDetails = null;
    state.userMissions = null;
  },
  refreshingUsers: function refreshingUsers(state, payload) {
    state.refreshingUsers = payload.refreshing;
  },
  searchingUsers: function searchingUsers(state, payload) {
    state.searchingUsers = payload.searching;
  },
  setUserDetails: function setUserDetails(state, payload) {
    state.userDetails = payload.userDetails;

    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].setTitle(__WEBPACK_IMPORTED_MODULE_0__app__["b" /* i18n */].t('user') + ' ' + state.userDetails.nickname);
  },
  setUserMissions: function setUserMissions(state, payload) {
    state.userMissions = payload.userMissions;
    state.totalUserMissions = payload.total;
  },
  setUsers: function setUsers(state, payload) {
    state.users = payload.users;
    state.totalUsers = payload.total;
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 289 */
/* exports provided: default */
/* exports used: default */
/*!***********************************!*\
  !*** ./src/store/modules/util.js ***!
  \***********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ../../app */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(/*! lodash */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(/*! moment-timezone */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(/*! raven-js */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_status__ = __webpack_require__(/*! ../../api/status */ 279);








var state = {
  backendVersion: null,
  activeWork: [],
  timezone: null
};

var getters = {
  backendVersion: function backendVersion() {
    return state.backendVersion;
  },
  working: function working() {
    return state.activeWork.length > 0 ? state.activeWork[0] : null;
  },
  timezone: function timezone() {
    return state.timezone;
  }
};

var actions = {
  getBackendVersion: function getBackendVersion(_ref) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_5__api_status__["a" /* default */].getStatus().then(function (response) {
      if (response.status !== 200) {
        console.error(response);
        throw "Retrieving backend version failed";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](response.data)) {
        console.error(response);
        throw "Received empty response";
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash__["isNil"](response.data.version) || !__WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](response.data.version)) {
        console.error(response);
        throw "Received invalid version";
      }

      commit({
        type: 'setBackendVersion',
        backendVersion: response.data.version
      });
    }).catch(function (error) {
      if (error.response) {
        console.error('getBackendVersion', error.response);
      } else if (error.request) {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'util', function: 'getBackendVersion' } }) : null;
        console.error('getBackendVersion', error.request);
      } else {
        error.message !== "Network Error" ? __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureException(error, { extra: { module: 'util', function: 'getBackendVersion' } }) : null;
        console.error('getBackendVersion', error.message);
      }
    });
  },
  setLocale: function setLocale(_ref2, payload) {
    var commit = _ref2.commit;

    commit({
      type: 'setLocale',
      locale: payload
    });
  },
  setTimezone: function setTimezone(_ref3, payload) {
    var commit = _ref3.commit;

    commit({
      type: 'setTimezone',
      timezone: payload
    });
  },
  startWorking: function startWorking(_ref4, payload) {
    var commit = _ref4.commit;

    commit({
      type: 'startWorking',
      message: payload
    });
  },
  stopWorking: function stopWorking(_ref5, payload) {
    var commit = _ref5.commit;

    commit({
      type: 'stopWorking',
      message: payload
    });
  }
};

var mutations = {
  setBackendVersion: function setBackendVersion(state, payload) {
    state.backendVersion = payload.backendVersion;
  },
  setLocale: function setLocale(state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.set('locale', payload.locale);

    __WEBPACK_IMPORTED_MODULE_1__app__["b" /* i18n */].locale = payload.locale;
    __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.locale(payload.locale);
  },
  setTimezone: function setTimezone(state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.set('timezone', payload.timezone);

    state.timezone = payload.timezone;

    __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.setDefault(payload.timezone);
  },
  startWorking: function startWorking(state, payload) {
    var message = __WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](payload.message) && !__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](payload.message) ? payload.message : 'Doing something...';

    state.activeWork.push(message);
    state.activeWork = __WEBPACK_IMPORTED_MODULE_2_lodash__["uniq"](state.activeWork);
  },
  stopWorking: function stopWorking(state, payload) {
    var message = __WEBPACK_IMPORTED_MODULE_2_lodash__["isString"](payload.message) && !__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"](payload.message) ? payload.message : 'Doing something...';

    state.activeWork = __WEBPACK_IMPORTED_MODULE_2_lodash__["uniq"](state.activeWork).filter(function (w) {
      return !__WEBPACK_IMPORTED_MODULE_2_lodash__["isEqual"](w, message);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/* unknown exports provided */
/*!****************************!*\
  !*** ./static/css/app.css ***!
  \****************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/* unknown exports provided */
/*!******************************!*\
  !*** ./static/css/arma3.css ***!
  \******************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/* unknown exports provided */
/*!********************************!*\
  !*** ./static/css/editors.css ***!
  \********************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/* unknown exports provided */
/*!*********************************!*\
  !*** ./static/css/popovers.css ***!
  \*********************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/* unknown exports provided */
/*!*******************************!*\
  !*** ./static/css/tables.css ***!
  \*******************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-33c83a00","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-quill-editor/src/editor.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-3b17cba1","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/CalendarMission.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-3d63342f","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/CalendarWeek.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-6ccb2588","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/CalendarHeader.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-700d7246","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/CalendarBody.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-a810e79e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/CalendarDay.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/moment-timezone/data/packed/latest.json ***!
  \***************************************************/
/***/ (function(module, exports) {

module.exports = {
	"version": "2017c",
	"zones": [
		"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
		"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
		"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
		"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
		"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
		"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
		"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
		"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
		"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
		"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
		"Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
		"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
		"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0",
		"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
		"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
		"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
		"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
		"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
		"Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|01213454545454545454545454545454545454545454545454543|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
		"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
		"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
		"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
		"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
		"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
		"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
		"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
		"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
		"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
		"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
		"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
		"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
		"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
		"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
		"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
		"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
		"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
		"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
		"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
		"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
		"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
		"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
		"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
		"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
		"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
		"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
		"America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
		"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
		"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
		"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
		"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
		"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
		"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
		"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
		"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
		"America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
		"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
		"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
		"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
		"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
		"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
		"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
		"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
		"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
		"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
		"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
		"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
		"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
		"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
		"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
		"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
		"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
		"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
		"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
		"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
		"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
		"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
		"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
		"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
		"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
		"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
		"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
		"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
		"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
		"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
		"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
		"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
		"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
		"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
		"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
		"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
		"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
		"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
		"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
		"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
		"America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
		"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
		"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
		"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
		"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
		"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
		"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
		"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
		"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
		"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
		"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
		"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
		"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
		"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
		"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
		"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
		"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
		"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
		"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
		"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
		"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
		"America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
		"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
		"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
		"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
		"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
		"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
		"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
		"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
		"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
		"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
		"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
		"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
		"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
		"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
		"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
		"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
		"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
		"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
		"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
		"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
		"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
		"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
		"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
		"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
		"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
		"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
		"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
		"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
		"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
		"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
		"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
		"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
		"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
		"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
		"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
		"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
		"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
		"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
		"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
		"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
		"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
		"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
		"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
		"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
		"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
		"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
		"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
		"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
		"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
		"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
		"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
		"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
		"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
		"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
		"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
		"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
		"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
		"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
		"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
		"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
		"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
		"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
		"Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4",
		"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
		"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
		"Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
		"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
		"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
		"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
		"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
		"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
		"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
		"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5",
		"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
		"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
		"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
		"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
		"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
		"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
		"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
		"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
		"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
		"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
		"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
		"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
		"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
		"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
		"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
		"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
		"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
		"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
		"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
		"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
		"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
		"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
		"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
		"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
		"Atlantic/South_Georgia|-02|20|0||30",
		"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
		"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
		"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
		"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
		"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
		"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
		"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
		"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
		"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
		"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
		"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
		"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
		"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
		"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
		"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"EST|EST|50|0|",
		"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Etc/GMT+0|GMT|0|0|",
		"Etc/GMT+1|-01|10|0|",
		"Etc/GMT+10|-10|a0|0|",
		"Etc/GMT+11|-11|b0|0|",
		"Etc/GMT+12|-12|c0|0|",
		"Etc/GMT+3|-03|30|0|",
		"Etc/GMT+4|-04|40|0|",
		"Etc/GMT+5|-05|50|0|",
		"Etc/GMT+6|-06|60|0|",
		"Etc/GMT+7|-07|70|0|",
		"Etc/GMT+8|-08|80|0|",
		"Etc/GMT+9|-09|90|0|",
		"Etc/GMT-1|+01|-10|0|",
		"Pacific/Port_Moresby|+10|-a0|0||25e4",
		"Pacific/Pohnpei|+11|-b0|0||34e3",
		"Pacific/Tarawa|+12|-c0|0||29e3",
		"Etc/GMT-13|+13|-d0|0|",
		"Etc/GMT-14|+14|-e0|0|",
		"Etc/GMT-2|+02|-20|0|",
		"Etc/GMT-3|+03|-30|0|",
		"Etc/GMT-4|+04|-40|0|",
		"Etc/GMT-5|+05|-50|0|",
		"Etc/GMT-6|+06|-60|0|",
		"Indian/Christmas|+07|-70|0||21e2",
		"Etc/GMT-8|+08|-80|0|",
		"Pacific/Palau|+09|-90|0||21e3",
		"Etc/UCT|UCT|0|0|",
		"Etc/UTC|UTC|0|0|",
		"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
		"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
		"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
		"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
		"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
		"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
		"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
		"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
		"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
		"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
		"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
		"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
		"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
		"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
		"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
		"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
		"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
		"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
		"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
		"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
		"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
		"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
		"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
		"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
		"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
		"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
		"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
		"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
		"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
		"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
		"HST|HST|a0|0|",
		"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
		"Indian/Cocos|+0630|-6u|0||596",
		"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
		"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
		"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
		"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
		"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
		"Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3",
		"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"MST|MST|70|0|",
		"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
		"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
		"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
		"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
		"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1",
		"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
		"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4",
		"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
		"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
		"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
		"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
		"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
		"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2",
		"Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2",
		"Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3",
		"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
		"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
		"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
		"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
		"Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
		"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
		"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
		"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
		"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
		"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
		"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
	],
	"links": [
		"Africa/Abidjan|Africa/Bamako",
		"Africa/Abidjan|Africa/Banjul",
		"Africa/Abidjan|Africa/Conakry",
		"Africa/Abidjan|Africa/Dakar",
		"Africa/Abidjan|Africa/Freetown",
		"Africa/Abidjan|Africa/Lome",
		"Africa/Abidjan|Africa/Nouakchott",
		"Africa/Abidjan|Africa/Ouagadougou",
		"Africa/Abidjan|Africa/Sao_Tome",
		"Africa/Abidjan|Africa/Timbuktu",
		"Africa/Abidjan|Atlantic/St_Helena",
		"Africa/Cairo|Egypt",
		"Africa/Johannesburg|Africa/Maseru",
		"Africa/Johannesburg|Africa/Mbabane",
		"Africa/Lagos|Africa/Bangui",
		"Africa/Lagos|Africa/Brazzaville",
		"Africa/Lagos|Africa/Douala",
		"Africa/Lagos|Africa/Kinshasa",
		"Africa/Lagos|Africa/Libreville",
		"Africa/Lagos|Africa/Luanda",
		"Africa/Lagos|Africa/Malabo",
		"Africa/Lagos|Africa/Niamey",
		"Africa/Lagos|Africa/Porto-Novo",
		"Africa/Maputo|Africa/Blantyre",
		"Africa/Maputo|Africa/Bujumbura",
		"Africa/Maputo|Africa/Gaborone",
		"Africa/Maputo|Africa/Harare",
		"Africa/Maputo|Africa/Kigali",
		"Africa/Maputo|Africa/Lubumbashi",
		"Africa/Maputo|Africa/Lusaka",
		"Africa/Nairobi|Africa/Addis_Ababa",
		"Africa/Nairobi|Africa/Asmara",
		"Africa/Nairobi|Africa/Asmera",
		"Africa/Nairobi|Africa/Dar_es_Salaam",
		"Africa/Nairobi|Africa/Djibouti",
		"Africa/Nairobi|Africa/Kampala",
		"Africa/Nairobi|Africa/Mogadishu",
		"Africa/Nairobi|Indian/Antananarivo",
		"Africa/Nairobi|Indian/Comoro",
		"Africa/Nairobi|Indian/Mayotte",
		"Africa/Tripoli|Libya",
		"America/Adak|America/Atka",
		"America/Adak|US/Aleutian",
		"America/Anchorage|US/Alaska",
		"America/Argentina/Buenos_Aires|America/Buenos_Aires",
		"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
		"America/Argentina/Catamarca|America/Catamarca",
		"America/Argentina/Cordoba|America/Cordoba",
		"America/Argentina/Cordoba|America/Rosario",
		"America/Argentina/Jujuy|America/Jujuy",
		"America/Argentina/Mendoza|America/Mendoza",
		"America/Atikokan|America/Coral_Harbour",
		"America/Chicago|US/Central",
		"America/Curacao|America/Aruba",
		"America/Curacao|America/Kralendijk",
		"America/Curacao|America/Lower_Princes",
		"America/Denver|America/Shiprock",
		"America/Denver|Navajo",
		"America/Denver|US/Mountain",
		"America/Detroit|US/Michigan",
		"America/Edmonton|Canada/Mountain",
		"America/Fort_Wayne|America/Indiana/Indianapolis",
		"America/Fort_Wayne|America/Indianapolis",
		"America/Fort_Wayne|US/East-Indiana",
		"America/Halifax|Canada/Atlantic",
		"America/Havana|Cuba",
		"America/Indiana/Knox|America/Knox_IN",
		"America/Indiana/Knox|US/Indiana-Starke",
		"America/Jamaica|Jamaica",
		"America/Kentucky/Louisville|America/Louisville",
		"America/Los_Angeles|US/Pacific",
		"America/Los_Angeles|US/Pacific-New",
		"America/Manaus|Brazil/West",
		"America/Mazatlan|Mexico/BajaSur",
		"America/Mexico_City|Mexico/General",
		"America/New_York|US/Eastern",
		"America/Noronha|Brazil/DeNoronha",
		"America/Panama|America/Cayman",
		"America/Phoenix|US/Arizona",
		"America/Port_of_Spain|America/Anguilla",
		"America/Port_of_Spain|America/Antigua",
		"America/Port_of_Spain|America/Dominica",
		"America/Port_of_Spain|America/Grenada",
		"America/Port_of_Spain|America/Guadeloupe",
		"America/Port_of_Spain|America/Marigot",
		"America/Port_of_Spain|America/Montserrat",
		"America/Port_of_Spain|America/St_Barthelemy",
		"America/Port_of_Spain|America/St_Kitts",
		"America/Port_of_Spain|America/St_Lucia",
		"America/Port_of_Spain|America/St_Thomas",
		"America/Port_of_Spain|America/St_Vincent",
		"America/Port_of_Spain|America/Tortola",
		"America/Port_of_Spain|America/Virgin",
		"America/Regina|Canada/Saskatchewan",
		"America/Rio_Branco|America/Porto_Acre",
		"America/Rio_Branco|Brazil/Acre",
		"America/Santiago|Chile/Continental",
		"America/Sao_Paulo|Brazil/East",
		"America/St_Johns|Canada/Newfoundland",
		"America/Tijuana|America/Ensenada",
		"America/Tijuana|America/Santa_Isabel",
		"America/Tijuana|Mexico/BajaNorte",
		"America/Toronto|America/Montreal",
		"America/Toronto|Canada/Eastern",
		"America/Vancouver|Canada/Pacific",
		"America/Whitehorse|Canada/Yukon",
		"America/Winnipeg|Canada/Central",
		"Asia/Ashgabat|Asia/Ashkhabad",
		"Asia/Bangkok|Asia/Phnom_Penh",
		"Asia/Bangkok|Asia/Vientiane",
		"Asia/Dhaka|Asia/Dacca",
		"Asia/Dubai|Asia/Muscat",
		"Asia/Ho_Chi_Minh|Asia/Saigon",
		"Asia/Hong_Kong|Hongkong",
		"Asia/Jerusalem|Asia/Tel_Aviv",
		"Asia/Jerusalem|Israel",
		"Asia/Kathmandu|Asia/Katmandu",
		"Asia/Kolkata|Asia/Calcutta",
		"Asia/Kuala_Lumpur|Asia/Singapore",
		"Asia/Kuala_Lumpur|Singapore",
		"Asia/Macau|Asia/Macao",
		"Asia/Makassar|Asia/Ujung_Pandang",
		"Asia/Nicosia|Europe/Nicosia",
		"Asia/Qatar|Asia/Bahrain",
		"Asia/Rangoon|Asia/Yangon",
		"Asia/Riyadh|Asia/Aden",
		"Asia/Riyadh|Asia/Kuwait",
		"Asia/Seoul|ROK",
		"Asia/Shanghai|Asia/Chongqing",
		"Asia/Shanghai|Asia/Chungking",
		"Asia/Shanghai|Asia/Harbin",
		"Asia/Shanghai|PRC",
		"Asia/Taipei|ROC",
		"Asia/Tehran|Iran",
		"Asia/Thimphu|Asia/Thimbu",
		"Asia/Tokyo|Japan",
		"Asia/Ulaanbaatar|Asia/Ulan_Bator",
		"Asia/Urumqi|Asia/Kashgar",
		"Atlantic/Faroe|Atlantic/Faeroe",
		"Atlantic/Reykjavik|Iceland",
		"Atlantic/South_Georgia|Etc/GMT+2",
		"Australia/Adelaide|Australia/South",
		"Australia/Brisbane|Australia/Queensland",
		"Australia/Broken_Hill|Australia/Yancowinna",
		"Australia/Darwin|Australia/North",
		"Australia/Hobart|Australia/Tasmania",
		"Australia/Lord_Howe|Australia/LHI",
		"Australia/Melbourne|Australia/Victoria",
		"Australia/Perth|Australia/West",
		"Australia/Sydney|Australia/ACT",
		"Australia/Sydney|Australia/Canberra",
		"Australia/Sydney|Australia/NSW",
		"Etc/GMT+0|Etc/GMT",
		"Etc/GMT+0|Etc/GMT-0",
		"Etc/GMT+0|Etc/GMT0",
		"Etc/GMT+0|Etc/Greenwich",
		"Etc/GMT+0|GMT",
		"Etc/GMT+0|GMT+0",
		"Etc/GMT+0|GMT-0",
		"Etc/GMT+0|GMT0",
		"Etc/GMT+0|Greenwich",
		"Etc/UCT|UCT",
		"Etc/UTC|Etc/Universal",
		"Etc/UTC|Etc/Zulu",
		"Etc/UTC|UTC",
		"Etc/UTC|Universal",
		"Etc/UTC|Zulu",
		"Europe/Belgrade|Europe/Ljubljana",
		"Europe/Belgrade|Europe/Podgorica",
		"Europe/Belgrade|Europe/Sarajevo",
		"Europe/Belgrade|Europe/Skopje",
		"Europe/Belgrade|Europe/Zagreb",
		"Europe/Chisinau|Europe/Tiraspol",
		"Europe/Dublin|Eire",
		"Europe/Helsinki|Europe/Mariehamn",
		"Europe/Istanbul|Asia/Istanbul",
		"Europe/Istanbul|Turkey",
		"Europe/Lisbon|Portugal",
		"Europe/London|Europe/Belfast",
		"Europe/London|Europe/Guernsey",
		"Europe/London|Europe/Isle_of_Man",
		"Europe/London|Europe/Jersey",
		"Europe/London|GB",
		"Europe/London|GB-Eire",
		"Europe/Moscow|W-SU",
		"Europe/Oslo|Arctic/Longyearbyen",
		"Europe/Oslo|Atlantic/Jan_Mayen",
		"Europe/Prague|Europe/Bratislava",
		"Europe/Rome|Europe/San_Marino",
		"Europe/Rome|Europe/Vatican",
		"Europe/Warsaw|Poland",
		"Europe/Zurich|Europe/Busingen",
		"Europe/Zurich|Europe/Vaduz",
		"Indian/Christmas|Etc/GMT-7",
		"Pacific/Auckland|Antarctica/McMurdo",
		"Pacific/Auckland|Antarctica/South_Pole",
		"Pacific/Auckland|NZ",
		"Pacific/Chatham|NZ-CHAT",
		"Pacific/Easter|Chile/EasterIsland",
		"Pacific/Guam|Pacific/Saipan",
		"Pacific/Honolulu|Pacific/Johnston",
		"Pacific/Honolulu|US/Hawaii",
		"Pacific/Kwajalein|Kwajalein",
		"Pacific/Pago_Pago|Pacific/Midway",
		"Pacific/Pago_Pago|Pacific/Samoa",
		"Pacific/Pago_Pago|US/Samoa",
		"Pacific/Palau|Etc/GMT-9",
		"Pacific/Pohnpei|Etc/GMT-11",
		"Pacific/Pohnpei|Pacific/Ponape",
		"Pacific/Port_Moresby|Etc/GMT-10",
		"Pacific/Port_Moresby|Pacific/Chuuk",
		"Pacific/Port_Moresby|Pacific/Truk",
		"Pacific/Port_Moresby|Pacific/Yap",
		"Pacific/Tarawa|Etc/GMT-12",
		"Pacific/Tarawa|Pacific/Funafuti",
		"Pacific/Tarawa|Pacific/Wake",
		"Pacific/Tarawa|Pacific/Wallis"
	]
};

/***/ }),
/* 325 */,
/* 326 */
/* unknown exports provided */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale ^\.\/.*$ ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 23,
	"./af.js": 23,
	"./ar": 30,
	"./ar-dz": 24,
	"./ar-dz.js": 24,
	"./ar-kw": 25,
	"./ar-kw.js": 25,
	"./ar-ly": 26,
	"./ar-ly.js": 26,
	"./ar-ma": 27,
	"./ar-ma.js": 27,
	"./ar-sa": 28,
	"./ar-sa.js": 28,
	"./ar-tn": 29,
	"./ar-tn.js": 29,
	"./ar.js": 30,
	"./az": 31,
	"./az.js": 31,
	"./be": 32,
	"./be.js": 32,
	"./bg": 33,
	"./bg.js": 33,
	"./bm": 34,
	"./bm.js": 34,
	"./bn": 35,
	"./bn.js": 35,
	"./bo": 36,
	"./bo.js": 36,
	"./br": 37,
	"./br.js": 37,
	"./bs": 38,
	"./bs.js": 38,
	"./ca": 39,
	"./ca.js": 39,
	"./cs": 40,
	"./cs.js": 40,
	"./cv": 41,
	"./cv.js": 41,
	"./cy": 42,
	"./cy.js": 42,
	"./da": 43,
	"./da.js": 43,
	"./de": 46,
	"./de-at": 44,
	"./de-at.js": 44,
	"./de-ch": 45,
	"./de-ch.js": 45,
	"./de.js": 46,
	"./dv": 47,
	"./dv.js": 47,
	"./el": 48,
	"./el.js": 48,
	"./en-au": 49,
	"./en-au.js": 49,
	"./en-ca": 50,
	"./en-ca.js": 50,
	"./en-gb": 51,
	"./en-gb.js": 51,
	"./en-ie": 52,
	"./en-ie.js": 52,
	"./en-il": 53,
	"./en-il.js": 53,
	"./en-nz": 54,
	"./en-nz.js": 54,
	"./eo": 55,
	"./eo.js": 55,
	"./es": 58,
	"./es-do": 56,
	"./es-do.js": 56,
	"./es-us": 57,
	"./es-us.js": 57,
	"./es.js": 58,
	"./et": 59,
	"./et.js": 59,
	"./eu": 60,
	"./eu.js": 60,
	"./fa": 61,
	"./fa.js": 61,
	"./fi": 62,
	"./fi.js": 62,
	"./fo": 63,
	"./fo.js": 63,
	"./fr": 66,
	"./fr-ca": 64,
	"./fr-ca.js": 64,
	"./fr-ch": 65,
	"./fr-ch.js": 65,
	"./fr.js": 66,
	"./fy": 67,
	"./fy.js": 67,
	"./gd": 68,
	"./gd.js": 68,
	"./gl": 69,
	"./gl.js": 69,
	"./gom-latn": 70,
	"./gom-latn.js": 70,
	"./gu": 71,
	"./gu.js": 71,
	"./he": 72,
	"./he.js": 72,
	"./hi": 73,
	"./hi.js": 73,
	"./hr": 74,
	"./hr.js": 74,
	"./hu": 75,
	"./hu.js": 75,
	"./hy-am": 76,
	"./hy-am.js": 76,
	"./id": 77,
	"./id.js": 77,
	"./is": 78,
	"./is.js": 78,
	"./it": 79,
	"./it.js": 79,
	"./ja": 80,
	"./ja.js": 80,
	"./jv": 81,
	"./jv.js": 81,
	"./ka": 82,
	"./ka.js": 82,
	"./kk": 83,
	"./kk.js": 83,
	"./km": 84,
	"./km.js": 84,
	"./kn": 85,
	"./kn.js": 85,
	"./ko": 86,
	"./ko.js": 86,
	"./ky": 87,
	"./ky.js": 87,
	"./lb": 88,
	"./lb.js": 88,
	"./lo": 89,
	"./lo.js": 89,
	"./lt": 90,
	"./lt.js": 90,
	"./lv": 91,
	"./lv.js": 91,
	"./me": 92,
	"./me.js": 92,
	"./mi": 93,
	"./mi.js": 93,
	"./mk": 94,
	"./mk.js": 94,
	"./ml": 95,
	"./ml.js": 95,
	"./mr": 96,
	"./mr.js": 96,
	"./ms": 98,
	"./ms-my": 97,
	"./ms-my.js": 97,
	"./ms.js": 98,
	"./mt": 99,
	"./mt.js": 99,
	"./my": 100,
	"./my.js": 100,
	"./nb": 101,
	"./nb.js": 101,
	"./ne": 102,
	"./ne.js": 102,
	"./nl": 104,
	"./nl-be": 103,
	"./nl-be.js": 103,
	"./nl.js": 104,
	"./nn": 105,
	"./nn.js": 105,
	"./pa-in": 106,
	"./pa-in.js": 106,
	"./pl": 107,
	"./pl.js": 107,
	"./pt": 109,
	"./pt-br": 108,
	"./pt-br.js": 108,
	"./pt.js": 109,
	"./ro": 110,
	"./ro.js": 110,
	"./ru": 111,
	"./ru.js": 111,
	"./sd": 112,
	"./sd.js": 112,
	"./se": 113,
	"./se.js": 113,
	"./si": 114,
	"./si.js": 114,
	"./sk": 115,
	"./sk.js": 115,
	"./sl": 116,
	"./sl.js": 116,
	"./sq": 117,
	"./sq.js": 117,
	"./sr": 119,
	"./sr-cyrl": 118,
	"./sr-cyrl.js": 118,
	"./sr.js": 119,
	"./ss": 120,
	"./ss.js": 120,
	"./sv": 121,
	"./sv.js": 121,
	"./sw": 122,
	"./sw.js": 122,
	"./ta": 123,
	"./ta.js": 123,
	"./te": 124,
	"./te.js": 124,
	"./tet": 125,
	"./tet.js": 125,
	"./tg": 126,
	"./tg.js": 126,
	"./th": 127,
	"./th.js": 127,
	"./tl-ph": 128,
	"./tl-ph.js": 128,
	"./tlh": 129,
	"./tlh.js": 129,
	"./tr": 130,
	"./tr.js": 130,
	"./tzl": 131,
	"./tzl.js": 131,
	"./tzm": 133,
	"./tzm-latn": 132,
	"./tzm-latn.js": 132,
	"./tzm.js": 133,
	"./ug-cn": 134,
	"./ug-cn.js": 134,
	"./uk": 135,
	"./uk.js": 135,
	"./ur": 136,
	"./ur.js": 136,
	"./uz": 138,
	"./uz-latn": 137,
	"./uz-latn.js": 137,
	"./uz.js": 138,
	"./vi": 139,
	"./vi.js": 139,
	"./x-pseudo": 140,
	"./x-pseudo.js": 140,
	"./yo": 141,
	"./yo.js": 141,
	"./zh-cn": 142,
	"./zh-cn.js": 142,
	"./zh-hk": 143,
	"./zh-hk.js": 143,
	"./zh-tw": 144,
	"./zh-tw.js": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 326;


/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/vue-quill-editor/src/editor.vue ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../vue-loader/lib/style-compiler/index?{"id":"data-v-33c83a00","scoped":false,"hasInlineConfig":false}!../../vue-loader/lib/selector?type=styles&index=0!./editor.vue */ 309)

var Component = __webpack_require__(/*! ../../vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../vue-loader/lib/selector?type=script&index=0!./editor.vue */ 163),
  /* template */
  __webpack_require__(/*! !../../vue-loader/lib/template-compiler/index?{"id":"data-v-33c83a00"}!../../vue-loader/lib/selector?type=template&index=0!./editor.vue */ 497),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/* unknown exports provided */
/* exports used: default */
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./App.vue */ 164),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-9603e6e6"}!../../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************!*\
  !*** ./src/components/Calendar.vue ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Calendar.vue */ 165),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7d73c9fc"}!../../~/vue-loader/lib/selector?type=template&index=0!./Calendar.vue */ 552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************!*\
  !*** ./src/components/EditorExplanation.vue ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./EditorExplanation.vue */ 166),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4c0f1f50"}!../../~/vue-loader/lib/selector?type=template&index=0!./EditorExplanation.vue */ 515),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************!*\
  !*** ./src/components/LoadingOverlay.vue ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./LoadingOverlay.vue */ 167),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-a852b990"}!../../~/vue-loader/lib/selector?type=template&index=0!./LoadingOverlay.vue */ 568),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************!*\
  !*** ./src/components/Typeahead.vue ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Typeahead.vue */ 168),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1be4db33"}!../../~/vue-loader/lib/selector?type=template&index=0!./Typeahead.vue */ 481),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************!*\
  !*** ./src/components/account/AccountMissions.vue ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./AccountMissions.vue */ 169),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7f742dbe"}!../../../~/vue-loader/lib/selector?type=template&index=0!./AccountMissions.vue */ 554),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./src/components/account/AccountMissionsRow.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./AccountMissionsRow.vue */ 170),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-554a726c"}!../../../~/vue-loader/lib/selector?type=template&index=0!./AccountMissionsRow.vue */ 523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/* unknown exports provided */
/* exports used: default */
/*!*********************************************************!*\
  !*** ./src/components/account/AccountMissionsTable.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./AccountMissionsTable.vue */ 171),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-8eebf840"}!../../../~/vue-loader/lib/selector?type=template&index=0!./AccountMissionsTable.vue */ 558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./src/components/account/AccountPermissions.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./AccountPermissions.vue */ 172),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6290527d"}!../../../~/vue-loader/lib/selector?type=template&index=0!./AccountPermissions.vue */ 538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./src/components/account/AccountPermissionsRow.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./AccountPermissionsRow.vue */ 173),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5d62a14d"}!../../../~/vue-loader/lib/selector?type=template&index=0!./AccountPermissionsRow.vue */ 533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************!*\
  !*** ./src/components/account/AccountPermissionsTable.vue ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./AccountPermissionsTable.vue */ 174),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1b51fe81"}!../../../~/vue-loader/lib/selector?type=template&index=0!./AccountPermissionsTable.vue */ 479),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************!*\
  !*** ./src/components/account/modals/AccountDeleteModal.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./AccountDeleteModal.vue */ 175),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-70bb0568"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./AccountDeleteModal.vue */ 549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************!*\
  !*** ./src/components/account/modals/AccountEditModal.vue ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./AccountEditModal.vue */ 176),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2e2fc369"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./AccountEditModal.vue */ 492),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************!*\
  !*** ./src/components/calendar/CalendarBody.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-700d7246","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarBody.vue */ 313)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarBody.vue */ 177),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-700d7246"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CalendarBody.vue */ 548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************!*\
  !*** ./src/components/calendar/CalendarDay.vue ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-a810e79e","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarDay.vue */ 314)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarDay.vue */ 178),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-a810e79e"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CalendarDay.vue */ 567),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************!*\
  !*** ./src/components/calendar/CalendarHeader.vue ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-6ccb2588","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarHeader.vue */ 312)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarHeader.vue */ 179),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6ccb2588"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CalendarHeader.vue */ 544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************!*\
  !*** ./src/components/calendar/CalendarMission.vue ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-3b17cba1","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarMission.vue */ 310)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarMission.vue */ 180),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3b17cba1"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CalendarMission.vue */ 505),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************!*\
  !*** ./src/components/calendar/CalendarWeek.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-3d63342f","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarWeek.vue */ 311)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarWeek.vue */ 181),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3d63342f"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CalendarWeek.vue */ 508),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************!*\
  !*** ./src/components/communities/CommunityApplications.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityApplications.vue */ 182),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-b2de0060"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityApplications.vue */ 570),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************************!*\
  !*** ./src/components/communities/CommunityApplicationsRow.vue ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityApplicationsRow.vue */ 183),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2fa6e1cc"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityApplicationsRow.vue */ 493),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************************!*\
  !*** ./src/components/communities/CommunityApplicationsTable.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityApplicationsTable.vue */ 184),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1b57ad0e"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityApplicationsTable.vue */ 480),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/* unknown exports provided */
/* exports used: default */
/*!*********************************************************!*\
  !*** ./src/components/communities/CommunityListRow.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityListRow.vue */ 185),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1c9d2e3f"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityListRow.vue */ 482),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************************!*\
  !*** ./src/components/communities/CommunityListTable.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityListTable.vue */ 186),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-13c5d21a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityListTable.vue */ 473),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/* unknown exports provided */
/* exports used: default */
/*!*********************************************************!*\
  !*** ./src/components/communities/CommunityMembers.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityMembers.vue */ 187),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0ae8ec7c"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityMembers.vue */ 471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************!*\
  !*** ./src/components/communities/CommunityMembersRow.vue ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityMembersRow.vue */ 188),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-07e95a24"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityMembersRow.vue */ 469),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************!*\
  !*** ./src/components/communities/CommunityMembersTable.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityMembersTable.vue */ 189),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-9ad6683c"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityMembersTable.vue */ 563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./src/components/communities/CommunityMissions.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityMissions.vue */ 190),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3400db94"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityMissions.vue */ 498),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************************!*\
  !*** ./src/components/communities/CommunityMissionsRow.vue ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityMissionsRow.vue */ 191),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1443ecd6"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityMissionsRow.vue */ 474),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************************************!*\
  !*** ./src/components/communities/CommunityMissionsTable.vue ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityMissionsTable.vue */ 192),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-c1e2e86c"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityMissionsTable.vue */ 573),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************************!*\
  !*** ./src/components/communities/CommunityPermissions.vue ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityPermissions.vue */ 193),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2189cce7"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityPermissions.vue */ 487),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************************!*\
  !*** ./src/components/communities/CommunityPermissionsRow.vue ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityPermissionsRow.vue */ 194),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-476f16a3"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityPermissionsRow.vue */ 511),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************!*\
  !*** ./src/components/communities/CommunityPermissionsTable.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityPermissionsTable.vue */ 195),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-97d31352"}!../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityPermissionsTable.vue */ 561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************!*\
  !*** ./src/components/communities/modals/CommunityEditModal.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityEditModal.vue */ 196),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-a53aadf2"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityEditModal.vue */ 566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************!*\
  !*** ./src/components/communities/modals/CommunityLogoModal.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityLogoModal.vue */ 197),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-cf3d52f4"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityLogoModal.vue */ 574),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************************!*\
  !*** ./src/components/communities/modals/CommunityPermissionModal.vue ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./CommunityPermissionModal.vue */ 198),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-055aa43c"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./CommunityPermissionModal.vue */ 467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/MissionSlotTemplateListRow.vue ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateListRow.vue */ 199),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-57367204"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateListRow.vue */ 525),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/MissionSlotTemplateListTable.vue ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateListTable.vue */ 200),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-21170510"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateListTable.vue */ 486),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/MissionSlotTemplateSlotlist.vue ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotlist.vue */ 201),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0149adb8"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotlist.vue */ 462),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroup.vue ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotlistGroup.vue */ 202),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-54f8326b"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotlistGroup.vue */ 522),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroupSlotsRow.vue ***!
  \******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotlistGroupSlotsRow.vue */ 203),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5587e720"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotlistGroupSlotsRow.vue */ 524),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroupSlotsTable.vue ***!
  \********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotlistGroupSlotsTable.vue */ 204),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-027d2ce4"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotlistGroupSlotsTable.vue */ 465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/modals/MissionSlotTemplateDuplicateModal.vue ***!
  \******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateDuplicateModal.vue */ 205),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4c504629"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateDuplicateModal.vue */ 516),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/modals/MissionSlotTemplateEditModal.vue ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateEditModal.vue */ 206),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-24d1624c"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateEditModal.vue */ 489),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotCreateModal.vue ***!
  \*******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotCreateModal.vue */ 207),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1fd7d8fc"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotCreateModal.vue */ 483),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotDetailsModal.vue ***!
  \********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotDetailsModal.vue */ 208),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-843c9da0"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotDetailsModal.vue */ 556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotEditModal.vue ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotEditModal.vue */ 209),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-21b8b46e"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotEditModal.vue */ 488),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupCreateModal.vue ***!
  \************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotGroupCreateModal.vue */ 210),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-67720e92"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotGroupCreateModal.vue */ 541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************************************************!*\
  !*** ./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupEditModal.vue ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateSlotGroupEditModal.vue */ 211),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4d5286e9"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateSlotGroupEditModal.vue */ 517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************!*\
  !*** ./src/components/missions/MissionAccesses.vue ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionAccesses.vue */ 212),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1ffda09a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionAccesses.vue */ 484),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************!*\
  !*** ./src/components/missions/MissionAccessesRow.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionAccessesRow.vue */ 213),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3057c210"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionAccessesRow.vue */ 495),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./src/components/missions/MissionAccessesTable.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionAccessesTable.vue */ 214),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0581fa84"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionAccessesTable.vue */ 468),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************!*\
  !*** ./src/components/missions/MissionListRow.vue ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionListRow.vue */ 215),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0ec63d04"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionListRow.vue */ 472),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************!*\
  !*** ./src/components/missions/MissionListTable.vue ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionListTable.vue */ 216),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-023d8878"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionListTable.vue */ 464),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************!*\
  !*** ./src/components/missions/MissionPermissions.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionPermissions.vue */ 217),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-b1581da8"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionPermissions.vue */ 569),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************************!*\
  !*** ./src/components/missions/MissionPermissionsRow.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionPermissionsRow.vue */ 218),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-f43c5f84"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionPermissionsRow.vue */ 578),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************************!*\
  !*** ./src/components/missions/MissionPermissionsTable.vue ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionPermissionsTable.vue */ 219),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-20c13532"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionPermissionsTable.vue */ 485),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************!*\
  !*** ./src/components/missions/MissionSlotRegistrations.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotRegistrations.vue */ 220),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-39d0d3b8"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotRegistrations.vue */ 502),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************************!*\
  !*** ./src/components/missions/MissionSlotRegistrationsRow.vue ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotRegistrationsRow.vue */ 221),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5a3c6846"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotRegistrationsRow.vue */ 529),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************************!*\
  !*** ./src/components/missions/MissionSlotRegistrationsTable.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotRegistrationsTable.vue */ 222),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-48d5eb3a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotRegistrationsTable.vue */ 513),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************!*\
  !*** ./src/components/missions/MissionSlotlist.vue ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotlist.vue */ 223),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-39c4be24"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotlist.vue */ 501),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./src/components/missions/MissionSlotlistGroup.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotlistGroup.vue */ 224),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7643bd6b"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotlistGroup.vue */ 551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************!*\
  !*** ./src/components/missions/MissionSlotlistGroupSlotsRow.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotlistGroupSlotsRow.vue */ 225),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-b866d120"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotlistGroupSlotsRow.vue */ 571),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************************!*\
  !*** ./src/components/missions/MissionSlotlistGroupSlotsTable.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotlistGroupSlotsTable.vue */ 226),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6f16f7e4"}!../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotlistGroupSlotsTable.vue */ 546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************************************!*\
  !*** ./src/components/missions/modals/MissionAccessModal.vue ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionAccessModal.vue */ 227),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-47c7ace2"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionAccessModal.vue */ 512),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************************!*\
  !*** ./src/components/missions/modals/MissionApplySlotTemplateModal.vue ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionApplySlotTemplateModal.vue */ 228),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5d84887e"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionApplySlotTemplateModal.vue */ 534),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************************!*\
  !*** ./src/components/missions/modals/MissionBannerImageModal.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionBannerImageModal.vue */ 229),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-51549375"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionBannerImageModal.vue */ 519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************************!*\
  !*** ./src/components/missions/modals/MissionConvertToSlotTemplateModal.vue ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionConvertToSlotTemplateModal.vue */ 230),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4f8b20de"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionConvertToSlotTemplateModal.vue */ 518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************************!*\
  !*** ./src/components/missions/modals/MissionDuplicateModal.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionDuplicateModal.vue */ 231),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-62b61b39"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionDuplicateModal.vue */ 539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************************!*\
  !*** ./src/components/missions/modals/MissionEditModal.vue ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionEditModal.vue */ 232),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3a3ea33c"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionEditModal.vue */ 503),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************!*\
  !*** ./src/components/missions/modals/MissionEmbedModal.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionEmbedModal.vue */ 233),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6f568eaa"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionEmbedModal.vue */ 547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************************!*\
  !*** ./src/components/missions/modals/MissionPermissionModal.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionPermissionModal.vue */ 234),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-03756c57"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionPermissionModal.vue */ 466),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotAssignModal.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotAssignModal.vue */ 235),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-54030759"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotAssignModal.vue */ 521),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotCreateModal.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotCreateModal.vue */ 236),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-53a6b428"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotCreateModal.vue */ 520),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotDetailsModal.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotDetailsModal.vue */ 237),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5bb2fb80"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotDetailsModal.vue */ 530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotEditModal.vue ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotEditModal.vue */ 238),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4bbbfd5e"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotEditModal.vue */ 514),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotGroupCreateModal.vue ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotGroupCreateModal.vue */ 239),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-bec67c72"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotGroupCreateModal.vue */ 572),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotGroupEditModal.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotGroupEditModal.vue */ 240),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-63a753f9"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotGroupEditModal.vue */ 540),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotRegistrationModal.vue ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotRegistrationModal.vue */ 241),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2fe8e48f"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotRegistrationModal.vue */ 494),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************************!*\
  !*** ./src/components/missions/modals/MissionSlotSelectionEditModal.vue ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotSelectionEditModal.vue */ 242),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-618500e8"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotSelectionEditModal.vue */ 536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************************!*\
  !*** ./src/components/notifications/NotificationListRow.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./NotificationListRow.vue */ 243),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-38163794"}!../../../~/vue-loader/lib/selector?type=template&index=0!./NotificationListRow.vue */ 500),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************************!*\
  !*** ./src/components/notifications/NotificationListTable.vue ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./NotificationListTable.vue */ 244),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-465f2b2a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./NotificationListTable.vue */ 510),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************!*\
  !*** ./src/components/users/UserListRow.vue ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./UserListRow.vue */ 245),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1626df76"}!../../../~/vue-loader/lib/selector?type=template&index=0!./UserListRow.vue */ 475),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************!*\
  !*** ./src/components/users/UserListTable.vue ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./UserListTable.vue */ 246),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-9801532c"}!../../../~/vue-loader/lib/selector?type=template&index=0!./UserListTable.vue */ 562),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************!*\
  !*** ./src/components/users/UserMissions.vue ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./UserMissions.vue */ 247),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6bad513d"}!../../../~/vue-loader/lib/selector?type=template&index=0!./UserMissions.vue */ 542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************!*\
  !*** ./src/components/users/UserMissionsRow.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./UserMissionsRow.vue */ 248),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3ad7aae6"}!../../../~/vue-loader/lib/selector?type=template&index=0!./UserMissionsRow.vue */ 504),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************!*\
  !*** ./src/components/users/UserMissionsTable.vue ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./UserMissionsTable.vue */ 249),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1a4637c1"}!../../../~/vue-loader/lib/selector?type=template&index=0!./UserMissionsTable.vue */ 478),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./src/components/users/modals/UserEditModal.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./UserEditModal.vue */ 250),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7db92e7a"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./UserEditModal.vue */ 553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************!*\
  !*** ./src/i18n/views/About.de.vue ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./About.de.vue */ 251),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-e61fc902"}!../../../~/vue-loader/lib/selector?type=template&index=0!./About.de.vue */ 576),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************!*\
  !*** ./src/i18n/views/About.en.vue ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./About.en.vue */ 252),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-e1b870b2"}!../../../~/vue-loader/lib/selector?type=template&index=0!./About.en.vue */ 575),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./src/i18n/views/FAQ.de.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5a1cf116"}!../../../~/vue-loader/lib/selector?type=template&index=0!./FAQ.de.vue */ 528),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./src/i18n/views/FAQ.en.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5c509d3e"}!../../../~/vue-loader/lib/selector?type=template&index=0!./FAQ.en.vue */ 532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/* unknown exports provided */
/* exports used: default */
/*!************************************!*\
  !*** ./src/i18n/views/Home.de.vue ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-59fab283"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Home.de.vue */ 527),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/* unknown exports provided */
/* exports used: default */
/*!************************************!*\
  !*** ./src/i18n/views/Home.en.vue ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5c2e5eab"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Home.en.vue */ 531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/i18n/views/Imprint.de.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-92df0b7a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Imprint.de.vue */ 559),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/i18n/views/Imprint.en.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-8e77b32a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Imprint.en.vue */ 557),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************!*\
  !*** ./src/i18n/views/Login.de.vue ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./Login.de.vue */ 253),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6c678023"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Login.de.vue */ 543),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************!*\
  !*** ./src/i18n/views/Login.en.vue ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./Login.en.vue */ 254),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6e9b2c4b"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Login.en.vue */ 545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/i18n/views/Privacy.de.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-9fde1438"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Privacy.de.vue */ 565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/i18n/views/Privacy.en.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-9b76bbe8"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Privacy.en.vue */ 564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************!*\
  !*** ./src/views/About.vue ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./About.vue */ 255),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1848fdd7"}!../../~/vue-loader/lib/selector?type=template&index=0!./About.vue */ 476),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./src/views/Account.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Account.vue */ 256),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5dae4ff7"}!../../~/vue-loader/lib/selector?type=template&index=0!./Account.vue */ 535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/* unknown exports provided */
/* exports used: default */
/*!***************************!*\
  !*** ./src/views/Api.vue ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Api.vue */ 257),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-342dab38"}!../../~/vue-loader/lib/selector?type=template&index=0!./Api.vue */ 499),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************!*\
  !*** ./src/views/CommunityCreator.vue ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./CommunityCreator.vue */ 258),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-f15aa0ae"}!../../~/vue-loader/lib/selector?type=template&index=0!./CommunityCreator.vue */ 577),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************!*\
  !*** ./src/views/CommunityDetails.vue ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./CommunityDetails.vue */ 259),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-198a26bf"}!../../~/vue-loader/lib/selector?type=template&index=0!./CommunityDetails.vue */ 477),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************!*\
  !*** ./src/views/CommunityList.vue ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./CommunityList.vue */ 260),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0ae8e371"}!../../~/vue-loader/lib/selector?type=template&index=0!./CommunityList.vue */ 470),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/* unknown exports provided */
/* exports used: default */
/*!****************************!*\
  !*** ./src/views/Home.vue ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 261),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-f99048f6"}!../../~/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 580),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./src/views/Imprint.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Imprint.vue */ 262),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-57f6985a"}!../../~/vue-loader/lib/selector?type=template&index=0!./Imprint.vue */ 526),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************!*\
  !*** ./src/views/Login.vue ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Login.vue */ 263),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-01a87bb3"}!../../~/vue-loader/lib/selector?type=template&index=0!./Login.vue */ 463),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************!*\
  !*** ./src/views/MissionCreator.vue ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./MissionCreator.vue */ 264),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3ce955a6"}!../../~/vue-loader/lib/selector?type=template&index=0!./MissionCreator.vue */ 507),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************!*\
  !*** ./src/views/MissionDetails.vue ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./MissionDetails.vue */ 265),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-61be6688"}!../../~/vue-loader/lib/selector?type=template&index=0!./MissionDetails.vue */ 537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./src/views/MissionList.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./MissionList.vue */ 266),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7fb972d8"}!../../~/vue-loader/lib/selector?type=template&index=0!./MissionList.vue */ 555),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************!*\
  !*** ./src/views/MissionSlotTemplateCreator.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateCreator.vue */ 267),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3ec1a224"}!../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateCreator.vue */ 509),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************************!*\
  !*** ./src/views/MissionSlotTemplateDetails.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateDetails.vue */ 268),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-72d6a604"}!../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateDetails.vue */ 550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************!*\
  !*** ./src/views/MissionSlotTemplateList.vue ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./MissionSlotTemplateList.vue */ 269),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2c159b68"}!../../~/vue-loader/lib/selector?type=template&index=0!./MissionSlotTemplateList.vue */ 491),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************!*\
  !*** ./src/views/NotificationList.vue ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./NotificationList.vue */ 270),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-29738ccf"}!../../~/vue-loader/lib/selector?type=template&index=0!./NotificationList.vue */ 490),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./src/views/Privacy.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Privacy.vue */ 271),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-f8ac785c"}!../../~/vue-loader/lib/selector?type=template&index=0!./Privacy.vue */ 579),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./src/views/UserDetails.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./UserDetails.vue */ 272),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-31f37bc1"}!../../~/vue-loader/lib/selector?type=template&index=0!./UserDetails.vue */ 496),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/* unknown exports provided */
/* exports used: default */
/*!********************************!*\
  !*** ./src/views/UserList.vue ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./UserList.vue */ 273),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3c1d7daf"}!../../~/vue-loader/lib/selector?type=template&index=0!./UserList.vue */ 506),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0149adb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlist.vue ***!
  \************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.missionSlotTemplateDetails.slotGroups), function(missionSlotGroup, index) {
    return _c('mission-slot-template-slotlist-group', {
      key: missionSlotGroup.uid,
      attrs: {
        "index": index,
        "missionSlotGroupCount": _vm.missionSlotTemplateDetails.slotGroups.length,
        "missionSlotGroup": missionSlotGroup
      }
    })
  }), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotGroupCreateModal",
      modifiers: {
        "missionSlotTemplateSlotGroupCreateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slotGroup')) + "\n    ")]), _vm._v(" "), (_vm.missionSlotTemplateUnsavedChanges) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-floppy-o",
      "yes-class": "btn btn-success",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slotTemplate.confirm.save.slotlist'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.saveMissionSlotTemplateSlotlist
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.save.mission.slotTemplate.slotlist')) + "\n      ")])], 1) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 463 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-01a87bb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('login-de') : _c('login-en')], 1)
},staticRenderFns: []}

/***/ }),
/* 464 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-023d8878"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionListTable.vue ***!
  \*************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts.available')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missions), function(mission) {
    return _c('mission-list-row', {
      key: mission.uid,
      attrs: {
        "mission": mission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missions.length >= 10),
      expression: "missions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts.available')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 465 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-027d2ce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroupSlotsTable.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotRoleStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionSlotGroup.slots), function(missionSlot, index) {
    return _c('mission-slot-template-slotlist-group-slots-row', {
      key: missionSlot.uid,
      attrs: {
        "index": index,
        "missionSlotCount": _vm.missionSlotGroup.slots.length,
        "missionSlotDetails": missionSlot,
        "missionSlotGroup": _vm.missionSlotGroup,
        "hasAnyMissionSlotDescription": _vm.hasAnyMissionSlotDescription
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotGroup.slots.length >= 10),
      expression: "missionSlotGroup.slots.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotRoleStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 466 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-03756c57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionPermissionModal.vue ***!
  \**************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionPermissionModal",
    attrs: {
      "id": "missionPermissionModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.permission'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionPermissions
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.permission.existing')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('mission-permissions', {
    attrs: {
      "missionPermissions": _vm.missionPermissions
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.permission.add')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionPermission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.permission.user.selection'),
      "state": _vm.missionPermissionAddUserState,
      "description": _vm.$t('mission.permission.user.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionPermissionAddUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.permissionUserSelected
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.permission.permission'),
      "state": _vm.missionPermissionAddPermissionState,
      "description": _vm.$t('mission.permission.permission.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionPermissionAddPermissionOptions
    },
    model: {
      value: (_vm.missionPermissionAdd.permission),
      callback: function($$v) {
        _vm.missionPermissionAdd.permission = $$v
      },
      expression: "missionPermissionAdd.permission"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionPermissionAddSuppressNotifications),
      callback: function($$v) {
        _vm.missionPermissionAddSuppressNotifications = $$v
      },
      expression: "missionPermissionAddSuppressNotifications"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionPermission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add.mission.permission')) + "\n                ")])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission permission actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionPermissionModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 467 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-055aa43c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/modals/CommunityPermissionModal.vue ***!
  \*******************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "communityPermissionModal",
    attrs: {
      "id": "communityPermissionModal",
      "size": "lg",
      "title": _vm.$t('community.modal.permission'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setCommunityPermissions
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.permission.existing')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('community-permissions', {
    attrs: {
      "communityPermissions": _vm.communityPermissions
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.permission.create')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createCommunityPermission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.permission.user.selection'),
      "state": _vm.communityPermissionCreateUserState,
      "description": _vm.$t('community.permission.user.selection.description')
    }
  }, [_c('typeahead', {
    ref: "communityPermissionCreateUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.permissionUserSelected
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.permission.permission'),
      "state": _vm.communityPermissionCreatePermissionState,
      "description": _vm.$t('community.permission.permission.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.communityPermissionCreatePermissionOptions
    },
    model: {
      value: (_vm.communityPermissionCreate.permission),
      callback: function($$v) {
        _vm.communityPermissionCreate.permission = $$v
      },
      expression: "communityPermissionCreate.permission"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createCommunityPermission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.community.permission')) + "\n                ")])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community permission actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideCommunityPermissionModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 468 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0581fa84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionAccessesTable.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionAccesses) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.access.list.type')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.access.list.name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionAccesses), function(missionAccess) {
    return _c('mission-accesses-row', {
      key: missionAccess.uid,
      attrs: {
        "missionAccess": missionAccess
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionAccesses.length >= 10),
      expression: "missionAccesses.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.access.list.type')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.access.list.name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 469 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-07e95a24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMembersRow.vue ***!
  \*******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [(!_vm.isShawalla) ? _c('div', [_vm._v(_vm._s(_vm.communityMember.nickname))]) : _vm._e(), _vm._v(" "), (_vm.isShawalla) ? _c('b-popover', {
    attrs: {
      "content": "<i class=\"fa fa-wheelchair fa-2x text-center\" aria-hidden=\"true\"></i>",
      "triggers": ['hover']
    }
  }, [_vm._v(_vm._s(_vm.communityMember.nickname))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedCommunityLeader)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Community member actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.communityMember.uid
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), (_vm.canEditCommunityMembers) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-ban",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('community.member.confirm.remove'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.removeCommunityMember
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.remove')) + "\n        ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 470 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae8e371"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommunityList.vue ***!
  \********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communities) ? _c('community-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityListPageCount > 1),
      expression: "communityListPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "communityListPaginate",
    attrs: {
      "pageCount": _vm.communityListPageCount,
      "initial-page": 0,
      "clickHandler": _vm.communityListPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loggedIn),
      expression: "loggedIn"
    }],
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "tag": "button",
      "type": "button",
      "to": {
        name: 'communityCreator'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.community')) + "\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('community.list.search')))]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": _vm.$t('community.list.search.description')
    }
  }, [_c('typeahead', {
    ref: "communitySearchTypeahead",
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.communitySelected
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 471 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae8ec7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMembers.vue ***!
  \****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('community-members-table'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community members actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshCommunityMembers
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n      ")]), _vm._v(" "), (_vm.loggedIn) ? _c('b-btn', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isCommunityMember || _vm.communityApplicationStatus !== null
    },
    on: {
      "click": _vm.applyToCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.apply')) + "\n      ")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 472 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec63d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionListRow.vue ***!
  \***********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.mission.startTime)))]), _vm._v(" "), _c('td', {
    class: {
      'text-primary': _vm.isMissionEditor
    }
  }, [(_vm.isMissionEditor) ? _c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.isMissionEditor'),
      "triggers": ['hover']
    }
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.mission.title) + "\n        "), _vm._l((_vm.missionRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2)]) : _c('span', [_vm._v(_vm._s(_vm.mission.title) + " "), _vm._l((_vm.missionRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2)], 1), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.mission.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.mission.creator)))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.slot.counts.popover', _vm.mission.slotCounts),
      "triggers": ['hover']
    }
  }, [_vm._v("\n      " + _vm._s(_vm.mission.slotCounts.assigned + _vm.mission.slotCounts.external + _vm.mission.slotCounts.unassigned) + "/" + _vm._s(_vm.mission.slotCounts.total) + "\n    ")])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.mission.isAssignedToAnySlot) ? _c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.slot.status.assigned'),
      "triggers": ['hover']
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-lg text-success",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.mission.isAssignedToAnySlot && _vm.mission.isRegisteredForAnySlot) ? _c('b-popover', {
    attrs: {
      "content": _vm.$t('mission.list.slot.status.registered'),
      "triggers": ['hover']
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-lg text-muted",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.mission.isAssignedToAnySlot && !_vm.mission.isRegisteredForAnySlot) ? _c('b-popover', {
    attrs: {
      "content": _vm.isUserInCommunity ? _vm.$t('mission.list.slot.counts.available.popover.community', {
        open: _vm.mission.slotCounts.open
      }) : _vm.$t('mission.list.slot.counts.available.popover', {
        open: _vm.mission.slotCounts.open
      }),
      "triggers": ['hover']
    }
  }, [_vm._v("\n      " + _vm._s(_vm.mission.slotCounts.open) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'missionDetails',
        params: {
          missionSlug: _vm.mission.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 473 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c5d21a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityListTable.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communities) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.tag')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.website')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communities), function(community) {
    return _c('community-list-row', {
      key: community.uid,
      attrs: {
        "community": community
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communities.length >= 10),
      expression: "communities.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.tag')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.website')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 474 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1443ecd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMissionsRow.vue ***!
  \********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.communityMission.startTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.communityMission.title))]), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.communityMission.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.communityMission.creator)))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'missionDetails',
        params: {
          missionSlug: _vm.communityMission.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 475 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1626df76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserListRow.vue ***!
  \*****************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.user.nickname))]), _vm._v(" "), _c('td', [(_vm.user.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.user.community.slug
        }
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.user.community.tag) + "] " + _vm._s(_vm.user.community.name))]) : _c('div', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.user.uid
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 476 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1848fdd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('about-de') : _c('about-en')], 1)
},staticRenderFns: []}

/***/ }),
/* 477 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-198a26bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommunityDetails.vue ***!
  \***********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4  text-center"
  }, [_vm._v(_vm._s(_vm.communityDetails.name))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.communityDetails.logoUrl) ? _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "240px"
    },
    attrs: {
      "src": _vm.communityDetails.logoUrl
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('community.tag')))]), _vm._v(" "), _c('p', [_vm._v("[" + _vm._s(_vm.communityDetails.tag) + "]")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v("Website")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionalCommunityWebsite)
    }
  })])]), _vm._v(" "), (_vm.isCommunityMember || _vm.isCommunityAdmin) ? _c('div', {
    staticClass: "row text-center"
  }, [(_vm.communityDetails.gameServers) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('community.gameServers')))]), _vm._v(" "), _vm._l((_vm.communityDetails.gameServers), function(gameServer, index) {
    return _c('div', {
      key: ((gameServer.hostname) + ":" + (gameServer.port)),
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(gameServer.hostname))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(gameServer.port))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(gameServer.name) ? _c('span', [_vm._v(_vm._s(gameServer.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(gameServer.password) ? _c('span', [_vm._v(_vm._s(gameServer.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), (index < _vm.communityDetails.gameServers.length - 1) ? _c('br') : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.communityDetails.voiceComms) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('community.voiceComms')))]), _vm._v(" "), _vm._l((_vm.communityDetails.voiceComms), function(voiceComms, index) {
    return _c('div', {
      key: ((voiceComms.hostname) + ":" + (voiceComms.port)),
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(voiceComms.hostname))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_vm._v(_vm._s(voiceComms.port))])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(voiceComms.name) ? _c('span', [_vm._v(_vm._s(voiceComms.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row justify-content-center"
    }, [_c('div', {
      staticClass: "col-4 font-weight-bold text-left"
    }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(voiceComms.password) ? _c('span', [_vm._v(_vm._s(voiceComms.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), (index < _vm.communityDetails.gameServers.length - 1) ? _c('br') : _vm._e()])])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.communityDetails.repositories) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.communityDetails.repositories) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.communityRepositoriesCollapse",
      modifiers: {
        "communityRepositoriesCollapse": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.repository.list')) + "\n          ")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "communityRepositoriesCollapse"
    }
  }, [(_vm.communityDetails.repositories.length === 0) ? _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-italic text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.repository.list.empty')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.communityRepositoryChunks), function(chunk, chunkIndex) {
    return _c('div', {
      key: chunk
    }, [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._l((chunk), function(communityRepository, index) {
      return _c('div', {
        key: communityRepository,
        staticClass: "col"
      }, [(communityRepository.name) ? _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.name')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4"
      }, [_vm._v(_vm._s(communityRepository.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.url')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(communityRepository.url) ? _c('span', [(communityRepository.kind === 'arma3sync') ? _c('a', {
        attrs: {
          "href": communityRepository.url
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.$copyText(communityRepository.url)
          }
        }
      }, [_vm._v(_vm._s(communityRepository.url))]) : _c('a', {
        attrs: {
          "href": communityRepository.url
        }
      }, [_vm._v(_vm._s(communityRepository.url))])]) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.notes')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(communityRepository.notes) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(communityRepository.notes)
        }
      }) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('b-btn', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (communityRepository.url),
          expression: "communityRepository.url",
          arg: "copy"
        }],
        attrs: {
          "size": "sm",
          "disabled": !communityRepository.url
        }
      }, [_c('i', {
        staticClass: "fa fa-clipboard",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n                    ")]), _vm._v(" "), (_vm.canEditCommunity) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.canEditCommunity) ? _c('b-btn', {
        attrs: {
          "size": "sm",
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeCommunityRepository(chunkIndex * 2 + index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.remove')) + "\n                    ")]) : _vm._e()], 1)])
    }), _vm._v(" "), (chunk.length === 1) ? _c('div', {
      staticClass: "col"
    }) : _vm._e()], 2)])
  }), _vm._v(" "), (_vm.canEditCommunity) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.name.required'),
      "state": _vm.communityRepositoryCreateNameState,
      "feedback": _vm.communityRepositoryCreateNameFeedback,
      "description": _vm.$t('mission.repository.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityRepositoryCreateData.name),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.name = $$v
      },
      expression: "communityRepositoryCreateData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.kind'),
      "state": _vm.communityRepositoryCreateKindState,
      "feedback": _vm.communityRepositoryCreateKindFeedback,
      "description": _vm.$t('mission.repository.kind.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.communityRepositoryCreateKindOptions
    },
    model: {
      value: (_vm.communityRepositoryCreateData.kind),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.kind = $$v
      },
      expression: "communityRepositoryCreateData.kind"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.url.optional'),
      "state": _vm.communityRepositoryCreateUrlState,
      "feedback": _vm.communityRepositoryCreateUrlFeedback,
      "description": _vm.$t('mission.repository.url.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityRepositoryCreateData.url),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.url = $$v
      },
      expression: "communityRepositoryCreateData.url"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.notes.optional'),
      "state": _vm.communityRepositoryCreateNotesState,
      "feedback": _vm.communityRepositoryCreateNotesFeedback,
      "description": _vm.$t('mission.repository.notes.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.communityRepositoryCreateData.notes),
      callback: function($$v) {
        _vm.communityRepositoryCreateData.notes = $$v
      },
      expression: "communityRepositoryCreateData.notes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.createCommunityRepository
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n                  ")])], 1)])]) : _vm._e()], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditCommunity),
      expression: "canEditCommunity"
    }],
    staticClass: "my-4"
  }), _vm._v(" "), (_vm.canEditCommunity) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.communityEditModal",
      modifiers: {
        "communityEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.communityLogoModal",
      modifiers: {
        "communityLogoModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.community.logo')) + "\n        ")]), _vm._v(" \n        "), (_vm.isCommunityFounder) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.communityPermissionModal",
      modifiers: {
        "communityPermissionModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.community.permissions')) + "\n        ")]) : _vm._e(), _vm._v(" \n        "), (_vm.isCommunityFounder) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "messages": {
        title: _vm.$t('community.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('nav.missions')))]), _vm._v(" "), _c('community-missions')], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('community.members')))]), _vm._v(" "), _c('community-members')], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.canEditCommunityMembers) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('community.applications')))]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('community.applications.filter'),
      "label-for": "communityApplicationsFilter"
    }
  }, [_c('div', {
    attrs: {
      "role": "group",
      "id": "communityApplicationsFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "processed",
      "value": "processed"
    },
    model: {
      value: (_vm.communityApplicationsFilter),
      callback: function($$v) {
        _vm.communityApplicationsFilter = $$v
      },
      expression: "communityApplicationsFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('community.applications.filter.processed')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "accepted",
      "value": "accepted"
    },
    model: {
      value: (_vm.communityApplicationsFilter),
      callback: function($$v) {
        _vm.communityApplicationsFilter = $$v
      },
      expression: "communityApplicationsFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('community.applications.filter.accepted')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "denied",
      "value": "denied"
    },
    model: {
      value: (_vm.communityApplicationsFilter),
      callback: function($$v) {
        _vm.communityApplicationsFilter = $$v
      },
      expression: "communityApplicationsFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('community.applications.filter.denied')) + "\n              ")])], 1)])], 1), _vm._v(" "), _c('community-applications')], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [(_vm.canEditCommunity) ? _c('community-edit-modal') : _vm._e(), _vm._v(" "), (_vm.canEditCommunity) ? _c('community-logo-modal') : _vm._e(), _vm._v(" "), (_vm.isCommunityFounder) ? _c('community-permission-modal') : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 478 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a4637c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserMissionsTable.vue ***!
  \***********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.userMissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "74%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userMissions), function(userMission) {
    return _c('user-missions-row', {
      key: userMission.uid,
      attrs: {
        "userMission": userMission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userMissions.length >= 10),
      expression: "userMissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "74%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 479 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b51fe81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPermissionsTable.vue ***!
  \*******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.accountPermissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.accountPermissions), function(accountPermission) {
    return _c('account-permissions-row', {
      key: accountPermission,
      attrs: {
        "accountPermission": accountPermission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountPermissions.length >= 10),
      expression: "accountPermissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 480 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b57ad0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityApplicationsTable.vue ***!
  \**************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityApplications) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.nickname')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityApplications), function(communityApplication) {
    return _c('community-applications-row', {
      key: communityApplication.uid,
      attrs: {
        "communityApplication": communityApplication
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityApplications.length >= 10),
      expression: "communityApplications.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.nickname')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 481 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be4db33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Typeahead.vue ***!
  \*********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    class: {
      'show': _vm.showDropdown
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('b-input-group', [(_vm.searchRunning) ? _c('b-input-group-addon', {
    domProps: {
      "innerHTML": _vm._s(_vm.searchStatus)
    },
    slot: "right"
  }) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    on: {
      "input": _vm.update,
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.hit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.reset($event)
      }],
      "blur": function($event) {
        _vm.showDropdown = false
      },
      "focus": function($event) {
        _vm.showDropdown = _vm.items.length > 0
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "dropdown-item",
      class: {
        'active': _vm.isActive(index)
      },
      attrs: {
        "type": "button"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.title, _vm.value))
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.hit($event)
        },
        "mousemove": function($event) {
          _vm.setActive(index)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 482 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9d2e3f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityListRow.vue ***!
  \****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("[" + _vm._s(_vm.community.tag) + "]")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.community.name))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.optionalCommunityWebsite)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.community.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 483 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd7d8fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotCreateModal.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotGroupDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotCreateModal",
    attrs: {
      "id": "missionSlotTemplateSlotCreateModal",
      "size": "lg",
      "title": _vm.slotCreateTitle,
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotTemplateSlotCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionSlotTemplateSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotTemplateSlotCreateTitleState,
      "feedback": _vm.missionSlotTemplateSlotCreateTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.title = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.description = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateSlotCreateDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.difficulty),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.difficulty = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.reserve),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.reserve = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.reserve"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.blocked),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.blocked = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.blocked"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotTemplateSlotCreateDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotTemplateSlotCreateDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.detailedDescription = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.insertAfter = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionSlotTemplateSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 484 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ffda09a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionAccesses.vue ***!
  \************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mission-accesses-table', {
    attrs: {
      "missionAccesses": _vm.missionAccesses
    }
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionAccessesPageCount > 1),
      expression: "missionAccessesPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "missionAccessesPaginate",
    attrs: {
      "pageCount": _vm.missionAccessesPageCount,
      "clickHandler": _vm.paginateMissionAccesses,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshMissionAccesses
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 485 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c13532"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionPermissionsTable.vue ***!
  \********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionPermissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionPermissions), function(missionPermission) {
    return _c('mission-permissions-row', {
      key: missionPermission.uid,
      attrs: {
        "missionPermission": missionPermission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionPermissions.length >= 10),
      expression: "missionPermissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 486 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-21170510"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateListTable.vue ***!
  \*************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionSlotTemplates), function(missionSlotTemplate) {
    return _c('mission-slot-template-list-row', {
      key: missionSlotTemplate.uid,
      attrs: {
        "missionSlotTemplate": missionSlotTemplate
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplates.length >= 10),
      expression: "missionSlotTemplates.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 487 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2189cce7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityPermissions.vue ***!
  \********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('community-permissions-table', {
    attrs: {
      "communityPermissions": _vm.communityPermissions
    }
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityPermissionsPageCount > 1),
      expression: "communityPermissionsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "communityPermissionsPaginate",
    attrs: {
      "pageCount": _vm.communityPermissionsPageCount,
      "clickHandler": _vm.paginateCommunityPermissions,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshCommunityPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 488 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-21b8b46e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotEditModal.vue ***!
  \************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotEditModal",
    attrs: {
      "id": "missionSlotTemplateSlotEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.slot.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotTemplateSlotEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotTemplateSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotTemplateSlotEditTitleState,
      "feedback": _vm.missionSlotTemplateSlotEditTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.title = $$v
      },
      expression: "missionSlotTemplateSlotEditData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.description = $$v
      },
      expression: "missionSlotTemplateSlotEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateSlotEditDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.difficulty),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.difficulty = $$v
      },
      expression: "missionSlotTemplateSlotEditData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.reserve),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.reserve = $$v
      },
      expression: "missionSlotTemplateSlotEditData.reserve"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.blocked),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.blocked = $$v
      },
      expression: "missionSlotTemplateSlotEditData.blocked"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotTemplateSlotEditDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotTemplateSlotEditDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditData.detailedDescription = $$v
      },
      expression: "missionSlotTemplateSlotEditData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.moveAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.moveAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotEditMoveAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotEditMoveAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotEditMoveAfter = $$v
      },
      expression: "missionSlotTemplateSlotEditMoveAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotTemplateSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 489 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-24d1624c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateEditModal.vue ***!
  \********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateEditModal",
    attrs: {
      "id": "missionSlotTemplateEditModal",
      "title": _vm.$t('mission.slotTemplate.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotTemplateEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionSlotTemplateEditTitleState,
      "feedback": _vm.missionSlotTemplateEditTitleFeedback,
      "description": _vm.$t('mission.slotTemplate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateEditData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateEditData.title = $$v
      },
      expression: "missionSlotTemplateEditData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": _vm.missionSlotTemplateEditVisibilityState,
      "feedback": _vm.missionSlotTemplateEditVisibilityFeedback,
      "description": _vm.$t('mission.slotTemplate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateEditVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateEditData.visibility),
      callback: function($$v) {
        _vm.missionSlotTemplateEditData.visibility = $$v
      },
      expression: "missionSlotTemplateEditData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 490 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-29738ccf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotificationList.vue ***!
  \***********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.notifications) ? _c('notification-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificationsPageCount > 1),
      expression: "notificationsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "notificationsPaginate",
    attrs: {
      "pageCount": _vm.notificationsPageCount,
      "initial-page": 0,
      "clickHandler": _vm.notificationsPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('notification.list.filter'),
      "label-for": "notificationListFilter"
    }
  }, [_c('div', {
    attrs: {
      "role": "group",
      "id": "notificationListFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "seen",
      "value": "seen"
    },
    model: {
      value: (_vm.notificationListFilter),
      callback: function($$v) {
        _vm.notificationListFilter = $$v
      },
      expression: "notificationListFilter"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('notification.list.filter.seen')) + "\n        ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingNotifications
    },
    on: {
      "click": _vm.refreshNotifications
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingNotifications
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 491 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c159b68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionSlotTemplateList.vue ***!
  \******************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplates) ? _c('mission-slot-template-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplatesPageCount > 1),
      expression: "missionSlotTemplatesPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "missionSlotTemplatesPaginate",
    attrs: {
      "pageCount": _vm.missionSlotTemplatesPageCount,
      "initial-page": 0,
      "clickHandler": _vm.missionSlotTemplatesPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "tag": "button",
      "type": "button",
      "to": {
        name: 'missionSlotTemplateCreator'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slot.template')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingMissionSlotTemplates
    },
    on: {
      "click": function($event) {
        _vm.missionSlotTemplatesPaginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingMissionSlotTemplates
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 492 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2fc369"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/modals/AccountEditModal.vue ***!
  \*******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "accountEditModal",
    attrs: {
      "id": "accountEditModal",
      "title": _vm.$t('account.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.setAccountEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editAccount($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.application.nickname'),
      "state": _vm.accountEditNicknameState,
      "feedback": _vm.accountEditNicknameFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.accountEditData.nickname),
      callback: function($$v) {
        _vm.accountEditData.nickname = $$v
      },
      expression: "accountEditData.nickname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('account.timezone'),
      "state": "success"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.accountEditTimezoneOptions,
      "required": ""
    },
    model: {
      value: (_vm.accountEditTimezone),
      callback: function($$v) {
        _vm.accountEditTimezone = $$v
      },
      expression: "accountEditTimezone"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Account edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editAccount
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.save')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideAccountEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 493 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fa6e1cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityApplicationsRow.vue ***!
  \************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.communityApplication.user.nickname))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedCommunityApplicationStatus)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Community application actions"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "button",
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.communityApplication.user.uid
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-plus",
      "yes-class": "btn btn-success",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('community.application.confirm.accept'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "size": "sm",
      "disabled": _vm.isCommunityApplicationProcessed
    },
    on: {
      "click": function($event) {
        _vm.processCommunityApplication(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.accept')) + "\n        ")])], 1), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-times",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('community.application.confirm.deny'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm",
      "disabled": _vm.isCommunityApplicationProcessed
    },
    on: {
      "click": function($event) {
        _vm.processCommunityApplication(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.deny')) + "\n        ")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 494 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe8e48f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotRegistrationModal.vue ***!
  \********************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotRegistrationModal",
    attrs: {
      "id": "missionSlotRegistrationModal",
      "title": _vm.$t('mission.modal.slot.register'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotRegistrationModalData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.registerForMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.translatedModalText)
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.registration.comment.optional'),
      "description": _vm.$t('mission.registration.comment.description'),
      "state": "success"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "maxlength": "128"
    },
    model: {
      value: (_vm.missionSlotRegistrationData.comment),
      callback: function($$v) {
        _vm.missionSlotRegistrationData.comment = $$v
      },
      expression: "missionSlotRegistrationData.comment"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot registration actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.missionSlotDetails.assignee ? true : false
    },
    on: {
      "click": _vm.registerForMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotRegistrationModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 495 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3057c210"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionAccessesRow.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.missionAccess.community ? _vm.$t('mission.access.list.type.community') : _vm.$t('mission.access.list.type.user')))]), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": _vm.routerLinkTarget
    }
  }, [_vm._v(_vm._s(_vm.missionAccess.community ? _vm.missionAccess.community.name : _vm.formatUserWithTag(_vm.missionAccess.user)))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 496 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f37bc1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserDetails.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.userDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.userDetails.nickname))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('p', [(_vm.userDetails.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.userDetails.community.slug
        }
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.userDetails.community.tag) + "] " + _vm._s(_vm.userDetails.community.name))]) : _vm._e(), _vm._v(" "), (!_vm.userDetails.community) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.isUserAdmin) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-steam-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user.steamId')))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": ("https://steamcommunity.com/profiles/" + (_vm.userDetails.steamId)),
      "target": "_blank"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.userDetails.steamId) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.isUserAdmin) ? _c('div', {
    staticClass: "col"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user.status')) + "\n          ")]), _vm._v(" "), _c('p', {
    class: {
      'text-success': _vm.userDetails.active, 'text-danger': !_vm.userDetails.active
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-check': _vm.userDetails.active, 'fa-times': !_vm.userDetails.active
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.userDetails.active ? _vm.$t('user.status.normal') : _vm.$t('user.status.deactivated')) + "\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.isUserAdmin) ? _c('hr', {
    staticClass: "my-4"
  }) : _vm._e(), _vm._v(" "), (_vm.isUserAdmin) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.userEditModal",
      modifiers: {
        "userEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), (_vm.userDetails.active) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-times",
      "yes-class": "btn btn-warning",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('user.confirm.deactivate'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.modifyUserStatus(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.deactivate.user')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.userDetails.active) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-user-plus",
      "yes-class": "btn btn-success",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('user.confirm.activate'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.modifyUserStatus(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.activate.user')) + "\n          ")])], 1) : _vm._e(), _vm._v(" \n        "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('user.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteUser
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete.user')) + "\n          ")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('nav.missions')))]), _vm._v(" "), _c('user-missions')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.isUserAdmin) ? _c('user-edit-modal') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 497 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-33c83a00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-quill-editor/src/editor.vue ***!
  \**************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quill-editor"
  }, [_vm._t("toolbar"), _vm._v(" "), _c('div', {
    ref: "editor"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 498 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3400db94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMissions.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('community-missions-table'), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityMissionsPageCount > 1),
      expression: "communityMissionsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "communityMissionsPaginate",
    attrs: {
      "pageCount": _vm.communityMissionsPageCount,
      "clickHandler": _vm.paginateCommunityMissions,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.paginateCommunityMissions(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 499 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-342dab38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Api.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-jumbotron', {
    attrs: {
      "header": "API documentation",
      "lead": "slotlist.info provides a public JSON REST API to all of its users"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [(_vm.$i18n.locale === 'de') ? _c('span', {
    staticClass: "font-weight-bold text-danger"
  }, [_vm._v("Diese API-Information ist nur in Englisch verfügbar, da die eigentliche\n        "), _c('a', {
    attrs: {
      "href": "https://api.slotlist.walthex.com/documentation"
    }
  }, [_vm._v("API-Dokumentation")]), _vm._v(" auch nur in englischer Sprache ausgeliefert wird. Für etwaige Fragen stehen wir trotzdem gerne zur Verfügung."), _c('br'), _c('br')]) : _vm._e(), _vm._v("\n      You can use this API to integrate\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v("'s mission and slotlists into your own community page and provide a better overview of your missions right alongside your own community's web appearance.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("The API can be found at\n      "), _c('code', [_vm._v("https://api.slotlist.walthex.com")]), _vm._v(", the current API version being\n      "), _c('code', [_vm._v("v1")]), _vm._v(". All current endpoints are thus available at\n      "), _c('code', [_vm._v("https://api.slotlist.walthex.com/v1/ENDPOINT")]), _vm._v(", e.g. the current list of (publicly visible) missions can be retrieved from\n      "), _c('code', [_c('a', {
    attrs: {
      "href": "https://api.slotlist.walthex.com/v1/missions"
    }
  }, [_vm._v("https://api.slotlist.walthex.com/v1/missions")])]), _vm._v(".\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("The full (swagger) API documentation can be found at\n        "), _c('a', {
    attrs: {
      "href": "https://api.slotlist.walthex.com/documentation"
    }
  }, [_vm._v("https://api.slotlist.walthex.com/documentation")])]), _vm._v(", the corresponding swagger file is available\n      "), _c('a', {
    attrs: {
      "href": "https://api.slotlist.walthex.com/swagger.json"
    }
  }, [_vm._v("here")]), _vm._v(" and can be used to automatically\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/swagger-api/swagger-codegen"
    }
  }, [_vm._v("generate client libraries")]), _vm._v(".\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("All information is served via HTTPS and represented as JSON, no other formats are available. Endpoints that return a list of objects (e.g. missions, slots or communities) are paginated and can be walked using\n      "), _c('code', [_vm._v("?limit=NUMBER&offset=NUMBER")]), _vm._v(" query parameters (explained in more details in the respective endpoint's swagger documentation).\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Breaking changes to the API will lead to an incremented API version number (e.g.\n      "), _c('code', [_vm._v("v2")]), _vm._v("), old endpoints will still be supported as long as possible, but we reserve the right to remove any endpoints should we deem it necessary.\n      "), _c('br'), _vm._v("Deprecated endpoints will be indicated as such in the swagger API documentation and their responses will also contain a\n      "), _c('code', [_vm._v("Warning")]), _vm._v(" header in the format of\n      "), _c('code', [_vm._v("299 - \"The endpoint\n        "), _c('em', [_vm._v("NAME")]), _vm._v(" is deprecated and will be removed by\n        "), _c('em', [_vm._v("DATE")]), _vm._v(". Please see\n        "), _c('em', [_vm._v("LINK")]), _vm._v(" for details.\"")]), _vm._v("\n      Deprecated endpoints should\n      "), _c('strong', [_vm._v("not")]), _vm._v(" be used and applications migrationed to the newest version as soon as possible. All deprecation notices will also be posted to the Discord server's\n      "), _c('code', [_vm._v("#announcements-api")]), _vm._v(" channel.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Whilst some endpoints such as mission creation, slot registration or likewise required authentication (via Steam SSO), many endpoints - especially the overview ones like mission list and details - can be retrieved unauthenticated by everyone. At the moment, there is no easy way for an external application to authenticate with the\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" backend since the Steam SSO login redirects to our pages. In the future, we might provide an API key page for users to allow external apps to act on their behalf.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("As of now, there is no fixed limits for the number of API requests allowed per app, however we are monitoring the requests received and reserve the right to block third parties as we see fit. Ratelimits might be introduced in the feature without additional notice (beside this page) as well. Please also make sure you've read our\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("privacy policy")]), _vm._v(" - by using our API, you also explicity agree to it.\n      "), _c('br'), _vm._v("Please provide some sort of identifying information about your site or application in your requests, e.g. as a custom User-Agent like\n      "), _c('code', [_vm._v("User-Agent: spezialeinheit-luchs.de v1.0.0 / info@spezialeinheit-luchs.de")]), _vm._v(". This allows us to contact you in case your requests are causing issues or could be optimized in any way. We will not use this information to send you any unrelated or advertisement messages and will not pass it on to any third parties for any purposes.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" provides no guarantee about the uptime and availability of its API and might cease services at any point. We are not responsible for any outages or errors caused to your applications due to our system.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Should you run into any issues with the API, please open an issues on our\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-backend/issues"
    }
  }, [_vm._v("backend repository issue tracker")]), _vm._v(" on GitHub or use any of the other contact methods mentioned on the\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" page to contact us. We're grateful for any report or suggestion - questions are best asked in our support Discord.\n    ")], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 500 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-38163794"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationListRow.vue ***!
  \*********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-check': _vm.notification.seenAt, 'text-success': _vm.notification.seenAt
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.notification.createdAt)))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.notificationText)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.notificationTarget === null,
      "to": _vm.notificationTarget
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 501 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c4be24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotlist.vue ***!
  \************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.missionSlotGroups), function(missionSlotGroup) {
    return _c('mission-slotlist-group', {
      key: missionSlotGroup.uid,
      attrs: {
        "missionSlotGroup": missionSlotGroup
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotGroupCreateModal",
      modifiers: {
        "missionSlotGroupCreateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slotGroup')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionApplySlotTemplateModal",
      modifiers: {
        "missionApplySlotTemplateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.apply.mission.slotGroup')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.refreshMissionSlotlist
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "small text-muted text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.anyMissionSlotSelected ? _vm.$tc('mission.slot.selection.actions', _vm.missionSlotSelectionCount, {
        count: _vm.missionSlotSelectionCount
      }) : _vm.$t('mission.slot.selection.hint'))
    }
  }), _vm._v(" "), (_vm.anyMissionSlotSelected) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.anyMissionSlotSelected) ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotSelectionEditModal",
      modifiers: {
        "missionSlotSelectionEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.slot.selection')) + "\n      ")]), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-close",
      "yes-class": "btn btn-warning",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.unassign.selection'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.unassignSelectedMissionSlots
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.unassign.mission.slot.selection')) + "\n        ")])], 1), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.delete.selection'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteSelectedMissionSlots
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete.mission.slot.selection')) + "\n        ")])], 1), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.clearMissionSlotSelection
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.clear.selection')) + "\n      ")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasMissionAnyRequiredDLCs) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.hasMissionAnyRequiredDLCs) ? _c('div', {
    staticClass: "text-center small text-muted"
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "12px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "12px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "12px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "12px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "12px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "12px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "12px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "12px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "12px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "12px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "12px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "12px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')) + " | \n    "), _c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "12px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 502 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d0d3b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotRegistrations.vue ***!
  \*********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mission-slot-registrations-table'), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotRegistrationSuppressNotifications),
      callback: function($$v) {
        _vm.missionSlotRegistrationSuppressNotifications = $$v
      },
      expression: "missionSlotRegistrationSuppressNotifications"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot registrations actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshMissionSlotRegistrations
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n      ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 503 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a3ea33c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionEditModal.vue ***!
  \********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('b-modal', {
    ref: "missionEditModal",
    attrs: {
      "id": "missionEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionEditTitleState,
      "feedback": _vm.missionEditTitleFeedback,
      "description": _vm.$t('mission.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.title),
      callback: function($$v) {
        _vm.missionEditData.title = $$v
      },
      expression: "missionEditData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.description'),
      "state": _vm.missionEditDescriptionState,
      "feedback": _vm.missionEditDescriptionFeedback,
      "description": _vm.$t('mission.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": "",
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.description),
      callback: function($$v) {
        _vm.missionEditData.description = $$v
      },
      expression: "missionEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.detailedDescription'),
      "state": _vm.missionEditDetailedDescriptionState,
      "feedback": _vm.missionEditDetailedDescriptionFeedback,
      "description": _vm.$t('mission.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionEditDetailedDescriptionQuillEditorOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.detailedDescription),
      callback: function($$v) {
        _vm.missionEditData.detailedDescription = $$v
      },
      expression: "missionEditData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.collapsedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.collapsedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditcollapsedDescriptionEditor",
    attrs: {
      "options": _vm.missionEditDetailedDescriptionQuillEditorOptions
    },
    model: {
      value: (_vm.missionEditData.collapsedDescription),
      callback: function($$v) {
        _vm.missionEditData.collapsedDescription = $$v
      },
      expression: "missionEditData.collapsedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slottingTime'),
      "state": _vm.missionEditSlottingTimeState,
      "feedback": _vm.missionEditSlottingTimeFeedback,
      "description": _vm.$t('mission.slottingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.slottingTime),
      callback: function($$v) {
        _vm.missionEditData.slottingTime = $$v
      },
      expression: "missionEditData.slottingTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.startTime'),
      "state": _vm.missionEditStartTimeState,
      "feedback": _vm.missionEditStartTimeFeedback,
      "description": _vm.$t('mission.startTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.startTime),
      callback: function($$v) {
        _vm.missionEditData.startTime = $$v
      },
      expression: "missionEditData.startTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.endTime'),
      "state": _vm.missionEditEndTimeState,
      "feedback": _vm.missionEditEndTimeFeedback,
      "description": _vm.$t('mission.endTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.endTime),
      callback: function($$v) {
        _vm.missionEditData.endTime = $$v
      },
      expression: "missionEditData.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.briefingTime'),
      "state": _vm.missionEditBriefingTimeState,
      "feedback": _vm.missionEditBriefingTimeFeedback,
      "description": _vm.$t('mission.briefingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionEditTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionEditData.briefingTime),
      callback: function($$v) {
        _vm.missionEditData.briefingTime = $$v
      },
      expression: "missionEditData.briefingTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.techSupport.optional'),
      "state": "success",
      "description": _vm.$t('mission.techSupport.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditTechSupportEditor",
    attrs: {
      "options": _vm.missionEditQuillEditorOptions
    },
    model: {
      value: (_vm.missionEditData.techSupport),
      callback: function($$v) {
        _vm.missionEditData.techSupport = $$v
      },
      expression: "missionEditData.techSupport"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.rules.optional'),
      "state": "success",
      "description": _vm.$t('mission.rules.description')
    }
  }, [_c('quill-editor', {
    ref: "missionEditRulesEditor",
    attrs: {
      "options": _vm.missionEditQuillEditorOptions
    },
    model: {
      value: (_vm.missionEditData.rules),
      callback: function($$v) {
        _vm.missionEditData.rules = $$v
      },
      expression: "missionEditData.rules"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.hostname.optional'),
      "state": _vm.missionEditGameServerHostnameState,
      "feedback": _vm.missionEditGameServerHostnameFeedback,
      "description": _vm.$t('mission.gameServer.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.gameServer.hostname),
      callback: function($$v) {
        _vm.missionEditData.gameServer.hostname = $$v
      },
      expression: "missionEditData.gameServer.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.hostname.optional'),
      "state": _vm.missionEditVoiceCommsHostnameState,
      "feedback": _vm.missionEditVoiceCommsHostnameFeedback,
      "description": _vm.$t('mission.voiceComms.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.hostname),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.hostname = $$v
      },
      expression: "missionEditData.voiceComms.hostname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.port.optional'),
      "state": _vm.missionEditGameServerPortState,
      "feedback": _vm.missionEditGameServerPortFeedback,
      "description": _vm.$t('mission.gameServer.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionEditData.gameServer.port),
      callback: function($$v) {
        _vm.missionEditData.gameServer.port = $$v
      },
      expression: "missionEditData.gameServer.port"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.port.optional'),
      "state": _vm.missionEditVoiceCommsPortState,
      "feedback": _vm.missionEditVoiceCommsPortFeedback,
      "description": _vm.$t('mission.voiceComms.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.port),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.port = $$v
      },
      expression: "missionEditData.voiceComms.port"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.gameServer.name),
      callback: function($$v) {
        _vm.missionEditData.gameServer.name = $$v
      },
      expression: "missionEditData.gameServer.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.name),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.name = $$v
      },
      expression: "missionEditData.voiceComms.name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.gameServer.password),
      callback: function($$v) {
        _vm.missionEditData.gameServer.password = $$v
      },
      expression: "missionEditData.gameServer.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionEditData.voiceComms.password),
      callback: function($$v) {
        _vm.missionEditData.voiceComms.password = $$v
      },
      expression: "missionEditData.voiceComms.password"
    }
  })], 1)], 1)]), _vm._v(" "), ((_vm.communityGameServers && _vm.communityGameServers.length > 0) || (_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.communityGameServers && _vm.communityGameServers.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.gameServers'),
      "state": "success",
      "description": _vm.$t('community.gameServers.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionEditCommunityGameServers
    },
    model: {
      value: (_vm.missionEditCommunityGameServersSelected),
      callback: function($$v) {
        _vm.missionEditCommunityGameServersSelected = $$v
      },
      expression: "missionEditCommunityGameServersSelected"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [(_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.voiceComms'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionEditCommunityVoiceComms
    },
    model: {
      value: (_vm.missionEditCommunityVoiceCommsSelected),
      callback: function($$v) {
        _vm.missionEditCommunityVoiceCommsSelected = $$v
      },
      expression: "missionEditCommunityVoiceCommsSelected"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionEditVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionEditData.visibility),
      callback: function($$v) {
        _vm.missionEditData.visibility = $$v
      },
      expression: "missionEditData.visibility"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotsAutoAssignable'),
      "state": "success",
      "description": _vm.$t('mission.slotsAutoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditData.slotsAutoAssignable),
      callback: function($$v) {
        _vm.missionEditData.slotsAutoAssignable = $$v
      },
      expression: "missionEditData.slotsAutoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.aow = $$v
      },
      expression: "missionEditRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.apex = $$v
      },
      expression: "missionEditRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.contact = $$v
      },
      expression: "missionEditRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.csla = $$v
      },
      expression: "missionEditRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.gm = $$v
      },
      expression: "missionEditRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.helicopters = $$v
      },
      expression: "missionEditRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.jets = $$v
      },
      expression: "missionEditRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.karts = $$v
      },
      expression: "missionEditRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionEditRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.marksmen = $$v
      },
      expression: "missionEditRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.tacops = $$v
      },
      expression: "missionEditRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.tanks = $$v
      },
      expression: "missionEditRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionEditRequiredDLCs.vn = $$v
      },
      expression: "missionEditRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionEditSuppressNotifications),
      callback: function($$v) {
        _vm.missionEditSuppressNotifications = $$v
      },
      expression: "missionEditSuppressNotifications"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 504 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ad7aae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserMissionsRow.vue ***!
  \*********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.userMission.startTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userMission.title))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'missionDetails',
        params: {
          missionSlug: _vm.userMission.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 505 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b17cba1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarMission.vue ***!
  \************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-popover', {
    attrs: {
      "content": _vm.missionPopoverContent,
      "triggers": ['hover']
    }
  }, [_c('div', {
    staticClass: "card card-inverse calendar-mission",
    class: {
      'card-primary': !_vm.mission.isAssignedToAnySlot && !_vm.mission.isRegisteredForAnySlot, 'card-info': !_vm.mission.isAssignedToAnySlot && _vm.mission.isRegisteredForAnySlot, 'card-success': _vm.mission.isAssignedToAnySlot
    },
    on: {
      "click": _vm.redirectToMissionDetails
    }
  }, [_c('div', {
    staticClass: "card-header calendar-mission-title"
  }, [_vm._v(_vm._s(_vm.mission.title))])])])
},staticRenderFns: []}

/***/ }),
/* 506 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c1d7daf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserList.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.users) ? _c('user-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usersPageCount > 1),
      expression: "usersPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "usersPaginate",
    attrs: {
      "pageCount": _vm.usersPageCount,
      "initial-page": 0,
      "clickHandler": _vm.usersPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingUsers
    },
    on: {
      "click": function($event) {
        _vm.usersPaginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingUsers
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('user.list.search')))]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": _vm.$t('user.list.search.description')
    }
  }, [_c('typeahead', {
    ref: "userSearchTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.userSelected
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 507 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce955a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionCreator.vue ***!
  \*********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('mission.creator.title')))])]), _vm._v(" "), _c('div', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submitMissionCreate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionCreateTitleState,
      "feedback": _vm.missionCreateTitleFeedback,
      "description": _vm.$t('mission.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.missionCreateTitleFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateTitle),
      callback: function($$v) {
        _vm.missionCreateTitle = $$v
      },
      expression: "missionCreateTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slug'),
      "state": _vm.missionCreateSlugState,
      "feedback": _vm.missionCreateSlugFeedback,
      "description": _vm.$t('mission.slug.description')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.missionCreateSlugAvailable
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.missionCreateSlugFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateSlug),
      callback: function($$v) {
        _vm.missionCreateSlug = $$v
      },
      expression: "missionCreateSlug"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.description'),
      "state": _vm.missionCreateDescriptionState,
      "feedback": _vm.missionCreateDescriptionFeedback,
      "description": _vm.$t('mission.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": "",
      "required": ""
    },
    model: {
      value: (_vm.missionCreateDescription),
      callback: function($$v) {
        _vm.missionCreateDescription = $$v
      },
      expression: "missionCreateDescription"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.detailedDescription'),
      "state": _vm.missionCreateDetailedDescriptionState,
      "feedback": _vm.missionCreateDetailedDescriptionFeedback,
      "description": _vm.$t('mission.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreateDetailedDescriptionEditor",
    attrs: {
      "options": _vm.descriptionEditorOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionCreateDetailedDescription),
      callback: function($$v) {
        _vm.missionCreateDetailedDescription = $$v
      },
      expression: "missionCreateDetailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.collapsedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.collapsedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreatecollapsedDescriptionEditor",
    attrs: {
      "options": _vm.descriptionEditorOptions
    },
    model: {
      value: (_vm.missionCreatecollapsedDescription),
      callback: function($$v) {
        _vm.missionCreatecollapsedDescription = $$v
      },
      expression: "missionCreatecollapsedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slottingTime'),
      "state": _vm.missionCreateSlottingTimeState,
      "feedback": _vm.missionCreateSlottingTimeFeedback,
      "description": _vm.$t('mission.slottingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    on: {
      "blur": _vm.missionCreateSlottingTimeBlur
    },
    model: {
      value: (_vm.missionCreateSlottingTime),
      callback: function($$v) {
        _vm.missionCreateSlottingTime = $$v
      },
      expression: "missionCreateSlottingTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.startTime'),
      "state": _vm.missionCreateStartTimeState,
      "feedback": _vm.missionCreateStartTimeFeedback,
      "description": _vm.$t('mission.startTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateStartTime),
      callback: function($$v) {
        _vm.missionCreateStartTime = $$v
      },
      expression: "missionCreateStartTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.endTime'),
      "state": _vm.missionCreateEndTimeState,
      "feedback": _vm.missionCreateEndTimeFeedback,
      "description": _vm.$t('mission.endTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateEndTime),
      callback: function($$v) {
        _vm.missionCreateEndTime = $$v
      },
      expression: "missionCreateEndTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.briefingTime'),
      "state": _vm.missionCreateBriefingTimeState,
      "feedback": _vm.missionCreateBriefingTimeFeedback,
      "description": _vm.$t('mission.briefingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionCreateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionCreateBriefingTime),
      callback: function($$v) {
        _vm.missionCreateBriefingTime = $$v
      },
      expression: "missionCreateBriefingTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.techSupport.optional'),
      "state": _vm.missionCreateTechSupportState,
      "feedback": _vm.missionCreateTechSupportFeedback,
      "description": _vm.$t('mission.techSupport.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreateTechSupportEditor",
    attrs: {
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.missionCreateTechSupport),
      callback: function($$v) {
        _vm.missionCreateTechSupport = $$v
      },
      expression: "missionCreateTechSupport"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.rules.optional'),
      "state": _vm.missionCreateRulesState,
      "feedback": _vm.missionCreateRulesFeedback,
      "description": _vm.$t('mission.rules.description')
    }
  }, [_c('quill-editor', {
    ref: "missionCreateRulesEditor",
    attrs: {
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.missionCreateRules),
      callback: function($$v) {
        _vm.missionCreateRules = $$v
      },
      expression: "missionCreateRules"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.hostname.optional'),
      "state": _vm.missionCreateGameServerHostnameState,
      "feedback": _vm.missionCreateGameServerHostnameFeedback,
      "description": _vm.$t('mission.gameServer.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateGameServerHostname),
      callback: function($$v) {
        _vm.missionCreateGameServerHostname = $$v
      },
      expression: "missionCreateGameServerHostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.hostname.optional'),
      "state": _vm.missionCreateVoiceCommsHostnameState,
      "feedback": _vm.missionCreateVoiceCommsHostnameFeedback,
      "description": _vm.$t('mission.voiceComms.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsHostname),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsHostname = $$v
      },
      expression: "missionCreateVoiceCommsHostname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.port.optional'),
      "state": _vm.missionCreateGameServerPortState,
      "feedback": _vm.missionCreateGameServerPortFeedback,
      "description": _vm.$t('mission.gameServer.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionCreateGameServerPort),
      callback: function($$v) {
        _vm.missionCreateGameServerPort = $$v
      },
      expression: "missionCreateGameServerPort"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.port.optional'),
      "state": _vm.missionCreateVoiceCommsPortState,
      "feedback": _vm.missionCreateVoiceCommsPortFeedback,
      "description": _vm.$t('mission.voiceComms.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsPort),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsPort = $$v
      },
      expression: "missionCreateVoiceCommsPort"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateGameServerName),
      callback: function($$v) {
        _vm.missionCreateGameServerName = $$v
      },
      expression: "missionCreateGameServerName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.name.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsName),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsName = $$v
      },
      expression: "missionCreateVoiceCommsName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.gameServer.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.gameServer.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateGameServerPassword),
      callback: function($$v) {
        _vm.missionCreateGameServerPassword = $$v
      },
      expression: "missionCreateGameServerPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.voiceComms.password.optional'),
      "state": "success",
      "description": _vm.$t('mission.voiceComms.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionCreateVoiceCommsPassword),
      callback: function($$v) {
        _vm.missionCreateVoiceCommsPassword = $$v
      },
      expression: "missionCreateVoiceCommsPassword"
    }
  })], 1)], 1)]), _vm._v(" "), ((_vm.communityGameServers && _vm.communityGameServers.length > 0) || (_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.communityGameServers && _vm.communityGameServers.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.gameServers'),
      "state": "success",
      "description": _vm.$t('community.gameServers.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionCreateCommunityGameServers
    },
    model: {
      value: (_vm.missionCreateCommunityGameServersSelected),
      callback: function($$v) {
        _vm.missionCreateCommunityGameServersSelected = $$v
      },
      expression: "missionCreateCommunityGameServersSelected"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [(_vm.communityVoiceComms && _vm.communityVoiceComms.length > 0) ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.voiceComms'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionCreateCommunityVoiceComms
    },
    model: {
      value: (_vm.missionCreateCommunityVoiceCommsSelected),
      callback: function($$v) {
        _vm.missionCreateCommunityVoiceCommsSelected = $$v
      },
      expression: "missionCreateCommunityVoiceCommsSelected"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.user.community) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.creator.addToCommunity'),
      "state": _vm.missionCreateAddToCommunityState,
      "feedback": _vm.missionCreateAddToCommunityFeedback,
      "description": _vm.missionCreateAddToCommunityDescription
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateAddToCommunity),
      callback: function($$v) {
        _vm.missionCreateAddToCommunity = $$v
      },
      expression: "missionCreateAddToCommunity"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotsAutoAssignable'),
      "state": "success",
      "description": _vm.$t('mission.slotsAutoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateSlotsAutoAssignable),
      callback: function($$v) {
        _vm.missionCreateSlotsAutoAssignable = $$v
      },
      expression: "missionCreateSlotsAutoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.aow = $$v
      },
      expression: "missionCreateRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.apex = $$v
      },
      expression: "missionCreateRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.contact = $$v
      },
      expression: "missionCreateRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.csla = $$v
      },
      expression: "missionCreateRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.gm = $$v
      },
      expression: "missionCreateRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.helicopters = $$v
      },
      expression: "missionCreateRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.jets = $$v
      },
      expression: "missionCreateRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.karts = $$v
      },
      expression: "missionCreateRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionCreateRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.marksmen = $$v
      },
      expression: "missionCreateRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.tacops = $$v
      },
      expression: "missionCreateRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.tanks = $$v
      },
      expression: "missionCreateRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionCreateRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionCreateRequiredDLCs.vn = $$v
      },
      expression: "missionCreateRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": _vm.missionCreateVisibilityState,
      "feedback": _vm.missionCreateVisibilityFeedback,
      "description": _vm.$t('mission.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionCreateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionCreateVisibility),
      callback: function($$v) {
        _vm.missionCreateVisibility = $$v
      },
      expression: "missionCreateVisibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitMissionCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 508 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d63342f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarWeek.vue ***!
  \*********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-week-row"
  }, _vm._l((_vm.week), function(day) {
    return _c('calendar-day', {
      key: day,
      attrs: {
        "day": day
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 509 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ec1a224"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionSlotTemplateCreator.vue ***!
  \*********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.creator.title')))])]), _vm._v(" "), _c('div', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createMissionSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionSlotTemplateCreateTitleState,
      "feedback": _vm.missionSlotTemplateCreateTitleFeedback,
      "description": _vm.$t('mission.slotTemplate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateCreateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateCreateData.title = $$v
      },
      expression: "missionSlotTemplateCreateData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": _vm.missionSlotTemplateCreateVisibilityState,
      "feedback": _vm.missionSlotTemplateCreateVisibilityFeedback,
      "description": _vm.$t('mission.slotTemplate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateCreateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateCreateData.visibility),
      callback: function($$v) {
        _vm.missionSlotTemplateCreateData.visibility = $$v
      },
      expression: "missionSlotTemplateCreateData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slot.template')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 510 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-465f2b2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationListTable.vue ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.seen')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.received')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "73%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.notification')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.notifications), function(notification) {
    return _c('notification-list-row', {
      key: notification.uid,
      attrs: {
        "notification": notification
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifications.length >= 10),
      expression: "notifications.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.seen')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.received')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "73%"
    }
  }, [_vm._v(_vm._s(_vm.$t('notification.notification')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 511 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-476f16a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityPermissionsRow.vue ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.communityPermission.user.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.communityPermission.user)))])], 1), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedCommunityPermission)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm",
      "disabled": _vm.isCommunityFounderPermission
    },
    on: {
      "click": _vm.deleteCommunityPermission
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 512 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-47c7ace2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionAccessModal.vue ***!
  \**********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionAccessModal",
    attrs: {
      "id": "missionAccessModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.access'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionAccesses
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('mission.access.existing')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('mission-accesses', {
    attrs: {
      "missionAccesses": _vm.missionAccesses
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('mission.access.add')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.access.add.explanation'))
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionAccess($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.access.community.selection'),
      "state": _vm.missionAccessAddCommunityState,
      "description": _vm.$t('mission.access.community.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionAccessAddCommunityTypeahead",
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.permissionCommunitySelected
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.access.user.selection'),
      "state": _vm.missionAccessAddUserState,
      "description": _vm.$t('mission.access.user.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionAccessAddUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.permissionUserSelected
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add.mission.access')) + "\n                ")])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission access actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionAccessModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 513 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d5eb3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotRegistrationsTable.vue ***!
  \**************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotRegistrations) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    style: (_vm.playerColumnWidth)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails) ? _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.comment')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.registered')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.confirmed')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails && !_vm.hasMissionEnded) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionSlotRegistrations), function(registration) {
    return _c('mission-slot-registrations-row', {
      key: registration.uid,
      attrs: {
        "registration": registration
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotRegistrations.length >= 10),
      expression: "missionSlotRegistrations.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    style: (_vm.playerColumnWidth)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails) ? _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.comment')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.registered')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.registration.confirmed')))]), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.hasAnyMissionSlotRegistrationDetails && !_vm.hasMissionEnded) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))]) : _vm._e()])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 514 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bbbfd5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotEditModal.vue ***!
  \************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotEditModal",
    attrs: {
      "id": "missionSlotEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.slot.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotEditTitleState,
      "feedback": _vm.missionSlotEditTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotEditData.title),
      callback: function($$v) {
        _vm.missionSlotEditData.title = $$v
      },
      expression: "missionSlotEditData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotEditData.description),
      callback: function($$v) {
        _vm.missionSlotEditData.description = $$v
      },
      expression: "missionSlotEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotEditDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotEditData.difficulty),
      callback: function($$v) {
        _vm.missionSlotEditData.difficulty = $$v
      },
      expression: "missionSlotEditData.difficulty"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.externalAssignee.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.externalAssignee.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "disabled": _vm.missionSlotDetails.assignee !== null
    },
    model: {
      value: (_vm.missionSlotEditData.externalAssignee),
      callback: function($$v) {
        _vm.missionSlotEditData.externalAssignee = $$v
      },
      expression: "missionSlotEditData.externalAssignee"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.restricted.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.restricted),
      callback: function($$v) {
        _vm.missionSlotEditData.restricted = $$v
      },
      expression: "missionSlotEditData.restricted"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.reserve),
      callback: function($$v) {
        _vm.missionSlotEditData.reserve = $$v
      },
      expression: "missionSlotEditData.reserve"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.blocked),
      callback: function($$v) {
        _vm.missionSlotEditData.blocked = $$v
      },
      expression: "missionSlotEditData.blocked"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.autoAssignable.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.autoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.autoAssignable),
      callback: function($$v) {
        _vm.missionSlotEditData.autoAssignable = $$v
      },
      expression: "missionSlotEditData.autoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.missionSlotEditData.restricted) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.selection'),
      "state": _vm.missionSlotEditRestrictedCommunityState,
      "description": _vm.$t('mission.slot.restricted.selection.description')
    }
  }, [_c('typeahead', {
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.restrictedSlotCommunitySelected,
      "initialValue": _vm.restrictedSlotTypeaheadInitialValue
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotEditDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotEditDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotEditData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotEditData.detailedDescription = $$v
      },
      expression: "missionSlotEditData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.aow = $$v
      },
      expression: "missionSlotEditRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.apex = $$v
      },
      expression: "missionSlotEditRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.contact = $$v
      },
      expression: "missionSlotEditRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.csla = $$v
      },
      expression: "missionSlotEditRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.gm = $$v
      },
      expression: "missionSlotEditRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.helicopters = $$v
      },
      expression: "missionSlotEditRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.jets = $$v
      },
      expression: "missionSlotEditRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.karts = $$v
      },
      expression: "missionSlotEditRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionSlotEditRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.marksmen = $$v
      },
      expression: "missionSlotEditRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.tacops = $$v
      },
      expression: "missionSlotEditRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.tanks = $$v
      },
      expression: "missionSlotEditRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.vn = $$v
      },
      expression: "missionSlotEditRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.moveAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.moveAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotEditMoveAfterOptions
    },
    model: {
      value: (_vm.missionSlotEditMoveAfter),
      callback: function($$v) {
        _vm.missionSlotEditMoveAfter = $$v
      },
      expression: "missionSlotEditMoveAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 515 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c0f1f50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditorExplanation.vue ***!
  \*****************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-muted small"
  }, [_c('b-popover', {
    attrs: {
      "content": _vm.editorExplanationContent,
      "triggers": ['click', 'focus']
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-question-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('editor.explanation')) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 516 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c504629"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateDuplicateModal.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateDuplicateModal",
    attrs: {
      "id": "missionSlotTemplateDuplicateModal",
      "title": _vm.$t('mission.slotTemplate.modal.duplicate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotTemplateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.duplicateMissionSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.slotTemplate.duplicate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": "success",
      "description": _vm.$t('mission.slotTemplate.duplicate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateDuplicateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateDuplicateData.title = $$v
      },
      expression: "missionSlotTemplateDuplicateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.slotTemplate.duplicate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateDuplicateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateDuplicateData.visibility),
      callback: function($$v) {
        _vm.missionSlotTemplateDuplicateData.visibility = $$v
      },
      expression: "missionSlotTemplateDuplicateData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template duplicate actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.duplicateMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateDuplicateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 517 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d5286e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupEditModal.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotGroupDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotGroupEditModal",
    attrs: {
      "id": "missionSlotTemplateSlotGroupEditModal",
      "title": _vm.$t('mission.modal.slotGroup.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotTemplateSlotGroupEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotTemplateSlotGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.title'),
      "state": _vm.missionSlotTemplateSlotGroupEditTitleState,
      "feedback": _vm.missionSlotTemplateSlotGroupEditTitleFeedback,
      "description": _vm.$t('mission.slotGroup.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupEditData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupEditData.title = $$v
      },
      expression: "missionSlotTemplateSlotGroupEditData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupEditData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupEditData.description = $$v
      },
      expression: "missionSlotTemplateSlotGroupEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.moveAfter'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.moveAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotGroupEditMoveAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupEditMoveAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupEditMoveAfter = $$v
      },
      expression: "missionSlotTemplateSlotGroupEditMoveAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot group edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotGroupEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 518 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f8b20de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionConvertToSlotTemplateModal.vue ***!
  \*************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionConvertToSlotTemplateModal",
    attrs: {
      "id": "missionConvertToSlotTemplateModal",
      "title": _vm.$t('mission.modal.convert.slotTemplate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionConvertToSlotTemplateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.convertMissionToSlotTemplate($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.convert.slotTemplate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": _vm.missionConvertToSlotTemplateTitleState,
      "feedback": _vm.missionConvertToSlotTemplateTitleFeedback,
      "description": _vm.$t('mission.slotTemplate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionConvertToSlotTemplateData.title),
      callback: function($$v) {
        _vm.missionConvertToSlotTemplateData.title = $$v
      },
      expression: "missionConvertToSlotTemplateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.slotTemplate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionConvertToSlotTemplateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionConvertToSlotTemplateData.visibility),
      callback: function($$v) {
        _vm.missionConvertToSlotTemplateData.visibility = $$v
      },
      expression: "missionConvertToSlotTemplateData.visibility"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission convert to slot template actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.convertMissionToSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionConvertToSlotTemplateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 519 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-51549375"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionBannerImageModal.vue ***!
  \***************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('b-modal', {
    ref: "missionBannerImageModal",
    attrs: {
      "id": "missionBannerImageModal",
      "title": _vm.$t('mission.modal.bannerImage'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionBannerImageData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.uploadMissionBannerImage($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.missionBannerImageData.url) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.missionBannerImageData.url
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _c('div', {
    staticClass: "col text-center font-italic"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('mission.bannerImage.notSelected')) + "\n            "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.bannerImage'),
      "state": _vm.missionBannerImageState,
      "feedback": _vm.missionBannerImageFeedback,
      "description": _vm.$t('mission.bannerImage.description')
    }
  }, [_c('b-form-file', {
    ref: "missionBannerImageSelection",
    attrs: {
      "id": "missionBannerImageSelection",
      "accept": "image/jpeg, image/png, image/gif",
      "choose-label": _vm.$t('mission.bannerImage.choose')
    },
    model: {
      value: (_vm.missionBannerImageData.file),
      callback: function($$v) {
        _vm.missionBannerImageData.file = $$v
      },
      expression: "missionBannerImageData.file"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission banner image actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.uploadMissionBannerImage
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.upload')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger",
      "disabled": !_vm.missionBannerImageData.url
    },
    on: {
      "click": _vm.deleteMissionBannerImage
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionBannerImageModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 520 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a6b428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotCreateModal.vue ***!
  \**************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotGroupDetails) ? _c('b-modal', {
    ref: "missionSlotCreateModal",
    attrs: {
      "id": "missionSlotCreateModal",
      "size": "lg",
      "title": _vm.slotCreateTitle,
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotCreateTitleState,
      "feedback": _vm.missionSlotCreateTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotCreateData.title),
      callback: function($$v) {
        _vm.missionSlotCreateData.title = $$v
      },
      expression: "missionSlotCreateData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotCreateData.description),
      callback: function($$v) {
        _vm.missionSlotCreateData.description = $$v
      },
      expression: "missionSlotCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotCreateDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotCreateData.difficulty),
      callback: function($$v) {
        _vm.missionSlotCreateData.difficulty = $$v
      },
      expression: "missionSlotCreateData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.restricted.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateData.restricted),
      callback: function($$v) {
        _vm.missionSlotCreateData.restricted = $$v
      },
      expression: "missionSlotCreateData.restricted"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateData.reserve),
      callback: function($$v) {
        _vm.missionSlotCreateData.reserve = $$v
      },
      expression: "missionSlotCreateData.reserve"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateData.blocked),
      callback: function($$v) {
        _vm.missionSlotCreateData.blocked = $$v
      },
      expression: "missionSlotCreateData.blocked"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.autoAssignable.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.autoAssignable.description'),
      "feedback": _vm.missionSlotCreateAutoAssignableFeedback
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.areMissionSlotAutoAssignable
    },
    model: {
      value: (_vm.missionSlotCreateData.autoAssignable),
      callback: function($$v) {
        _vm.missionSlotCreateData.autoAssignable = $$v
      },
      expression: "missionSlotCreateData.autoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.missionSlotCreateData.restricted) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.selection'),
      "state": _vm.missionSlotCreateRestrictedCommunityState,
      "description": _vm.$t('mission.slot.restricted.selection.description')
    }
  }, [_c('typeahead', {
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.restrictedSlotCommunitySelected
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotCreateDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotCreateDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotCreateData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotCreateData.detailedDescription = $$v
      },
      expression: "missionSlotCreateData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.aow = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.apex = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.contact = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.csla = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.gm = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.helicopters = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.jets = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.karts = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.marksmen = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.tacops = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.tanks = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.vn = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotCreateData.insertAfter = $$v
      },
      expression: "missionSlotCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 521 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-54030759"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotAssignModal.vue ***!
  \**************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotAssignModal",
    attrs: {
      "id": "missionSlotAssignModal",
      "title": _vm.missionSlotAssignTitle,
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotAssignData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.assignMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.assign.selection'),
      "state": _vm.missionSlotAssignUserState,
      "description": _vm.$t('mission.slot.assign.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionSlotAssignUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.assignUserSelected
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.assign.force'),
      "state": "success",
      "description": _vm.$t('mission.slot.assign.force.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotAssign.force),
      callback: function($$v) {
        _vm.missionSlotAssign.force = $$v
      },
      expression: "missionSlotAssign.force"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotAssignSuppressNotifications),
      callback: function($$v) {
        _vm.missionSlotAssignSuppressNotifications = $$v
      },
      expression: "missionSlotAssignSuppressNotifications"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.assignMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.assign.mission.slot')) + "\n      ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotAssignModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n      ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 522 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f8326b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroup.vue ***!
  \*****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.missionSlotGroup.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotGroup.description),
      expression: "missionSlotGroup.description"
    }],
    staticClass: "word-wrap"
  }, [_vm._v(_vm._s(_vm.missionSlotGroup.description))]), _vm._v(" "), _c('mission-slot-template-slotlist-group-slots-table', {
    attrs: {
      "missionSlotGroup": _vm.missionSlotGroup
    }
  }), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.index > 0) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.moveMissionSlotTemplateSlotGroup(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.move.up')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.index < (_vm.missionSlotGroupCount - 1)) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.moveMissionSlotTemplateSlotGroup(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.move.down')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotCreateModal",
      modifiers: {
        "missionSlotTemplateSlotCreateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.setMissionSlotTemplateSlotGroupDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slot')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotGroupEditModal",
      modifiers: {
        "missionSlotTemplateSlotGroupEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.setMissionSlotTemplateSlotGroupDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.slotGroup')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.duplicateMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slotGroup')) + "\n    ")]), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slotGroup.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n      ")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 523 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-554a726c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountMissionsRow.vue ***!
  \**************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.accountMission.startTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accountMission.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accountMission.description))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'missionDetails',
        params: {
          missionSlug: _vm.accountMission.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 524 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5587e720"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateSlotlistGroupSlotsRow.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.orderNumber))]), _vm._v(" "), _c('td', [(!_vm.missionSlotDetails.reserve && !_vm.missionSlotDetails.blocked) ? _c('div', [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.missionSlotDetails.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.missionSlotDetails.reserve || _vm.missionSlotDetails.blocked) ? _c('b-popover', {
    attrs: {
      "content": _vm.titlePopoverContent,
      "triggers": ['hover']
    }
  }, [_c('span', {
    class: _vm.titleColor,
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTitle)
    }
  })]) : _vm._e()], 1), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.description))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot actions"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotDetailsModal",
      modifiers: {
        "missionSlotTemplateSlotDetailsModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.prepareMissionSlotTemplateSlotDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlotTemplateMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 525 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-57367204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/MissionSlotTemplateListRow.vue ***!
  \***********************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.missionSlotTemplate.title))]), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionSlotTemplate.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.missionSlotTemplate.creator)))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplate.slotGroupCount))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplate.slotCount))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'missionSlotTemplateDetails',
        params: {
          missionSlotTemplateUid: _vm.missionSlotTemplate.uid
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 526 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f6985a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Imprint.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('imprint-de') : _c('imprint-en')], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-59fab283"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Home.de.vue ***!
  \*******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "slotlist.info",
      "lead": "ArmA 3 Missions- und Slotlist-Management"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" ermöglicht das Erstellen und Verwalten von\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_vm._v("Missionen")]), _vm._v(" - inklusive Slotlisten, bei denen Benutzer sich für ihre gewünschten Slots anmelden können.\n    "), _c('br'), _vm._v("Das\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_vm._v("Community-Feature")]), _vm._v(" erlaubt es Arma-Communities, ihre Gemeinschaft auf unserer Website zu präsentieren und dadurch für ihre selbsterstellten Missionen zu werben.\n    "), _c('br'), _vm._v("Da\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" Steam Single Sign-on benutzt, wird keine lästige Registrierung und kein weiterer Account auf noch einer weiteren Seite benötigt - alle Authentifizierung wird sicher von den Steam Servern erledigt. Zum Loslegen einfach\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("anmelden")]), _vm._v(" und\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionCreator'
      }
    }
  }, [_vm._v("eine neue Mission erstellen")]), _vm._v("!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Weil sich\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" noch immer in der Entwicklungsphase befindet, wird es immer wieder Änderungen an den Seiten und deren Features (oder Daten) geben. Wir werden unser Bestes geben, um Service-Ausfälle möglichst kurz zu halten und Datenverluste zu verhindern.\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Kontaktiere uns")]), _vm._v(" aber bitte jederzeit, falls irgendwelche Probleme auftreten sollten oder es Anregungen gibt.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Vielen Dank für die Nutzung unserer Services - ich hoffe, sie sind von gutem Nutzen!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v("— MorpheusXAUT, slotlist.info Entwickler")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 528 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a1cf116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/FAQ.de.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-justify"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("Was ist\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v("?\n      ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" ist ein ArmA 3 Slotlist- und Missionsverwaltungs-Tool. Missionsersteller sowie Spieler können es benutzen, um einfach Missionen zu organisieren und Slots auszuwählen.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Wer hat\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" entwickelt und betreibt es?\n      ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" wurde von\n        "), _c('a', {
    attrs: {
      "href": "https://steamcommunity.com/id/morpheusxaut"
    }
  }, [_vm._v("[SeL] MorpheusXAUT")]), _vm._v(", hauptsächlich als Slotting-Tool für die\n        "), _c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("Spezialeinheit Luchs")]), _vm._v(", entwickelt. Wir haben uns dazu entschieden, den Dienst für alle verfügbar zu machen und hoffen, dass er eine nützliche Alternative zu Anmeldungen über verschiedene Foren bietet.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Muss ich mich anmelden, um Missionen oder Slotlisten zu sehen?")]), _vm._v(" "), _c('p', [_vm._v("\n        Nein. Du kannst alle öffentlich sichtbaren\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_vm._v("Missionen")]), _vm._v(" einsehen und deren Details und Slotliste ansehen, ohne dich anmelden zu müssen. Beachte dabei aber bitte, dass Missionsersteller die Möglichkeit haben, Missionen nur für Community-Mitglieder oder ausgewählte Benutzer sichtbar zu machen - du siehst daher eventuell nicht alle Missionen, die du sehen würdest, wenn du eingeloggt wärst.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Muss ich mich auf\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" für einen Slot anmelden, um an einer Mission teilnehmen zu können?\n      ")], 1), _vm._v(" "), _c('p', [_vm._v("\n        Das kommt einzig auf den Missionsersteller an -\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" stellt diesen nur einen Dienst zur Verfügung, um ihre Missionen und Slotlist zu verwalten, wie sie sich dazu entscheiden, diesen einzusetzen, ist jedem Ersteller vorbehalten. Manche Missionsersteller könnten verlangen, dass jeder Mitspieler für einen Slot angemeldet und bestätigt ist, bevor die Mission anfängt, während andere eine externe Anmeldung via z.B. Community-Forum auch zulassen könnten und diese Website nur nutzen, um ihre Mission zu bewerben. Zuletzt können manche Ersteller auch zulassen, dass du zum Missionsbeginn erscheinst und einen der übrigen, noch freien Slots belegst. Am besten versuchst du, den Missionsersteller vor dem Beginn zu kontaktieren und zu fragen, falls du dir nicht sicher bist.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Muss sicher jeder auf dieser Website anmelden, damit ich sie für meine Mission verwenden kann?")]), _vm._v(" "), _c('p', [_vm._v("\n        Idealerweise loggt sich jeder Spieler auf\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" ein und meldet sich für seinen gewünschten Slot über die Slotliste deiner Mission an. Da wir uns aber bewusst sind, dass manche Leute nicht gerne eine externe Seite benutzen, um sich einen Slot für eine Mission auszusuchen, haben wir Missionserstellern auch die Möglichkeit gegeben, einen Slot zu \"blockieren\", wodurch andere\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v("-Benutzer sich nicht mehr auf diesen anmelden können - händische Slotzuweisungen von \"externen\" Spielern können dann als Slotbeschreibung hinzugefügt werden."), _c('br'), _vm._v("Während diese Art der Anmeldung nicht die selbe Funktionalität wie eine \"normale\" Anmeldung bietet, hoffen wir, dass dies eine akzeptable Alternative für unsere skeptischeren Spieler bietet.\n      ")], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n        Sollte sich die Leitung der Community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v(" dazu entschieden haben, ihre Community auf unserer Website zu repräsentieren und darum eine\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_vm._v("Community")]), _vm._v(" angelegt haben, kannst du einfach einen Haken bei der \"Reservierter Slot\" Checkbox setzen, während du einen Slot erstellst oder bearbeitest, und nach dem Community-Namen suchen. Sobald der Slot reserviert ist, können sich nur noch Benutzer dafür anmelden, die als Mitglieder dieser Community auf\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" gelistet sind."), _c('br'), _vm._v("Sollte sich Community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v(" dagegen entscheiden, auf unserer Website aufzutreten, solltest du den Slot blockieren, indem du einen Haken bei der \"Blockierter Slot\" Checkbox setzt und eine Nachricht ähnlich \"Reserviert für Community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v("\" als Slotbeschreibung hinzufügst."), _c('br'), _vm._v("Genau wie bei der Spielerzuweisung via blockierten Slots stellt dies nicht die volle Funktionalität der Slotliste von\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" zur Verfügung, dient aber als Alternative, falls du Spieler und Communities nicht ausschließen wollen, wenn diese sich gegen die Verwendung unseres Dienstes entscheiden.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Ich bin noch immer skeptisch oder verwirrt...")]), _vm._v(" "), _c('p', [_vm._v("\n        Gerne kommen wir für ein Gespräch zu euch, um unseren Dienst genauer zu erklären und möglichst alle Verwirrungen so gut wir können aufzuklären - kontaktiere uns einfach über einen der Wege, die auf unserer\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über-Seite")]), _vm._v(" angegeben sind. Während wir euch gerne als Nutzer unseres Dienstes begrüßen würden, können wir natürlich Skeptizismus auch verstehen und freuen uns über jegliche Art von Feedback.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("Wie funktioniert der Login?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h5', [_vm._v("Kann auf meinen Steam-Account zugegriffen werden, nachdem ich mich auf eurer Website eingeloggt habe?")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h5', [_vm._v("Welche Informationen werden über mich gespeichert?")]), _vm._v(" "), _c('p', [_vm._v("\n        Wenn du dich das erste Mal einloggst, legt unser Backend einen neuen Benutzer in der Datenbank an und speichert die SteamID, welche uns von Steam's Login-Dienst übermittelt wird, sowie deinen (öffentlichen) Nickname zu diesem Zeitpunkt. Du kannst den Nickname auf dieser Website jederzeit ändern, indem du auf deine\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account-Seite")]), _vm._v(" gehst während du eingeloggt bist. Bitte beachte, dass die Änderung deines Steam-Nicknames nicht den Nickname auf\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" aktualisiert, weil wir die Steam-Server nach der initialen Anmeldung nicht mehr nach deinem Nickname fragen. Neben der SteamID und dem Nickname beinhaltet die gespeicherte Benutzerinformation auch noch eine eindeutige ID, welche von unserem Backend zufällig erstellt wird und benötigt wird, um einen Benutzer eindeutig im Service identifizieren zu können."), _c('br'), _vm._v("Wenn du dich für einen Missionsslot anmeldest, wird ein Datenbankeintrag angelegt, welcher die Slot ID, deine Benutzer ID sowie den optionale Kommentar - sofern du eines angegeben hast - speichert."), _c('br'), _vm._v("Solltest du einen Auszug aller Daten, die wir aktuell über dich speichern, erhalten wollen, kontaktiere uns bitte auf einem der Wege, die auf unserer\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über-Seite")]), _vm._v(" erwähnt werden, und wir stellen dir gerne alle Informationen zur Verfügung, die wir haben."), _c('br'), _vm._v("Genauere Informationen zur Datenschutzrichtlinie dieser Website können\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("hier")]), _vm._v(" gefunden werden.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Ich möchte, dass ihr alle Daten über mich löscht!")]), _vm._v(" "), _c('p', [_vm._v("Das ist zwar keine Frage, aber klar!"), _c('br'), _vm._v("Gehe dazu einfach auf deine\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account-Seite")]), _vm._v(" während du eingeloggt bist und drücken den \"Account löschen\" Knopf. Nach Bestätigung der Löschung werden alle Informationen, die mit deinem Benutzer verbunden sind, aus unserem Backend gelöscht und du wirst ausgeloggt."), _c('br'), _vm._v("Wir weisen darauf hin, dass dies auch\n        "), _c('strong', [_vm._v("jede")]), _vm._v(" von dir erstelle Mission, jede von dir abgeschickte Slotanmeldung sowie jede Berechtigung, die an dich vergeben wurden, löschen wird. Dies entfernt dich auch als Community-Gründer und nimmt dir dadurch die Möglichkeit, deine Community zu löschen - falls du eine erstellt hast. Lösche daher bitte deine Community vor deinem Account, falls du deren Daten auch entfernt haben möchtest.\n        "), _c('strong', [_vm._v("Diese Änderungen sind irreversibel - wir haben keine Möglichkeit, diese Daten wiederherzustellen, sobald sie gelöscht wurden.")])], 1), _vm._v(" "), _c('h5', [_vm._v("Seid ihr böse?")]), _vm._v(" "), _c('p', [_vm._v("\n        Nur an jedem zweiten Dienstag.\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Häufig gestellte Fragen")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Wie kann ich Slots für Community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v(" reservieren?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Wir nutzen einen Login-Service, genannt\n        "), _c('em', [_vm._v("Steam OpenID")]), _vm._v(" oder\n        "), _c('em', [_vm._v("Steam Single Sign On")]), _vm._v(", der von Steam zur Verfügung gestellt wird. Mehr Informationen zu diesem Service können\n        "), _c('a', {
    attrs: {
      "href": "https://steamcommunity.com/dev"
    }
  }, [_vm._v("hier")]), _vm._v(" gefunden werden."), _c('br'), _vm._v("Wenn du auf den\n        "), _c('em', [_vm._v("Sign in through Steam")]), _vm._v(" Knopf drückst, wirst du auf eine Steam Community-Seite weitergeleitet, auf welcher du dich in deinen Steam-Account einloggen sollst. Wir weisen darauf hin, dass wir keinerlei Zugang zu dieser Seite haben und deine Steam-Logindaten nicht erhalten. Der gesamte Login-Vorgang wird sicher von Steam über die\n        "), _c('code', [_vm._v("steamcommunity.com")]), _vm._v(" Domain abgewickelt.\n        "), _c('strong', [_vm._v("Du musst deine Steam-Logindaten niemals auf unserer Website oder irgendeiner anderen, nicht-Steam Seite eingeben.")]), _c('br'), _vm._v("Sobald du dich erfolgreich eingeloggt hast, wirst du von Steam wieder auf unsere Website zurückgeleitet und wir erhalten Daten, welche benötigt werden, um dich als einen Nutzer unserer Dienstes zu identifizieren."), _c('br'), _vm._v("Die Informationen, die von Steam's Login-Service an uns weitergegeben werden, beschränken sich dabei auf deine SteamID sowie deinen Nickname, welche beide öffentlich für jeden auf Steam ersichtlich sind.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Nein, absolut nicht.")]), _vm._v(" Wie schon zuvor erwähnt führen wir keinerlei Login selbst durch, sondern nutzen einen Dienst, der von Steam für alle Entwickler zur Verfügung gestellt wird. Jegliche Authentifizierung wird von Steam selbst abgewickelt - wir erhalten jeglich eine \"Zusicherung\", dass du der Nutzer bist, der du vorgibst, zu sein.\n        "), _c('strong', [_vm._v("Die Informationen, die wir erhalten, ermöglichen uns keinerlei Zugang zu deinem Steam-Account, deiner Steam-Bibliothek oder den Login-Details, die damit verbunden sind.")])])
}]}

/***/ }),
/* 529 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a3c6846"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotRegistrationsRow.vue ***!
  \************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.registration.user.uid
        }
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formatUserWithTag(_vm.registration.user)) + "\n    ")])], 1), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.registration.uid) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedComment)
    }
  }) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(_vm.registration.createdAt)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedConfirmation)
    }
  }), _vm._v(" "), ((_vm.isMissionEditor || _vm.hasMissionSlotlistCommunityPermission) && _vm.registration.uid && !_vm.hasMissionEnded) ? _c('td', {
    staticClass: "text-center"
  }, [(!_vm.registration.confirmed) ? _c('b-btn', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.modifyMissionSlotRegistration(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.registration.confirmed) ? _c('b-btn', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.modifyMissionSlotRegistration(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlotRegistration
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 530 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bb2fb80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotDetailsModal.vue ***!
  \***************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotDetailsModal",
    attrs: {
      "id": "missionSlotDetailsModal",
      "size": "lg",
      "title": _vm.slotDetailsTitle,
      "no-close-on-backdrop": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.difficulty')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.orderNumber))]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.title) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [(_vm.missionSlotDetails.blocked) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.blocked')))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && _vm.missionSlotDetails.assignee) ? _c('span', [_c('router-link', {
    staticClass: "text-success font-weight-bold",
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionSlotDetails.assignee.uid
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formatUserWithTag(_vm.missionSlotDetails.assignee)) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && _vm.missionSlotDetails.externalAssignee) ? _c('span', {
    staticClass: "text-success font-weight-bold font-italic"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.externalAssignee))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && (!_vm.missionSlotDetails.registrationCount || _vm.missionSlotDetails.registrationCount <= 0)) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(("" + (this.$tc('mission.slot.assignee.registration', 0)))))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && _vm.missionSlotDetails.registrationCount && _vm.missionSlotDetails.registrationCount > 0) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(((this.missionSlotDetails.registrationCount) + " " + (this.$tc('mission.slot.assignee.registration', this.missionSlotDetails.registrationCount > 1 ? 2 : 1)))))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.difficultyColor
  }, [_vm._v(_vm._s(_vm.difficultyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.status')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.description))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5",
    domProps: {
      "innerHTML": _vm._s(_vm.slotStatus)
    }
  })]), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotDetails.detailedDescription),
      expression: "missionSlotDetails.detailedDescription"
    }],
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotDetails.detailedDescription),
      expression: "missionSlotDetails.detailedDescription"
    }],
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.detailedDescription')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotDetails.detailedDescription),
      expression: "missionSlotDetails.detailedDescription"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.missionSlotDetails.detailedDescription)
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.registrations')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('mission-slot-registrations', {
    attrs: {
      "missionSlotDetails": _vm.missionSlotDetails
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [(_vm.loggedIn && !_vm.missionSlotDetails.registrationUid && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotRegistrationModal",
      modifiers: {
        "missionSlotRegistrationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.missionSlotDetails.blocked || !_vm.canRegisterForSlot
    },
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ticket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.register')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotAssignModal",
      modifiers: {
        "missionSlotAssignModal": true
      }
    }],
    attrs: {
      "variant": "warning",
      "disabled": _vm.missionSlotDetails.blocked
    },
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.assign.mission.slot')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.duplicateMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slot')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotEditModal",
      modifiers: {
        "missionSlotEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n      ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 531 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c2e5eab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Home.en.vue ***!
  \*******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "slotlist.info",
      "lead": "ArmA 3 mission planning and slotlist management tool"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" allows you to create and manage\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_vm._v("missions")]), _vm._v(", including slotlists for users to register for their desired roles.\n    "), _c('br'), _vm._v("The\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_vm._v("communities")]), _vm._v(" feature also allows you to represent your ArmA community on our website, further advertising your community's members and the missions created by them.\n    "), _c('br'), _vm._v("Since\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" uses Steam Single Sign-on, there's no need for your to create yet another account on a different website - all authentication is securely handled by Steam servers. You can get started right away by\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("logging in")]), _vm._v(" and\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionCreator'
      }
    }
  }, [_vm._v("creating a new mission")]), _vm._v("!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Since\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" is still in development, there will be ongoing changes to the sites and the features (or data) provided by it. We will do our best to keep downtimes low and prevent any data loss, but please\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("contact us")]), _vm._v(" regarding any suggestions or issues - should they arise.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Thank you for using our service - I hope you enjoy it!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v("— MorpheusXAUT, slotlist.info developer")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 532 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c509d3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/FAQ.en.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-justify"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("What is\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v("?\n      ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" is an ArmA 3 slotlist and mission management tool. Mission creators as well as players can use it to easily organise missions and choose their slots.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Who made and runs\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v("?\n      ")], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" was developed by\n        "), _c('a', {
    attrs: {
      "href": "https://steamcommunity.com/id/morpheusxaut"
    }
  }, [_vm._v("[SeL] MorpheusXAUT")]), _vm._v(", primarily as a slotting tool for\n        "), _c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("Spezialeinheit Luchs")]), _vm._v(". We have decided to open the tool to everyone, hoping to provide a useful alternative to slotting managed via forums.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Do I have to sign in to see missions or slotlists?")]), _vm._v(" "), _c('p', [_vm._v("\n        No. You can browse all publicly visible\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_vm._v("missions")]), _vm._v(" and check their details and slotlist without having to sign in. Please be aware that mission creators can limit access to only allow community members or selected users to view and participate in their missions - you thus might not see all missions available to you unless you log in.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Do I have to register for a slot on\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" in order to participate in a mission?\n      ")], 1), _vm._v(" "), _c('p', [_vm._v("\n        That solely depends on the mission creator -\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" only provides them with a tool to manage their mission and slotlist, how they decide to employ it is up to each creator themselves. Some mission creators might require everyone to register and have a slot assigned before the mission starts while others might also allow you to e.g. register for a slot on their community forums and only use this website as a way to advertise their mission. Lastly, some creators might let you simply join the mission when it starts and fill any slots that are still open. Your best bet would be to try and contact the mission creator beforehand and ask if you're unsure on how to participate.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("Does everyone have to register on this site in order for me to use it for my missions?")]), _vm._v(" "), _c('p', [_vm._v("\n        Ideally, every one of your players would log in to\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" and register for their desired slot via your mission's slotlist. Since we are aware of people not wanting to use an external site to choose a slot for a mission, we have also provided mission creators with the possibility to \"block\" slots, preventing other\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" users from registering - manual slot assignments of \"external\" players can then be added as a slot description."), _c('br'), _vm._v("Whilst this does not provide the same functionality as a \"regular\" slot registration, we hope that it will provide a suitable alternative for more sceptical players.\n      ")], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n        Should the leadership of community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v(" have decided to represent their community on our website already and thus have created a\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_vm._v("community")]), _vm._v(", you can simply tick the \"Restricted slot\" checkbox when creating or editing a slot and search for the community name. Once restricted, only players registered as members of this community on\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" can sumbit a slot registration."), _c('br'), _vm._v("Should community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v(" decide they do not want to be represented on our website, you should block the slot by ticking the \"Blocked slot\" checkbox and add something along the lines of \"Restricted to community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v("\" as the slot's description."), _c('br'), _vm._v("Same as with the manual player assignment via blocked slots, this will not provide you with the full functionality of\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v("'s slotlist, but serves as an alternative should you not want to exclude users and communities that decide against using our service.\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("I am still sceptical or confused...")]), _vm._v(" "), _c('p', [_vm._v("\n        We would be happy to talk to you, explaining our service in more detail and trying to clear up any confusion as best as we can - just contact us via any method mentioned on our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" page. Whilst we obviously would like to have you as a user of our service, we can also understand scepticism and value any sort of feedback highly.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("How does the login work?")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h5', [_vm._v("Can you access my Steam account after I log in to your website?")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h5', [_vm._v("What information do you store about me?")]), _vm._v(" "), _c('p', [_vm._v("\n        When you log in for the first time, our backend creates a new user in our database, storing the SteamID provided by Steam's login service as well as your (public) Steam nickname at that point. You can change your nickname on this website at any point by going to your\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account")]), _vm._v(" page while logged in. Please note that changing your Steam nickname will not update your nickname on\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" since we do not query Steam for your nickname after the initial login anymore. Beside your SteamID and nickname, the stored user information contains a unique user ID that is randomly generated by our backend and used to uniquely identify your user throughout the app."), _c('br'), _vm._v("When you register for a mission slot, a database entry containing the slot ID, your user ID and the optional comment - if provided - is created."), _c('br'), _vm._v("If you would like to receive a dump of all information currently stored about you, please contact us via any method mentioned on the\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" page and we will be happy to provide you with any data we have."), _c('br'), _vm._v("More information regarding the privacy policy of this website can be found\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("here")]), _vm._v(".\n      ")], 1), _vm._v(" "), _c('h5', [_vm._v("I want you to delete all data stored about me!")]), _vm._v(" "), _c('p', [_vm._v("This is not a question, but sure!"), _c('br'), _vm._v("Just head to the\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account")]), _vm._v(" page while logged in and press the \"Delete account\" button. After confirming the deletion, all information associated with your user will be deleted from our backend and you will be logged out."), _c('br'), _vm._v("Please be aware that this will also delete\n        "), _c('strong', [_vm._v("every")]), _vm._v(" mission created by you, every slot registration you submitted as well as all permissions granted to you. This also removes you as a community founder, thus removing your ability to delete your community - should you have created one. Please make sure to delete your community beforehand if you want to have its data removed as well.\n        "), _c('strong', [_vm._v("These changes are irreversible - we have no way of restoring the data once it has been deleted.")])], 1), _vm._v(" "), _c('h5', [_vm._v("Are you evil?")]), _vm._v(" "), _c('p', [_vm._v("\n        Only on every second Tuesday.\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Frequently Asked Questions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("How can I reserve slots for community\n        "), _c('em', [_vm._v("XYZ")]), _vm._v("?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        We are utilising a login service provided by Steam, called\n        "), _c('em', [_vm._v("Steam OpenID")]), _vm._v(" or\n        "), _c('em', [_vm._v("Steam Single Sign On")]), _vm._v(". You can find more information about this service\n        "), _c('a', {
    attrs: {
      "href": "https://steamcommunity.com/dev"
    }
  }, [_vm._v("here")]), _vm._v("."), _c('br'), _vm._v("When you click the\n        "), _c('em', [_vm._v("Sign in through Steam")]), _vm._v(" button, you will be redirected to a Steam community page where you will be asked to log in to your Steam account. Please note that we have no access at all to this page and do not receive your Steam credentials. The whole login process is handled securely by Steam on the\n        "), _c('code', [_vm._v("steamcommunity.com")]), _vm._v(" domain.\n        "), _c('strong', [_vm._v("You will never have to enter your Steam credentials on our website or any other non-Steam service.")]), _c('br'), _vm._v("Once you have successfully completed your login, Steam will redirect you back to our website and provide us with information required to identify you as a user of our service."), _c('br'), _vm._v("The data provided by Steam's login service is limited to your SteamID as well as your nickname, both of which are also publicly visible to everyone on Steam.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        No. As previously mentioned, we do not handle any login at all, but use a service provided by Steam to all developers. All authentication is handled by Steam itself - we only receive an \"assurance\" you actually are who you claim to be.\n        "), _c('strong', [_vm._v("The information we receive does not grant us any access to your Steam account, Steam library or any credentials associated.")])])
}]}

/***/ }),
/* 533 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d62a14d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPermissionsRow.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.accountPermission))])])
},staticRenderFns: []}

/***/ }),
/* 534 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d84887e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionApplySlotTemplateModal.vue ***!
  \*********************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplates) ? _c('b-modal', {
    ref: "missionApplySlotTemplateModal",
    attrs: {
      "id": "missionApplySlotTemplateModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.apply.slotTemplate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionApplySlotTemplateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.applySlotTemplateToMission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.apply.slotTemplate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotTemplate.filter'),
      "description": _vm.$t('mission.slotTemplate.filter.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateFilter),
      callback: function($$v) {
        _vm.missionSlotTemplateFilter = $$v
      },
      expression: "missionSlotTemplateFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotTemplate.insertAfter'),
      "description": _vm.$t('mission.slotTemplate.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateInsertAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateInsertAfter = $$v
      },
      expression: "missionSlotTemplateInsertAfter"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "22%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredMissionSlotTemplates), function(missionSlotTemplate) {
    return _c('tr', {
      key: missionSlotTemplate.uid
    }, [_c('td', [_vm._v(_vm._s(missionSlotTemplate.title))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'userDetails',
          params: {
            userUid: missionSlotTemplate.creator.uid
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.formatUserWithTag(missionSlotTemplate.creator)))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(missionSlotTemplate.slotGroupCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(missionSlotTemplate.slotCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-btn', {
      attrs: {
        "variant": "primary",
        "size": "sm",
        "to": {
          name: 'missionSlotTemplateDetails',
          params: {
            missionSlotTemplateUid: missionSlotTemplate.uid
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n                    ")]), _vm._v(" "), _c('b-btn', {
      attrs: {
        "variant": "success",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.applySlotTemplateToMission(missionSlotTemplate.uid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.apply.mission.slotGroup.short')) + "\n                    ")])], 1)])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredMissionSlotTemplates.length >= 10),
      expression: "filteredMissionSlotTemplates.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "22%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission apply slot template actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionConvertToSlotTemplateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 535 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dae4ff7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Account.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.accountDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.accountDetails.nickname))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('p', [(_vm.accountDetails.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.accountDetails.community.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.accountDetails.community.name))]) : _vm._e(), _vm._v(" "), (!_vm.accountDetails.community) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('account.timezone')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.timezone) + "\n            "), _c('span', {
    staticClass: "text-muted small",
    attrs: {
      "if": "currentTime"
    }
  }, [_vm._v("(" + _vm._s(_vm.$t('account.currentTime')) + " " + _vm._s(_vm.currentTime) + ")")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.accountEditModal",
      modifiers: {
        "accountEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), _c('b-popover', {
    attrs: {
      "content": _vm.$t('button.refresh.authentication.explanation'),
      "triggers": ['hover']
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshAuthentication
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh.authentication')) + "\n          ")])], 1), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.accountDeleteModal",
      modifiers: {
        "accountDeleteModal": true
      }
    }],
    attrs: {
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete.account')) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('nav.missions')))]), _vm._v(" "), _c('account-missions')], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.$t('account.permissions')))]), _vm._v(" "), _c('account-permissions')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [_c('account-delete-modal'), _vm._v(" "), _c('account-edit-modal')], 1)])
},staticRenderFns: []}

/***/ }),
/* 536 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-618500e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotSelectionEditModal.vue ***!
  \*********************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.selectedMissionSlots) ? _c('b-modal', {
    ref: "missionSlotSelectionEditModal",
    attrs: {
      "id": "missionSlotSelectionEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.slot.selection.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotSelectionEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$tc('mission.slot.selection.edit', _vm.selectedMissionSlots.length, {
        count: _vm.selectedMissionSlots.length
      }))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.selectedMissionSlots), function(slot) {
    return _c('li', {
      key: slot.uid
    }, [_c('strong', [_vm._v("#" + _vm._s(slot.orderNumber))]), _vm._v(" - " + _vm._s(slot.title))])
  }))]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotSelection($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotSelectionEditData.description),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.description = $$v
      },
      expression: "missionSlotSelectionEditData.description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotEditDifficultyOptions
    },
    model: {
      value: (_vm.missionSlotSelectionEditData.difficulty),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.difficulty = $$v
      },
      expression: "missionSlotSelectionEditData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.restricted.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.restricted),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.restricted = $$v
      },
      expression: "missionSlotSelectionEditData.restricted"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.reserve),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.reserve = $$v
      },
      expression: "missionSlotSelectionEditData.reserve"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.blocked),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.blocked = $$v
      },
      expression: "missionSlotSelectionEditData.blocked"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.autoAssignable.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.autoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotSelectionEditData.autoAssignable),
      callback: function($$v) {
        _vm.missionSlotSelectionEditData.autoAssignable = $$v
      },
      expression: "missionSlotSelectionEditData.autoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.missionSlotSelectionEditData.restricted) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.selection'),
      "state": _vm.missionSlotEditRestrictedCommunityState,
      "description": _vm.$t('mission.slot.restricted.selection.description')
    }
  }, [_c('typeahead', {
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.restrictedSlotCommunitySelected
    }
  })], 1)], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot selection edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotSelection
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotSelectionEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 537 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-61be6688"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionDetails.vue ***!
  \*********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.missionDetails.title))]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.by')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionDetails.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.missionDetails.creator)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.missionDetails.bannerImageUrl) ? _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "480px"
    },
    attrs: {
      "src": _vm.missionDetails.bannerImageUrl
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "lead text-justify"
  }, [_vm._v(_vm._s(_vm.missionDetails.description))]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('p', [(_vm.missionDetails.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.missionDetails.community.slug
        }
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.missionDetails.community.tag) + "] " + _vm._s(_vm.missionDetails.community.name))]) : _vm._e(), _vm._v(" "), (!_vm.missionDetails.community) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('p', [(_vm.missionRequiredDLCs && _vm.missionRequiredDLCs.length > 0) ? _c('span', _vm._l((_vm.missionRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "24px"
      }
    })
  })) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs.none')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.visibility')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionVisibility)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.slottingTime')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.slottingTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.startTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.endTime')) + "\n            "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm.$t('mission.abbr.estimated')) + ")")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.endTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.briefingTime.short')) + "\n            "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm.$t('mission.abbr.leadership')) + ")")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.briefingTime)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm",
      "href": _vm.googleCalendarLink(_vm.missionDetails.slottingTime),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.google')) + "\n          ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.downloadICalFile(_vm.missionDetails.slottingTime)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.ical')) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 small",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.timezone', {
        timezone: _vm.timezone
      }))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm",
      "href": _vm.googleCalendarLink(_vm.missionDetails.briefingTime),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.google')) + "\n          ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.downloadICalFile(_vm.missionDetails.briefingTime)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.ical')) + "\n          ")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.gameServer')))]), _vm._v(" "), (_vm.missionDetails.gameServer) ? _c('div', [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.gameServer.hostname))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.gameServer.port))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.gameServer.name) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.gameServer.name))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.gameServer.password) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.gameServer.password))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.gameServerHostnamePort),
      expression: "gameServerHostnamePort",
      arg: "copy"
    }],
    attrs: {
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n              ")]), _vm._v(" \n              "), _c('b-btn', {
    attrs: {
      "size": "sm",
      "href": ("steam://connect/" + (_vm.missionDetails.gameServer.hostname) + ":" + (_vm.missionDetails.gameServer.port) + (_vm.missionDetails.gameServer.password ? ("/" + (_vm.missionDetails.gameServer.password)) : ''))
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.join')) + "\n              ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.missionDetails.gameServer) ? _c('p', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.voiceComms')))]), _vm._v(" "), (_vm.missionDetails.voiceComms) ? _c('div', [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.voiceComms.hostname))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.voiceComms.port))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.voiceComms.name) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.voiceComms.name))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.voiceComms.password) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.voiceComms.password))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.voiceCommsHostnamePort),
      expression: "voiceCommsHostnamePort",
      arg: "copy"
    }],
    attrs: {
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n              ")]), _vm._v(" \n              "), _c('b-btn', {
    attrs: {
      "size": "sm",
      "href": ("ts3server://" + (_vm.missionDetails.voiceComms.hostname) + "?port=" + (_vm.missionDetails.voiceComms.port) + (_vm.missionDetails.voiceComms.password ? ("&password=" + (_vm.missionDetails.voiceComms.password)) : ''))
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.join')) + "\n              ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.missionDetails.voiceComms) ? _c('p', {
    staticClass: "text-center text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.techSupport')))]), _vm._v(" "), _c('p', {
    staticClass: "html ql-editor text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.optionalTechSupport)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.rules')))]), _vm._v(" "), _c('p', {
    staticClass: "html ql-editor text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.optionalRules)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.missionRepositoriesCollapse",
      modifiers: {
        "missionRepositoriesCollapse": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.fetchCommunityRepositories
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.repository.list')) + "\n          ")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "missionRepositoriesCollapse"
    }
  }, [(_vm.missionDetails.repositories.length === 0) ? _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-italic text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.repository.list.empty')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.missionRepositoryChunks), function(chunk, chunkIndex) {
    return _c('div', {
      key: chunk
    }, [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._l((chunk), function(missionRepository, index) {
      return _c('div', {
        key: missionRepository,
        staticClass: "col"
      }, [(missionRepository.name) ? _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.name')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [_vm._v(_vm._s(missionRepository.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.url')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(missionRepository.url) ? _c('span', [(missionRepository.kind === 'arma3sync') ? _c('a', {
        attrs: {
          "href": missionRepository.url
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.$copyText(missionRepository.url)
          }
        }
      }, [_vm._v(_vm._s(missionRepository.url))]) : _c('a', {
        attrs: {
          "href": missionRepository.url
        }
      }, [_vm._v(_vm._s(missionRepository.url))])]) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.notes')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(missionRepository.notes) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(missionRepository.notes)
        }
      }) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('b-btn', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (missionRepository.url),
          expression: "missionRepository.url",
          arg: "copy"
        }],
        attrs: {
          "size": "sm",
          "disabled": !missionRepository.url
        }
      }, [_c('i', {
        staticClass: "fa fa-clipboard",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n                    ")]), _vm._v(" "), (_vm.isMissionEditor) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('b-btn', {
        attrs: {
          "size": "sm",
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeMissionRepository(chunkIndex * 2 + index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.remove')) + "\n                    ")]) : _vm._e()], 1)])
    }), _vm._v(" "), (chunk.length === 1) ? _c('div', {
      staticClass: "col"
    }) : _vm._e()], 2)])
  }), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.name.required'),
      "state": _vm.missionRepositoryCreateNameState,
      "feedback": _vm.missionRepositoryCreateNameFeedback,
      "description": _vm.$t('mission.repository.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionRepositoryCreateData.name),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.name = $$v
      },
      expression: "missionRepositoryCreateData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.kind'),
      "state": _vm.missionRepositoryCreateKindState,
      "feedback": _vm.missionRepositoryCreateKindFeedback,
      "description": _vm.$t('mission.repository.kind.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionRepositoryCreateKindOptions
    },
    model: {
      value: (_vm.missionRepositoryCreateData.kind),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.kind = $$v
      },
      expression: "missionRepositoryCreateData.kind"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.url.optional'),
      "state": _vm.missionRepositoryCreateUrlState,
      "feedback": _vm.missionRepositoryCreateUrlFeedback,
      "description": _vm.$t('mission.repository.url.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionRepositoryCreateData.url),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.url = $$v
      },
      expression: "missionRepositoryCreateData.url"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.notes.optional'),
      "state": _vm.missionRepositoryCreateNotesState,
      "feedback": _vm.missionRepositoryCreateNotesFeedback,
      "description": _vm.$t('mission.repository.notes.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionRepositoryCreateData.notes),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.notes = $$v
      },
      expression: "missionRepositoryCreateData.notes"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.communityRepositories && _vm.communityRepositories.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.repositories'),
      "state": "success",
      "description": _vm.$t('community.repositories.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.communityRepositoryOptions
    },
    model: {
      value: (_vm.communityRepositoriesSelected),
      callback: function($$v) {
        _vm.communityRepositoriesSelected = $$v
      },
      expression: "communityRepositoriesSelected"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionRepository
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n                  ")])], 1)])]) : _vm._e()], 2)], 1)]), _vm._v(" "), (_vm.isMissionEditor) ? _c('hr', {
    staticClass: "my-4"
  }) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionDuplicateModal",
      modifiers: {
        "missionDuplicateModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission')) + "\n        ")]), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionConvertToSlotTemplateModal",
      modifiers: {
        "missionConvertToSlotTemplateModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.convert.slotTemplate')) + "\n        ")]), _vm._v(" \n        "), (_vm.isMissionCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionEmbedModal",
      modifiers: {
        "missionEmbedModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.embed.mission')) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionEditModal",
      modifiers: {
        "missionEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.fetchCommunityServers
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionBannerImageModal",
      modifiers: {
        "missionBannerImageModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.bannerImage')) + "\n        ")]), _vm._v(" \n        "), (_vm.isMissionCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionPermissionModal",
      modifiers: {
        "missionPermissionModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.permissions')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionCreator) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && _vm.isPrivateMission) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionAccessModal",
      modifiers: {
        "missionAccessModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-secret",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.accesses')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && _vm.isPrivateMission) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionCreator) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteMission
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('div', {
    staticClass: "html ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.missionDetails.detailedDescription)
    }
  })])]), _vm._v(" "), (_vm.missionDetails.collapsedDescription) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.missioncollapsedDescriptionCollapse",
      modifiers: {
        "missioncollapsedDescriptionCollapse": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleMissioncollapsedDescription
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-down': !_vm.isMissionCollapsedDescriptionExtended, 'fa-chevron-up': _vm.isMissionCollapsedDescriptionExtended
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.isMissionCollapsedDescriptionExtended ? _vm.$t('mission.collapsedDescription.toggle.close') : _vm.$t('mission.collapsedDescription.toggle.open')) + "\n        ")])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "missioncollapsedDescriptionCollapse"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('div', {
    staticClass: "html ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.missionDetails.collapsedDescription)
    }
  })])])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('mission.slotlist')))]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('mission.slotlist.filter'),
      "label-for": "missionSlotlistFilter"
    }
  }, [_c('div', {
    attrs: {
      "role": "group",
      "id": "missionSlotlistFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "assigned",
      "value": "assigned"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.assigned')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "hasRegistrations",
      "value": "hasRegistrations"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.hasRegistrations')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "restricted",
      "value": "restricted"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.restricted')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "blocked",
      "value": "blocked"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.blocked')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "open",
      "value": "open"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.open')) + "\n              ")])], 1), _vm._v(" "), (_vm.haveMissionSlotsAnyRequiredDLCs || (_vm.missionSlotlistRequiredDLCsFilter && _vm.missionSlotlistRequiredDLCsFilter.length > 0)) ? _c('div', {
    staticClass: "group",
    attrs: {
      "id": "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "aow",
      "value": "aow"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "apex",
      "value": "apex"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "contact",
      "value": "contact"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "csla",
      "value": "csla"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "gm",
      "value": "gm"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "helicopters",
      "value": "helicopters"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "jets",
      "value": "jets"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "karts",
      "value": "karts"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "laws-of-war",
      "value": "laws-of-war"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')) + "\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "marksmen",
      "value": "marksmen"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "tac-ops",
      "value": "tac-ops"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "tanks",
      "value": "tanks"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "vn",
      "value": "vn"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')) + "\n              ")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('mission-slotlist')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loggedIn && _vm.isMissionEditor && _vm.isPrivateMission) ? _c('mission-access-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-apply-slot-template-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-banner-image-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('mission-convert-to-slot-template-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-duplicate-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionCreator) ? _c('mission-permission-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-assign-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-create-modal') : _vm._e(), _vm._v(" "), _c('mission-slot-details-modal'), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-group-create-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-group-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && !_vm.hasMissionEnded) ? _c('mission-slot-registration-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-selection-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionCreator) ? _c('mission-embed-modal') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 538 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6290527d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPermissions.vue ***!
  \**************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('account-permissions-table'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshAccountPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 539 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b61b39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionDuplicateModal.vue ***!
  \*************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('b-modal', {
    ref: "missionDuplicateModal",
    attrs: {
      "id": "missionDuplicateModal",
      "title": _vm.$t('mission.modal.duplicate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.duplicateMission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.duplicate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slug'),
      "state": _vm.missionDuplicateSlugState,
      "feedback": _vm.missionDuplicateSlugFeedback,
      "description": _vm.$t('mission.duplicate.slug.description')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.missionDuplicateSlugAvailable
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.missionDuplicateSlugFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.slug),
      callback: function($$v) {
        _vm.missionDuplicateData.slug = $$v
      },
      expression: "missionDuplicateData.slug"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.title'),
      "state": "success",
      "description": _vm.$t('mission.duplicate.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionDuplicateData.title),
      callback: function($$v) {
        _vm.missionDuplicateData.title = $$v
      },
      expression: "missionDuplicateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slottingTime'),
      "state": _vm.missionDuplicateSlottingTimeState,
      "feedback": _vm.missionDuplicateSlottingTimeFeedback,
      "description": _vm.$t('mission.duplicate.slottingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.slottingTime),
      callback: function($$v) {
        _vm.missionDuplicateData.slottingTime = $$v
      },
      expression: "missionDuplicateData.slottingTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.startTime'),
      "state": _vm.missionDuplicateStartTimeState,
      "feedback": _vm.missionDuplicateStartTimeFeedback,
      "description": _vm.$t('mission.duplicate.startTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.startTime),
      callback: function($$v) {
        _vm.missionDuplicateData.startTime = $$v
      },
      expression: "missionDuplicateData.startTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.endTime'),
      "state": _vm.missionDuplicateEndTimeState,
      "feedback": _vm.missionDuplicateEndTimeFeedback,
      "description": _vm.$t('mission.duplicate.endTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.endTime),
      callback: function($$v) {
        _vm.missionDuplicateData.endTime = $$v
      },
      expression: "missionDuplicateData.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.briefingTime'),
      "state": _vm.missionDuplicateBriefingTimeState,
      "feedback": _vm.missionDuplicateBriefingTimeFeedback,
      "description": _vm.$t('mission.duplicate.briefingTime.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "YYYY-MM-DD HH:mm",
      "formatter": _vm.missionDuplicateTimeFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.missionDuplicateData.briefingTime),
      callback: function($$v) {
        _vm.missionDuplicateData.briefingTime = $$v
      },
      expression: "missionDuplicateData.briefingTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.visibility'),
      "state": "success",
      "description": _vm.$t('mission.duplicate.visibility.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionDuplicateVisibilityOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionDuplicateData.visibility),
      callback: function($$v) {
        _vm.missionDuplicateData.visibility = $$v
      },
      expression: "missionDuplicateData.visibility"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.user.community) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.creator.addToCommunity'),
      "state": "success",
      "description": _vm.missionDuplicateAddToCommunityDescription
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionDuplicateData.addToCommunity),
      callback: function($$v) {
        _vm.missionDuplicateData.addToCommunity = $$v
      },
      expression: "missionDuplicateData.addToCommunity"
    }
  })], 1)], 1) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission duplicate actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.duplicateMission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionDuplicateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 540 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-63a753f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotGroupEditModal.vue ***!
  \*****************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotGroupDetails) ? _c('b-modal', {
    ref: "missionSlotGroupEditModal",
    attrs: {
      "id": "missionSlotGroupEditModal",
      "title": _vm.$t('mission.modal.slotGroup.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotGroupEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlotGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.title'),
      "state": _vm.missionSlotGroupEditTitleState,
      "feedback": _vm.missionSlotGroupEditTitleFeedback,
      "description": _vm.$t('mission.slotGroup.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotGroupEditData.title),
      callback: function($$v) {
        _vm.missionSlotGroupEditData.title = $$v
      },
      expression: "missionSlotGroupEditData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotGroupEditData.description),
      callback: function($$v) {
        _vm.missionSlotGroupEditData.description = $$v
      },
      expression: "missionSlotGroupEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.moveAfter'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.moveAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotGroupEditMoveAfterOptions
    },
    model: {
      value: (_vm.missionSlotGroupEditMoveAfter),
      callback: function($$v) {
        _vm.missionSlotGroupEditMoveAfter = $$v
      },
      expression: "missionSlotGroupEditMoveAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot group edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotGroupEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 541 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-67720e92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupCreateModal.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionSlotTemplateSlotGroupCreateModal",
    attrs: {
      "id": "missionSlotTemplateSlotGroupCreateModal",
      "title": _vm.$t('mission.modal.slotGroup.create'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotTemplateSlotGroupCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionSlotTemplateSlotGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.title'),
      "state": _vm.missionSlotTemplateSlotGroupCreateTitleState,
      "feedback": _vm.missionSlotTemplateSlotGroupCreateTitleFeedback,
      "description": _vm.$t('mission.slotGroup.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupCreateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupCreateData.title = $$v
      },
      expression: "missionSlotTemplateSlotGroupCreateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupCreateData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupCreateData.description = $$v
      },
      expression: "missionSlotTemplateSlotGroupCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotGroupCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupCreateData.insertAfter = $$v
      },
      expression: "missionSlotTemplateSlotGroupCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot group create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotGroupCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 542 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bad513d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserMissions.vue ***!
  \******************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-missions-table'), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userMissionsPageCount > 1),
      expression: "userMissionsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "userMissionsPaginate",
    attrs: {
      "pageCount": _vm.userMissionsPageCount,
      "clickHandler": _vm.paginateUserMissions,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.paginateUserMissions(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 543 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c678023"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Login.de.vue ***!
  \********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.working) ? _c('b-jumbotron', {
    attrs: {
      "header": "Anmeldung via Steam",
      "lead": "slotlist.info benutzt Steam OpenID Authentifizierung. Du kannst daher deinen bestehenden Steam Account benutzen, um dich auf unserer Seite einzuloggen."
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n      Die Website kann weder deine Steam-Anmeldedaten lesen, noch speichern oder irgendeine Aktion mit deinem Steam Account durchführen.\n      "), _c('br'), _vm._v("Wir erhalten einzig die SteamID und einige öffentlich ersichtlichen Daten (wie z.B. den Nicknamen) über deinen Account.\n      "), _c('br'), _vm._v("Die Informationen, welche Steam an uns übermittelt, werden dazu verwendet, einen eindeutigen Benutzer in unserem Backend zu erstellen. Dadurch können alle notwendigen Funktionen von\n      "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" verwendet werden.\n      "), _c('br'), _vm._v("Genauere Details bezüglich der Datenschutzerklärung dieser Website können\n      "), _c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("hier")]), _vm._v(" gefunden werden.\n    ")], 1), _vm._v(" "), (_vm.loginRedirectUrl) ? _c('p', {
    staticClass: "lead text-center"
  }, [_c('a', {
    attrs: {
      "href": _vm.loginRedirectUrl
    }
  }, [_c('img', {
    attrs: {
      "src": "https://steamcommunity-a.akamaihd.net/public/images/signinthroughsteam/sits_01.png",
      "alt": "Anmeldung via Steam",
      "title": "Ja, das Login-Banner sieht absolut grässlich aus, aber leider zwingt uns Valve, es zu verwenden >.< Wie auch immer, klick hier zur Anmeldung via Steam"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Häufig gestellte Fragen bezüglich des Steam-Logins")]), _vm._v(" "), _c('p', [_vm._v("Auszug aus den Häufig gestellten Fragen von unserer\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Startseite")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-justify"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("Wie funktioniert der Login?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_vm._v("Ich bin noch immer skeptisch oder verwirrt...")]), _vm._v(" "), _c('p', [_vm._v("\n        Gerne kommen wir für ein Gespräch zu euch, um unseren Dienst genauer zu erklären und möglichst alle Verwirrungen so gut wir können aufzuklären - kontaktiere uns einfach über einen der Wege, die auf unserer\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über-Seite")]), _vm._v(" angegeben sind. Während wir euch gerne als Nutzer unseres Dienstes begrüßen würden, können wir natürlich Skeptizismus auch verstehen und freuen uns über jegliche Art von Feedback.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("Kann auf meinen Steam-Account zugegriffen werden, nachdem ich mich auf eurer Website eingeloggt habe?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("Welche Informationen werden über mich gespeichert?")]), _vm._v(" "), _c('p', [_vm._v("\n        Wenn du dich das erste Mal einloggst, legt unser Backend einen neuen Benutzer in der Datenbank an und speichert die SteamID, welche uns von Steam's Login-Dienst übermittelt wird, sowie deinen (öffentlichen) Nickname zu diesem Zeitpunkt. Du kannst den Nickname auf dieser Website jederzeit ändern, indem du auf deine\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account-Seite")]), _vm._v(" gehst während du eingeloggt bist. Bitte beachte, dass die Änderung deines Steam-Nicknames nicht den Nickname auf\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" aktualisiert, weil wir die Steam-Server nach der initialen Anmeldung nicht mehr nach deinem Nickname fragen. Neben der SteamID und dem Nickname beinhaltet die gespeicherte Benutzerinformation auch noch eine eindeutige ID, welche von unserem Backend zufällig erstellt wird und benötigt wird, um einen Benutzer eindeutig im Service identifizieren zu können."), _c('br'), _vm._v("Wenn du dich für einen Missionsslot anmeldest, wird ein Datenbankeintrag angelegt, welcher die Slot ID, deine Benutzer ID sowie den optionale Kommentar - sofern du eines angegeben hast - speichert."), _c('br'), _vm._v("Solltest du einen Auszug aller Daten, die wir aktuell über dich speichern, erhalten wollen, kontaktiere uns bitte auf einem der Wege, die auf unserer\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über-Seite")]), _vm._v(" erwähnt werden, und wir stellen dir gerne alle Informationen zur Verfügung, die wir haben."), _c('br'), _vm._v("Genauere Informationen zur Datenschutzrichtlinie dieser Website können\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("hier")]), _vm._v(" gefunden werden.\n      ")], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Wir nutzen einen Login-Service, genannt\n        "), _c('em', [_vm._v("Steam OpenID")]), _vm._v(" oder\n        "), _c('em', [_vm._v("Steam Single Sign On")]), _vm._v(", der von Steam zur Verfügung gestellt wird. Mehr Informationen zu diesem Service können\n        "), _c('a', {
    attrs: {
      "href": "https://steamcommunity.com/dev"
    }
  }, [_vm._v("hier")]), _vm._v(" gefunden werden."), _c('br'), _vm._v("Wenn du auf den\n        "), _c('em', [_vm._v("Sign in through Steam")]), _vm._v(" Knopf drückst, wirst du auf eine Steam Community-Seite weitergeleitet, auf welcher du dich in deinen Steam-Account einloggen sollst. Wir weisen darauf hin, dass wir keinerlei Zugang zu dieser Seite haben und deine Steam-Logindaten nicht erhalten. Der gesamte Login-Vorgang wird sicher von Steam über die\n        "), _c('code', [_vm._v("steamcommunity.com")]), _vm._v(" Domain abgewickelt.\n        "), _c('strong', [_vm._v("Du musst deine Steam-Logindaten niemals auf unserer Website oder irgendeiner anderen, nicht-Steam Seite eingeben.")]), _c('br'), _vm._v("Sobald du dich erfolgreich eingeloggt hast, wirst du von Steam wieder auf unsere Website zurückgeleitet und wir erhalten Daten, welche benötigt werden, um dich als einen Nutzer unserer Dienstes zu identifizieren."), _c('br'), _vm._v("Die Informationen, die von Steam's Login-Service an uns weitergegeben werden, beschränken sich dabei auf deine SteamID sowie deinen Nickname, welche beide öffentlich für jeden auf Steam ersichtlich sind.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Nein, absolut nicht.")]), _vm._v(" Wie schon zuvor erwähnt führen wir keinerlei Login selbst durch, sondern nutzen einen Dienst, der von Steam für alle Entwickler zur Verfügung gestellt wird. Jegliche Authentifizierung wird von Steam selbst abgewickelt - wir erhalten jeglich eine \"Zusicherung\", dass du der Nutzer bist, der du vorgibst, zu sein.\n        "), _c('strong', [_vm._v("Die Informationen, die wir erhalten, ermöglichen uns keinerlei Zugang zu deinem Steam-Account, deiner Steam-Bibliothek oder den Login-Details, die damit verbunden sind.")])])
}]}

/***/ }),
/* 544 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ccb2588"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarHeader.vue ***!
  \***********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingMissionsForCalendar
    },
    on: {
      "click": function($event) {
        _vm.refreshCalendarMissions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingMissionsForCalendar
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-btn-group', [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeMonth(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('calendar.month.previous')) + "\n      ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.changeMonth(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('calendar.month.current')) + "\n      ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeMonth(1)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('calendar.month.next')) + "\n        "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "calendar-header-month"
  }, [_vm._v(_vm._s(_vm.currentMonth.locale(_vm.locale).format('MMMM Y')))])])])
},staticRenderFns: []}

/***/ }),
/* 545 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e9b2c4b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Login.en.vue ***!
  \********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.working) ? _c('b-jumbotron', {
    attrs: {
      "header": "Sign in using Steam",
      "lead": "slotlist.info uses Steam OpenID authentication. This allows you to use your existing Steam account to log into our site."
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n      The site will not be able to read or store your Steam login credentials or perform any action regarding your Steam account.\n      "), _c('br'), _vm._v(" We will only receive your SteamID as well as some other public information such as your username.\n      "), _c('br'), _vm._v(" The information provided by Steam will be used to create a unique user in our backend for you, allowing you to use all features on\n      "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("slotlist.info")]), _vm._v(".\n      "), _c('br'), _vm._v(" More information regarding the privacy policy of this site can be found\n      "), _c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("here")]), _vm._v(".\n    ")], 1), _vm._v(" "), (_vm.loginRedirectUrl) ? _c('p', {
    staticClass: "lead text-center"
  }, [_c('a', {
    attrs: {
      "href": _vm.loginRedirectUrl
    }
  }, [_c('img', {
    attrs: {
      "src": "https://steamcommunity-a.akamaihd.net/public/images/signinthroughsteam/sits_01.png",
      "alt": "Sign in through Steam",
      "title": "Yes, this login banner looks atrocious, unfortunately Valve forces us to use it >.< Anyways, click to sign in through Steam"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Frequently Asked Questions regarding the Steam login")]), _vm._v(" "), _c('p', [_vm._v("taken from the FAQ on our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Home")]), _vm._v(" page\n      ")], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-justify"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("How does the login work?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_vm._v("I am still sceptical or confused...")]), _vm._v(" "), _c('p', [_vm._v("\n        We would be happy to talk to you, explaining our service in more detail and trying to clear up any confusion as best as we can - just contact us via any method mentioned on our\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" page. Whilst we obviously would like to have you as a user of our service, we can also understand scepticism and value any sort of feedback highly.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("Can you access my Steam account after I log in to your website?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h5', [_vm._v("What information do you store about me?")]), _vm._v(" "), _c('p', [_vm._v("\n        When you log in for the first time, our backend creates a new user in our database, storing the SteamID provided by Steam's login service as well as your (public) Steam nickname at that point. You can change your nickname on this website at any point by going to your\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account")]), _vm._v(" page while logged in. Please note that changing your Steam nickname will not update your nickname on\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" since we do not query Steam for your nickname after the initial login anymore. Beside your SteamID and nickname, the stored user information contains a unique user ID that is randomly generated by our backend and used to uniquely identify your user throughout the app."), _c('br'), _vm._v("When you register for a mission slot, a database entry containing the slot ID, your user ID and the optional comment - if provided - is created."), _c('br'), _vm._v("If you would like to receive a dump of all information currently stored about you, please contact us via any method mentioned on the\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" page and we will be happy to provide you with any data we have."), _c('br'), _vm._v("More information regarding the privacy policy of this website can be found\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      }
    }
  }, [_vm._v("here")]), _vm._v(".\n      ")], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        We are utilising a login service provided by Steam, called\n        "), _c('em', [_vm._v("Steam OpenID")]), _vm._v(" or\n        "), _c('em', [_vm._v("Steam Single Sign On")]), _vm._v(". You can find more information about this service\n        "), _c('a', {
    attrs: {
      "href": "https://steamcommunity.com/dev"
    }
  }, [_vm._v("here")]), _vm._v("."), _c('br'), _vm._v("When you click the\n        "), _c('em', [_vm._v("Sign in through Steam")]), _vm._v(" button, you will be redirected to a Steam community page where you will be asked to log in to your Steam account. Please note that we have no access at all to this page and do not receive your Steam credentials. The whole login process is handled securely by Steam on the\n        "), _c('code', [_vm._v("steamcommunity.com")]), _vm._v(" domain.\n        "), _c('strong', [_vm._v("You will never have to enter your Steam credentials on our website or any other non-Steam service.")]), _c('br'), _vm._v("Once you have successfully completed your login, Steam will redirect you back to our website and provide us with information required to identify you as a user of our service."), _c('br'), _vm._v("The data provided by Steam's login service is limited to your SteamID as well as your nickname, both of which are also publicly visible to everyone on Steam.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("No, absolutely not.")]), _vm._v(" As previously mentioned, we do not handle any login at all, but use a service provided by Steam to all developers. All authentication is handled by Steam itself - we only receive an \"assurance\" you actually are who you claim to be.\n        "), _c('strong', [_vm._v("The information we receive does not grant us any access to your Steam account, Steam library or any credentials associated.")])])
}]}

/***/ }),
/* 546 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f16f7e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotlistGroupSlotsTable.vue ***!
  \***************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [(_vm.anyMissionSlotSelected) ? _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotRoleStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotPlayerStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionSlotGroup.slots), function(missionSlot) {
    return _c('mission-slotlist-group-slots-row', {
      key: missionSlot.uid,
      attrs: {
        "missionSlotDetails": missionSlot,
        "missionSlotGroup": _vm.missionSlotGroup,
        "hasAnyMissionSlotDescription": _vm.hasAnyMissionSlotDescription
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotGroup.slots.length >= 10),
      expression: "missionSlotGroup.slots.length >= 10"
    }]
  }, [_c('tr', [(_vm.anyMissionSlotSelected) ? _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotRoleStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotPlayerStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 547 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f568eaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionEmbedModal.vue ***!
  \*********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionEmbedModal",
    attrs: {
      "id": "missionEmbedModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.embed'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionEmbedInformation
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 font-weight-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.token'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.token.description'))
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionToken)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.generateMissionToken
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.generate')) + "\n          ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger",
      "disabled": _vm.missionToken === null
    },
    on: {
      "click": _vm.deleteMissionToken
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission embed actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionEmbedModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-700d7246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarBody.vue ***!
  \*********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-body"
  }, [_c('div', {
    staticClass: "calendar-weeks-header"
  }, _vm._l((7), function(day) {
    return _c('span', {
      key: day,
      staticClass: "calendar-week-header"
    }, [_vm._v(_vm._s(_vm.localizedWeekDay(day - 1)))])
  })), _vm._v(" "), _c('div', {
    staticClass: "calendar-dates"
  }, _vm._l((_vm.weeks), function(week) {
    return _c('calendar-week', {
      key: week,
      attrs: {
        "week": week
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 549 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-70bb0568"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/modals/AccountDeleteModal.vue ***!
  \*********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.accountDetails) ? _c('b-modal', {
    ref: "accountDeleteModal",
    attrs: {
      "id": "accountDeleteModal",
      "title": _vm.$t('account.modal.delete'),
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.clearAccountDeleteData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.deleteAccount($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('account.delete.confirm'))
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('account.delete.nickname'),
      "description": _vm.$t('account.delete.nickname.description'),
      "feedback": _vm.accountEditNicknameFeedback,
      "state": _vm.accountEditNicknameState
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.accountDeleteData.nickname),
      callback: function($$v) {
        _vm.accountDeleteData.nickname = $$v
      },
      expression: "accountDeleteData.nickname"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Account delete actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteAccount
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideAccountDeleteModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 550 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d6a604"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionSlotTemplateDetails.vue ***!
  \*********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateDetails.title))]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.by')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionSlotTemplateDetails.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.missionSlotTemplateDetails.creator)))])], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.visibility')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionSlotTemplateVisibility)
    }
  })])]), _vm._v(" "), (_vm.loggedIn) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [(_vm.isMissionSlotTemplateCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateEditModal",
      modifiers: {
        "missionSlotTemplateEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]) : _vm._e(), _vm._v(" \n        "), (_vm.loggedIn) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateDuplicateModal",
      modifiers: {
        "missionSlotTemplateDuplicateModal": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slotTemplate')) + "\n        ")]) : _vm._e(), _vm._v(" \n        "), (_vm.isMissionSlotTemplateCreator) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slotTemplate.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.slotlist')))]), _vm._v(" "), _c('mission-slot-template-slotlist')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loggedIn) ? _c('mission-slot-template-duplicate-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-edit-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-create-modal') : _vm._e(), _vm._v(" "), _c('mission-slot-template-slot-details-modal'), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-edit-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-group-create-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-group-edit-modal') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 551 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7643bd6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotlistGroup.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.missionSlotGroup.title))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotGroup.description),
      expression: "missionSlotGroup.description"
    }],
    staticClass: "word-wrap"
  }, [_vm._v(_vm._s(_vm.missionSlotGroup.description))]), _vm._v(" "), _c('mission-slotlist-group-slots-table', {
    attrs: {
      "missionSlotGroup": _vm.missionSlotGroup
    }
  }), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotCreateModal",
      modifiers: {
        "missionSlotCreateModal": true
      }
    }],
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.setMissionSlotGroupDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission.slot')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotGroupEditModal",
      modifiers: {
        "missionSlotGroupEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.setMissionSlotGroupDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.slotGroup')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.duplicateMissionSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slotGroup')) + "\n    ")]), _vm._v(" "), _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slotGroup.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteMissionSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}

/***/ }),
/* 552 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d73c9fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue ***!
  \********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('calendar.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('calendar-header'), _vm._v(" "), _c('calendar-body'), _vm._v(" "), _c('div', {
    staticClass: "small text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.timezone', {
        timezone: _vm.timezone
      }))
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 553 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7db92e7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/modals/UserEditModal.vue ***!
  \**************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "userEditModal",
    attrs: {
      "id": "userEditModal",
      "title": _vm.$t('user.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.setUserEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editUser($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.application.nickname'),
      "state": _vm.userEditNicknameState,
      "feedback": _vm.userEditNicknameFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.userEditData.nickname),
      callback: function($$v) {
        _vm.userEditData.nickname = $$v
      },
      expression: "userEditData.nickname"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "User edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editUser
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.save')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideUserEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f742dbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountMissions.vue ***!
  \***********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('account-missions-table'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshAccountMissions
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 555 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fb972d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionList.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missions) ? _c('mission-list-table') : _vm._e(), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionsPageCount > 1),
      expression: "missionsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "missionsPaginate",
    attrs: {
      "pageCount": _vm.missionsPageCount,
      "initial-page": 0,
      "clickHandler": _vm.missionsPaginate,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "small",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.timezone', {
        timezone: _vm.timezone
      }))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('mission.list.filter'),
      "label-for": "missionListFilter"
    }
  }, [_c('div', {
    attrs: {
      "role": "group",
      "id": "missionListFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "ended",
      "value": "ended"
    },
    model: {
      value: (_vm.missionListFilter),
      callback: function($$v) {
        _vm.missionListFilter = $$v
      },
      expression: "missionListFilter"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('mission.list.filter.ended')) + "\n        ")]), _vm._v(" "), (_vm.loggedIn) ? _c('b-form-checkbox', {
    attrs: {
      "name": "assigned",
      "value": "assigned"
    },
    model: {
      value: (_vm.missionListFilter),
      callback: function($$v) {
        _vm.missionListFilter = $$v
      },
      expression: "missionListFilter"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('mission.list.filter.assigned')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('b-form-checkbox', {
    attrs: {
      "name": "registered",
      "value": "registered"
    },
    model: {
      value: (_vm.missionListFilter),
      callback: function($$v) {
        _vm.missionListFilter = $$v
      },
      expression: "missionListFilter"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('mission.list.filter.registered')) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.haveMissionsAnyRequiredDLCs || (_vm.missionListRequiredDLCsFilter && _vm.missionListRequiredDLCsFilter.length > 0)) ? _c('div', {
    attrs: {
      "role": "group",
      "id": "missionListRequiredDLCsFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "aow",
      "value": "aow"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "apex",
      "value": "apex"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "contact",
      "value": "contact"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "csla",
      "value": "csla"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "gm",
      "value": "gm"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "helicopters",
      "value": "helicopters"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "jets",
      "value": "jets"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "karts",
      "value": "karts"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "laws-of-war",
      "value": "laws-of-war"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "marksmen",
      "value": "marksmen"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "tac-ops",
      "value": "tac-ops"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "tanks",
      "value": "tanks"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')) + "\n        ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "vn",
      "value": "vn"
    },
    model: {
      value: (_vm.missionListRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionListRequiredDLCsFilter = $$v
      },
      expression: "missionListRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')) + "\n        ")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loggedIn),
      expression: "loggedIn"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "tag": "button",
      "type": "button",
      "to": {
        name: 'missionCreator'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.mission')) + "\n    ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "disabled": _vm.refreshingMissions
    },
    on: {
      "click": function($event) {
        _vm.missionsPaginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.refreshingMissions
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('mission.list.search')))]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": _vm.$t('mission.list.search.description')
    }
  }, [_c('typeahead', {
    ref: "missionSearchTypeahead",
    attrs: {
      "action": "searchMissions",
      "actionIndicator": "searchingMissions",
      "onHit": _vm.missionSelected
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 556 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-843c9da0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotDetailsModal.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotDetailsModal",
    attrs: {
      "id": "missionSlotTemplateSlotDetailsModal",
      "size": "lg",
      "title": _vm.slotDetailsTitle,
      "no-close-on-backdrop": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.difficulty')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateSlotDetails.orderNumber))]), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateSlotDetails.title) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.difficultyColor
  }, [_vm._v(_vm._s(_vm.difficultyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.status')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateSlotDetails.description))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5",
    domProps: {
      "innerHTML": _vm._s(_vm.slotStatus)
    }
  })]), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplateSlotDetails.detailedDescription),
      expression: "missionSlotTemplateSlotDetails.detailedDescription"
    }],
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplateSlotDetails.detailedDescription),
      expression: "missionSlotTemplateSlotDetails.detailedDescription"
    }],
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.detailedDescription')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotTemplateSlotDetails.detailedDescription),
      expression: "missionSlotTemplateSlotDetails.detailedDescription"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.missionSlotTemplateSlotDetails.detailedDescription)
    }
  })])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [(_vm.isMissionSlotTemplateCreator) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.duplicateMissionSlotTemplateSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slot')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateSlotEditModal",
      modifiers: {
        "missionSlotTemplateSlotEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.hideMissionSlotTemplateSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n      ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 557 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e77b32a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Imprint.en.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "Imprint"
    }
  }, [_c('br'), _vm._v(" "), _c('h4', [_vm._v("Legal disclosure")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }), _c('address', [_c('strong', [_vm._v("Nick 'MorpheusXAUT' Müller")]), _vm._v(" "), _c('br'), _vm._v("Bergmillergasse 8/2/13\n      "), _c('br'), _vm._v("1140, Vienna\n      "), _c('br'), _vm._v("Austria\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Email:\n      "), _c('a', {
    attrs: {
      "href": "mailto:nick@slotlist.info?subject=slotlist.info - legal inquiry"
    }
  }, [_vm._v("nick@slotlist.info")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Disclaimer")]), _vm._v(" "), _c('h5', [_vm._v("Accountability for content")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this context, please note that we are accordingly not obliged to monitor merely the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity. This also includes content created by third-parties on our website (e.g. missions or communities, website links, descriptions and uploaded images).\n  ")]), _vm._v(" "), _c('h5', [_vm._v("Accountability for links")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective link immediately.\n  ")]), _vm._v(" "), _c('h5', [_vm._v("Copyright and trademark laws")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    In all our publications, we endeavor to respect the copyright of the images, graphics, sound documents, video sequences and texts used, to use images, graphics, sound documents, video sequences and texts created by ourselves or resort to using royality-free images, graphics, sound documents, video sequences and texts. All brand names and trademarks mentioned on the website and, where applicable, protected by third parties are subject without restriction to the provisions of the applicable transmark law and the ownership rights of the respective registered owners. A mere mention should not lead to the conclusion that trademarks are not protected by rights of third parties! The copyright for objects, created and published by us, remains with us. Reproduction or use of such images, graphics, sound documents, video sequences and texts in other electronic or printed publications is not permitted without express consent of the author.#\n    "), _c('br'), _vm._v("Content that has been created by third parties on our website - for example missions, communities or the like - are the sole responsibility of their respective creators. We assume no liability for copyright or trademark infringements committed by third party content on our site.\n    "), _c('br'), _vm._v("Should you find copyrighted content in third-party content on our site, please contact us via any way mentioned at our\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" or\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Imprint")]), _vm._v(" pages and provide us with proof of ownership of the content in question. After successful examination, we will remove the respective contents immediately.\n  ")], 1), _vm._v(" "), _c('h5', [_vm._v("Content rights")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    All rights reserved. Any duplication or distribution of the whole content or parts of it in any media is subject to consent of the publisher.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 558 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-8eebf840"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountMissionsTable.vue ***!
  \****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.accountMissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.description')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.accountMissions), function(accountMission) {
    return _c('account-missions-row', {
      key: accountMission.uid,
      attrs: {
        "accountMission": accountMission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountMissions.length >= 10),
      expression: "accountMissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.description')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 559 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-92df0b7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Imprint.de.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "Impressum"
    }
  }, [_c('br'), _vm._v(" "), _c('h4', [_vm._v("Offenlegung")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }), _c('address', [_c('strong', [_vm._v("Nick 'MorpheusXAUT' Müller")]), _vm._v(" "), _c('br'), _vm._v("Bergmillergasse 8/2/13\n      "), _c('br'), _vm._v("1140, Wien\n      "), _c('br'), _vm._v("Österreich\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Email:\n      "), _c('a', {
    attrs: {
      "href": "mailto:nick@slotlist.info?subject=slotlist.info - rechliche Anfrage"
    }
  }, [_vm._v("nick@slotlist.info")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Haftungsausschluss")]), _vm._v(" "), _c('h5', [_vm._v("Inhalt des Onlineangebotes")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Der Inhalt dieser Website wurde mit größtmöglicher Sorgfalt erstellt, wir übernehmen jedoch keinerlei Gewähr für die Richtigkeit, Vollständigkeit und Aktualität. Gemäß geltender Gesetzesbestimmungen sind wir für den eigenen Inhalt auf diesen Webseiten verantwortlich. Wir weisen in diesem Kontext aber darauf hin, dass wir gleichzeitig nicht dazu verpflichtet sind, Informationen, welche von Dritten übertragen oder gespeichert werden, zu überwachen oder Umstände, welche auf illegale Aktivitäten hinweisen, zu untersuchen - dies beinhaltet auch Inhalte, welche von Dritten auf unserer Website (z.B. Missionen, Communities, Links auf andere Websites, Beschreibungen oder hochgeladene Bilder).\n  ")]), _vm._v(" "), _c('h5', [_vm._v("Verweise und Links")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Die Verwantwortung für den Inhalt von externen Verweisen und Links (auf Websiten von Dritten) liegt ausschließlich bei den Betreibern der verwiesenen Seiten. Zur Zeit der Verlinkung waren keine offensichtlichen Verstöße erkennbar. Sollte uns ein rechtlicher Verstoß bekannt werden, entfernen wir die jeweiligen Verweise sofort.\n  ")]), _vm._v(" "), _c('h5', [_vm._v("Urheber- und Kennzeichenrecht")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Wir sind bemüht, in allen unserer Publikationen die Urheberrechte der verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von uns selbst erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zurückzugefreifen. Alle innerhalb der Website genannten und gegebenenfalls durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, von uns selbst erstellte Objekte bleibt allein bei uns. Eine Vervielfältigung oder Verwendung solcher Bilder, Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.\n    "), _c('br'), _vm._v("Inhalte, welche durch Dritte auf unserer Website erstellt wurden - zum Beispiel Missionen, Communities oder ähnliches - unterliegen komplett der Verantwortung der jeweiligen Ersteller. Wir übernehmen keinerlei Haftung für Copyright-, Kennzeichen- oder Marken-Verstöße, welche durch Dritt-Inhalte auf unserer Website begangen wurden.\n    "), _c('br'), _vm._v("Sollten Sie urheberrechtlich geschützte Inhalte in von Dritten erstellten Inhalten auf unserer Website finden, so kontaktieren Sie uns bitte auf einem der Wege, die auf userer\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über")]), _vm._v(" oder\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Impressum-Seite")]), _vm._v(" angegeben sind und übermitteln uns Nachweise Ihres Eigentums der betroffenen Inhalte. Nach erfolgreicher Prüfung entfernen wir die jeweiligen Inhalte dann umgehend.\n  ")], 1), _vm._v(" "), _c('h5', [_vm._v("Inhaltsrechte")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Alle Rechte vorbehalten. Jegliche Vervielfältigung oder Verbreitung des ganzen Inhalts - oder nur Teilen davon - benötigt die Zustimmung des Rechteinhabers.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 560 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-9603e6e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.home')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.missions')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'missionSlotTemplateList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.missionSlotTemplates')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.communities')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'userList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.users')) + "\n          ")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav"
  }, [(_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'text-danger': _vm.unseenNotificationCount > 0, 'font-weight-bold': _vm.unseenNotificationCount > 0
    },
    attrs: {
      "to": {
        name: 'notificationList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.unseenNotificationCount) + " " + _vm._s(_vm.$t('nav.notifications')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.account')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link text-primary",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.login')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link text-danger",
    attrs: {
      "to": {
        name: 'home'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('nav.logout')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle text-muted",
    attrs: {
      "id": "navbarLanguageDropdown",
      "href": "#",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLanguage)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarLanguageDropdown"
    }
  }, [_c('a', {
    staticClass: "dropdown-item text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('en')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/flags/gb.png"
    }
  }), _vm._v(" English")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('de')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/flags/de.png"
    }
  }), _vm._v(" Deutsch")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setLocale('de-at')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/flags/at.png"
    }
  }), _vm._v(" Österreichisch")])])])])])], 1), _vm._v(" "), [_c('div', {
    staticClass: "container"
  }, [_c('b-alert', {
    attrs: {
      "variant": _vm.alertVariant,
      "dismissible": _vm.alertDismissible,
      "show": _vm.showAlert
    },
    on: {
      "dismissed": _vm.alertDismissed,
      "dismiss-count-down": _vm.alertDismissCountDown
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.alertMessage)
    }
  })]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.working),
      expression: "working"
    }]
  }, [_c('loading-overlay', {
    attrs: {
      "message": _vm.working
    }
  })], 1)], 1)], _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "text-muted small float-left"
  }, [_vm._v("\n            Copyright © 2017-" + _vm._s(_vm.year) + "\n            "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("slotlist.info")]), _vm._v(". " + _vm._s(_vm.$t('rights.reserved')) + ".\n          ")], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "text-muted small float-right"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.about')))]), _vm._v(" |\n            "), _c('router-link', {
    attrs: {
      "to": "/imprint"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.imprint')))]), _vm._v(" |\n            "), _c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.privacy')))]), _vm._v(" |\n            "), _c('router-link', {
    attrs: {
      "to": "/api"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.api')))]), _vm._v(" |\n            "), _vm._m(2), _vm._v(" |\n            "), _vm._m(3)], 1)])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col text-center"
  }, [_c('span', {
    staticClass: "text-muted small"
  }, [_vm._v("\n            Made with\n            "), _c('i', {
    staticClass: "fa fa-heart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" by\n            "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v(" Frontend")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-backend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v(" Backend")])
}]}

/***/ }),
/* 561 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-97d31352"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityPermissionsTable.vue ***!
  \*************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityPermissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityPermissions), function(communityPermission) {
    return _c('community-permissions-row', {
      key: communityPermission.uid,
      attrs: {
        "communityPermission": communityPermission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityPermissions.length >= 10),
      expression: "communityPermissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 562 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-9801532c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserListTable.vue ***!
  \*******************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user.nickname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('user-list-row', {
      key: user.uid,
      attrs: {
        "user": user
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.users.length >= 10),
      expression: "users.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v(_vm._s(_vm.$t('user.nickname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 563 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ad6683c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMembersTable.vue ***!
  \*********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityMembers) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.nickname')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.leader')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityMembers), function(communityMember) {
    return _c('community-members-row', {
      key: communityMember.uid,
      attrs: {
        "communityMember": communityMember
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityMembers.length >= 10),
      expression: "communityMembers.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.application.nickname')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('community.leader')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 564 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b76bbe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Privacy.en.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "Privacy policy",
      "lead": "Last updated: <strong>2017-11-15 14:28 CET</strong>."
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    The\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" team (\"us\", \"we\" or \"our\") operates the\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" website (the \"Service\").\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("This page informs you of our policies regarding the collection, use and discolsure of personal information when you use our Service.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Your privacy and information safety is important to us - we will\n    "), _c('strong', [_vm._v("not")]), _vm._v(" use or share your information with anyone except as described in this privacy policy.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("We use your personal information to provide this Service and improve its quality continously. By using our Service, you agree to the collection and processing of your information in accordance to this policy. Should you disagree with any points of our privacy policy, stop using our Service immediately as continued usage automatically counts as consent.\n    "), _c('br')], 1), _c('h4', [_vm._v("Information collection and use")]), _vm._v("\n    While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you.\n    "), _c('br'), _vm._v("This data includes - but is not restricted to - your Steam ID and nickname (as retrieved via the public information available from your Steam profile and the Steam Single Sign-on) as well as any other information entered by you.\n    "), _c('br'), _vm._v("Our service never receives additional details about your Steam account beside your\n    "), _c('code', [_vm._v("Steam 64 ID")]), _vm._v(" and the nickname associated with it at the time you first log into our Service (thus creating a new account). Your nickname can be changed at any time via the\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account")]), _vm._v(" page.\n    "), _c('strong', [_vm._v("We never receive your Steam username, password or the email address associated with your account")]), _vm._v(".\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Log Data")]), _vm._v("\n    We collect information transmitted by your browser whenever you visit our Service (\"Log Data\"). This Log Data may include identifiable information such as your computer's Internet Protocol (\"IP\") address, browser type, browser version, the pages of our Service that you visit, the time and date of your visits, the time spent on those Service pages as well as other statistics.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Cookies")]), _vm._v("\n    Cookies are files with small amount of data, stored by your browser on your computer's hard drive. Cookies may contain an anonymous unique identifier and are sent to your browser from our Service or a third party used to provide our Service.\n    "), _c('br'), _vm._v("We (or our Service Providers) may use Cookies to collect information about your website usage. You can instruct your browser to reject all Cookies, however some parts of our Service might not work to their fullest extend when doing so.\n    "), _c('br'), _vm._v("Our Service currently does not use any additional tracking or storage Cookies, however our Service Provider\n    "), _c('a', {
    attrs: {
      "href": "https://cloudflare.com"
    }
  }, [_vm._v("Cloudflare")]), _vm._v(" may add a cookie to better serve your requests. Furthermore, the cookie consent popup displayed to you upon visiting our Service also stores a cookie indicating your approval.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Service Providers")]), _vm._v("\n    We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is being used.\n    "), _c('br'), _vm._v("These third parties only have access to your personal information as required to perform their designated task and are obligated not to disclose or use it for any other purposes.\n    "), _c('br'), _vm._v("As of now, our Service uses\n    "), _c('a', {
    attrs: {
      "href": "https://cloudflare.com"
    }
  }, [_vm._v("Cloudflare")]), _vm._v(" as a DNS-, CDN- and DDoS protection service as well as\n    "), _c('a', {
    attrs: {
      "href": "https://cloud.google.com"
    }
  }, [_vm._v("Google Cloud Platform")]), _vm._v(" as a hosting provider (with servers currently located in the\n    "), _c('code', [_vm._v("europe-west3")]), _vm._v(" zone in Frankfurt). Furthermore, we employ services of\n    "), _c('a', {
    attrs: {
      "href": "https://sentry.io"
    }
  }, [_vm._v("sentry.io")]), _vm._v(" for error reporting and crash monitoring.\n    "), _c('br'), _vm._v("The respective privacy policies can be found on the companies' websites.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Links to other sites")]), _vm._v("\n    Our Service may contain links to other sites that are not operated by us. If you click on a third-party link, you will be redirected to that respective third-party site. We do not have any control over, and assume no responsibility for the content, privacy policies and practices of any third-party sites or services and strongly advise you to review the privacy policy of any third-party site you visit.\n    "), _c('br'), _vm._v("Should you notice any illegal or otherwise offensive material on any third-party sites linked to by our Service, please contact us via any way mentioned at our\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" or\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Imprint")]), _vm._v(" pages and inform us about the link.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Copyright and trademark laws")]), _vm._v("\n    In all our publications, we endeavor to respect the copyright of the images, graphics, sound documents, video sequences and texts used, to use images, graphics, sound documents, video sequences and texts created by ourselves or resort to using royality-free images, graphics, sound documents, video sequences and texts. All brand names and trademarks mentioned on the website and, where applicable, protected by third parties are subject without restriction to the provisions of the applicable transmark law and the ownership rights of the respective registered owners. A mere mention should not lead to the conclusion that trademarks are not protected by rights of third parties! The copyright for objects, created and published by us, remains with us. Reproduction or use of such images, graphics, sound documents, video sequences and texts in other electronic or printed publications is not permitted without express consent of the author.\n    "), _c('br'), _vm._v("Content that has been created by third parties on our website - for example missions, communities or the like - are the sole responsibility of their respective creators. We assume no liability for copyright or trademark infringements committed by third party content on our site.\n    "), _c('br'), _vm._v("Should you find copyrighted content in third-party content on our site, please contact us via any way mentioned at our\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" or\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Imprint")]), _vm._v(" pages and provide us with proof of ownership of the content in question. After successful examination, we will remove the respective contents immediately.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Children's privacy")]), _vm._v("\n    Our Service does not adress anyone under the age of 13 (\"Child\", Children\").\n    "), _c('br'), _vm._v("We do not knowingly collect personally identifiable information from Children under 13. If you are a parent or guardian and you are aware that your Child has provided us with personal information, please contact us via any way mentioned at our\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" or\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Imprint")]), _vm._v(" pages.\n    "), _c('br'), _vm._v("Should we discover any personal information provided by Children under the age of 13 years, we will delete such information from our Service immediately.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Changes to this privacy policy")]), _vm._v("\n    We may update this privacy policy from time to time. We will notify you of any changes by posting the new, updated privacy policy on this page as well as a notice in the\n    "), _c('code', [_vm._v("#announcements")]), _vm._v(" channel in our\n    "), _c('a', {
    attrs: {
      "href": "https://discord.gg/QZ5HpwT"
    }
  }, [_vm._v("support Discord server")]), _vm._v(".\n    "), _c('br'), _vm._v("We advise you to review this privacy policy periodically for any changes as they are effective when posted on this page.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Contact us")]), _vm._v("\n    If you have any questions regarding this privacy policy, please contact us via any way mentioned on our\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("About")]), _vm._v(" or\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Imprint")]), _vm._v(" pages.\n  "), _c('p')], 1)
},staticRenderFns: []}

/***/ }),
/* 565 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fde1438"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Privacy.de.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "Datenschutzerklärung",
      "lead": "Zuletzt aktualisiert: <strong>2017-11-15 14:28 CET</strong>."
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Das\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" Team (\"wir\", \"uns\" oder \"unser\") betreibt die\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v("-Website (der \"Dienst\").\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Diese Seite informiert über die Richtlinen zur Sammlung, Verarbeitung und Weitergabe von persönlichen Daten, die bei der Benutzung unseres Dienstes gesammelt werden.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Ihre Privatsphäre und Informationssicherheit ist uns sehr wichtig - wir werden Ihre Daten\n    "), _c('strong', [_vm._v("nicht")]), _vm._v(" an Dritte weitergeben, außer wie in dieser Datenschutzerklärung beschreiben.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Wir nutzen Ihre persönlichen Daten, um den Dienst anzubieten und dessen Qualität kontinuierlich verbessern zu können. Durch die Nutzung des Dienstes stimmen Sie der Sammlung und Verarbeitung Ihrer Daten in Übereinstimmung dieser Datenschutzerklärung zu. Sollten Sie mit irgendeinem Punkt dieser Erklärung nicht einverstanden sein, so verlassen Sie die Seite sofort und benutzen Sie unseren Dienst nicht weiter, da eine weitere Verwendung automatisch als Zustimmung gewertet wird.\n    "), _c('br')], 1), _c('h4', [_vm._v("Datensammlung und -verwendung")]), _vm._v("\n    Während der Verwendung unseres Dienstes fragen wir Sie nach Bedarf nach bestimmten, persönlich identifizierbaren Informationen, über die Sie kontaktiert oder identifiziert werden könnten.\n    "), _c('br'), _vm._v("Diese Daten beinhalten - aber sind nicht beschränkt auf - Ihre Steam ID und Nickname (wie aus den öffentlichen verfügbaren Daten Ihres Steam-Profils und des Steam Single Sign-on ersichtlich) sowie alle anderen, von Ihnen bei diesem Dienst eingegebenen Informationen.\n    "), _c('br'), _vm._v("Unser Dienst erhält niemals weitere Details über Ihren Steam Account abgesehen von der\n    "), _c('code', [_vm._v("Steam 64 ID")]), _vm._v(" und dem Nickname, der beim ersten Login in unseren Dienst festgelegt wurde (da zu diesem Zeitpunkt ein Account in unserem Dienst erstellt wird). Der Nickname kann jederzeit über die\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("Account-Seite")]), _vm._v(" geändert werden.\n    "), _c('strong', [_vm._v("Wir erhalten niemals Ihren Steam-Benutzernamen, Ihr Passwort oder die Emailadresse, die mit Ihrem Steam-Account verknüpft ist.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Logdaten")]), _vm._v("\n    Wir speichern die Informationen, die von Ihrem Browser bei der Verwendung unseres Dienstes übertragen werden (\"Logdaten\"). Diese Logdaten können identifizierbare Informationen wie die Internet Protocol Adresse (\"IP\") Ihres Computers, den Browsertyp, die Browserversion, die Seiten unseres Dienstes, die Sie besucht haben, Datum und Uhrzeit Ihrer Dienst-Besuche, die Zeit, die sie auf unseren Seiten verbracht haben sowie andere Statistiken enthalten.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Cookies")]), _vm._v("\n    Cookies sind Dateien mit kleinem Textinhalt, die von Ihrem Browser auf der Festplatte Ihres Computers abgelegt werden. Cookies können potenziell anonyme, einzigartige Identifizierungsmerkmale enthalten, die von unserem Dienst oder einer dritten Partei, deren Dienste von uns verwendet werden, um unseren Dienst anzubieten, an Ihren Browser geschickt werden.\n    "), _c('br'), _vm._v("Wir (oder unsere weiteren Dienstanbieter) können Cookies dazu verwenden, um Informationen zur Nutzung unserer Website zu sammeln. Sie können Ihren Browser anweisen, alle Cookies abzulehnen, dadurch könnten jedoch einige Teile des Dienstes nicht mehr vollständig funktionieren.\n    "), _c('br'), _vm._v("Unser Dienst nutzt aktuell keine zusätzlichen Tracking- oder Speicher-Cookies, unser Dienstanbieter\n    "), _c('a', {
    attrs: {
      "href": "https://cloudflare.com"
    }
  }, [_vm._v("Cloudflare")]), _vm._v(" kann aber ein Cookie hinzufügen, um Anfragen besser bearbeiten zu können. Weiterhin wird ein Cookie von dem Cookie-Zustimmungs-Popup beim Besuchen unserer Website als Zeichen der Zustimmung gespeichert.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Dienstanbieter")]), _vm._v("\n    Wir können dritte Firmen oder Individuen einsetzen, um unsere Dienste zu unterstützen, unsere Dienste für uns anzubieten, um Dienst-bezogene Dienstleistungen anzubieten oder um uns zu helfen, zu analysieren, wie unser Dienst genutzt wird.\n    "), _c('br'), _vm._v("Diese dritten Parteien haben nur zu den persönlichen Daten Zugang, die für die Verrichtung ihrer zugewiesenen Tätigkeit benötigt werden und sind dazu verpflichtet, diese Daten nicht zu veröffentlichen oder für irgendwelche anderen Zwecke zu verwenden.\n    "), _c('br'), _vm._v("Zum aktuellen Stand nutzt unser Dienst\n    "), _c('a', {
    attrs: {
      "href": "https://cloudflare.com"
    }
  }, [_vm._v("Cloudflare")]), _vm._v(" als DNS-, CDN- und DDoS-Schutz-Dienst sowie\n    "), _c('a', {
    attrs: {
      "href": "https://cloud.google.com"
    }
  }, [_vm._v("Google Cloud Platform")]), _vm._v(" als Hosting-Provider (mit Servern, welche aktuell in der\n    "), _c('code', [_vm._v("europe-west3")]), _vm._v(" Zone in Frankfurt angesammelt sind). Weiters nutzen wir Dienste von\n    "), _c('a', {
    attrs: {
      "href": "https://sentry.io"
    }
  }, [_vm._v("sentry.io")]), _vm._v(" für Fehlermeldungen und Absturzmonitoring.\n    "), _c('br'), _vm._v("Die Datenschutzerklärungen dieser Dienstanbieter können auf der jeweiligen Website der Firma gefunden werden.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Verweise und Links")]), _vm._v("\n    Unser Dienst kann Verweise auf andere Seiten, die nicht von uns betrieben werden, beinhalten. Beim Klicken auf einen Link einer dritten Partei werden Sie auf die jeweilige externe Website weitergeleitet. Wir haben keine Kontrolle über und übernehmen keine Verantwortung für die Inhalte, die Datenschutzbestimmungen und -verfahren von Dritten oder deren Dienstleistern und empfehlen Ihnen stark, die jeweiligen Richtlinen der Seiten Dritter, die Sie besuchen, zu überprüfen.\n    "), _c('br'), _vm._v("Sollten Sie irgendwelche illegalen oder anderweitig anstößlichen Materialien auf irgendeiner Seite einer dritten Partei entdecken, auf welche von unserem Dienst verwiesen wird, so bitten wir Sie, uns auf einem der Wege zu kontaktieren, die auf unserer\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über-")]), _vm._v(" oder\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Impressum-Seite")]), _vm._v(" angegeben sind, und uns über den Link zu informieren.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Urheber- und Kennzeichenrecht")]), _vm._v("\n    Wir sind bemüht, in allen unserer Publikationen die Urheberrechte der verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von uns selbst erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zurückzugefreifen. Alle innerhalb der Website genannten und gegebenenfalls durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, von uns selbst erstellte Objekte bleibt allein bei uns. Eine Vervielfältigung oder Verwendung solcher Bilder, Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.\n    "), _c('br'), _vm._v("Inhalte, welche durch Dritte auf unserer Website erstellt wurden - zum Beispiel Missionen, Communities oder ähnliches - unterliegen komplett der Verantwortung der jeweiligen Ersteller. Wir übernehmen keinerlei Haftung für Copyright-, Kennzeichen- oder Marken-Verstöße, welche durch Dritt-Inhalte auf unserer Website begangen wurden.\n    "), _c('br'), _vm._v("Sollten Sie urheberrechtlich geschützte Inhalte in von Dritten erstellten Inhalten auf unserer Website finden, so kontaktieren Sie uns bitte auf einem der Wege, die auf userer\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über")]), _vm._v(" oder\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Impressum-Seite")]), _vm._v(" angegeben sind und übermitteln uns Nachweise Ihres Eigentums der betroffenen Inhalte. Nach erfolgreicher Prüfung entfernen wir die jeweiligen Inhalte dann umgehend.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Schutz der Privatsphäre von Kindern")]), _vm._v("\n    Unser Dienst richtet sich nicht an Personen unter dem Alter von 13 Jahren (\"Kind\", \"Kindern\").\n    "), _c('br'), _vm._v("Wir sammeln nicht bewusst persönlich identifizierbare Informationen von Kindern unter 13 Jahren. Falls Sie ein Elternteil oder Vormund eines Kindes sind und Sie wissen, dass Ihr Kind uns persönliche Informationen übermittelt hat, so kontaktieren Sie uns bitte auf einem der Wege, die auf userer\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über")]), _vm._v(" oder\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Impressum-Seite")]), _vm._v(" angegeben sind.\n    "), _c('br'), _vm._v("Sollten wir bemerken, dass irgendwelche persönlichen Informationen von Kindern unter dem Alten von 13 Jahren an unser übermittelt wurden, werden wir diese Daten sofort von unserem Dienst entfernen.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Änderungen an dieser Datenschutzerklärung")]), _vm._v("\n    Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Wir werde Sie über jegliche Änderungen informieren, indem wir die neue, aktualisierte Datenschutzerklärung auf dieser Seite sowie eine Ankündigung im\n    "), _c('code', [_vm._v("#announcements")]), _vm._v("-Channel in unserem\n    "), _c('a', {
    attrs: {
      "href": "https://discord.gg/QZ5HpwT"
    }
  }, [_vm._v("Support-Discord-Server")]), _vm._v(" veröffentlichen werden.\n    "), _c('br'), _vm._v("Wir raten Ihnen, diese Erklärung regelmäßig auf Änderungen zu überprüfen, da diese sofort gültig sind, sobald sie auf dieser Seite veröffentlicht werden.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Kontaktieren Sie uns")]), _vm._v("\n    Sollten Sie irgendwelche Fragen bezüglich dieser Datenschutzerklärung haben, so kontaktieren Sie uns bitte auf einem der Wege, die auf userer\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("Über-")]), _vm._v(" oder\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Impressum-Seite")]), _vm._v(" angegeben sind.\n  "), _c('p')], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-a53aadf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/modals/CommunityEditModal.vue ***!
  \*************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "communityEditModal",
    attrs: {
      "id": "communityEditModal",
      "size": "lg",
      "title": _vm.$t('community.modal.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.setCommunityEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editCommunity($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.name'),
      "state": _vm.communityEditNameState,
      "feedback": _vm.communityEditNameFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.communityEditData.name),
      callback: function($$v) {
        _vm.communityEditData.name = $$v
      },
      expression: "communityEditData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.tag'),
      "state": _vm.communityEditTagState,
      "feedback": _vm.communityEditTagFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.communityEditData.tag),
      callback: function($$v) {
        _vm.communityEditData.tag = $$v
      },
      expression: "communityEditData.tag"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.website.optional'),
      "state": _vm.communityEditWebsiteState,
      "feedback": _vm.communityEditWebsiteFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditData.website),
      callback: function($$v) {
        _vm.communityEditData.website = $$v
      },
      expression: "communityEditData.website"
    }
  })], 1)], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.gameServers')))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.communityEditData && _vm.communityEditData.gameServers) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityEditData.gameServers), function(gameServer, index) {
    return _c('tr', {
      key: ((gameServer.hostname) + ":" + (gameServer.port))
    }, [_c('td', [_vm._v(_vm._s(gameServer.hostname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(gameServer.port))]), _vm._v(" "), _c('td', [(gameServer.name) ? _c('span', [_vm._v(_vm._s(gameServer.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])]), _vm._v(" "), _c('td', [(gameServer.password) ? _c('span', [_vm._v(_vm._s(gameServer.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-btn', {
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeCommunityGameServer(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n                    ")])], 1)])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityEditData.gameServers.length >= 10),
      expression: "communityEditData.gameServers.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.hostname'),
      "state": _vm.communityEditGameServerHostnameState,
      "feedback": _vm.communityEditGameServerHostnameFeedback,
      "description": _vm.$t('community.gameServers.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditGameServer.hostname),
      callback: function($$v) {
        _vm.communityEditGameServer.hostname = $$v
      },
      expression: "communityEditGameServer.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.port'),
      "state": _vm.communityEditGameServerPortState,
      "feedback": _vm.communityEditGameServerPortFeedback,
      "description": _vm.$t('community.gameServers.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.communityEditGameServer.port),
      callback: function($$v) {
        _vm.communityEditGameServer.port = $$v
      },
      expression: "communityEditGameServer.port"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.name'),
      "state": "success",
      "description": _vm.$t('community.gameServers.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditGameServer.name),
      callback: function($$v) {
        _vm.communityEditGameServer.name = $$v
      },
      expression: "communityEditGameServer.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.password'),
      "state": "success",
      "description": _vm.$t('community.gameServers.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditGameServer.password),
      callback: function($$v) {
        _vm.communityEditGameServer.password = $$v
      },
      expression: "communityEditGameServer.password"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addCommunityGameServer
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n            ")])], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('community.voiceComms')))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.communityEditData && _vm.communityEditData.voiceComms) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityEditData.voiceComms), function(voiceComms, index) {
    return _c('tr', {
      key: ((voiceComms.hostname) + ":" + (voiceComms.port))
    }, [_c('td', [_vm._v(_vm._s(voiceComms.hostname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(voiceComms.port))]), _vm._v(" "), _c('td', [(voiceComms.name) ? _c('span', [_vm._v(_vm._s(voiceComms.name))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])]), _vm._v(" "), _c('td', [(voiceComms.password) ? _c('span', [_vm._v(_vm._s(voiceComms.password))]) : _c('span', {
      staticClass: "text-muted font-italic"
    }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-btn', {
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeCommunityVoiceComms(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n                    ")])], 1)])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityEditData.voiceComms.length >= 10),
      expression: "communityEditData.voiceComms.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.hostname'),
      "state": _vm.communityEditVoiceCommsHostnameState,
      "feedback": _vm.communityEditVoiceCommsHostnameFeedback,
      "description": _vm.$t('community.voiceComms.hostname.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditVoiceComms.hostname),
      callback: function($$v) {
        _vm.communityEditVoiceComms.hostname = $$v
      },
      expression: "communityEditVoiceComms.hostname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.port'),
      "state": _vm.communityEditVoiceCommsPortState,
      "feedback": _vm.communityEditVoiceCommsPortFeedback,
      "description": _vm.$t('community.voiceComms.port.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "65535"
    },
    model: {
      value: (_vm.communityEditVoiceComms.port),
      callback: function($$v) {
        _vm.communityEditVoiceComms.port = $$v
      },
      expression: "communityEditVoiceComms.port"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.name'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditVoiceComms.name),
      callback: function($$v) {
        _vm.communityEditVoiceComms.name = $$v
      },
      expression: "communityEditVoiceComms.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.serverInfo.password'),
      "state": "success",
      "description": _vm.$t('community.voiceComms.password.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityEditVoiceComms.password),
      callback: function($$v) {
        _vm.communityEditVoiceComms.password = $$v
      },
      expression: "communityEditVoiceComms.password"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addCommunityVoiceComms
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n            ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.save')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideCommunityEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 567 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-a810e79e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarDay.vue ***!
  \********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-day",
    class: {
      'calendar-day-today': _vm.day.isToday, 'calendar-day-current-month': _vm.day.isCurrentMonth, 'calendar-day-weekend': _vm.day.isWeekend, 'calendar-day-selected': _vm.isDaySelected
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "calendar-day-number"
  }, [_vm._v(_vm._s(_vm.day.date.format('D')))])])]), _vm._v(" "), _c('div', _vm._l((_vm.missionsForDay), function(mission) {
    return _c('calendar-mission', {
      key: mission.uid,
      attrs: {
        "mission": mission
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 568 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-a852b990"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingOverlay.vue ***!
  \**************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-overlay"
  }, [_c('spinner', {
    attrs: {
      "size": _vm.size || "big",
      "message": _vm.message || "Loading..."
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 569 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1581da8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionPermissions.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mission-permissions-table', {
    attrs: {
      "missionPermissions": _vm.missionPermissions
    }
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionPermissionsPageCount > 1),
      expression: "missionPermissionsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "missionPermissionsPaginate",
    attrs: {
      "pageCount": _vm.missionPermissionsPageCount,
      "clickHandler": _vm.paginateMissionPermissions,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshMissionPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 570 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2de0060"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityApplications.vue ***!
  \*********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('community-applications-table'), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityApplicationsPageCount > 1),
      expression: "communityApplicationsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "communityApplicationsPaginate",
    attrs: {
      "pageCount": _vm.communityApplicationsPageCount,
      "clickHandler": _vm.paginateCommunityApplications,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshCommunityApplications
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 571 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-b866d120"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotlistGroupSlotsRow.vue ***!
  \*************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    class: {
      'table-active': _vm.missionSlotSelected
    },
    on: {
      "click": function($event) {
        if (!$event.ctrlKey) { return null; }
        _vm.toggleMissionSlotSelection($event)
      }
    }
  }, [(_vm.anyMissionSlotSelected) ? _c('td', [(_vm.missionSlotSelected) ? _c('i', {
    staticClass: "fa fa-check-square text-muted",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.orderNumber))]), _vm._v(" "), _c('td', [(!_vm.missionSlotDetails.restrictedCommunity && !_vm.missionSlotDetails.reserve && !_vm.missionSlotDetails.blocked) ? _c('div', [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.missionSlotDetails.title) + "\n      "), _vm._l((_vm.missionSlotRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.missionSlotDetails.restrictedCommunity || _vm.missionSlotDetails.reserve || _vm.missionSlotDetails.blocked) ? _c('b-popover', {
    attrs: {
      "content": _vm.titlePopoverContent,
      "triggers": ['hover']
    }
  }, [_c('span', {
    class: _vm.titleColor,
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTitle)
    }
  }), _vm._v(" "), _vm._l((_vm.missionSlotRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "16px"
      }
    })
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.missionSlotDetails.blocked) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.blocked')))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && _vm.missionSlotDetails.assignee) ? _c('span', [_c('router-link', {
    staticClass: "text-success font-weight-bold",
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionSlotDetails.assignee.uid
        }
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.formatUserWithTag(_vm.missionSlotDetails.assignee)) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && _vm.missionSlotDetails.externalAssignee) ? _c('span', {
    staticClass: "text-success font-weight-bold font-italic"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.externalAssignee))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && (!_vm.missionSlotDetails.registrationCount || _vm.missionSlotDetails.registrationCount <= 0)) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(("" + (this.$tc('mission.slot.assignee.registration', 0)))))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && _vm.missionSlotDetails.registrationCount && _vm.missionSlotDetails.registrationCount > 0) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(((this.missionSlotDetails.registrationCount) + " " + (this.$tc('mission.slot.assignee.registration', this.missionSlotDetails.registrationCount > 1 ? 2 : 1)))))]) : _vm._e()]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('td', [_vm._v(_vm._s(_vm.missionSlotDetails.description))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot actions"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotDetailsModal",
      modifiers: {
        "missionSlotDetailsModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.prepareMissionSlotDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), (_vm.loggedIn && !_vm.missionSlotDetails.registrationUid && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotRegistrationModal",
      modifiers: {
        "missionSlotRegistrationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.missionSlotDetails.blocked || !_vm.canRegisterForSlot
    },
    on: {
      "click": _vm.setMissionSlotDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-ticket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.register')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.missionSlotDetails.registrationUid && !_vm.hasMissionEnded) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-eraser",
      "yes-class": "btn btn-warning",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.unregister'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlotRegistration
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.unregister')) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slot.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 572 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-bec67c72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotGroupCreateModal.vue ***!
  \*******************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionSlotGroupCreateModal",
    attrs: {
      "id": "missionSlotGroupCreateModal",
      "title": _vm.$t('mission.modal.slotGroup.create'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotGroupCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createMissionSlotGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.title'),
      "state": _vm.missionSlotGroupCreateTitleState,
      "feedback": _vm.missionSlotGroupCreateTitleFeedback,
      "description": _vm.$t('mission.slotGroup.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotGroupCreateData.title),
      callback: function($$v) {
        _vm.missionSlotGroupCreateData.title = $$v
      },
      expression: "missionSlotGroupCreateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotGroupCreateData.description),
      callback: function($$v) {
        _vm.missionSlotGroupCreateData.description = $$v
      },
      expression: "missionSlotGroupCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotGroupCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotGroupCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotGroupCreateData.insertAfter = $$v
      },
      expression: "missionSlotGroupCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot group create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotGroupCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 573 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1e2e86c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMissionsTable.vue ***!
  \**********************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityMissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "44%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityMissions), function(communityMission) {
    return _c('community-missions-row', {
      key: communityMission.uid,
      attrs: {
        "communityMission": communityMission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityMissions.length >= 10),
      expression: "communityMissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "44%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 574 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf3d52f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/modals/CommunityLogoModal.vue ***!
  \*************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityDetails) ? _c('b-modal', {
    ref: "communityLogoModal",
    attrs: {
      "id": "communityLogoModal",
      "title": _vm.$t('community.modal.logo'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setCommunityLogoData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.uploadCommunityLogo($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.communityLogoData.url) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100px"
    },
    attrs: {
      "src": _vm.communityLogoData.url
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _c('div', {
    staticClass: "col text-center font-italic"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('community.logo.notSelected')) + "\n            "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.logo'),
      "state": _vm.communityLogoState,
      "feedback": _vm.communityLogoFeedback,
      "description": _vm.$t('community.logo.description')
    }
  }, [_c('b-form-file', {
    ref: "communityLogoSelection",
    attrs: {
      "id": "communityLogoSelection",
      "accept": "image/jpeg, image/png, image/gif",
      "choose-label": _vm.$t('community.logo.choose')
    },
    model: {
      value: (_vm.communityLogoData.file),
      callback: function($$v) {
        _vm.communityLogoData.file = $$v
      },
      expression: "communityLogoData.file"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community logo actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.uploadCommunityLogo
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.upload')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger",
      "disabled": !_vm.communityLogoData.url
    },
    on: {
      "click": _vm.deleteCommunityLogo
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideCommunityLogoModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 575 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1b870b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/About.en.vue ***!
  \********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "About slotlist.info"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" was created by\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(" due to being fed up of having to register in countless ArmA community forums just to participate in ArmA missions. The tools allows for easier creating and management of missions and provides easy and direct access to all users - all that's required is a Steam account, and you should already have that, otherwise you wouldn't be playing ArmA\n    "), _c('i', {
    staticClass: "fa fa-smile-o"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This service is provided to you for free without any guarantees of uptime or availability - we might shut down\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" without any additional warnings at any time. Since it's our goal to provide an easy tool to a broad number of ArmA enthusiats, we aim for the highest availability and longevity possible and thus appreciate any feedback you have for us.\n  ")], 1), _vm._v(" "), _c('h4', [_vm._v("Development")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" is currently solely developed by\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(". The website's frontend and backend source code repositories as well as the current versions deployed can be found below. Please include this information is bug reports as it helps with narrowing down issues.\n    ")], 1), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-1"
  }, [_vm._v("frontend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-frontend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.frontendVersion),
      expression: "frontendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.frontendVersion))])]), _vm._v(" "), _c('dt', {
    staticClass: "col-1"
  }, [_vm._v("backend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-backend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-backend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backendVersion),
      expression: "backendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.backendVersion))])])]), _vm._v("\n    You can also use these repositories and their respective issue trackers to report any bugs you encounter - or use one of the contact methods available, as mentioned below.\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Contact us")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Should you run into any issues or bugs or have a suggestion for our site, feel free to:\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("open an issue on GitHub")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend/issues"
    }
  }, [_vm._v("issue tracker")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("email us directly")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "mailto:hello@slotlist.info?subject=slotlist.info - Hello!"
    }
  }, [_vm._v("hello@slotlist.info")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("join our Discord server")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://discord.gg/QZ5HpwT"
    }
  }, [_vm._v("Discord")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("add the developer on Steam")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://steamcommunity.com/id/morpheusxaut"
    }
  }, [_vm._v("MorpheusXAUT")])])]), _vm._v("\n    Contact details for legal inquiries can be found on the\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("imprint")]), _vm._v(".\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Special thanks & credits")]), _vm._v(" "), _c('p', [_vm._v("\n    Last, but not least, there's a few people that I, MorpheusXAUT, would like to thank (in no particular order):\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/Regner"
    }
  }, [_vm._v("Regner")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for helping me start this project, set everything up and not complaining about my question bombardment")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] LeWarz")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for suggesting features and functionality, testing the service and providing general feedback")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Belbo")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feature suggestions and feedback as well as proofreading my partly random translations")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Sinus")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feedback regarding the structure and design of the site, general testing and filling my database with trash data")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] buur")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for constant feedback and suggestions as well as testing all different kinds of functionality")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://task-force-wolf.de"
    }
  }, [_vm._v("[TFW] Isaac")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feedback, suggestions and bug reports")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jaegerzug-achilles.de"
    }
  }, [_vm._v("[JgZg-A] Steff")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feature suggestions and providing an Austrian translation")])]), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}

/***/ }),
/* 576 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-e61fc902"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/About.de.vue ***!
  \********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "Über slotlist.info"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" wurde von\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(" entwickelt, da das andauernde Neu-Registrieren bei zahllosen ArmA-Communities, nur um bei deren Missionen mitzuspielen, nervig wurde. Das Tool erlaubt eine einfachere Erstellung und Verwaltung von Missionen und bietet schnellen und direkten Zugang für alle Benutzer - alles was dafür benötigt wird, ist ein Steam Account - und diesen sollte jeder hoffentlich haben, ansonsten wird das ArmA-Spielen schwer\n    "), _c('i', {
    staticClass: "fa fa-smile-o"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Dieser Service wird gratis und ohne jegliche Garantie über Verfügbarkeit oder Erreichbarkeit angeboten - wir können\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" jederzeit und ohne weitere Vorwarnungen beendigen. Da es unser Ziel ist, ein einfaches Mittel für eine breite Anzahl an ArmA-Enthusiasten zur Verfügung zu stellen, bemühen wir uns, die höchste Verfügbarkeit und Langlebigkeit zu erreichen und freuen uns dabei über jedes Feedback.\n  ")], 1), _vm._v(" "), _c('h4', [_vm._v("Entwicklung")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" wird aktuell ausschließlich von\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(" entwickelt. Die Repostories des Frontend- und Backend-Sourcecodes sowie die aktuell eingesetzten Versionen können unterhalb gefunden werden. Bitte gib diese Informationen in jeglichen Fehlermeldungen an, da es die Fehlersuche erleichtert.\n    ")], 1), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-1"
  }, [_vm._v("Frontend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-frontend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.frontendVersion),
      expression: "frontendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.frontendVersion))])]), _vm._v(" "), _c('dt', {
    staticClass: "col-1"
  }, [_vm._v("Backend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-backend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-backend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backendVersion),
      expression: "backendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.backendVersion))])])]), _vm._v("\n    Die Repositories sowie deren Fehler-Tracker können außerdem dazu verwenden werden, um etwaige Bugs zu melden - alternativ kann dies über eine der unten genannten Kontaktmöglichkeiten geschehen.\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Kontaktiere uns")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Sollten irgendwelche Probleme oder Fehler auftreten oder solltest du Vorschläge for unsere Seite haben, dann:\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("öffne einen Fehlerbericht auf GitHub")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend/issues"
    }
  }, [_vm._v("Fehler-Tracker")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("schick uns eine Email")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "mailto:hello@slotlist.info?subject=slotlist.info - Hallo!"
    }
  }, [_vm._v("hello@slotlist.info")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("tritt unserem Discord Server bei")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://discord.gg/QZ5HpwT"
    }
  }, [_vm._v("Discord")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("füge den Entwickler als Steam-Freund hinzu")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://steamcommunity.com/id/morpheusxaut"
    }
  }, [_vm._v("MorpheusXAUT")])])]), _vm._v("\n    Kontakt-Details für rechtliche Anfrangen können im\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("Impressum")]), _vm._v(" gefunden werden.\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Spezielle Danksagungen")]), _vm._v(" "), _c('p', [_vm._v("\n    Zuletzt gibt es noch einige Leute, bei denen ich, MorpheusXAUT, mich bedanken möchte (in keiner bestimmten Reihenfolge):\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/Regner"
    }
  }, [_vm._v("Regner")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("dafür, dass er mir beim Start des Projektes und dem Einrichten von Allem geholfen und meine Fragenbombardierungen ertragen hat")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] LeWarz")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für das Vorschlagen von Features und Funktionalitäten, dem Testen der Services und dem allgemeinen Feedback")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Belbo")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feature-Vorschläge und -Feedback sowie dem Korrekturlesen meiner teils wirren Übersetzungen")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Sinus")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feedback zum Aufbau und Design der Seite, allgemeinem Testing und dem Füllen meiner Datenbank mit Datenmüll")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] buur")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für konstantes Feedback und Verbesserungsvorschläge und das Testen aller möglichen Funktionalitäten")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://task-force-wolf.de"
    }
  }, [_vm._v("[TFW] Isaac")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feedback, Verbesserungsvorschläge und Fehlerberichte")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jaegerzug-achilles.de"
    }
  }, [_vm._v("[JgZg-A] Steff")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("für Feature-Vorschläge und die Übersetzung ins Österreichische")])]), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}

/***/ }),
/* 577 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-f15aa0ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommunityCreator.vue ***!
  \***********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('community.creator.title')))])]), _vm._v(" "), _c('div', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createCommunity($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.name'),
      "description": _vm.$t('community.name.description'),
      "state": _vm.communityCreateNameState,
      "feedback": _vm.communityCreateNameFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.communityCreateNameFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.communityCreate.name),
      callback: function($$v) {
        _vm.communityCreate.name = $$v
      },
      expression: "communityCreate.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.slug'),
      "description": _vm.$t('community.slug.description'),
      "state": _vm.communityCreateSlugState,
      "feedback": _vm.communityCreateSlugFeedback
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.communityCreateSlugAvailable
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.communityCreateSlugFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.communityCreate.slug),
      callback: function($$v) {
        _vm.communityCreate.slug = $$v
      },
      expression: "communityCreate.slug"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.tag'),
      "description": _vm.$t('community.tag.description'),
      "state": _vm.communityCreateTagState,
      "feedback": _vm.communityCreateTagFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.communityCreate.tag),
      callback: function($$v) {
        _vm.communityCreate.tag = $$v
      },
      expression: "communityCreate.tag"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.website.optional'),
      "state": _vm.communityCreateWebsiteState,
      "feedback": _vm.communityCreateWebsiteFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityCreate.website),
      callback: function($$v) {
        _vm.communityCreate.website = $$v
      },
      expression: "communityCreate.website"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.community')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 578 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-f43c5f84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionPermissionsRow.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionPermission.user.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.missionPermission.user)))])], 1), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionPermission)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm",
      "disabled": _vm.isMissionCreatorPermission
    },
    on: {
      "click": _vm.deleteMissionPermission
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 579 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8ac785c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Privacy.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('privacy-de') : _c('privacy-en')], 1)
},staticRenderFns: []}

/***/ }),
/* 580 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-f99048f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue ***!
  \***********************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('home-de') : _c('home-en'), _vm._v(" "), _c('calendar'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('faq-de') : _c('faq-en')], 1)
},staticRenderFns: []}

/***/ }),
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/* unknown exports provided */
/* all exports used */
/*!*****************************!*\
  !*** ./src/i18n/de-at.json ***!
  \*****************************/
/***/ (function(module, exports) {

module.exports = {
	"account.currentTime": "wöcha Dog/Zeit:",
	"account.delete.confirm": "Wüst dein Acoount echt löschn?<br><span class='font-weight-bold text-danger'>Des kaunst nimma zruck nehma! Des löscht olle Daten, de wos mit deim Account verknüpft san.</span><br>Des haßt olle Missionen, Aunmödungen und Rechte, de wos aun dein Account vagebn wordn san.",
	"account.delete.feedback.nickname": "Da eigebene Nickneim stimmt den gaunz mit deim jezign Nickneim zaum",
	"account.delete.nickname": "Gib in exaktn Nickneim vun deim Account ei",
	"account.delete.nickname.description": "Gib den aktuellen, exakten Nickname - inklusive korrekter Groß-/Kleinschreibung - ein, um die Löschung deines Accounts zu bestätigen",
	"account.feedback.nickname": "Nickneim eigebn",
	"account.modal.delete": "Account löschn",
	"account.modal.edit": "Accountdetails beoabeitn",
	"account.noChanges": "Es san kane Ändarungen aun de Accountdetails gscheng",
	"account.notAssociated": "ned assoziiert",
	"account.permission": "Berechtigung",
	"account.permissions": "Berechtigungen",
	"account.timezone": "Zeitzone",
	"button.accept": "Akzeptieren",
	"button.activate.user": "Account aktiwian",
	"button.add": "Add",
	"button.add.mission.access": "Add access",
	"button.add.mission.permission": "Berechtigung dazuafügn",
	"button.apply": "Beweam",
	"button.apply.mission.slotGroup": "Apply slot template",
	"button.apply.mission.slotGroup.short": "Apply",
	"button.assign": "Zuaweisn",
	"button.assign.mission.slot": "Slot zuaweisn",
	"button.cancel": "Obrechn",
	"button.clear.selection": "Auswahl aufheben",
	"button.close": "Zuamochn",
	"button.confirm": "Passt so",
	"button.convert.slotTemplate": "Convert to slot template",
	"button.copy": "Copy",
	"button.create.community": "Community erstöhn",
	"button.create.community.permission": "Berechtigung erstöhn",
	"button.create.mission": "Mission erstöhn",
	"button.create.mission.slot": "Slot erstöhn",
	"button.create.mission.slot.template": "Create slot template",
	"button.create.mission.slotGroup": "Slotgrupn erstöhn",
	"button.deactivate.user": "Account deaktiwian",
	"button.delete": "Entsoagn",
	"button.delete.account": "Account entsoagn",
	"button.delete.mission.slot.selection": "Ausgewöhte Slots entsoagn",
	"button.delete.user": "Benutza entsoagn",
	"button.deny": "Oblehna",
	"button.details": "Detöis",
	"button.duplicate.mission": "Mission duplizian",
	"button.duplicate.mission.slot": "Slot duplizian",
	"button.duplicate.mission.slotGroup": "Slotgrupn duplizian",
	"button.duplicate.mission.slotTemplate": "Duplicate slot template",
	"button.edit": "Beoabeitn",
	"button.edit.community.logo": "Edit logo",
	"button.edit.community.permissions": "Berechtigungen beoabeitn",
	"button.edit.mission.accesses": "Edit access",
	"button.edit.mission.bannerImage": "Banner-Büdl beoabeitn",
	"button.edit.mission.permissions": "Berechtigungen beoabeitn",
	"button.edit.mission.slot.selection": "Ausgewöhte Slots beoabeitn",
	"button.edit.mission.slotGroup": "Slotgrupn beoabeitn",
	"button.embed.mission": "Embed mission",
	"button.export.calendar.google": "Guugl",
	"button.export.calendar.ical": "iCal",
	"button.generate": "Generate",
	"button.join": "Join",
	"button.move.down": "Move down",
	"button.move.up": "Move up",
	"button.refresh": "Aktualisian",
	"button.refresh.authentication": "Authentifizierung aktualisian",
	"button.refresh.authentication.explanation": "Du kaunst de Authentifizierung aktualisian, damit sichagstöht is, dass dei Accaunt de richtign Berechtigungan, Community o.ä. hod.<br>Waunst in a Community aufgnumma woadn bist, muast des mochn, wei sunst wird de Community ned richtig auzagt und du kaunst kane Community-Missionen erstöhn.",
	"button.register": "Aumödn",
	"button.remove": "Entsoagn",
	"button.save": "Speichan",
	"button.save.mission.slotTemplate.slotlist": "Save template slotlist",
	"button.submit": "Oschickn",
	"button.unassign": "Zuaweisung löschn",
	"button.unassign.mission.slot.selection": "Unassign selected slots",
	"button.unregister": "Omödn",
	"button.upload": "Aufilodn",
	"calendar.month.current": "Heid",
	"calendar.month.next": "Nexta",
	"calendar.month.previous": "Voriga",
	"calendar.title": "Bevoastehade Missionen",
	"community.application.confirm.accept": "Bewerbung aunehma?",
	"community.application.confirm.deny": "Bewerbung olehna?",
	"community.application.nickname": "Nicknaume",
	"community.application.status": "Status",
	"community.applications": "Bewerbungen",
	"community.applications.filter": "Füta - abgearbeitete Bewerbungen werden standardmäßig ausgeblendet",
	"community.applications.filter.accepted": "augnumma",
	"community.applications.filter.denied": "oglehnt",
	"community.applications.filter.processed": "abgearbeitet",
	"community.confirm.delete": "Community entsoagn?",
	"community.creator.feedback.name": "Naum eigebn",
	"community.creator.feedback.slug": "Slug eigebn",
	"community.creator.feedback.slug.checking": "<em>Community-Slug Vafügboakeit wiad prüft...</em>",
	"community.creator.feedback.slug.notAvailable": "Community-Slug ned vafügboa",
	"community.creator.feedback.tag": "Tag eigebn",
	"community.creator.feedback.website": "Valide Website URL eigebn",
	"community.creator.title": "Neiche Community erstöhn",
	"community.creator.title.browser": "Community-Erstölla",
	"community.gameServers": "Community gameservers",
	"community.gameServers.description": "You can select a gameserver defined for your community to quickly fill out the gameserver details above. Please note that this overwrites any data entered by you before",
	"community.gameServers.hostname.description": "Hostname/IP address of the gameserver to add to the community's list",
	"community.gameServers.name.description": "Name of the gameserver (e.g. in a server list) to add to the community's list. Leave empty if not relevant",
	"community.gameServers.password.description": "Password for the gameserver to add to the community's list. Leave empty if no password is required",
	"community.gameServers.port.description": "Port of the gameserver to add to the community's list",
	"community.leader": "Chefkriega",
	"community.list.search": "Search communities",
	"community.list.search.description": "Start typing to search for a community with the given name, including partial matches. Clicking a community result will take you to its details page",
	"community.logo": "Logo",
	"community.logo.choose": "Choose file",
	"community.logo.description": "The logo is prominently displayed below the community name and above the community's information",
	"community.logo.feedback.fileType": "Invalid file type (only jpeg, png and gif are allowed)",
	"community.logo.feedback.size": "File too large (max. 2 MiB)",
	"community.logo.notSelected": "No logo selected",
	"community.member.confirm.remove": "Mitglied entsoagn?",
	"community.members": "Mitglieder",
	"community.modal.edit": "Communitydetails beoabeitn",
	"community.modal.logo": "Edit logo",
	"community.modal.permission": "Communityberechtigungan",
	"community.name": "Naume",
	"community.name.description": "Volla Naume vun da Community",
	"community.noChanges": "Es san koane Ändarungen aun de Communitydetails gmocht woadn",
	"community.permission.create": "Communityberechtigung erstöhn",
	"community.permission.existing": "Bestehende Missionsberechtigungen",
	"community.permission.founder": "Community-Gründa",
	"community.permission.leader": "Community-Leita",
	"community.permission.permission": "Berechtigungen de wos ma hergebn kaun",
	"community.permission.permission.description": "Wähle die an den Benutzer zu vergebende Berechtigung aus. <span class='font-weight-bold'>Community-Leiter</span> können die Communitydetails bearbeiten und Mitglieder aufnehmen und entfernen, aber können die Community nicht löschen oder Berechtigungen an andere vergeben. <span class='font-weight-bold'>Community-Recruiter</span> können nur Communitybewerbungen annehmen, aber keine Mitglieder entfernen oder Details bearbeiten.",
	"community.permission.recruitment": "Community-Recruiter",
	"community.permission.user.selection": "Suach an Benutza wegn de Berechtigungen",
	"community.permission.user.selection.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen",
	"community.repositories": "Community mod repositories",
	"community.repositories.description": "You can select a mod repository defined for your community to quickly fill out the repo details above. Please note that this overwrites any data entered by you before",
	"community.slug": "Slug",
	"community.slug.description": "Slug für die Community URL, muss einzigartig sein",
	"community.tag": "Tag",
	"community.tag.description": "Community-Tag, der wos füa olle Mitglieda auzagt weadn soi (ois Prefix voam Naumen)",
	"community.voiceComms": "Community voice comms",
	"community.voiceComms.description": "You can select a voice comms server defined for your community to quickly fill out the voice comms details above. Please note that this overwrites any data entered by you before",
	"community.voiceComms.hostname.description": "Hostname/IP address of the voice comms server to add to the community's list",
	"community.voiceComms.name.description": "Name of the voice comms server (e.g. in a server list) to add to the community's list. Leave empty if not relevant",
	"community.voiceComms.password.description": "Password for the voice comms server to add to the community's list. Leave empty if no password is required",
	"community.voiceComms.port.description": "Port of the voice comms server to add to the community's list",
	"community.website": "Website",
	"community.website.optional": "Website <em>(optional)</em>",
	"editor.explanation": "Für Editor-Erklärung hier klicken",
	"editor.explanation.1": "Textgröße",
	"editor.explanation.2": "Überschriften",
	"editor.explanation.3": "Textfarbe",
	"editor.explanation.4": "Fetter/kursiver Text",
	"editor.explanation.5": "Text-Ausrichtung, Text-Einrückung",
	"editor.explanation.6": "Numerierte & ungeordnete Listen",
	"editor.explanation.7": "Link, Bild oder Video einfügen",
	"editor.explanation.8": "Formatierung aufheben",
	"editor.explanation.missing": "Einige Editor-Bedienelemente können - abhängig von dem bearbeiteten Missionselement - deaktiviert sein oder fehlen",
	"failed.request": "Request fögschlogn",
	"failed.something": "Iagndwos is fögschlogn...",
	"misc.actions": "Aktionen",
	"misc.notProvided": "nicht angegeben",
	"misc.notRequired": "not required",
	"misc.notSpecified": "nicht angegeben",
	"mission": "Mission",
	"mission.abbr.estimated": "ca.",
	"mission.abbr.leadership": "Führung",
	"mission.access.add": "Add mission access",
	"mission.access.add.explanation": "Choose communities or users that should have access to your mission and can register for slots.<br>By default, only you and all mission editors can see this mission - you will have to explicitly grant access to any other community or user.<br>Granting access to a community allows all members of this community to view the mission. Granting access to a single user only allows this user to view the mission.",
	"mission.access.community.selection": "Search for community to grant access to",
	"mission.access.community.selection.description": "Start typing to search for a community with the given name or tag, including partial matches. You can only grant a permission to either a community or an user, but not both simultaneously",
	"mission.access.existing": "Existing mission access",
	"mission.access.list.name": "Name",
	"mission.access.list.type": "Access type",
	"mission.access.list.type.community": "Community",
	"mission.access.list.type.user": "User",
	"mission.access.user.selection": "Search for user to grant access to",
	"mission.access.user.selection.description": "Start typing to search for an user with the given nickname, including partial matches. You can only grant a permission to either an user or a community, but not both simultaneously",
	"mission.apply.slotTemplate.description": "Apply a slot template to a mission, adding all defined slot groups at the selected position.<br>You can filter slot templates and select the desired template to apply.",
	"mission.bannerImage": "Banner-Büdl",
	"mission.bannerImage.choose": "Datei wöhn",
	"mission.bannerImage.description": "Des Banner-Büdl wiad untam Missionsnaumen und übam Text auzoagt",
	"mission.bannerImage.feedback.fileType": "Ungültiger Dateityp (nur jpeg, png und gif sind erlaubt)",
	"mission.bannerImage.feedback.size": "Datei is zgroß (max. 2 MiB)",
	"mission.bannerImage.notSelected": "Ka Banner-Büdl ausgewöht",
	"mission.briefingTime": "Briefing-Zeit",
	"mission.briefingTime.description": "Datum und Uhrzeit, an dem das Führungsbriefing abgehalten wird",
	"mission.briefingTime.short": "Briefing",
	"mission.by": "von",
	"mission.collapsedDescription.description": "An optional, collapsed mission description can be used to provide even greater mission details and preparations to your players without having to scroll endlessly every time they want to check out the slotlist. This description is collapsed by default - only displaying a toggle button - and will be displayed after the mission's detailed description and before the slotlist",
	"mission.collapsedDescription.optional": "Collapsed mission description <em>(optional)</em>",
	"mission.collapsedDescription.toggle.close": "Collapse additional mission description",
	"mission.collapsedDescription.toggle.open": "Extend additional mission description",
	"mission.community": "Community",
	"mission.confirm.delete": "Mission löschen?",
	"mission.convert.slotTemplate.description": "You can convert the current slotlist of this mission to a slot template, allowing you to reuse the configured slot groups and slots for other missions. Slot templates do not include community restrictions or slot assignments. Converting a mission to a slot template does not modify or delete the mission's slotlist in any way.<br>Choose a title and a visibility setting for the converted slot template.",
	"mission.creator": "Erstölla",
	"mission.creator.addToCommunity": "Mission zur Community hinzufügen?",
	"mission.creator.addToCommunity.description": "Durch das Hinzufügen einer Mission zur deiner Community <strong>{communityInfo}</strong> wird diese auch in der Missionsliste der Community aufgeführt",
	"mission.creator.title": "Neiche Mission erstöhn",
	"mission.creator.title.browser": "Missions-Erstölla",
	"mission.description": "Beschreibung",
	"mission.description.description": "Beschreibung der Mission, gibt eine kurze Übersicht für die Missionsliste",
	"mission.detailedDescription": "Detaillierte Beschreibung",
	"mission.detailedDescription.description": "Detaillierte Beschreibung der Missions-Story, des Szenarios, Plots, der Aufgabe, etc. Alles, was Spieler wissen sollten, bevor sie sich entscheiden, mitzumachen",
	"mission.details": "Missionsdetails",
	"mission.duplicate.briefingTime.description": "Neue, optionale Briefing-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.description": "Wähle einen neuen Slug für die duplizierte Mission aus.<br>Der Titel, die Missionszeiten sowie die Sichtbarkeit und Community-Verknüpfung können überschrieben werden.<br>Alle weggelassenen Informationen werden mit den Daten der Originalmission ersetzt.",
	"mission.duplicate.endTime.description": "Neue, optionale Spielende-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.slottingTime.description": "Neue, optionale Slotting-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.slug.description": "Slug für die duplizierte Mission",
	"mission.duplicate.startTime.description": "Neue, optionale Spielbeginn-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.title.description": "Neuer, optionaler Titel, der für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.visibility.description": "Definiert die Sichtbarkeit der duplizierten Mission für andere Benutzer, erlaubt Zugang nur für die ausgewählte Gruppe",
	"mission.endTime": "Spielende",
	"mission.endTime.description": "Geschätztes Datum und Uhrzeit, zu dem die Mission enden wird",
	"mission.feedback.dateTime": "Valides Datum und Uhrzeit eingeben",
	"mission.feedback.dateTime.afterSlotting": "Spielbeginn-Zeit muss nach der Slotting-Zeit sein",
	"mission.feedback.dateTime.afterStart": "Spielende der Mission muss nach der Spielbeginn-Zeit sein",
	"mission.feedback.description": "Beschreibung eigebn",
	"mission.feedback.detailedDescription": "Detaillierte Beschreibung eigebn",
	"mission.feedback.orderNumber": "Sortier-Nummer eigebn",
	"mission.feedback.repository.kind": "Please select a repository type",
	"mission.feedback.repository.name": "Please provide a repository name",
	"mission.feedback.repository.url": "Please provide a valid URL",
	"mission.feedback.repository.url.arma3sync": "Please provide a repository URL for an ArmA3Sync repository",
	"mission.feedback.repository.urlOrNotes": "Please provide at least either a repository URL or notes",
	"mission.feedback.serverInfo.hostnamePort": "Both hostname and port must be provided",
	"mission.feedback.serverInfo.portRange": "Port values must be between 0 and 65535",
	"mission.feedback.slot.autoAssignable.mission": "All slots will be created as auto-assignable since the mission's auto-assignable setting is enabled",
	"mission.feedback.slug": "Slug eingeben",
	"mission.feedback.slug.checking": "<em>Missions-Slug Verfügbarkeit wird prüft...</em>",
	"mission.feedback.slug.notAvailable": "Missions-Slug ned vafügboa",
	"mission.feedback.title": "Missionstitel eigebn",
	"mission.feedback.title.slot": "Slottitel eigebn",
	"mission.feedback.title.slotGroup": "Slotgruppentitel eigebn",
	"mission.feedback.visibility": "Sichtbarkeits-Einstellung auswöhn",
	"mission.gameServer": "Gameserver",
	"mission.gameServer.hostname.description": "Hostname/IP address of the gameserver the mission will be held on",
	"mission.gameServer.hostname.optional": "Gameserver hostname/IP <em>(optional)</em>",
	"mission.gameServer.name.description": "Name of the gameserver (e.g. in a server list) the mission will be held on. Leave empty if not relevant",
	"mission.gameServer.name.optional": "Gameserver name <em>(optional)</em>",
	"mission.gameServer.password.description": "Password for the gameserver the mission will be held on. Leave empty if no password is required",
	"mission.gameServer.password.optional": "Gameserver password <em>(optional)</em>",
	"mission.gameServer.port.description": "Port of the gameserver the mission will be held on",
	"mission.gameServer.port.optional": "Gameserver port <em>(optional)</em>",
	"mission.list.creator": "Ersteller",
	"mission.list.description": "Beschreibung",
	"mission.list.filter": "Füta - vergangene Missionen werden standardmäßig ausgeblendet",
	"mission.list.filter.assigned": "Missionen mit zugewiesenen Slots",
	"mission.list.filter.ended": "Vergangene Missionen auzagn",
	"mission.list.filter.registered": "Missionen mit Slotanmödungen",
	"mission.list.isMissionEditor": "You have editor permissions for this mission",
	"mission.list.search": "Search missions",
	"mission.list.search.description": "Start typing to search for a mission with the given title, including partial matches. Clicking a mission result will take you to its details page",
	"mission.list.slot.counts": "Spülaanzahl",
	"mission.list.slot.counts.available": "Verfügbare Slots",
	"mission.list.slot.counts.available.popover": "<strong>{open}</strong> Slots sind für dich verfügbar",
	"mission.list.slot.counts.available.popover.community": "<strong>{open}</strong> Slots sind für dich und alle anderen Mitglieder deiner Community verfügbar",
	"mission.list.slot.counts.popover": "<strong>{unassigned}</strong> Slots haben Anmeldungen, die noch nicht bestätigt wurden. <strong>{assigned}</strong> Slots wurden zugewiesen, <strong>{external}</strong> Slots wurden externen Spielern zugewiesen.<br>Es gibt <strong>{blocked}</strong> blockierte, <strong>{restricted}</strong> reservierte und <strong>{reserve}</strong> Reserve-Slots.",
	"mission.list.slot.status": "Aumödung",
	"mission.list.slot.status.assigned": "Slotaumödung <span class='font-weight-bold text-success'>bestätigt</span>, zu Slot zuagwiesn",
	"mission.list.slot.status.registered": "Slotaumödung <span class='font-weight-bold text-danger'>ned bestätigt</span>, nu zu koam Slot zuagwiesn",
	"mission.list.startTime": "Spübeginn",
	"mission.list.title": "Titel",
	"mission.modal.access": "Mission access",
	"mission.modal.apply.slotTemplate": "Apply slot template to mission",
	"mission.modal.bannerImage": "Banner-Büdl beoabeitn",
	"mission.modal.convert.slotTemplate": "Convert mission to slot template",
	"mission.modal.duplicate": "Mission duplizian",
	"mission.modal.edit": "Mission beoabeitn",
	"mission.modal.embed": "Embed mission",
	"mission.modal.permission": "Missionsberechtigungen",
	"mission.modal.slot.assign": "Slot {slotInfo} am Benutzer zuaweisen",
	"mission.modal.slot.create": "Slot in Slotgruppn erstöhn",
	"mission.modal.slot.details": "Slot-Details",
	"mission.modal.slot.edit": "Slot beöabeitn",
	"mission.modal.slot.register": "Für Slot aumödn",
	"mission.modal.slot.register.text": "Aumödung ois {slotInfo} bestätign?",
	"mission.modal.slot.selection.edit": "Ausgewöhte Slots beoabeitn",
	"mission.modal.slotGroup.create": "Slotgruppe erstöhn",
	"mission.modal.slotGroup.edit": "Slotgruppn beoabeitn",
	"mission.permission.add": "Missionsberechtigung vagebn",
	"mission.permission.creator": "Missionsersteller",
	"mission.permission.editor": "Missionseditor",
	"mission.permission.existing": "Bestehende Missionsberechtigungen",
	"mission.permission.permission": "Zu vergebende Berechtigung",
	"mission.permission.permission.description": "Wähle die an den Benutzer zu vergebende Berechtigung aus. <span class='font-weight-bold'>Missionseditoren</span> können die Missionsdetails und Slotliste bearbeiten, aber können die Mission nicht löschen oder Berechtigungen an andere vergeben. Benutzer mit der <span class='font-weight-bold'>Community-Slotmanager</span> Berechtigung können Anmeldungen für Slots, die für ihre Community reserviert wurden, annehmen und entfernen, aber keine anderen Missionsdetails oder Slotanmeldungen ändern",
	"mission.permission.slotlist.community": "Community slot manager",
	"mission.permission.user.selection": "Suach noch Benutza für Berechtigung",
	"mission.permission.user.selection.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen",
	"mission.registration.comment": "Kommentar",
	"mission.registration.comment.description": "Optionaler Kommentar an den Missionsersteller (max. 128 Zeichen)",
	"mission.registration.comment.optional": "Kommentar <em>(optional)</em>",
	"mission.registration.confirmed": "Bestätigt",
	"mission.registration.registered": "Augmödt",
	"mission.repository.kind": "Type",
	"mission.repository.kind.arma3sync": "ArmA3Sync",
	"mission.repository.kind.description": "Defined the type of mod repository. Clicking an <code>ArmA3Sync</code> repository link automatically copies it to clipboard",
	"mission.repository.kind.other": "Other",
	"mission.repository.list": "Mod repositories",
	"mission.repository.list.empty": "No mod repositories required",
	"mission.repository.name": "Name",
	"mission.repository.name.description": "Name of the mod repository, mostly useful for searching in repo lists",
	"mission.repository.name.optional": "Name <em>(optional)</em>",
	"mission.repository.name.required": "Name",
	"mission.repository.notes": "Notes",
	"mission.repository.notes.description": "Optional notes about a repository, e.g. explaining the usage or required files. Required if no URL is provided",
	"mission.repository.notes.optional": "Notes <em>(optional)</em>",
	"mission.repository.url": "URL",
	"mission.repository.url.description": "URL of the mod repository. Required for <code>ArmA3Sync</code> repos, optional for others",
	"mission.repository.url.empty": "no repo URL provided",
	"mission.repository.url.optional": "URL <em>(optional)</em>",
	"mission.repositoryUrl": "Repository URL",
	"mission.repositoryUrl.description": "Kann entweder leer sein (falls nicht benötigt), ein einzelner Link zum Repository oder mehrere Links, inklusive eigener HTML-Formatierung",
	"mission.repositoryUrl.optional": "Repository URL <em>(optional)</em>",
	"mission.requiredDLCs": "Benötigte DLCs",
	"mission.requiredDLCs.aow": "Art of War",
	"mission.requiredDLCs.apex": "Apex",
	"mission.requiredDLCs.contact": "Contact",
	"mission.requiredDLCs.csla": "CSLA Iron Curtain",
	"mission.requiredDLCs.gm": "Global Mobilization",
	"mission.requiredDLCs.helicopters": "Helicopters",
	"mission.requiredDLCs.jets": "Jets",
	"mission.requiredDLCs.karts": "Karts",
	"mission.requiredDLCs.laws-of-war": "Laws of War",
	"mission.requiredDLCs.marksmen": "Marksmen",
	"mission.requiredDLCs.none": "keine DLCs benötigt",
	"mission.requiredDLCs.tac-ops": "Tac-Ops",
	"mission.requiredDLCs.tanks": "Tanks",
	"mission.requiredDLCs.vn": "S.O.G. Prairie Fire",
	"mission.rules": "Regeln",
	"mission.rules.description": "Allgemeine Regeln und Richtlichen für Spieler während der Teilnahme - missionsspezifische Einschränkungen sollten als detaillierte Beschreibung hinzugefügt werden",
	"mission.rules.optional": "Regeln <em>(optional)</em>",
	"mission.serverInfo.hostname": "Hostname/IP",
	"mission.serverInfo.name": "Server name",
	"mission.serverInfo.password": "Password",
	"mission.serverInfo.port": "Port",
	"mission.slot.assign.force": "Slotzuaweisung erzwinga",
	"mission.slot.assign.force.description": "Durch das Erzwingen einer Slotzuweisung wird der ausgewählte Benutzer von seinem Slot entfernt, falls er bereits zugewiesen ist - außerdem wird der Benutzer, der aktuell auf den gewählten Slot zugewiesen ist, entfernt",
	"mission.slot.assign.selection": "Suach noch Benutza für Zuaweisung",
	"mission.slot.assign.selection.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen",
	"mission.slot.assignee.registration": "keine Anmeldungen | Anmeldung | Anmeldungen",
	"mission.slot.autoAssignable.description": "Auto-assignable slots do not require a registration-confirmation by a mission editor, but will automatically be assigned to the first user that register for it",
	"mission.slot.autoAssignable.slot": "Auto-assignable slot",
	"mission.slot.blocked": "geht ned - koane Aumödungen meglich",
	"mission.slot.blocked.description": "Blockierte Slots stengan ned fia Aunmödungen zua Vafügung",
	"mission.slot.blocked.popover": "Blockiad - der Slot is vum Missionserstölla blockiad, drum kennts eich do ned aumödn",
	"mission.slot.blocked.slot": "Blockierter Slot",
	"mission.slot.confirm.delete": "Slot löschn?",
	"mission.slot.confirm.delete.selection": "Ausgewöhte Slots entsoagn?",
	"mission.slot.confirm.unassign.selection": "Unassign selected slots?",
	"mission.slot.confirm.unregister": "Vom Slot amödn?",
	"mission.slot.description": "Beschreibung",
	"mission.slot.description.description": "Optionale, kurze Beschreibung des Slots, um z.B. das benutzte Equipment oder Fahrzeug zu beschreiben - wird in der Slotliste angezeigt",
	"mission.slot.description.optional": "Beschreibung <em>(optional)</em>",
	"mission.slot.detailedDescription": "Detaillierte Beschreibung",
	"mission.slot.detailedDescription.description": "Optionale, detailliertere Beschreibung des Slots, gibt mehr Informationen über die zugewiesenen Verantwortungen oder Aufgaben - wird in den Slot-Details angezeigt",
	"mission.slot.detailedDescription.optional": "Detaillierte Beschreibung <em>(optional)</em>",
	"mission.slot.difficulty": "Wie zach wirds weadn",
	"mission.slot.difficulty.advanced": "do kumman ned olle zruck",
	"mission.slot.difficulty.beginner": "geht mit lauta Neiche",
	"mission.slot.difficulty.description": "Schwierigkeit des Slots, als Hilfe für die Slotwahl für Spieler",
	"mission.slot.difficulty.easy": "wiad scho weadn",
	"mission.slot.difficulty.expert": "wiad scheiß zach",
	"mission.slot.difficulty.medium": "passt scho",
	"mission.slot.externalAssignee.description": "Du kannst eine externe Spieler-Zuweisung vornehmen, um einen Slot einem Spieler zuzuweisen, der kein Nutzer unserer Webseite ist. Ein Slot kann nur entweder einem Benutzer zugewiesen werden <em>oder</em> an einen externen Spieler vergeben werden",
	"mission.slot.externalAssignee.optional": "Externe Spieler-Zuweisung <em>(optional)</em>",
	"mission.slot.insertAfter": "Neichn Slot eifügn noch",
	"mission.slot.insertAfter.description": "Wo soi der neiche Slot in da Listn hi?",
	"mission.slot.insertAfter.top": "Aufaung vun da Listn",
	"mission.slot.move": "Slot vaschiabn",
	"mission.slot.move.description": "Slot aun a neiche Position vaschiabn",
	"mission.slot.moveAfter": "Slot auzagn noch",
	"mission.slot.moveAfter.description": "Position auswöhn, noch der da Slot augzagt weadn soi",
	"mission.slot.moveAfter.keep": "Aktuelle Position beibehoidn",
	"mission.slot.orderNumber": "Sortier-Numma",
	"mission.slot.orderNumber.description": "Wird für die Sortierung des Slots in der Missions-Slotliste verwendet",
	"mission.slot.player": "Spüla",
	"mission.slot.registrations": "Aumödungen",
	"mission.slot.reserve": "da Rest",
	"mission.slot.reserve.description": "Reserve-Slots werden nur gefüllt, wenn alle anderen Slots davor vergeben wurden",
	"mission.slot.reserve.popover": "Reserve - nur vergeben, wenn alle anderen Slots belegt wurden",
	"mission.slot.reserve.regular": "normal",
	"mission.slot.reserve.slot": "Reserve-Slot",
	"mission.slot.restricted": "reserviert für {communityInfo}",
	"mission.slot.restricted.description": "Reservierte Slots sind nicht für alle, sondern nur für Spieler der ausgewählten Community verfügbar",
	"mission.slot.restricted.popover": "Reserviert - nur für <strong>{communityInfo}</strong> Mitglieder verfügbar",
	"mission.slot.restricted.selection": "Suche nach Community für Slot-Reservierung",
	"mission.slot.restricted.selection.description": "Suche nach einer Community mit dem angegebenen Namen oder Tag, inklusive Teil-Übereinstimmungen",
	"mission.slot.restricted.slot": "Resawierda Slot",
	"mission.slot.restricted.unrestricted": "frei vafügboa",
	"mission.slot.role": "Roin",
	"mission.slot.selection.actions": "Aktionen für 1 ausgewöhten Slot ausführen | Aktionen für {count} ausgewöhte Slots ausführen",
	"mission.slot.selection.edit": "Erlaubt das Bearbeiten bestimmter Werte von 1 ausgewähltem Slot.<br>Ausgelassene Informationen werden nicht verändert, dadurch kannst du nur die gewünschten Werte verändern und den Rest leer/unausgewählt lassen. Leider können die Slot-Status <code>reserviert</code>, <code>Reserve</code> und <code>blockiert</code> nur für einen Slot auf einmal entfernt werden.<br>Der folgende Slot ist betroffen: | Erlaubt das Bearbeiten bestimmter Werte von {count} ausgewählten Slots.<br>Ausgelassene Informationen werden nicht verändert, dadurch kannst du nur die gewünschten Werte verändern und den Rest leer/unausgewählt lassen. Leider können die Slot-Status <code>reserviert</code>, <code>Reserve</code> und <code>blockiert</code> nur für einen Slot auf einmal entfernt werden.<br>Die folgenden Slots sind betroffen: ",
	"mission.slot.selection.hint": "Wähle mehrere Slots gleichzeitig aus, indem du sie anklickst, während du <kbd>STRG</kbd> gedrückt hältst",
	"mission.slot.status": "Status",
	"mission.slot.title": "Titel",
	"mission.slot.title.description": "Titel des Slots, wie er in der Slotlist angezeigt wird",
	"mission.slotGroup.confirm.delete": "Slotgruppn löschn?",
	"mission.slotGroup.description": "Beschreibung",
	"mission.slotGroup.description.description": "Optionale, kurze Beschreibung der Slotgruppe, um z.B. den allgemeinen Auftrag der Gruppe oder deren Rufzeichen zu beschreiben - wird in der Slotlist angezeigt",
	"mission.slotGroup.description.optional": "Description <em>(optional)</em>",
	"mission.slotGroup.insertAfter": "Neiche Slotgruppn eifügn noch",
	"mission.slotGroup.insertAfter.description": "Position auswöhn, wo da neiche Slot einikumma soi",
	"mission.slotGroup.insertAfter.top": "Aufaung vun da Listn",
	"mission.slotGroup.move": "Slotgruppn vaschiabn",
	"mission.slotGroup.move.description": "Slotgruppn aun a neiche Position vaschiabn",
	"mission.slotGroup.moveAfter": "Slotgruppn auzagn noch",
	"mission.slotGroup.moveAfter.description": "Position auswählen, nach welcher die Slotgruppe angezeigt werden soll",
	"mission.slotGroup.moveAfter.keep": "Position soi so bleibn",
	"mission.slotGroup.orderNumber": "Sortier-Nummer",
	"mission.slotGroup.orderNumber.description": "Wird für die Sortierung der Slotgruppe in der Missions-Slotlist verwendet",
	"mission.slotGroup.title": "Titel",
	"mission.slotGroup.title.description": "Titel der Slotgruppe, wie er in der Slotlist angezeigt wird",
	"mission.slotlist": "Slotlistn",
	"mission.slotlist.filter": "Füta",
	"mission.slotlist.filter.assigned": "belegt",
	"mission.slotlist.filter.blocked": "blockiert",
	"mission.slotlist.filter.hasRegistrations": "nu ned zuagwiesn",
	"mission.slotlist.filter.open": "offn",
	"mission.slotlist.filter.restricted": "resawiert",
	"mission.slotsAutoAssignable": "Auto-assignable slots",
	"mission.slotsAutoAssignable.description": "Auto-assignable slots do not require a registration-confirmation by a mission editor, but will automatically be assigned to the first user that register for it. By enabling this setting, all slots created <strong>from this point on</strong> will be set to be auto-assignable - existing slots will not be affected",
	"mission.slotTemplate": "Slot template",
	"mission.slotTemplate.confirm.delete": "Delete slot template?",
	"mission.slotTemplate.confirm.save.slotlist": "Save template slotlist?",
	"mission.slotTemplate.confirm.unsavedChanges": "Do you really want to leave? Your unsaved template slotlist changes will be lost!",
	"mission.slotTemplate.creator.title": "Create new slot template",
	"mission.slotTemplate.creator.title.browser": "Slot template creator",
	"mission.slotTemplate.duplicate.description": "You can overwrite the slot template's title as well as visibility setting.<br>All data omitted will be replaced by the original slot templates's values.",
	"mission.slotTemplate.duplicate.title.description": "New, optional title to overwrite for duplicated slot template - can be omitted",
	"mission.slotTemplate.duplicate.visibility.description": "Defines visibility of duplicated slot template to other users, only allowing access to selected group",
	"mission.slotTemplate.feedback.title": "Please enter a slot template title",
	"mission.slotTemplate.feedback.visibility": "Please select a visibility setting",
	"mission.slotTemplate.filter": "Slot template filter",
	"mission.slotTemplate.filter.description": "Filter slot templates by title or creator name, including partial matches",
	"mission.slotTemplate.insertAfter": "Apply slot template after",
	"mission.slotTemplate.insertAfter.description": "Select the position after which the slot template should be applied",
	"mission.slotTemplate.list.counts.slots": "# of slots",
	"mission.slotTemplate.list.counts.slots.groups": "# of slot groups",
	"mission.slotTemplate.modal.duplicate": "Duplicate slot template",
	"mission.slotTemplate.modal.edit": "Edit slot template",
	"mission.slotTemplate.slotlist": "Template slotlist",
	"mission.slotTemplate.title.description": "Title of the slot template, displayed in slot template list and details",
	"mission.slotTemplate.visibility.community": "community members",
	"mission.slotTemplate.visibility.default": "unknown",
	"mission.slotTemplate.visibility.description": "Defines visibility of the slot template to other users, only allowing access to the selected group",
	"mission.slotTemplate.visibility.hidden": "template creator only",
	"mission.slotTemplate.visibility.private": "selected communities and users",
	"mission.slotTemplate.visibility.public": "everyone",
	"mission.slottingTime": "Slotting-Zeit",
	"mission.slottingTime.description": "Datum und Uhrzeit, zu dem das Slotting in der Mission beginnt",
	"mission.slug": "Slug",
	"mission.slug.description": "Slug für die Missions URL, muss einzigartig sein",
	"mission.startTime": "Spielbeginn",
	"mission.startTime.description": "Datum und Uhrzeit, an dem die Mission beginnt",
	"mission.techSupport": "Techsupport",
	"mission.techSupport.description": "Optionale Informationen über Techsupport oder -checks, die vor der Mission angeboten werden",
	"mission.techSupport.optional": "Techsupport <em>(optional)</em>",
	"mission.times": "Slotting time: {slotting}\nStart time: {start}\nEnd time (est.): {end}\nBriefing (ldrsp.): {briefing}",
	"mission.times.ical": "Slotting time: {slotting}\\nStart time: {start}\\nEnd time (est.): {end}\\nBriefing (ldrsp.): {briefing}",
	"mission.timezone": "Alle Missionszeiten werden in der <em>{timezone}</em> Zeitzone angezeigt",
	"mission.title": "Titel",
	"mission.title.description": "Titel der Mission, wird in Missionsliste und -details angezeigt",
	"mission.token": "Mission token",
	"mission.token.description": "Mission tokens can be used as an alternative, static authentication method for embedding missions into different websites or forums. By default, all public missions can be embedded without extra configuration, however missions that do not have a public visibility setting require a mission token for embedding.<br>On the contrary to regular user authentication, mission tokens do not expire and only grant access to this specific mission. The information returned is identical to what a regular user would receive - no mission editor or creator specific data is provided.<br>By clicking the <strong>Generate</strong> button, you can generate a new mission token. Please note that this invalidates any previous tokens.<br>Using the <strong>Delete</strong> button, you can completely remove all mission tokens and thus remove all options to embed a non-public mission.",
	"mission.token.notGeneratedYet": "not generated yet",
	"mission.visibility": "Sichtboakeit",
	"mission.visibility.community": "Community-Mitglieda",
	"mission.visibility.default": "unbekaunt",
	"mission.visibility.description": "Definiert die Sichtbarkeit der Mission für andere Benutzer, erlaubt Zugang nur für die ausgewählte Gruppe",
	"mission.visibility.hidden": "nua füa Missionserstölla und -editor",
	"mission.visibility.private": "ausgewöhde Communities und Benutza",
	"mission.visibility.public": "für alle sichtbar",
	"mission.voiceComms": "Voice Comms",
	"mission.voiceComms.hostname.description": "Hostname/IP address of the voice comms server used for the mission",
	"mission.voiceComms.hostname.optional": "Voice comms hostname/IP <em>(optional)</em>",
	"mission.voiceComms.name.description": "Name of the voice comms server (e.g. in a server list) the mission will be held on. Leave empty if not relevant",
	"mission.voiceComms.name.optional": "Voice comms name <em>(optional)</em>",
	"mission.voiceComms.password.description": "Password for the voice comms server used for the mission. Leave empty if no password is required",
	"mission.voiceComms.password.optional": "Voice comms password <em>(optional)</em>",
	"mission.voiceComms.port.description": "Port of the voice comms server used for the mission",
	"mission.voiceComms.port.optional": "Voice comms port <em>(optional)</em>",
	"nav.about": "Über",
	"nav.account": "Account",
	"nav.admin.panel": "Admin Panel",
	"nav.api": "API",
	"nav.communities": "Communities",
	"nav.home": "Start",
	"nav.imprint": "Impressum",
	"nav.login": "Eiloggn",
	"nav.logout": "Ausloggn",
	"nav.missions": "Missionen",
	"nav.missionSlotTemplates": "Slot templates",
	"nav.notifications": "Notifications",
	"nav.privacy": "Privacy",
	"nav.users": "Users",
	"notification.list.filter": "Filter",
	"notification.list.filter.seen": "Include seen notifications",
	"notification.notification": "Notification",
	"notification.received": "Received",
	"notification.seen": "Seen",
	"notification.suppress": "Suppress notifications",
	"notification.suppress.description": "By suppressing notifications, you can prevent spamming your users due to multiple, subsequent or minor updates. If this checkbox is ticked, no notification will be created for the action performed. Please note that \"destructive\" actions such as slot unassignments, permission removal or mission deletion cannot have their notifications suppressed",
	"notification.type.community.application.accepted": "Your application to the community <strong>{communityName}</strong> has been <span class='text-success font-weight-bold'>accepted</span>",
	"notification.type.community.application.deleted": "<strong>{userNickname}</strong> has <span class='text-danger font-weight-bold'>deleted</span> their application to your community <strong>{communityName}</strong>",
	"notification.type.community.application.denied": "Your application to the community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>denied</span>",
	"notification.type.community.application.new": "<strong>{userNickname}</strong> has <span class='text-success font-weight-bold'>applied</span> to your community <strong>{communityName}</strong>",
	"notification.type.community.application.removed": "You have been <span class='text-danger font-weight-bold'>removed</span> from your community <strong>{communityName}</strong> by a community recruiter",
	"notification.type.community.deleted": "Your community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>deleted</span> by its founder",
	"notification.type.community.permission.granted": "You have been <span class='text-success font-weight-bold'>granted</span> the <strong>{translatedPermission}</strong> permission for your community <strong>{communityName}</strong>",
	"notification.type.community.permission.revoked": "Your <strong>{translatedPermission}</strong> permission for your community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>revoked</span>",
	"notification.type.mission.deleted": "The mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>deleted</span> by its creator",
	"notification.type.mission.permission.granted": "You have been <span class='text-success font-weight-bold'>granted</span> the <strong>{translatedPermission}</strong> permission for the mission <strong>{missionTitle}</strong>",
	"notification.type.mission.permission.revoked": "Your <strong>{translatedPermission}</strong> permission for the mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>revoked</span>",
	"notification.type.mission.slot.assigned": "You have been <span class='text-success font-weight-bold'>assigned</span> as <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong>",
	"notification.type.mission.slot.registration.new": "<strong>{userNicknameWithTag}</strong> has <span class='text-success font-weight-bold'>registered</span> for slot <strong>{slotTitle}</strong> for the mission <strong>{missionTitle}</strong>",
	"notification.type.mission.slot.unassigned": "Your assignment as <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>removed</span>",
	"notification.type.mission.slot.unregistered": "<strong>{userNicknameWithTag}</strong> has <span class='text-danger font-weight-bold'>unregistered</span> from their slot <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong>",
	"notification.type.mission.updated": "Mission <strong>{missionTitle}</strong> was updated by a mission editor",
	"rights.reserved": "Alle Rechte vorbehalten",
	"store.addMissionAccess": "Adding mission access...",
	"store.addMissionAccess.error": "Failed to add mission access",
	"store.addMissionAccess.success": "Successfully added mission access",
	"store.addMissionPermission": "Missionsberechtigung wird hinzugefügt...",
	"store.addMissionPermission.error": "Hinzufügen der Missionsberechtigung ist fehlgeschlagen",
	"store.addMissionPermission.success": "Missionsberechtigung wurde erfolgreich hinzugefügt",
	"store.applySlotTemplateToMission": "Applying slot template to mission...",
	"store.applySlotTemplateToMission.error": "Failed to apply slot template to mission",
	"store.applySlotTemplateToMission.success": "Successfully applied slot template to mission",
	"store.applyToCommunity": "Community-Bewerbung wird obgschickt...",
	"store.applyToCommunity.error": "Iagndwos past beim obschickn vun da Community-Beweabung ned",
	"store.applyToCommunity.success": "Community-Bewerbung wurde erfolgreich abgeschickt",
	"store.assignMissionSlot": "Slot wird zugwiesn...",
	"store.assignMissionSlot.error": "Iagndwos passt beim Slotzuaweisn ned",
	"store.assignMissionSlot.success": "Slotzuaweisung hod funktioniat",
	"store.checkCommunitySlugAvailability.error": "Überprüfung der Community-Slug Verfügbarkeit ist fehlgeschlagen",
	"store.checkMissionSlugAvailability.error": "Überprüfung der Missions-Slug Verfügbarkeit für <strong>{payload}</strong> ist fehlgeschlagen",
	"store.createCommunity": "Community wird erstellt...",
	"store.createCommunity.error": "Community-Erstellung ist fehlgeschlagen",
	"store.createCommunity.success": "Community wurde erfolgreich erstellt",
	"store.createCommunityPermission": "Communityberechtigung wird erstellt...",
	"store.createCommunityPermission.error": "Erstellung der Communityberechtigung ist fehlgeschlagen",
	"store.createCommunityPermission.success": "Communityberechtigung wurde erfolgreich erstellt",
	"store.createMission": "Mission wird erstellt...",
	"store.createMission.error": "Erstellung der Mission <strong>{title}</strong> ist fehlgeschlagen",
	"store.createMission.success": "Mission <strong>{title}</strong> wurde erfolgreich erstellt",
	"store.createMissionSlot": "Slot wird erstellt... | {count} Slots werden erstellt...",
	"store.createMissionSlot.error": "Erstellung des Slots ist fehlgeschlagen | Erstellung von {count} Slots ist fehlgeschlagen",
	"store.createMissionSlot.success": "Slot wurde erfolgreich erstellt | {count} Slots wurden erfolgreich erstellt",
	"store.createMissionSlotGroup": "Slotgruppn wiad erstöht...",
	"store.createMissionSlotGroup.error": "Erstöllung vun da Slotgruppn <strong>{slotGroupInfo}</strong> hod ned funktioniat",
	"store.createMissionSlotGroup.success": "Slotgrouppe <strong>{slotGroupInfo}</strong> wurde erfolgreich erstellt",
	"store.createMissionSlotTemplate": "Creating slot template...",
	"store.createMissionSlotTemplate.error": "Failed to create slot template <strong>{title}</strong>",
	"store.createMissionSlotTemplate.success": "Successfully created slot template <strong>{title}</strong>",
	"store.deleteAccount": "Account wird gelöscht...",
	"store.deleteAccount.error": "Löschen des Accounts ist fehlgeschlagen",
	"store.deleteAccount.success": "Account wurde erfolgreich gelöscht",
	"store.deleteCommunity": "Community wird gelöscht...",
	"store.deleteCommunity.error": "Löschen der Community ist fehlgeschlagen",
	"store.deleteCommunity.success": "Community wurde erfolgreich gelöscht",
	"store.deleteCommunityLogo": "Deleting logo...",
	"store.deleteCommunityLogo.error": "Failed to delete logo",
	"store.deleteCommunityLogo.success": "Successfully deleted logo",
	"store.deleteCommunityPermission": "Communityberechtigung wird gelöscht...",
	"store.deleteCommunityPermission.error": "Löschen der Communityberechtigung ist fehlgeschlagen",
	"store.deleteCommunityPermission.success": "Communityberechtigung wurde erfolgreich gelöscht",
	"store.deleteMission": "Mission wiad glöscht...",
	"store.deleteMission.error": "Löschen der Mission <strong>{title}</strong> ist fehlgeschlagen",
	"store.deleteMission.success": "Mission <strong>{title}</strong> wurde erfolgreich gelöscht",
	"store.deleteMissionAccess": "Deleting mission access...",
	"store.deleteMissionAccess.error": "Failed to delete mission access",
	"store.deleteMissionAccess.success": "Successfully deleted mission access",
	"store.deleteMissionBannerImage": "Banner-Bild wiad glöscht...",
	"store.deleteMissionBannerImage.error": "Löschen des Banner-Bildes ist fehlgeschlagen",
	"store.deleteMissionBannerImage.success": "Banner-Bild wurde erfolgreich gelöscht",
	"store.deleteMissionPermission": "Missionsberechtigung wiad glöscht...",
	"store.deleteMissionPermission.error": "Löschen der Missionsberechtigung ist fehlgeschlagen",
	"store.deleteMissionPermission.success": "Missionsberechtigung wurde erfolgreich gelöscht",
	"store.deleteMissionSlot": "Slot wiad glöscht...",
	"store.deleteMissionSlot.error": "Löschen des Slots <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.deleteMissionSlot.success": "Slot <strong>{slotInfo}</strong> wurde erfolgreich gelöscht",
	"store.deleteMissionSlotGroup": "Slotgruppe wird gelöscht...",
	"store.deleteMissionSlotGroup.error": "Löschen der Slotgruppe <strong>{title}</strong> ist fehlgeschlagen",
	"store.deleteMissionSlotGroup.success": "Slotgruppe <strong>{title}</strong> wurde erfolgreich gelöscht",
	"store.deleteMissionSlotRegistration": "Slotanmeldung wird gelöscht...",
	"store.deleteMissionSlotRegistration.error": "Löschen der Slotanmeldung ist fehlgeschlagen",
	"store.deleteMissionSlotRegistration.success": "Slotanmeldung wurde erfolgreich gelöscht",
	"store.deleteMissionSlotTemplate": "Deleting slot template...",
	"store.deleteMissionSlotTemplate.error": "Failed to delete slot template <strong>{title}</strong>",
	"store.deleteMissionSlotTemplate.success": "Successfully deleted slot template <strong>{title}</strong>",
	"store.deleteMissionToken": "Deleting mission token...",
	"store.deleteMissionToken.error": "Failed to delete mission token",
	"store.deleteMissionToken.success": "Successfully deleted mission token",
	"store.deleteSelectedMissionSlots": "1 Slot wird gelöscht... | {count} Slots werden gelöscht...",
	"store.deleteSelectedMissionSlots.error": "Löschen von einem oder mehreren Slots ist fehlgeschlagen",
	"store.deleteSelectedMissionSlots.success": "1 Slot wurde erfolgreich gelöscht | {count} Slots wurden erfolgreich gelöscht",
	"store.deleteUser": "Benutzer wird gelöscht...",
	"store.deleteUser.error": "Löschen des Benutzers ist fehlgeschlagen",
	"store.deleteUser.success": "Benutza is glöscht woadn",
	"store.duplicateMission": "Mission wird dupliziert...",
	"store.duplicateMission.error": "Duplizierung der Mission ist fehlgeschlagen",
	"store.duplicateMission.success": "Mission wurde erfolgreich dupliziert",
	"store.duplicateMissionSlotGroup": "Slotgruppe wird dupliziert...",
	"store.duplicateMissionSlotGroup.error": "Duplizierung der Slotgruppe <strong>{slotGroupInfo}</strong> ist fehlgeschlagen",
	"store.duplicateMissionSlotGroup.success": "Slotgrouppe <strong>{slotGroupInfo}</strong> wurde erfolgreich dupliziert",
	"store.editAccount": "Accountdetails weadn aktualisiat...",
	"store.editAccount.error": "Aktualisiarung vun de Accountdetails hod ned hinghaut",
	"store.editAccount.success": "Accountdetails san aktualisiert woadn",
	"store.editCommunity": "Communitydetails weadn aktualisiat...",
	"store.editCommunity.error": "Aktualisierung der Communitydetails ist fehlgeschlagen",
	"store.editCommunity.success": "Communitydetails wurden erfolgreich aktualisiert",
	"store.editMission": "Mission wird bearbeitet...",
	"store.editMission.error": "Bearbeitung der Mission <strong>{title}</strong> ist fehlgeschlagen",
	"store.editMission.success": "Mission <strong>{title}</strong> wurde erfolgreich bearbeitet",
	"store.editMissionSlot": "Slot wird bearbeitet...",
	"store.editMissionSlot.error": "Bearbeitung des Slots <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.editMissionSlot.success": "Slot <strong>{slotInfo}</strong> wurde erfolgreich bearbeitet",
	"store.editMissionSlotGroup": "Slotgruppe wird bearbeitet...",
	"store.editMissionSlotGroup.error": "Bearbeitung der Slotgruppe ist fehlgeschlagen",
	"store.editMissionSlotGroup.success": "Slotgruppe wurde erfolgreich bearbeitet",
	"store.editMissionSlotTemplate": "Editing slot template...",
	"store.editMissionSlotTemplate.error": "Failed to edit slot template <strong>{title}</strong>",
	"store.editMissionSlotTemplate.success": "Successfully edited slot template <strong>{title}</strong>",
	"store.editSelectedMissionSlots": "1 Slot wird bearbeitet... | {count} Slots werden bearbeitet...",
	"store.editSelectedMissionSlots.error": "Bearbeiten von einem oder mehreren Slots ist fehlgeschlagen",
	"store.editSelectedMissionSlots.success": "1 Slot wurde erfolgreich bearbeitet | {count} Slots wurden erfolgreich bearbeitet",
	"store.editUser": "Userdetails werden aktualisiert...",
	"store.editUser.error": "Aktualisierung der Userdetails ist fehlgeschlagen",
	"store.editUser.success": "Userdetails wurden erfolgreich aktualisiert",
	"store.generateMissionToken": "Generating mission token...",
	"store.generateMissionToken.error": "Failed to generate mission token",
	"store.generateMissionToken.success": "Successfully generated mission token",
	"store.getAccountDetails": "Accountdetails werden geladen...",
	"store.getAccountDetails.error": "Laden der Accountdetails ist fehlgeschlagen",
	"store.getCommunities": "Communities werden geladen...",
	"store.getCommunities.error": "Laden der Communities ist fehlgeschlagen",
	"store.getCommunityApplications": "Community-Bewerbungen werden geladen...",
	"store.getCommunityApplications.error": "Laden der Community-Bewerbungen ist fehlgeschlagen",
	"store.getCommunityApplicationStatus": "Status der Community-Bewerbung wird geladen...",
	"store.getCommunityApplicationStatus.error": "Laden des Status der Community-Bewerbung ist fehlgeschlagen",
	"store.getCommunityDetails": "Communitydetails werden geladen...",
	"store.getCommunityDetails.error": "Laden der Communitydetails ist fehlgeschlagen",
	"store.getCommunityDetails.error.notFound": "Eine Community mit dem Slug <strong>{slug}</strong> wurde nicht gefunden",
	"store.getCommunityMissions": "Community-Missionen werden geladen...",
	"store.getCommunityMissions.error": "Laden der Community-Missionen ist fehlgeschlagen",
	"store.getCommunityPermissions": "Communityberechtigungen werden geladen...",
	"store.getCommunityPermissions.error": "Laden der Communityberechtigungen ist fehlgeschlagen",
	"store.getCommunityRepositories": "Loading community mod repositories...",
	"store.getCommunityRepositories.error": "Failed to load community mod repositories",
	"store.getCommunityServers": "Loading community servers...",
	"store.getCommunityServers.error": "Failed to load community servers",
	"store.getLoginRedirectUrl.error": "Steam SSO URL konnte nicht geladen werden",
	"store.getMissionAccesses": "Loading mission access...",
	"store.getMissionAccesses.error": "Failed to load mission access",
	"store.getMissionDetails": "Missionsdetails werden geladen...",
	"store.getMissionDetails.error": "Laden der Missionsdetails ist fehlgeschlagen",
	"store.getMissionDetails.error.notFound": "Eine Mission mit dem Slug <strong>{slug}</strong> wurde nicht gefunden oder ist nicht sichtbar",
	"store.getMissionPermissions": "Missionsberechtigungen werden geladen...",
	"store.getMissionPermissions.error": "Laden der Missionsberechtigungen ist fehlgeschlagen",
	"store.getMissions": "Missionen werden geladen...",
	"store.getMissions.error": "Laden der Missionen ist fehlgeschlagen",
	"store.getMissionsForCalendar.error": "Laden der Missionen für den Kalender ist fehlgeschlagen",
	"store.getMissionSlotlist": "Missions-Slotliste wird geladen...",
	"store.getMissionSlotlist.error": "Laden der Missions-Slotliste ist fehlgeschlagen",
	"store.getMissionSlotRegistrations": "Slot-Anmeldungen werden geladen...",
	"store.getMissionSlotRegistrations.error": "Laden der Anmeldungen für Slot <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.getMissionSlotTemplateDetails": "Loading slot template details...",
	"store.getMissionSlotTemplateDetails.error": "Failed to load slot template details...",
	"store.getMissionSlotTemplates": "Loading slot templates...",
	"store.getMissionSlotTemplates.error": "Failed to load slot templates",
	"store.getMissionToken": "Loading mission token...",
	"store.getMissionToken.error": "Failed to load mission token",
	"store.getNotifications": "Loading notifications...",
	"store.getNotifications.error": "Failed to load notifications",
	"store.getUnseenNotificationCount.error": "Failed to load unseen notification count",
	"store.getUserDetails": "Benutzerdetails werden geladen...",
	"store.getUserDetails.error": "Laden der Benutzerdetails ist fehlgeschlagen",
	"store.getUserMissions": "Benutzer-Missionen werden geladen...",
	"store.getUserMissions.error": "Laden der Benutzer-Missionen ist fehlgeschlagen",
	"store.getUsers": "Loading users...",
	"store.getUsers.error": "Failed to load users",
	"store.modifyMissionSlotRegistration": "Slot-Anmeldung wird bearbeitet...",
	"store.modifyMissionSlotRegistration.error": "Bearbeitung der Slot-Anmeldung ist fehlgeschlagen",
	"store.modifyMissionSlotRegistration.success": "Slot-Anmeldung wurde erfolgreich bearbeitet",
	"store.performLogin": "Login wird durchgeführt...",
	"store.performLogin.error": "Login fehlgeschlagen",
	"store.processCommunityApplication": "Community-Bewerbung wird verarbeitet...",
	"store.processCommunityApplication.accept": "Aunehma",
	"store.processCommunityApplication.accepted": "augnumma",
	"store.processCommunityApplication.denied": "oglehnt",
	"store.processCommunityApplication.deny": "Olehna",
	"store.processCommunityApplication.error": "{action} der Community-Bewerbung für Benutzer <strong>{nickname}</strong> ist fehlgeschlagen",
	"store.processCommunityApplication.success": "Community-Bewerbung für Benutzer <strong>{nickname}</strong> wurde erfolgreich {action}",
	"store.refreshToken": "Authentifizierung wird aktualisiert...",
	"store.refreshToken.error": "Login hod ned hinghaut",
	"store.registerForMissionSlot": "Aumödung fia Slot wiad gmocht...",
	"store.registerForMissionSlot.error": "Aumödung fia Slot <strong>{slotInfo}</strong> hod ned hinghaut",
	"store.registerForMissionSlot.success": "Aumödung fia Slot <strong>{slotInfo}</strong> hod passt",
	"store.removeCommunityMember": "Community-Mitglied wird entfernt...",
	"store.removeCommunityMember.error": "Entfernen des Community-Mitglieds <strong>{nickname}</strong> ist fehlgeschlagen",
	"store.removeCommunityMember.success": "Community-Mitglied <strong>{nickname}</strong> wurde erfolgreich entfernt",
	"store.searchCommunities.error": "Suche nach Communities ist fehlgeschlagen",
	"store.searchMissions.error": "Failed to search missions",
	"store.searchUsers.error": "Suche nach Benutzern ist fehlgeschlagen",
	"store.unassignSelectedMissionSlots": "Unassigning 1 slot... | Unassigning {count} slots...",
	"store.unassignSelectedMissionSlots.error": "Failed to unassign one or multiple selected slots",
	"store.unassignSelectedMissionSlots.success": "Successfully unassigned 1 slot | Successfully unassigned {count} slots",
	"store.unregisterFromMissionSlot": "Obmödung vum Slot wiad gmocht...",
	"store.unregisterFromMissionSlot.error": "Obmödung vum Slot <strong>{slotInfo}</strong> hod ned hinghaut",
	"store.unregisterFromMissionSlot.success": "Obmödung vum Slot <strong>{slotInfo}</strong> hod passt",
	"store.uploadCommunityLogo": "Uploading logo...",
	"store.uploadCommunityLogo.error": "Failed to upload logo",
	"store.uploadCommunityLogo.success": "Successfully uploaded logo",
	"store.uploadMissionBannerImage": "Banner-Bild wiad aufiglodn...",
	"store.uploadMissionBannerImage.error": "Aufilodn vum Banner-Büdl hod ned hinghaut",
	"store.uploadMissionBannerImage.success": "Banner-Büdl aufilodn hod hinghaut",
	"title.browser": "ArmA 3 Missions- und Slotlist-Management",
	"user": "Benutza",
	"user.confirm.activate": "User-Account aktivieren?",
	"user.confirm.deactivate": "User-Account deaktiveren?",
	"user.confirm.delete": "User löschen?",
	"user.list.search": "Search users",
	"user.list.search.description": "Start typing to search for an user with the given nickname, including partial matches. Clicking a user result will take you to their details page",
	"user.modal.edit": "Userdetails bearbeiten",
	"user.nickname": "Nickname",
	"user.status": "Status",
	"user.status.deactivated": "Account deaktiviert",
	"user.status.normal": "normal",
	"user.steamId": "Steam ID"
};

/***/ }),
/* 592 */
/* unknown exports provided */
/* all exports used */
/*!**************************!*\
  !*** ./src/i18n/de.json ***!
  \**************************/
/***/ (function(module, exports) {

module.exports = {
	"account.currentTime": "aktuelles Datum/Uhrzeit:",
	"account.delete.confirm": "Bist du sicher, dass du deinen Account löschen möchtest?<br><span class='font-weight-bold text-danger'>Diese Aktion ist irreversibel und löscht alle Daten, die mit deinem Account verknüpft sind.</span><br>Dies beinhaltet alle deine Missionen, Anmeldungen sowie Berechtigungen, die an deinen Account vergeben wurden.",
	"account.delete.feedback.nickname": "Der von dir eingegebene Nickname stimmt nicht exakt mit deinem aktuellen Nickname überein",
	"account.delete.nickname": "Gib den exakten Nickname deines Accounts ein",
	"account.delete.nickname.description": "Gib den aktuellen, exakten Nickname - inklusive korrekter Groß-/Kleinschreibung - ein, um die Löschung deines Accounts zu bestätigen",
	"account.feedback.nickname": "Nickname eingeben",
	"account.modal.delete": "Account löschen",
	"account.modal.edit": "Accountdetails bearbeiten",
	"account.noChanges": "Es wurden keine Änderungen an den Accountdetails vorgenommen",
	"account.notAssociated": "nicht assoziiert",
	"account.permission": "Berechtigung",
	"account.permissions": "Berechtigungen",
	"account.timezone": "Zeitzone",
	"button.accept": "Akzeptieren",
	"button.activate.user": "Account aktivieren",
	"button.add": "Hinzufügen",
	"button.add.mission.access": "Zugang hinzufügen",
	"button.add.mission.permission": "Berechtigung hinzufügen",
	"button.apply": "Bewerben",
	"button.apply.mission.slotGroup": "Slot-Vorlage anwenden",
	"button.apply.mission.slotGroup.short": "Anwenden",
	"button.assign": "Zuweisen",
	"button.assign.mission.slot": "Slot zuweisen",
	"button.cancel": "Abbrechen",
	"button.clear.selection": "Auswahl aufheben",
	"button.close": "Schließen",
	"button.confirm": "Bestätigen",
	"button.convert.slotTemplate": "In Slot-Vorlage umwandeln",
	"button.copy": "Kopieren",
	"button.create.community": "Community erstellen",
	"button.create.community.permission": "Berechtigung erstellen",
	"button.create.mission": "Mission erstellen",
	"button.create.mission.slot": "Slot erstellen",
	"button.create.mission.slot.template": "Slot-Vorlage erstellen",
	"button.create.mission.slotGroup": "Slotgruppe erstellen",
	"button.deactivate.user": "Account deaktivieren",
	"button.delete": "Löschen",
	"button.delete.account": "Account löschen",
	"button.delete.mission.slot.selection": "Ausgewählte Slots löschen",
	"button.delete.user": "Benutzer löschen",
	"button.deny": "Ablehnen",
	"button.details": "Details",
	"button.duplicate.mission": "Mission duplizieren",
	"button.duplicate.mission.slot": "Slot duplizieren",
	"button.duplicate.mission.slotGroup": "Slotgruppe duplizieren",
	"button.duplicate.mission.slotTemplate": "Slot-Vorlage duplizieren",
	"button.edit": "Bearbeiten",
	"button.edit.community.logo": "Logo bearbeiten",
	"button.edit.community.permissions": "Berechtigungen bearbeiten",
	"button.edit.mission.accesses": "Zugang bearbeiten",
	"button.edit.mission.bannerImage": "Banner-Bild bearbeiten",
	"button.edit.mission.permissions": "Berechtigungen bearbeiten",
	"button.edit.mission.slot.selection": "Ausgewählte Slots bearbeiten",
	"button.edit.mission.slotGroup": "Slotgruppe bearbeiten",
	"button.embed.mission": "Mission einbinden",
	"button.export.calendar.google": "Google",
	"button.export.calendar.ical": "iCal",
	"button.generate": "Generieren",
	"button.join": "Beitreten",
	"button.move.down": "Nach unten",
	"button.move.up": "Nach oben",
	"button.refresh": "Aktualisieren",
	"button.refresh.authentication": "Authentifizierung aktualisieren",
	"button.refresh.authentication.explanation": "Du kannst die Authentifizierung aktualisieren, um sicherzustellen, dass deinem Account die korrekten Berechtigungen, Community o.ä. zugewiesen wurden.<br>Nachdem du in eine Community aufgenommen wurdest, ist eine Aktualisierung von­nö­ten, bevor die Community korrekt in deinem Account angezeigt wird und du Community-Missionen erstellen kannst.",
	"button.register": "Anmelden",
	"button.remove": "Entfernen",
	"button.save": "Speichern",
	"button.save.mission.slotTemplate.slotlist": "Vorlagen-Slotliste speichern",
	"button.submit": "Abschicken",
	"button.unassign": "Zuweisung entfernen",
	"button.unassign.mission.slot.selection": "Zuweisung von ausgewählten Slots entfernen",
	"button.unregister": "Abmelden",
	"button.upload": "Hochladen",
	"calendar.month.current": "Heute",
	"calendar.month.next": "Nächster",
	"calendar.month.previous": "Vorheriger",
	"calendar.title": "Bevorstehende Missionen",
	"community.application.confirm.accept": "Bewerbung annehmen?",
	"community.application.confirm.deny": "Bewerbung ablehnen?",
	"community.application.nickname": "Nickname",
	"community.application.status": "Status",
	"community.applications": "Bewerbungen",
	"community.applications.filter": "Filter - abgearbeitete Bewerbungen werden standardmäßig ausgeblendet",
	"community.applications.filter.accepted": "angenommen",
	"community.applications.filter.denied": "abgelehnt",
	"community.applications.filter.processed": "abgearbeitet",
	"community.confirm.delete": "Community löschen?",
	"community.creator.feedback.name": "Name eingeben",
	"community.creator.feedback.slug": "Slug eingeben",
	"community.creator.feedback.slug.checking": "<em>Community-Slug Verfügbarkeit wird geprüft...</em>",
	"community.creator.feedback.slug.notAvailable": "Community-Slug nicht verfügbar",
	"community.creator.feedback.tag": "Tag eingeben",
	"community.creator.feedback.website": "Valide Website URL eingeben",
	"community.creator.title": "Neue Community erstellen",
	"community.creator.title.browser": "Community-Ersteller",
	"community.gameServers": "Community Gameserver",
	"community.gameServers.description": "Du kannst einen für deine Community definierten Gameserver auswählen, um die Gameserver-Daten oberhalb schnell auszufüllen. Beachte dabei, dass jegliche davor eingegebenen Daten dabei gelöscht werden",
	"community.gameServers.hostname.description": "Hostname/IP Adresse des Gameservers, der zur Community-Liste hinzugefügt werden soll",
	"community.gameServers.name.description": "Name des Gameservers (z.B. in einer Serverliste), der zur Community-Liste hinzugefügt werden soll. Leer lassen, falls nicht relevant",
	"community.gameServers.password.description": "Passwort des Gameservers, der zur Community-Liste hinzugefügt werden soll. Leer lassen, falls kein Passwort benötigt wird",
	"community.gameServers.port.description": "Port des Gameservers, der zur Community-Liste hinzugefügt werden soll",
	"community.leader": "Anführer",
	"community.list.search": "Nach Community suchen",
	"community.list.search.description": "Suche nach einer Community mit dem angegebenen Namen, inklusive Teil-Übereinstimmungen. Per Klick auf das Suchergebnis wirst du auf die Detail-Seite der Community weitergeleitet",
	"community.logo": "Logo",
	"community.logo.choose": "Datei wählen",
	"community.logo.description": "Das Logo wird prominent unter dem Community-Namen und über den Daten der Community angezeigt",
	"community.logo.feedback.fileType": "Ungültiger Dateityp (nur jpeg, png und gif sind erlaubt)",
	"community.logo.feedback.size": "Datei zu groß (max. 2 MiB)",
	"community.logo.notSelected": "Kein Logo ausgewählt",
	"community.member.confirm.remove": "Mitglied entfernen?",
	"community.members": "Mitglieder",
	"community.modal.edit": "Communitydetails bearbeiten",
	"community.modal.logo": "Logo bearbeiten",
	"community.modal.permission": "Communityberechtigungen",
	"community.name": "Name",
	"community.name.description": "Voller Name der Community",
	"community.noChanges": "Es wurden keine Änderungen an den Communitydetails vorgenommen",
	"community.permission.create": "Communityberechtigung erstellen",
	"community.permission.existing": "Bestehende Missionsberechtigungen",
	"community.permission.founder": "Community-Gründer",
	"community.permission.leader": "Community-Leiter",
	"community.permission.permission": "Zu vergebende Berechtigung",
	"community.permission.permission.description": "Wähle die an den Benutzer zu vergebende Berechtigung aus. <span class='font-weight-bold'>Community-Leiter</span> können die Communitydetails bearbeiten und Mitglieder aufnehmen und entfernen, aber können die Community nicht löschen oder Berechtigungen an andere vergeben. <span class='font-weight-bold'>Community-Recruiter</span> können nur Communitybewerbungen annehmen, aber keine Mitglieder entfernen oder Details bearbeiten.",
	"community.permission.recruitment": "Community-Recruiter",
	"community.permission.user.selection": "Suche nach Benutzer für Berechtigung",
	"community.permission.user.selection.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen",
	"community.repositories": "Community Mod-Repositories",
	"community.repositories.description": "Du kannst ein für deine Community definiertes Mod-Repository auswählen, um die Repository-Daten oberhalb schnell auszufüllen. Beachte dabei, dass jegliche davor eingegebenen Daten dabei gelöscht werden",
	"community.slug": "Slug",
	"community.slug.description": "Slug für die Community URL, muss einzigartig sein",
	"community.tag": "Tag",
	"community.tag.description": "Community-Tag, der für alle Mitglieder angezeigt werden soll (als Prefix vor dem Namen)",
	"community.voiceComms": "Community Voice Comms",
	"community.voiceComms.description": "Du kannst einen für deine Community definierten Voice Comms Server auswählen, um die Voice Comms-Daten oberhalb schnell auszufüllen. Beachte dabei, dass jegliche davor eingegebenen Daten dabei gelöscht werden",
	"community.voiceComms.hostname.description": "Hostname/IP Adresse des Voice Comms Servers, der zur Community-Liste hinzugefügt werden soll",
	"community.voiceComms.name.description": "Name des Voice Comms Servers (z.B. in einer Serverliste), der zur Community-Liste hinzugefügt werden soll. Leer lassen, falls nicht relevant",
	"community.voiceComms.password.description": "Passwort des Voice Comms Servers, der zur Community-Liste hinzugefügt werden soll. Leer lassen, falls kein Passwort benötigt wird",
	"community.voiceComms.port.description": "Port des Voice Comms Servers, der zur Community-Liste hinzugefügt werden soll",
	"community.website": "Webseite",
	"community.website.optional": "Webseite <em>(optional)</em>",
	"editor.explanation": "Für Editor-Erklärung hier klicken",
	"editor.explanation.1": "Textgröße",
	"editor.explanation.2": "Überschriften",
	"editor.explanation.3": "Textfarbe",
	"editor.explanation.4": "Fetter/kursiver Text",
	"editor.explanation.5": "Text-Ausrichtung, Text-Einrückung",
	"editor.explanation.6": "Numerierte & ungeordnete Listen",
	"editor.explanation.7": "Link, Bild oder Video einfügen",
	"editor.explanation.8": "Formatierung aufheben",
	"editor.explanation.missing": "Einige Editor-Bedienelemente können - abhängig von dem bearbeiteten Missionselement - deaktiviert sein oder fehlen",
	"failed.request": "Request fehlgeschlagen",
	"failed.something": "Irgendetwas ist fehlgeschlagen...",
	"misc.actions": "Aktionen",
	"misc.notProvided": "nicht angegeben",
	"misc.notRequired": "nicht benötigt",
	"misc.notSpecified": "nicht angegeben",
	"mission": "Mission",
	"mission.abbr.estimated": "ca.",
	"mission.abbr.leadership": "Führung",
	"mission.access.add": "Missionszugang hinzufügen",
	"mission.access.add.explanation": "Wähle Communities oder Benutzer aus, die Zugang zu deiner Mission haben und sich für Slots anmelden können sollen.<br>Standardmäßig können nur du sowie alle Missionseditoren diese Mission sehen - du musst allen anderen Communities oder Benutzern explizit Zugang geben.<br>Vergibst du Zugang an eine Community, können alle Mitglieder dieser die Mission sehen. Vergibst du Zugang an einen einzelnen Benutzer, kann nur dieser Benutzer die Mission sehen.",
	"mission.access.community.selection": "Suche nach Community für Zugang",
	"mission.access.community.selection.description": "Suche nach einer Community mit dem angegebenen Namen oder Tag, inklusive Teil-Übereinstimmungen. Du kannst einen Zugang immer nur entweder an eine Community oder an einen Benutzer vergeben, nicht aber an beide gleichzeitig",
	"mission.access.existing": "Bestehende Missionszugänge",
	"mission.access.list.name": "Name",
	"mission.access.list.type": "Zugangstyp",
	"mission.access.list.type.community": "Community",
	"mission.access.list.type.user": "Benutzer",
	"mission.access.user.selection": "Suche nach Benutzer für Zugang",
	"mission.access.user.selection.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen. Du kannst einen Zugang immer nur entweder an einen Benutzer oder an eine Community vergeben, nicht aber an beide gleichzeitig",
	"mission.apply.slotTemplate.description": "Wende ein Slot-Vorlage auf eine Mission an, um alle darin definierten Slotgruppen an der ausgewählten Position einzufügen.<br>Du kannst die Slot-Vorlagen filtern und die gewünschte Vorlage auswählen.",
	"mission.bannerImage": "Banner-Bild",
	"mission.bannerImage.choose": "Datei wählen",
	"mission.bannerImage.description": "Das Banner-Bild wird prominent unter dem Missionstitel und über der Beschreibung angezeigt",
	"mission.bannerImage.feedback.fileType": "Ungültiger Dateityp (nur jpeg, png und gif sind erlaubt)",
	"mission.bannerImage.feedback.size": "Datei zu groß (max. 2 MiB)",
	"mission.bannerImage.notSelected": "Kein Banner-Bild ausgewählt",
	"mission.briefingTime": "Briefing-Zeit",
	"mission.briefingTime.description": "Datum und Uhrzeit, an dem das Führungsbriefing abgehalten wird",
	"mission.briefingTime.short": "Briefing",
	"mission.by": "von",
	"mission.collapsedDescription.description": "Eine optionale, eingeklappte Missionsbeschreibung, die dazu verwendet werden kann, noch genauere Missionsdetails und -vorbereitungen an die Spieler weiterzugeben, ohne dass diese jedes Mal endlos scrollen müssen, um die Slotliste anschauen zu können. Diese Beschreibung ist standardmäßig eingeklappt - es wird nur ein Button zum Ausklappen angezeigt - und wird nach der detaillierten Missionsbeschreibung und vor der Slotlist angezeigt",
	"mission.collapsedDescription.optional": "Eingeklappte Missionsbeschreibung <em>(optional)</em>",
	"mission.collapsedDescription.toggle.close": "Zusätzliche Missionsbeschreibung einklappen",
	"mission.collapsedDescription.toggle.open": "Zusätzliche Missionsbeschreibung ausklappen",
	"mission.community": "Community",
	"mission.confirm.delete": "Mission löschen?",
	"mission.convert.slotTemplate.description": "Du kannst die aktuelle Slotliste der Mission in eine Slot-Vorlage umwandeln, wodurch die eingerichteten Slotgruppen und Slots für andere Missionen weiterverwendet werden können. Slot-Vorlagen inkludieren keine Community-Reservierungen oder Slotzuweisungen. Das Umwandeln einer Mission in eine Slot-Vorlage verändert oder löscht die Slotliste der Mission in keiner Weise.<br>Wähle einen Titel und eine Sichtbarkeits-Einstellung für die umgewandelte Slot-Vorlage aus.",
	"mission.creator": "Ersteller",
	"mission.creator.addToCommunity": "Mission zur Community hinzufügen?",
	"mission.creator.addToCommunity.description": "Durch das Hinzufügen einer Mission zur deiner Community <strong>{communityInfo}</strong> wird diese auch in der Missionsliste der Community aufgeführt",
	"mission.creator.title": "Neue Mission erstellen",
	"mission.creator.title.browser": "Missions-Ersteller",
	"mission.description": "Beschreibung",
	"mission.description.description": "Beschreibung der Mission, gibt eine kurze Übersicht für die Missionsliste",
	"mission.detailedDescription": "Detaillierte Beschreibung",
	"mission.detailedDescription.description": "Detaillierte Beschreibung der Missions-Story, des Szenarios, Plots, der Aufgabe, etc. Alles, was Spieler wissen sollten, bevor sie sich entscheiden, mitzumachen",
	"mission.details": "Missionsdetails",
	"mission.duplicate.briefingTime.description": "Neue, optionale Briefing-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.description": "Wähle einen neuen Slug für die duplizierte Mission aus.<br>Der Titel, die Missionszeiten sowie die Sichtbarkeit und Community-Verknüpfung können überschrieben werden.<br>Alle weggelassenen Informationen werden mit den Daten der Originalmission ersetzt.",
	"mission.duplicate.endTime.description": "Neue, optionale Spielende-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.slottingTime.description": "Neue, optionale Slotting-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.slug.description": "Slug für die duplizierte Mission",
	"mission.duplicate.startTime.description": "Neue, optionale Spielbeginn-Zeit, die für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.title.description": "Neuer, optionaler Titel, der für die duplizierte Mission überschrieben werden soll - kann weggelassen werden",
	"mission.duplicate.visibility.description": "Definiert die Sichtbarkeit der duplizierten Mission für andere Benutzer, erlaubt Zugang nur für die ausgewählte Gruppe",
	"mission.endTime": "Spielende",
	"mission.endTime.description": "Geschätztes Datum und Uhrzeit, zu dem die Mission enden wird",
	"mission.feedback.dateTime": "Valides Datum und Uhrzeit eingeben",
	"mission.feedback.dateTime.afterSlotting": "Spielbeginn-Zeit muss nach der Slotting-Zeit sein",
	"mission.feedback.dateTime.afterStart": "Spielende der Mission muss nach der Spielbeginn-Zeit sein",
	"mission.feedback.description": "Beschreibung eingeben",
	"mission.feedback.detailedDescription": "Detaillierte Beschreibung eingeben",
	"mission.feedback.orderNumber": "Sortier-Nummer eingeben",
	"mission.feedback.repository.kind": "Repository-Typ auswählen",
	"mission.feedback.repository.name": "Repository-Name angeben",
	"mission.feedback.repository.url": "Gültige URL angeben",
	"mission.feedback.repository.url.arma3sync": "Repository-URL für ArmA3Sync Repository angeben",
	"mission.feedback.repository.urlOrNotes": "Zumindest eine Repository-URL oder -Notizen angeben",
	"mission.feedback.serverInfo.hostnamePort": "Sowohl Hostname als auch Port müssen angegeben werden",
	"mission.feedback.serverInfo.portRange": "Port-Werte müssen zwischen 0 und 65535 liegen",
	"mission.feedback.slot.autoAssignable.mission": "Alle Slots werden als automatisch zuweisbar erstellt, da die Auto-Zuweisungseinstellung der Mission aktiviert wurde",
	"mission.feedback.slug": "Slug eingeben",
	"mission.feedback.slug.checking": "<em>Missions-Slug Verfügbarkeit wird geprüft...</em>",
	"mission.feedback.slug.notAvailable": "Missions-Slug nicht verfügbar",
	"mission.feedback.title": "Missionstitel eingeben",
	"mission.feedback.title.slot": "Slottitel eingeben",
	"mission.feedback.title.slotGroup": "Slotgruppentitel eingeben",
	"mission.feedback.visibility": "Sichtbarkeits-Einstellung auswählen",
	"mission.gameServer": "Gameserver",
	"mission.gameServer.hostname.description": "Hostname/IP Adresse des Gameservers, auf dem die Mission stattfindet",
	"mission.gameServer.hostname.optional": "Gameserver Hostname/IP <em>(optional)</em>",
	"mission.gameServer.name.description": "Name des Gameservers (z.B. in einer Serverliste), auf dem die Mission stattfindet. Leer lassen, falls nicht relevant",
	"mission.gameServer.name.optional": "Gameserver-Name <em>(optional)</em>",
	"mission.gameServer.password.description": "Passwort des Gameservers, auf dem die Mission stattfindet. Leer lassen, falls kein Passwort benötigt wird",
	"mission.gameServer.password.optional": "Gameserver Passwort <em>(optional)</em>",
	"mission.gameServer.port.description": "Port des Gameservers, auf dem die Mission stattfindet",
	"mission.gameServer.port.optional": "Gameserver Port <em>(optional)</em>",
	"mission.list.creator": "Ersteller",
	"mission.list.description": "Beschreibung",
	"mission.list.filter": "Filter - vergangene Missionen werden standardmäßig ausgeblendet",
	"mission.list.filter.assigned": "Missionen mit zugewiesenen Slots",
	"mission.list.filter.ended": "Vergangene Missionen anzeigen",
	"mission.list.filter.registered": "Missionen mit Slotanmeldungen",
	"mission.list.isMissionEditor": "Du hast Editor-Berechtigungen für diese Mission",
	"mission.list.search": "Nach Mission suchen",
	"mission.list.search.description": "Suche nach einer Mission mit dem angegebenen Titel, inklusive Teil-Übereinstimmungen. Per Klick auf das Suchergebnis wirst du auf die Detail-Seite der Mission weitergeleitet",
	"mission.list.slot.counts": "Spieleranzahl",
	"mission.list.slot.counts.available": "Verfügbare Slots",
	"mission.list.slot.counts.available.popover": "<strong>{open}</strong> Slots sind für dich verfügbar",
	"mission.list.slot.counts.available.popover.community": "<strong>{open}</strong> Slots sind für dich und alle anderen Mitglieder deiner Community verfügbar",
	"mission.list.slot.counts.popover": "<strong>{unassigned}</strong> Slots haben Anmeldungen, die noch nicht bestätigt wurden. <strong>{assigned}</strong> Slots wurden zugewiesen, <strong>{external}</strong> Slots wurden externen Spielern zugewiesen.<br>Es gibt <strong>{blocked}</strong> blockierte, <strong>{restricted}</strong> reservierte und <strong>{reserve}</strong> Reserve-Slots.",
	"mission.list.slot.status": "Anmeldung",
	"mission.list.slot.status.assigned": "Slotanmeldung <span class='font-weight-bold text-success'>bestätigt</span>, zu Slot zugewiesen",
	"mission.list.slot.status.registered": "Slotanmeldung <span class='font-weight-bold text-danger'>nicht bestätigt</span>, noch zu keinem Slot zugewiesen",
	"mission.list.startTime": "Spielbeginn",
	"mission.list.title": "Titel",
	"mission.modal.access": "Missionszugänge",
	"mission.modal.apply.slotTemplate": "Slot-Vorlage auf Mission anwenden",
	"mission.modal.bannerImage": "Banner-Bild bearbeiten",
	"mission.modal.convert.slotTemplate": "Mission in Slot-Vorlage umwandeln",
	"mission.modal.duplicate": "Mission duplizieren",
	"mission.modal.edit": "Mission bearbeiten",
	"mission.modal.embed": "Mission einbinden",
	"mission.modal.permission": "Missionsberechtigungen",
	"mission.modal.slot.assign": "Slot {slotInfo} einem Benutzer zuweisen",
	"mission.modal.slot.create": "Slot in Slotgruppe erstellen",
	"mission.modal.slot.details": "Slot-Details",
	"mission.modal.slot.edit": "Slot bearbeiten",
	"mission.modal.slot.register": "Für Slot anmelden",
	"mission.modal.slot.register.text": "Anmeldung als {slotInfo} bestätigen?",
	"mission.modal.slot.selection.edit": "Ausgewählte Slots bearbeiten",
	"mission.modal.slotGroup.create": "Slotgruppe erstellen",
	"mission.modal.slotGroup.edit": "Slotgruppe bearbeiten",
	"mission.permission.add": "Missionsberechtigung hinzufügen",
	"mission.permission.creator": "Missionsersteller",
	"mission.permission.editor": "Missionseditor",
	"mission.permission.existing": "Bestehende Missionsberechtigungen",
	"mission.permission.permission": "Zu vergebende Berechtigung",
	"mission.permission.permission.description": "Wähle die an den Benutzer zu vergebende Berechtigung aus. <span class='font-weight-bold'>Missionseditoren</span> können die Missionsdetails und Slotliste bearbeiten, aber können die Mission nicht löschen oder Berechtigungen an andere vergeben. Benutzer mit der <span class='font-weight-bold'>Community-Slotmanager</span> Berechtigung können Anmeldungen für Slots, die für ihre Community reserviert wurden, annehmen und entfernen, aber keine anderen Missionsdetails oder Slotanmeldungen ändern",
	"mission.permission.slotlist.community": "Community-Slotmanager",
	"mission.permission.user.selection": "Suche nach Benutzer für Berechtigung",
	"mission.permission.user.selection.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen",
	"mission.registration.comment": "Kommentar",
	"mission.registration.comment.description": "Optionaler Kommentar an den Missionsersteller (max. 128 Zeichen)",
	"mission.registration.comment.optional": "Kommentar <em>(optional)</em>",
	"mission.registration.confirmed": "Bestätigt",
	"mission.registration.registered": "Angemeldet",
	"mission.repository.kind": "Typ",
	"mission.repository.kind.arma3sync": "ArmA3Sync",
	"mission.repository.kind.description": "Wähle den Typ des Mod-Repositories aus. Beim Klick auf einen <code>ArmA3Sync</code>-Repository Link wird dieser automatisch in die Zwischenablage kopiert",
	"mission.repository.kind.other": "Anderes",
	"mission.repository.list": "Mod-Repositories",
	"mission.repository.list.empty": "Keine Mod-Repositories benötigt",
	"mission.repository.name": "Name",
	"mission.repository.name.description": "Name des Mod-Repositories, hauptsächlich für die Suche in Repository-Listen nützlich",
	"mission.repository.name.optional": "Name <em>(optional)</em>",
	"mission.repository.name.required": "Name",
	"mission.repository.notes": "Notizen",
	"mission.repository.notes.description": "Optionale Notizen über ein Repository, z.B. als Erklärung der Benutzung oder der benötigten Dateien. Benötigt, falls keine URL angegeben wurde",
	"mission.repository.notes.optional": "Notizen <em>(optional)</em>",
	"mission.repository.url": "URL",
	"mission.repository.url.description": "URL des Mod-Repositories. Benötigt für <code>ArmA3Sync</code>-Repositories, optional für andere",
	"mission.repository.url.empty": "keine Repository-URL angegeben",
	"mission.repository.url.optional": "URL <em>(optional)</em>",
	"mission.repositoryUrl": "Repository URL",
	"mission.repositoryUrl.description": "Kann entweder leer sein (falls nicht benötigt), ein einzelner Link zum Repository oder mehrere Links, inklusive eigener HTML-Formatierung",
	"mission.repositoryUrl.optional": "Repository URL <em>(optional)</em>",
	"mission.requiredDLCs": "Benötigte DLCs",
	"mission.requiredDLCs.aow": "Art of War",
	"mission.requiredDLCs.apex": "Apex",
	"mission.requiredDLCs.contact": "Contact",
	"mission.requiredDLCs.csla": "CSLA Iron Curtain",
	"mission.requiredDLCs.gm": "Global Mobilization",
	"mission.requiredDLCs.helicopters": "Helicopters",
	"mission.requiredDLCs.jets": "Jets",
	"mission.requiredDLCs.karts": "Karts",
	"mission.requiredDLCs.laws-of-war": "Laws of War",
	"mission.requiredDLCs.marksmen": "Marksmen",
	"mission.requiredDLCs.none": "keine DLCs benötigt",
	"mission.requiredDLCs.tac-ops": "Tac-Ops",
	"mission.requiredDLCs.tanks": "Tanks",
	"mission.requiredDLCs.vn": "S.O.G. Prairie Fire",
	"mission.rules": "Regeln",
	"mission.rules.description": "Allgemeine Regeln und Richtlichen für Spieler während der Teilnahme - missionsspezifische Einschränkungen sollten als detaillierte Beschreibung hinzugefügt werden",
	"mission.rules.optional": "Regeln <em>(optional)</em>",
	"mission.serverInfo.hostname": "Hostname/IP",
	"mission.serverInfo.name": "Server-Name",
	"mission.serverInfo.password": "Passwort",
	"mission.serverInfo.port": "Port",
	"mission.slot.assign.force": "Slotzuweisung erzwingen",
	"mission.slot.assign.force.description": "Durch das Erzwingen einer Slotzuweisung wird der ausgewählte Benutzer von seinem Slot entfernt, falls er bereits zugewiesen ist - außerdem wird der Benutzer, der aktuell auf den gewählten Slot zugewiesen ist, entfernt",
	"mission.slot.assign.selection": "Suche nach Benutzer für Zuweisung",
	"mission.slot.assign.selection.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen",
	"mission.slot.assignee.registration": "keine Anmeldungen | Anmeldung | Anmeldungen",
	"mission.slot.autoAssignable.description": "Automatisch zuweisbare Slots benötigen keiner Bestätigung von Registrierungen durch Missionseditoren, sondern werden automatisch dem ersten Benutzer zugewiesen, der sich für sie anmeldet",
	"mission.slot.autoAssignable.slot": "Automatisch zuweisbarer Slot",
	"mission.slot.blocked": "blockiert - keine Anmeldungen möglich",
	"mission.slot.blocked.description": "Blockierte Slots stehen nicht für Anmeldungen zur Verfügung",
	"mission.slot.blocked.popover": "Blockiert - dieser Slot wurde vom Missionsersteller blockiert und steht nicht für Anmeldungen zur Verfügung",
	"mission.slot.blocked.slot": "Blockierter Slot",
	"mission.slot.confirm.delete": "Slot löschen?",
	"mission.slot.confirm.delete.selection": "Ausgewählte Slots löschen?",
	"mission.slot.confirm.unassign.selection": "Zuweisung von ausgewählten Slots entfernen?",
	"mission.slot.confirm.unregister": "Von Slot abmelden?",
	"mission.slot.description": "Beschreibung",
	"mission.slot.description.description": "Optionale, kurze Beschreibung des Slots, um z.B. das benutzte Equipment oder Fahrzeug zu beschreiben - wird in der Slotliste angezeigt",
	"mission.slot.description.optional": "Beschreibung <em>(optional)</em>",
	"mission.slot.detailedDescription": "Detaillierte Beschreibung",
	"mission.slot.detailedDescription.description": "Optionale, detailliertere Beschreibung des Slots, gibt mehr Informationen über die zugewiesenen Verantwortungen oder Aufgaben - wird in den Slot-Details angezeigt",
	"mission.slot.detailedDescription.optional": "Detaillierte Beschreibung <em>(optional)</em>",
	"mission.slot.difficulty": "Schwierigkeit",
	"mission.slot.difficulty.advanced": "Fortgeschritten",
	"mission.slot.difficulty.beginner": "Anfänger",
	"mission.slot.difficulty.description": "Schwierigkeit des Slots, als Hilfe für die Slotwahl für Spieler",
	"mission.slot.difficulty.easy": "Einfach",
	"mission.slot.difficulty.expert": "Experte",
	"mission.slot.difficulty.medium": "Mittel",
	"mission.slot.externalAssignee.description": "Du kannst eine externe Spieler-Zuweisung vornehmen, um einen Slot einem Spieler zuzuweisen, der kein Nutzer unserer Webseite ist. Ein Slot kann nur entweder einem Benutzer zugewiesen werden <em>oder</em> an einen externen Spieler vergeben werden",
	"mission.slot.externalAssignee.optional": "Externe Spieler-Zuweisung <em>(optional)</em>",
	"mission.slot.insertAfter": "Neuen Slot einfügen nach",
	"mission.slot.insertAfter.description": "Position auswählen, nach welcher der neue Slot eingefügt werden soll",
	"mission.slot.insertAfter.top": "Anfang der Liste",
	"mission.slot.move": "Slot verschieben",
	"mission.slot.move.description": "Slot an eine neue Position verschieben",
	"mission.slot.moveAfter": "Slot anzeigen nach",
	"mission.slot.moveAfter.description": "Position auswählen, nach welcher der Slot angezeigt werden soll",
	"mission.slot.moveAfter.keep": "Aktuelle Position beibehalten",
	"mission.slot.orderNumber": "Sortier-Nummer",
	"mission.slot.orderNumber.description": "Wird für die Sortierung des Slots in der Missions-Slotliste verwendet",
	"mission.slot.player": "Spieler",
	"mission.slot.registrations": "Anmeldungen",
	"mission.slot.reserve": "Reserve",
	"mission.slot.reserve.description": "Reserve-Slots werden nur gefüllt, wenn alle anderen Slots davor vergeben wurden",
	"mission.slot.reserve.popover": "Reserve - nur vergeben, wenn alle anderen Slots belegt wurden",
	"mission.slot.reserve.regular": "normal",
	"mission.slot.reserve.slot": "Reserve-Slot",
	"mission.slot.restricted": "reserviert für {communityInfo}",
	"mission.slot.restricted.description": "Reservierte Slots sind nicht für alle, sondern nur für Spieler der ausgewählten Community verfügbar",
	"mission.slot.restricted.popover": "Reserviert - nur für <strong>{communityInfo}</strong> Mitglieder verfügbar",
	"mission.slot.restricted.selection": "Suche nach Community für Slot-Reservierung",
	"mission.slot.restricted.selection.description": "Suche nach einer Community mit dem angegebenen Namen oder Tag, inklusive Teil-Übereinstimmungen",
	"mission.slot.restricted.slot": "Reservierter Slot",
	"mission.slot.restricted.unrestricted": "frei verfügbar",
	"mission.slot.role": "Rolle",
	"mission.slot.selection.actions": "Aktionen für 1 ausgewählten Slot ausführen | Aktionen für {count} ausgewählte Slots ausführen",
	"mission.slot.selection.edit": "Erlaubt das Bearbeiten bestimmter Werte von 1 ausgewähltem Slot.<br>Ausgelassene Informationen werden nicht verändert, dadurch kannst du nur die gewünschten Werte verändern und den Rest leer/unausgewählt lassen. Leider können die Slot-Status <code>reserviert</code>, <code>Reserve</code>, <code>blockiert</code> und <code>automatisch Zuweisung</code>/<code>auto-assignable</code> nur für einen Slot auf einmal entfernt werden.<br>Der folgende Slot ist betroffen: | Erlaubt das Bearbeiten bestimmter Werte von {count} ausgewählten Slots.<br>Ausgelassene Informationen werden nicht verändert, dadurch kannst du nur die gewünschten Werte verändern und den Rest leer/unausgewählt lassen. Leider können die Slot-Status <code>reserviert</code>, <code>Reserve</code>, <code>blockiert</code> und <code>automatisch Zuweisung</code>/<code>auto-assignable</code> nur für einen Slot auf einmal entfernt werden.<br>Die folgenden Slots sind betroffen: ",
	"mission.slot.selection.hint": "Wähle mehrere Slots gleichzeitig aus, indem du sie anklickst, während du <kbd>STRG</kbd> gedrückt hältst",
	"mission.slot.status": "Status",
	"mission.slot.title": "Titel",
	"mission.slot.title.description": "Titel des Slots, wie er in der Slotlist angezeigt wird",
	"mission.slotGroup.confirm.delete": "Slotgruppe löschen?",
	"mission.slotGroup.description": "Beschreibung",
	"mission.slotGroup.description.description": "Optionale, kurze Beschreibung der Slotgruppe, um z.B. den allgemeinen Auftrag der Gruppe oder deren Rufzeichen zu beschreiben - wird in der Slotlist angezeigt",
	"mission.slotGroup.description.optional": "Beschreibung <em>(optional)</em>",
	"mission.slotGroup.insertAfter": "Neue Slotgruppe einfügen nach",
	"mission.slotGroup.insertAfter.description": "Position auswählen, nach welcher die neue Slotgruppe eingefügt werden soll",
	"mission.slotGroup.insertAfter.top": "Anfang der Liste",
	"mission.slotGroup.move": "Slotgruppe verschieben",
	"mission.slotGroup.move.description": "Slotgruppe an eine neue Position verschieben",
	"mission.slotGroup.moveAfter": "Slotgruppe anzeigen nach",
	"mission.slotGroup.moveAfter.description": "Position auswählen, nach welcher die Slotgruppe angezeigt werden soll",
	"mission.slotGroup.moveAfter.keep": "Aktuelle Position beibehalten",
	"mission.slotGroup.orderNumber": "Sortier-Nummer",
	"mission.slotGroup.orderNumber.description": "Wird für die Sortierung der Slotgruppe in der Missions-Slotlist verwendet",
	"mission.slotGroup.title": "Titel",
	"mission.slotGroup.title.description": "Titel der Slotgruppe, wie er in der Slotlist angezeigt wird",
	"mission.slotlist": "Slotliste",
	"mission.slotlist.filter": "Filter",
	"mission.slotlist.filter.assigned": "belegt",
	"mission.slotlist.filter.blocked": "blockiert",
	"mission.slotlist.filter.hasRegistrations": "noch nicht zugewiesen",
	"mission.slotlist.filter.open": "offen",
	"mission.slotlist.filter.restricted": "reserviert",
	"mission.slotsAutoAssignable": "Automatisch zuweisbarer Slots",
	"mission.slotsAutoAssignable.description": "Automatisch zuweisbare Slots benötigen keiner Bestätigung von Registrierungen durch Missionseditoren, sondern werden automatisch dem ersten Benutzer zugewiesen, der sich für sie anmeldet. Durch das Aktivieren dieser Einstellungen werden alle Slots, die <strong>ab diesem Zeitpunkt</strong> angelegt werden, als automatisch zuweisbar erstellt - bestehende Slots sind davon nicht betroffen",
	"mission.slotTemplate": "Slot-Vorlage",
	"mission.slotTemplate.confirm.delete": "Slot-Vorlage löschen?",
	"mission.slotTemplate.confirm.save.slotlist": "Vorlagen-Slotlist speichern?",
	"mission.slotTemplate.confirm.unsavedChanges": "Möchtest du die Seite wirklich verlassen? Deine ungespeicherten Änderungen an der Vorlagen-Slotlist gehen dabei verloren!",
	"mission.slotTemplate.creator.title": "Neue Slot-Vorlage erstellen",
	"mission.slotTemplate.creator.title.browser": "Slot-Vorlagen-Ersteller",
	"mission.slotTemplate.duplicate.description": "Du kannst den Titel sowie die Sichtbarkeit der Slot-Vorlage überschreiben.<br>Alle weggelassenen Informationen werden mit den Daten der Originalslotvorlage ersetzt.",
	"mission.slotTemplate.duplicate.title.description": "Neuer, optionaler Titel, der für die duplizierte Slot-Vorlage überschrieben werden soll - kann weggelassen werden",
	"mission.slotTemplate.duplicate.visibility.description": "Definiert die Sichtbarkeit der duplizierten Slot-Vorlage für andere Benutzer, erlaubt Zugang nur für die ausgewählte Gruppe",
	"mission.slotTemplate.feedback.title": "Slotvorlagen-Titel eingeben",
	"mission.slotTemplate.feedback.visibility": "Sichtbarkeits-Einstellung auswählen",
	"mission.slotTemplate.filter": "Slot-Vorlagen Filter",
	"mission.slotTemplate.filter.description": "Filtere Slot-Vorlagen nach ihrem Titel oder dem Namen des Erstellers, einschließlich Teilübereinstimmungen",
	"mission.slotTemplate.insertAfter": "Slot-Vorlage anwenden nach",
	"mission.slotTemplate.insertAfter.description": "Wähle die Position aus, nach der die Slot-Vorlage angewandt werden soll",
	"mission.slotTemplate.list.counts.slots": "# an Slots",
	"mission.slotTemplate.list.counts.slots.groups": "# an Slotgruppen",
	"mission.slotTemplate.modal.duplicate": "Slot-Vorlage duplizieren",
	"mission.slotTemplate.modal.edit": "Slot-Vorlage bearbeiten",
	"mission.slotTemplate.slotlist": "Vorlagen-Slotliste",
	"mission.slotTemplate.title.description": "Titel der Slot-Vorlage, wie er in der Slotvorlagen-Listen und -Details angezeigt wird",
	"mission.slotTemplate.visibility.community": "Community-Mitglieder",
	"mission.slotTemplate.visibility.default": "unbekannt",
	"mission.slotTemplate.visibility.description": "Definiert die Sichtbarkeit der Slot-Vorlage für andere Benutzer, erlaubt Zugang nur für die ausgewählte Gruppe",
	"mission.slotTemplate.visibility.hidden": "nur für Slotvorlagen-Ersteller",
	"mission.slotTemplate.visibility.private": "ausgewählte Communities und Benutzer",
	"mission.slotTemplate.visibility.public": "für alle sichtbar",
	"mission.slottingTime": "Slotting-Zeit",
	"mission.slottingTime.description": "Datum und Uhrzeit, zu dem das Slotting in der Mission beginnt",
	"mission.slug": "Slug",
	"mission.slug.description": "Slug für die Missions URL, muss einzigartig sein",
	"mission.startTime": "Spielbeginn",
	"mission.startTime.description": "Datum und Uhrzeit, an dem die Mission beginnt",
	"mission.techSupport": "Techsupport",
	"mission.techSupport.description": "Optionale Informationen über Techsupport oder -checks, die vor der Mission angeboten werden",
	"mission.techSupport.optional": "Techsupport <em>(optional)</em>",
	"mission.times": "Slotting-Zeit: {slotting}\nSpielbeginn: {start}\nSpielende: {end}\nBriefing (Führung): {briefing}",
	"mission.times.ical": "Slotting-Zeit: {slotting}\\nSpielbeginn: {start}\\nSpielende: {end}\\nBriefing (Führung): {briefing}",
	"mission.timezone": "Alle Missionszeiten werden in der <em>{timezone}</em> Zeitzone angezeigt",
	"mission.title": "Titel",
	"mission.title.description": "Titel der Mission, wird in Missionsliste und -details angezeigt",
	"mission.token": "Missions-Token",
	"mission.token.description": "Missions-Token können als alternative, statische Authentifizierungsmethode für das Einbinden von Missionen auf anderen Webseiten oder Foren verwendet werden. Standardmäßig können alle öffentliche Missionen ohne zusätzliche Konfiguration eingebunden werden - Missionen, die eine nicht-öffentliche Sichtbarkeitseinstellung haben, benötigen einen Missions-Token für das Einbinden.<br>Im Gegensatz zur normalen Benutzer-Authentifizierung laufen Missions-Token nicht ab und erlauben nur den Zugang zu einer bestimmten Mission. Die zurückgelieferten Informationen entsprechen denen, die ein normaler Benutzer erhalten würde - Missionseditor oder -ersteller spezifische Daten werden nicht inkludiert.<br>Per Klick auf den <strong>Generieren</strong>-Button wird ein neuer Missions-Token generiert. Dabei ist zu beachten, dass dadurch alle vorherigen Token invalidiert werden.<br>Mit Hilfe des <strong>Löschen</strong>-Button können alle vorherigen Missions-Token vollständig gelöscht und damit jede Möglichkeit zur Einbindung einer nicht-öffentlichen Mission entfernt werden.",
	"mission.token.notGeneratedYet": "noch nicht generiert",
	"mission.visibility": "Sichtbarkeit",
	"mission.visibility.community": "Community-Mitglieder",
	"mission.visibility.default": "unbekannt",
	"mission.visibility.description": "Definiert die Sichtbarkeit der Mission für andere Benutzer, erlaubt Zugang nur für die ausgewählte Gruppe",
	"mission.visibility.hidden": "nur für Missionsersteller und -editor",
	"mission.visibility.private": "ausgewählte Communities und Benutzer",
	"mission.visibility.public": "für alle sichtbar",
	"mission.voiceComms": "Voice Comms",
	"mission.voiceComms.hostname.description": "Hostname/IP Adresse des Voice Comms Servers, der für die Mission verwendet wird",
	"mission.voiceComms.hostname.optional": "Voice Comms Hostname/IP <em>(optional)</em>",
	"mission.voiceComms.name.description": "Name des Voice Comms Servers (z.B. in einer Serverliste), auf dem die Mission stattfindet. Leer lassen, falls nicht relevant",
	"mission.voiceComms.name.optional": "Voice Comms-Name <em>(optional)</em>",
	"mission.voiceComms.password.description": "Passwort des Voice Comms Servers, der für die Mission verwendet wird. Leer lassen, falls kein Passwort benötigt wird",
	"mission.voiceComms.password.optional": "Voice Comms Passwort <em>(optional)</em>",
	"mission.voiceComms.port.description": "Port des Voice Comms Servers, der für die Mission verwendet wird",
	"mission.voiceComms.port.optional": "Voice Comms Port <em>(optional)</em>",
	"nav.about": "Über",
	"nav.account": "Account",
	"nav.admin.panel": "Admin Panel",
	"nav.api": "API",
	"nav.communities": "Communities",
	"nav.home": "Start",
	"nav.imprint": "Impressum",
	"nav.login": "Einloggen",
	"nav.logout": "Ausloggen",
	"nav.missions": "Missionen",
	"nav.missionSlotTemplates": "Slot-Vorlagen",
	"nav.notifications": "Benachrichtigungen",
	"nav.privacy": "Privacy",
	"nav.users": "Benutzer",
	"notification.list.filter": "Filter",
	"notification.list.filter.seen": "Gelesene Benachrichtigungen anzeigen",
	"notification.notification": "Benachrichtigung",
	"notification.received": "Erhalten",
	"notification.seen": "Gelesen",
	"notification.suppress": "Benachrichtigungen unterdrücken",
	"notification.suppress.description": "Durch das Unterdrücken von Benachrichtigungen kannst du verhindern, andere Benutzer mit mehreren, aufeinander folgenden oder unwichtigen Aktualisierungen vollzuspammen. Wenn diese Checkbox ausgewählt ist, werden keine Nachrichten für die ausgeführte Aktion erstellt. Dabei ist zu beachten, dass die Benachrichtigungen für \"destruktive\" Aktionen wie das Entfernen einer Slotzuweisung oder von Berechtigungen oder das Löschen einer Mission nicht unterdrückt werden können",
	"notification.type.community.application.accepted": "Deine Bewerbung bei der Community <strong>{communityName}</strong> wurde <span class='text-success font-weight-bold'>angenommen</span>",
	"notification.type.community.application.deleted": "<strong>{userNickname}</strong> hat seine Bewerbung bei deiner Community <strong>{communityName}</strong> <span class='text-danger font-weight-bold'>gelöscht</span>",
	"notification.type.community.application.denied": "Deine Bewerbung bei der Community <strong>{communityName}</strong> wurde <span class='text-danger font-weight-bold'>abgelehnt</span>",
	"notification.type.community.application.new": "<strong>{userNickname}</strong> hat sich bei deiner Community <strong>{communityName}</strong> <span class='text-success font-weight-bold'>beworben</span>",
	"notification.type.community.application.removed": "Du wurdest von einem Community-Recruiter aus deiner Community <strong>{communityName}</strong> <span class='text-danger font-weight-bold'>entfernt</span>",
	"notification.type.community.deleted": "Deine Community <strong>{communityName}</strong> wurde von ihrem Gründer <span class='text-danger font-weight-bold'>gelöscht</span>",
	"notification.type.community.permission.granted": "Dir wurde die <strong>{translatedPermission}</strong> Berechtigung für deine Community <strong>{communityName}</strong> <span class='text-success font-weight-bold'>zugewiesen</span>",
	"notification.type.community.permission.revoked": "Dir wurde die <strong>{translatedPermission}</strong> Berechtigung für deine Community <strong>{communityName}</strong> <span class='text-danger font-weight-bold'>entzogen</span>",
	"notification.type.mission.deleted": "Die Mission <strong>{missionTitle}</strong> wurde von ihrem Ersteller <span class='text-danger font-weight-bold'>gelöscht</span>",
	"notification.type.mission.permission.granted": "Dir wurde die <strong>{translatedPermission}</strong> Berechtigung für die Mission <strong>{missionTitle}</strong> <span class='text-success font-weight-bold'>zugewiesen</span>",
	"notification.type.mission.permission.revoked": "Dir wurde die <strong>{translatedPermission}</strong> Berechtigung für die Mission <strong>{missionTitle}</strong> <span class='text-danger font-weight-bold'>entzogen</span>",
	"notification.type.mission.slot.assigned": "Du wurdest als <strong>{slotTitle}</strong> in der Mission <strong>{missionTitle}</strong> <span class='text-success font-weight-bold'>zugewiesen</span>",
	"notification.type.mission.slot.registration.new": "<strong>{userNicknameWithTag}</strong> hat sich für den Slot <strong>{slotTitle}</strong> für die Mission <strong>{missionTitle}</strong> <span class='text-success font-weight-bold'>angemeldet</span>",
	"notification.type.mission.slot.unassigned": "Deine Zuweisung als <strong>{slotTitle}</strong> in der Mission <strong>{missionTitle}</strong> wurde <span class='text-danger font-weight-bold'>aufgehoben</span>",
	"notification.type.mission.slot.unregistered": "<strong>{userNicknameWithTag}</strong> hat sich von seinem Slot <strong>{slotTitle}</strong> in der Mission <strong>{missionTitle}</strong> <span class='text-danger font-weight-bold'>abgemeldet</span>",
	"notification.type.mission.updated": "Die Mission <strong>{missionTitle}</strong> wurde von einem Missionseditor aktualisiert",
	"rights.reserved": "Alle Rechte vorbehalten",
	"store.addMissionAccess": "Missionszugang wird hinzugefügt...",
	"store.addMissionAccess.error": "Hinzufügen des Missionszugangs ist fehlgeschlagen",
	"store.addMissionAccess.success": "Misisonszugang wurde erfolgreich hinzugefügt",
	"store.addMissionPermission": "Missionsberechtigung wird hinzugefügt...",
	"store.addMissionPermission.error": "Hinzufügen der Missionsberechtigung ist fehlgeschlagen",
	"store.addMissionPermission.success": "Missionsberechtigung wurde erfolgreich hinzugefügt",
	"store.applySlotTemplateToMission": "Slot-Vorlage wird auf Mission angewandt...",
	"store.applySlotTemplateToMission.error": "Anwenden der Slot-Vorlage auf Mission ist fehlgeschlagen",
	"store.applySlotTemplateToMission.success": "Slot-Vorlage wurde erfolgreich auf Mission angewandt",
	"store.applyToCommunity": "Community-Bewerbung wird abgeschickt...",
	"store.applyToCommunity.error": "Abschicken der Community-Bewerbung ist fehlgeschlagen",
	"store.applyToCommunity.success": "Community-Bewerbung wurde erfolgreich abgeschickt",
	"store.assignMissionSlot": "Slot wird zugewiesen...",
	"store.assignMissionSlot.error": "Zuweisung des Slots ist fehlgeschlagen",
	"store.assignMissionSlot.success": "Slot wurde erfolgreich zugewiesen",
	"store.checkCommunitySlugAvailability.error": "Überprüfung der Community-Slug Verfügbarkeit ist fehlgeschlagen",
	"store.checkMissionSlugAvailability.error": "Überprüfung der Missions-Slug Verfügbarkeit für <strong>{payload}</strong> ist fehlgeschlagen",
	"store.createCommunity": "Community wird erstellt...",
	"store.createCommunity.error": "Community-Erstellung ist fehlgeschlagen",
	"store.createCommunity.success": "Community wurde erfolgreich erstellt",
	"store.createCommunityPermission": "Communityberechtigung wird erstellt...",
	"store.createCommunityPermission.error": "Erstellung der Communityberechtigung ist fehlgeschlagen",
	"store.createCommunityPermission.success": "Communityberechtigung wurde erfolgreich erstellt",
	"store.createMission": "Mission wird erstellt...",
	"store.createMission.error": "Erstellung der Mission <strong>{title}</strong> ist fehlgeschlagen",
	"store.createMission.success": "Mission <strong>{title}</strong> wurde erfolgreich erstellt",
	"store.createMissionSlot": "Slot wird erstellt... | {count} Slots werden erstellt...",
	"store.createMissionSlot.error": "Erstellung des Slots ist fehlgeschlagen | Erstellung von {count} Slots ist fehlgeschlagen",
	"store.createMissionSlot.success": "Slot wurde erfolgreich erstellt | {count} Slots wurden erfolgreich erstellt",
	"store.createMissionSlotGroup": "Slotgruppe wird erstellt...",
	"store.createMissionSlotGroup.error": "Erstellung der Slotgruppe <strong>{slotGroupInfo}</strong> ist fehlgeschlagen",
	"store.createMissionSlotGroup.success": "Slotgrouppe <strong>{slotGroupInfo}</strong> wurde erfolgreich erstellt",
	"store.createMissionSlotTemplate": "Slot-Vorlage wird erstellt...",
	"store.createMissionSlotTemplate.error": "Erstellen der Slot-Vorlage <strong>{title}</strong> ist fehlgeschlagen",
	"store.createMissionSlotTemplate.success": "Slot-Vorlage <strong>{title}</strong> wurde erfolgreich erstellt",
	"store.deleteAccount": "Account wird gelöscht...",
	"store.deleteAccount.error": "Löschen des Accounts ist fehlgeschlagen",
	"store.deleteAccount.success": "Account wurde erfolgreich gelöscht",
	"store.deleteCommunity": "Community wird gelöscht...",
	"store.deleteCommunity.error": "Löschen der Community ist fehlgeschlagen",
	"store.deleteCommunity.success": "Community wurde erfolgreich gelöscht",
	"store.deleteCommunityLogo": "Logo wird gelöscht...",
	"store.deleteCommunityLogo.error": "Löschen des Logos ist fehlgeschlagen",
	"store.deleteCommunityLogo.success": "Logo wurde erfolgreich gelöscht",
	"store.deleteCommunityPermission": "Communityberechtigung wird gelöscht...",
	"store.deleteCommunityPermission.error": "Löschen der Communityberechtigung ist fehlgeschlagen",
	"store.deleteCommunityPermission.success": "Communityberechtigung wurde erfolgreich gelöscht",
	"store.deleteMission": "Mission wird gelöscht...",
	"store.deleteMission.error": "Löschen der Mission <strong>{title}</strong> ist fehlgeschlagen",
	"store.deleteMission.success": "Mission <strong>{title}</strong> wurde erfolgreich gelöscht",
	"store.deleteMissionAccess": "Missionszugang wird gelöscht...",
	"store.deleteMissionAccess.error": "Löschen des Missionszugangs ist fehlgeschlagen",
	"store.deleteMissionAccess.success": "Missionszugang wurde erfolgreich gelöscht",
	"store.deleteMissionBannerImage": "Banner-Bild wird gelöscht...",
	"store.deleteMissionBannerImage.error": "Löschen des Banner-Bildes ist fehlgeschlagen",
	"store.deleteMissionBannerImage.success": "Banner-Bild wurde erfolgreich gelöscht",
	"store.deleteMissionPermission": "Missionsberechtigung wird gelöscht...",
	"store.deleteMissionPermission.error": "Löschen der Missionsberechtigung ist fehlgeschlagen",
	"store.deleteMissionPermission.success": "Missionsberechtigung wurde erfolgreich gelöscht",
	"store.deleteMissionSlot": "Slot wird gelöscht...",
	"store.deleteMissionSlot.error": "Löschen des Slots <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.deleteMissionSlot.success": "Slot <strong>{slotInfo}</strong> wurde erfolgreich gelöscht",
	"store.deleteMissionSlotGroup": "Slotgruppe wird gelöscht...",
	"store.deleteMissionSlotGroup.error": "Löschen der Slotgruppe <strong>{title}</strong> ist fehlgeschlagen",
	"store.deleteMissionSlotGroup.success": "Slotgruppe <strong>{title}</strong> wurde erfolgreich gelöscht",
	"store.deleteMissionSlotRegistration": "Slotanmeldung wird gelöscht...",
	"store.deleteMissionSlotRegistration.error": "Löschen der Slotanmeldung ist fehlgeschlagen",
	"store.deleteMissionSlotRegistration.success": "Slotanmeldung wurde erfolgreich gelöscht",
	"store.deleteMissionSlotTemplate": "Slot-Vorlage wird gelöscht...",
	"store.deleteMissionSlotTemplate.error": "Löschen der Slot-Vorlage <strong>{title}</strong> ist fehlgeschlagen",
	"store.deleteMissionSlotTemplate.success": "Slot-Vorlage <strong>{title}</strong> wurde erfolgreich gelöscht",
	"store.deleteMissionToken": "Missions-Token wird gelöscht...",
	"store.deleteMissionToken.error": "Löschen des Missions-Tokens ist fehlgeschlagen",
	"store.deleteMissionToken.success": "Missions-Token wurde erfolgreich gelöscht",
	"store.deleteSelectedMissionSlots": "Slot wird gelöscht... | {count} Slots werden gelöscht...",
	"store.deleteSelectedMissionSlots.error": "Löschen von einem oder mehreren Slots ist fehlgeschlagen",
	"store.deleteSelectedMissionSlots.success": "Slot wurde erfolgreich gelöscht | {count} Slots wurden erfolgreich gelöscht",
	"store.deleteUser": "Benutzer wird gelöscht...",
	"store.deleteUser.error": "Löschen des Benutzers ist fehlgeschlagen",
	"store.deleteUser.success": "Benutzer wurde erfolgreich gelöscht",
	"store.duplicateMission": "Mission wird dupliziert...",
	"store.duplicateMission.error": "Duplizierung der Mission ist fehlgeschlagen",
	"store.duplicateMission.success": "Mission wurde erfolgreich dupliziert",
	"store.duplicateMissionSlotGroup": "Slotgruppe wird dupliziert...",
	"store.duplicateMissionSlotGroup.error": "Duplizierung der Slotgruppe <strong>{slotGroupInfo}</strong> ist fehlgeschlagen",
	"store.duplicateMissionSlotGroup.success": "Slotgrouppe <strong>{slotGroupInfo}</strong> wurde erfolgreich dupliziert",
	"store.editAccount": "Accountdetails werden aktualisiert...",
	"store.editAccount.error": "Aktualisierung der Accountdetails ist fehlgeschlagen",
	"store.editAccount.success": "Accountdetails wurden erfolgreich aktualisiert",
	"store.editCommunity": "Communitydetails werden aktualisiert...",
	"store.editCommunity.error": "Aktualisierung der Communitydetails ist fehlgeschlagen",
	"store.editCommunity.success": "Communitydetails wurden erfolgreich aktualisiert",
	"store.editMission": "Mission wird bearbeitet...",
	"store.editMission.error": "Bearbeitung der Mission <strong>{title}</strong> ist fehlgeschlagen",
	"store.editMission.success": "Mission <strong>{title}</strong> wurde erfolgreich bearbeitet",
	"store.editMissionSlot": "Slot wird bearbeitet...",
	"store.editMissionSlot.error": "Bearbeitung des Slots <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.editMissionSlot.success": "Slot <strong>{slotInfo}</strong> wurde erfolgreich bearbeitet",
	"store.editMissionSlotGroup": "Slotgruppe wird bearbeitet...",
	"store.editMissionSlotGroup.error": "Bearbeitung der Slotgruppe ist fehlgeschlagen",
	"store.editMissionSlotGroup.success": "Slotgruppe wurde erfolgreich bearbeitet",
	"store.editMissionSlotTemplate": "Slot-Vorlage wird bearbeitet...",
	"store.editMissionSlotTemplate.error": "Bearbeitung der Slot-Vorlage <strong>{title}</strong> ist fehlgeschlagen",
	"store.editMissionSlotTemplate.success": "Slot-Vorlage <strong>{title}</strong> wurde erfolgreich bearbeitet",
	"store.editSelectedMissionSlots": "1 Slot wird bearbeitet... | {count} Slots werden bearbeitet...",
	"store.editSelectedMissionSlots.error": "Bearbeiten von einem oder mehreren Slots ist fehlgeschlagen",
	"store.editSelectedMissionSlots.success": "1 Slot wurde erfolgreich bearbeitet | {count} Slots wurden erfolgreich bearbeitet",
	"store.editUser": "Userdetails werden aktualisiert...",
	"store.editUser.error": "Aktualisierung der Userdetails ist fehlgeschlagen",
	"store.editUser.success": "Userdetails wurden erfolgreich aktualisiert",
	"store.generateMissionToken": "Missions-Token wird generiert...",
	"store.generateMissionToken.error": "Generieren des Missions-Tokens ist fehlgeschlagen",
	"store.generateMissionToken.success": "Missions-Token wurde erfolgreich generiert",
	"store.getAccountDetails": "Accountdetails werden geladen...",
	"store.getAccountDetails.error": "Laden der Accountdetails ist fehlgeschlagen",
	"store.getCommunities": "Communities werden geladen...",
	"store.getCommunities.error": "Laden der Communities ist fehlgeschlagen",
	"store.getCommunityApplications": "Community-Bewerbungen werden geladen...",
	"store.getCommunityApplications.error": "Laden der Community-Bewerbungen ist fehlgeschlagen",
	"store.getCommunityApplicationStatus": "Status der Community-Bewerbung wird geladen...",
	"store.getCommunityApplicationStatus.error": "Laden des Status der Community-Bewerbung ist fehlgeschlagen",
	"store.getCommunityDetails": "Communitydetails werden geladen...",
	"store.getCommunityDetails.error": "Laden der Communitydetails ist fehlgeschlagen",
	"store.getCommunityDetails.error.notFound": "Eine Community mit dem Slug <strong>{slug}</strong> wurde nicht gefunden",
	"store.getCommunityMissions": "Community-Missionen werden geladen...",
	"store.getCommunityMissions.error": "Laden der Community-Missionen ist fehlgeschlagen",
	"store.getCommunityPermissions": "Communityberechtigungen werden geladen...",
	"store.getCommunityPermissions.error": "Laden der Communityberechtigungen ist fehlgeschlagen",
	"store.getCommunityRepositories": "Community Mod-Repositories werden geladen...",
	"store.getCommunityRepositories.error": "Laden der Community Mod-Repositories ist fehlgeschlagen",
	"store.getCommunityServers": "Community-Server werden geladen...",
	"store.getCommunityServers.error": "Laden der Community-Server ist fehlgeschlagen",
	"store.getLoginRedirectUrl.error": "Steam SSO URL konnte nicht geladen werden",
	"store.getMissionAccesses": "Missionszugänge werden geladen...",
	"store.getMissionAccesses.error": "Laden der Missionszugänge ist fehlgeschlagen",
	"store.getMissionDetails": "Missionsdetails werden geladen...",
	"store.getMissionDetails.error": "Laden der Missionsdetails ist fehlgeschlagen",
	"store.getMissionDetails.error.notFound": "Eine Mission mit dem Slug <strong>{slug}</strong> wurde nicht gefunden oder ist nicht sichtbar",
	"store.getMissionPermissions": "Missionsberechtigungen werden geladen...",
	"store.getMissionPermissions.error": "Laden der Missionsberechtigungen ist fehlgeschlagen",
	"store.getMissions": "Missionen werden geladen...",
	"store.getMissions.error": "Laden der Missionen ist fehlgeschlagen",
	"store.getMissionsForCalendar.error": "Laden der Missionen für den Kalender ist fehlgeschlagen",
	"store.getMissionSlotlist": "Missions-Slotliste wird geladen...",
	"store.getMissionSlotlist.error": "Laden der Missions-Slotliste ist fehlgeschlagen",
	"store.getMissionSlotRegistrations": "Slot-Anmeldungen werden geladen...",
	"store.getMissionSlotRegistrations.error": "Laden der Anmeldungen für Slot <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.getMissionSlotTemplateDetails": "Slotvorlagen-Details werden geladen...",
	"store.getMissionSlotTemplateDetails.error": "Laden der Slotvorlagen-Details ist fehlgeschlagen",
	"store.getMissionSlotTemplates": "Slot-Vorlagen werden geladen...",
	"store.getMissionSlotTemplates.error": "Laden der Slot-Vorlagen ist fehlgeschlagen",
	"store.getMissionToken": "Missions-Token wird geladen...",
	"store.getMissionToken.error": "Laden des Missions-Tokens ist fehlgeschlagen",
	"store.getNotifications": "Benachrichtigungen werden geladen...",
	"store.getNotifications.error": "Laden der Benachrichtigungen ist fehlgeschlagen",
	"store.getUnseenNotificationCount.error": "Laden der Anzahl an ungelesenen Benachrichtigungen ist fehlgeschlagen",
	"store.getUserDetails": "Benutzerdetails werden geladen...",
	"store.getUserDetails.error": "Laden der Benutzerdetails ist fehlgeschlagen",
	"store.getUserMissions": "Benutzer-Missionen werden geladen...",
	"store.getUserMissions.error": "Laden der Benutzer-Missionen ist fehlgeschlagen",
	"store.getUsers": "Benutzer werden geladen...",
	"store.getUsers.error": "Laden der Benutzer ist fehlgeschlagen",
	"store.modifyMissionSlotRegistration": "Slot-Anmeldung wird bearbeitet...",
	"store.modifyMissionSlotRegistration.error": "Bearbeitung der Slot-Anmeldung ist fehlgeschlagen",
	"store.modifyMissionSlotRegistration.success": "Slot-Anmeldung wurde erfolgreich bearbeitet",
	"store.performLogin": "Login wird durchgeführt...",
	"store.performLogin.error": "Login fehlgeschlagen",
	"store.processCommunityApplication": "Community-Bewerbung wird verarbeitet...",
	"store.processCommunityApplication.accept": "Annehmen",
	"store.processCommunityApplication.accepted": "angenommen",
	"store.processCommunityApplication.denied": "abgelehnt",
	"store.processCommunityApplication.deny": "Ablehnen",
	"store.processCommunityApplication.error": "{action} der Community-Bewerbung für Benutzer <strong>{nickname}</strong> ist fehlgeschlagen",
	"store.processCommunityApplication.success": "Community-Bewerbung für Benutzer <strong>{nickname}</strong> wurde erfolgreich {action}",
	"store.refreshToken": "Authentifizierung wird aktualisiert...",
	"store.refreshToken.error": "Login fehlgeschlagen",
	"store.registerForMissionSlot": "Anmeldung für Slot wird durchgeführt...",
	"store.registerForMissionSlot.error": "Anmeldung für Slot <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.registerForMissionSlot.success": "Anmeldung für Slot <strong>{slotInfo}</strong> wurde erfolgreich durchgeführt",
	"store.removeCommunityMember": "Community-Mitglied wird entfernt...",
	"store.removeCommunityMember.error": "Entfernen des Community-Mitglieds <strong>{nickname}</strong> ist fehlgeschlagen",
	"store.removeCommunityMember.success": "Community-Mitglied <strong>{nickname}</strong> wurde erfolgreich entfernt",
	"store.searchCommunities.error": "Suche nach Communities ist fehlgeschlagen",
	"store.searchMissions.error": "Suche nach Missionen ist fehlgeschlagen",
	"store.searchUsers.error": "Suche nach Benutzern ist fehlgeschlagen",
	"store.unassignSelectedMissionSlots": "Zuweisung von Slot wird entfernt... | Zuweisungen von {count} Slots werden entfernt...",
	"store.unassignSelectedMissionSlots.error": "Entfernung der Zuweisung von einem oder mehreren Slots ist fehlgeschlagen",
	"store.unassignSelectedMissionSlots.success": "Zuweisung von Slot wurde erfolgreich entfernt | Zuweisungen von {count} Slots wurden erfolgreich entfernt",
	"store.unregisterFromMissionSlot": "Abmeldung von Slot wird durchgeführt...",
	"store.unregisterFromMissionSlot.error": "Abmeldung von Slot <strong>{slotInfo}</strong> ist fehlgeschlagen",
	"store.unregisterFromMissionSlot.success": "Abmeldung von Slot <strong>{slotInfo}</strong> wurde erfolgreich durchgeführt",
	"store.uploadCommunityLogo": "Lade Logo hoch...",
	"store.uploadCommunityLogo.error": "Hochladen des Logos ist fehlgeschlagen",
	"store.uploadCommunityLogo.success": "Logo wurde erfolgreich hochgeladen",
	"store.uploadMissionBannerImage": "Lade Banner-Bild hoch...",
	"store.uploadMissionBannerImage.error": "Hochladen des Banner-Bildes ist fehlgeschlagen",
	"store.uploadMissionBannerImage.success": "Banner-Bild wurde erfolgreich hochgeladen",
	"title.browser": "ArmA 3 Missions- und Slotlist-Management",
	"user": "Benutzer",
	"user.confirm.activate": "User-Account aktivieren?",
	"user.confirm.deactivate": "User-Account deaktiveren?",
	"user.confirm.delete": "User löschen?",
	"user.list.search": "Nach Benutzer suchen",
	"user.list.search.description": "Suche nach einem Benutzer mit dem angegebenen Nickname, inklusive Teil-Übereinstimmungen. Per Klick auf das Suchergebnis wirst du auf die Detail-Seite des Benutzers weitergeleitet",
	"user.modal.edit": "Userdetails bearbeiten",
	"user.nickname": "Nickname",
	"user.status": "Status",
	"user.status.deactivated": "Account deaktiviert",
	"user.status.normal": "normal",
	"user.steamId": "Steam ID"
};

/***/ }),
/* 593 */
/* unknown exports provided */
/* all exports used */
/*!**************************!*\
  !*** ./src/i18n/en.json ***!
  \**************************/
/***/ (function(module, exports) {

module.exports = {
	"account.currentTime": "current date/time:",
	"account.delete.confirm": "Are you sure you want to delete your account?<br><span class='font-weight-bold text-danger'>This action is irreversible and will destroy all data associated with your account</span>.<br>This includes all of your missions, registrations as well as permissions granted to your account.",
	"account.delete.feedback.nickname": "The entered nickname does not exactly match your current nickname",
	"account.delete.nickname": "Enter the exact nickname of your account",
	"account.delete.nickname.description": "Please enter your current, exact nickname - including correct capitalisation - to confirm the deletion of your account",
	"account.feedback.nickname": "Please enter a nickname",
	"account.modal.delete": "Delete account",
	"account.modal.edit": "Edit account details",
	"account.noChanges": "No changes made to account details",
	"account.notAssociated": "not associated",
	"account.permission": "Permission",
	"account.permissions": "Permissions",
	"account.timezone": "Timezone",
	"button.accept": "Accept",
	"button.activate.user": "Activate account",
	"button.add": "Add",
	"button.add.mission.access": "Add access",
	"button.add.mission.permission": "Add permission",
	"button.apply": "Apply",
	"button.apply.mission.slotGroup": "Apply slot template",
	"button.apply.mission.slotGroup.short": "Apply",
	"button.assign": "Assign",
	"button.assign.mission.slot": "Assign slot",
	"button.cancel": "Cancel",
	"button.clear.selection": "Clear selection",
	"button.close": "Close",
	"button.confirm": "Confirm",
	"button.convert.slotTemplate": "Convert to slot template",
	"button.copy": "Copy",
	"button.create.community": "Create community",
	"button.create.community.permission": "Create permission",
	"button.create.mission": "Create mission",
	"button.create.mission.slot": "Create slot",
	"button.create.mission.slot.template": "Create slot template",
	"button.create.mission.slotGroup": "Create slot group",
	"button.deactivate.user": "Deactivate account",
	"button.delete": "Delete",
	"button.delete.account": "Delete account",
	"button.delete.mission.slot.selection": "Delete selected slots",
	"button.delete.user": "Delete user",
	"button.deny": "Deny",
	"button.details": "Details",
	"button.duplicate.mission": "Duplicate mission",
	"button.duplicate.mission.slot": "Duplicate slot",
	"button.duplicate.mission.slotGroup": "Duplicate slot group",
	"button.duplicate.mission.slotTemplate": "Duplicate slot template",
	"button.edit": "Edit",
	"button.edit.community.logo": "Edit logo",
	"button.edit.community.permissions": "Edit permissions",
	"button.edit.mission.accesses": "Edit access",
	"button.edit.mission.bannerImage": "Edit banner image",
	"button.edit.mission.permissions": "Edit permissions",
	"button.edit.mission.slot.selection": "Edit selected slots",
	"button.edit.mission.slotGroup": "Edit slot group",
	"button.embed.mission": "Embed mission",
	"button.export.calendar.google": "Google",
	"button.export.calendar.ical": "iCal",
	"button.generate": "Generate",
	"button.join": "Join",
	"button.move.down": "Move down",
	"button.move.up": "Move up",
	"button.refresh": "Refresh",
	"button.refresh.authentication": "Refresh authentication",
	"button.refresh.authentication.explanation": "You can refresh your authentication to make sure your account is updated with the correct permissions, community or likewise.<br>After being accepted to a community, a refresh is required before your account shows you as a community member and you can create community missions.",
	"button.register": "Register",
	"button.remove": "Remove",
	"button.save": "Save",
	"button.save.mission.slotTemplate.slotlist": "Save template slotlist",
	"button.submit": "Submit",
	"button.unassign": "Unassign",
	"button.unassign.mission.slot.selection": "Unassign selected slots",
	"button.unregister": "Unregister",
	"button.upload": "Upload",
	"calendar.month.current": "Today",
	"calendar.month.next": "Next",
	"calendar.month.previous": "Previous",
	"calendar.title": "Upcoming missions",
	"community.application.confirm.accept": "Accept application?",
	"community.application.confirm.deny": "Deny application?",
	"community.application.nickname": "Nickname",
	"community.application.status": "Status",
	"community.applications": "Applications",
	"community.applications.filter": "Filter - processed applications are hidden by default",
	"community.applications.filter.accepted": "accepted",
	"community.applications.filter.denied": "denied",
	"community.applications.filter.processed": "processed",
	"community.confirm.delete": "Delete community?",
	"community.creator.feedback.name": "Please enter a name",
	"community.creator.feedback.slug": "Enter a slug",
	"community.creator.feedback.slug.checking": "<em>Checking community slug availability...</em>",
	"community.creator.feedback.slug.notAvailable": "Community slug not available",
	"community.creator.feedback.tag": "Please enter a tag",
	"community.creator.feedback.website": "Please enter a valid website URL",
	"community.creator.title": "Create new community",
	"community.creator.title.browser": "Community creator",
	"community.gameServers": "Community gameservers",
	"community.gameServers.description": "You can select a gameserver defined for your community to quickly fill out the gameserver details above. Please note that this overwrites any data entered by you before",
	"community.gameServers.hostname.description": "Hostname/IP address of the gameserver to add to the community's list",
	"community.gameServers.name.description": "Name of the gameserver (e.g. in a server list) to add to the community's list. Leave empty if not relevant",
	"community.gameServers.password.description": "Password for the gameserver to add to the community's list. Leave empty if no password is required",
	"community.gameServers.port.description": "Port of the gameserver to add to the community's list",
	"community.leader": "Leader",
	"community.list.search": "Search communities",
	"community.list.search.description": "Start typing to search for a community with the given name, including partial matches. Clicking a community result will take you to its details page",
	"community.logo": "Logo",
	"community.logo.choose": "Choose file",
	"community.logo.description": "The logo is prominently displayed below the community name and above the community's information",
	"community.logo.feedback.fileType": "Invalid file type (only jpeg, png and gif are allowed)",
	"community.logo.feedback.size": "File too large (max. 2 MiB)",
	"community.logo.notSelected": "No logo selected",
	"community.member.confirm.remove": "Remove member?",
	"community.members": "Members",
	"community.modal.edit": "Edit community details",
	"community.modal.logo": "Edit logo",
	"community.modal.permission": "Community permissions",
	"community.name": "Name",
	"community.name.description": "Full name of the community",
	"community.noChanges": "No changes made to community details",
	"community.permission.create": "Create community permission",
	"community.permission.existing": "Existing community permissions",
	"community.permission.founder": "Community founder",
	"community.permission.leader": "Community leader",
	"community.permission.permission": "Permission to grant to user",
	"community.permission.permission.description": "Select the permission to grant to the user. <span class='font-weight-bold'>Community leaders</span> can modify your community's details as well as accept and remove members, but cannot delete the community or grant permissions to others. <span class='font-weight-bold'>Community recruitment</span> users can only accept community applications, but not remove members or edit any details.",
	"community.permission.recruitment": "Community recruitment",
	"community.permission.user.selection": "Search for user to grant permission to",
	"community.permission.user.selection.description": "Start typing to search for an user with the given nickname, including partial matches",
	"community.repositories": "Community mod repositories",
	"community.repositories.description": "You can select a mod repository defined for your community to quickly fill out the repo details above. Please note that this overwrites any data entered by you before",
	"community.slug": "Slug",
	"community.slug.description": "Slug to use for community URL, must be unique",
	"community.tag": "Tag",
	"community.tag.description": "Community tag to display for all members (prefixed before name)",
	"community.voiceComms": "Community voice comms",
	"community.voiceComms.description": "You can select a voice comms server defined for your community to quickly fill out the voice comms details above. Please note that this overwrites any data entered by you before",
	"community.voiceComms.hostname.description": "Hostname/IP address of the voice comms server to add to the community's list",
	"community.voiceComms.name.description": "Name of the voice comms server (e.g. in a server list) to add to the community's list. Leave empty if not relevant",
	"community.voiceComms.password.description": "Password for the voice comms server to add to the community's list. Leave empty if no password is required",
	"community.voiceComms.port.description": "Port of the voice comms server to add to the community's list",
	"community.website": "Website",
	"community.website.optional": "Website <em>(optional)</em>",
	"editor.explanation": "Click here for editor explanation",
	"editor.explanation.1": "Text size",
	"editor.explanation.2": "Headings",
	"editor.explanation.3": "Text color",
	"editor.explanation.4": "Bold/italic text",
	"editor.explanation.5": "Text alignment, text indentation",
	"editor.explanation.6": "Ordered & unordered lists",
	"editor.explanation.7": "Insert link, image or video",
	"editor.explanation.8": "Clear formatting",
	"editor.explanation.missing": "Some editor controls might be disabled or missing depending on the edited mission element",
	"failed.request": "Request failed",
	"failed.something": "Something failed...",
	"misc.actions": "Actions",
	"misc.notProvided": "not provided",
	"misc.notRequired": "not required",
	"misc.notSpecified": "not specified",
	"mission": "Mission",
	"mission.abbr.estimated": "est.",
	"mission.abbr.leadership": "ldrsp.",
	"mission.access.add": "Add mission access",
	"mission.access.add.explanation": "Choose communities or users that should have access to your mission and can register for slots.<br>By default, only you and all mission editors can see this mission - you will have to explicitly grant access to any other community or user.<br>Granting access to a community allows all members of this community to view the mission. Granting access to a single user only allows this user to view the mission.",
	"mission.access.community.selection": "Search for community to grant access to",
	"mission.access.community.selection.description": "Start typing to search for a community with the given name or tag, including partial matches. You can only grant a permission to either a community or an user, but not both simultaneously",
	"mission.access.existing": "Existing mission access",
	"mission.access.list.name": "Name",
	"mission.access.list.type": "Access type",
	"mission.access.list.type.community": "Community",
	"mission.access.list.type.user": "User",
	"mission.access.user.selection": "Search for user to grant access to",
	"mission.access.user.selection.description": "Start typing to search for an user with the given nickname, including partial matches. You can only grant a permission to either an user or a community, but not both simultaneously",
	"mission.apply.slotTemplate.description": "Apply a slot template to a mission, adding all defined slot groups at the selected position.<br>You can filter slot templates and select the desired template to apply.",
	"mission.bannerImage": "Banner image",
	"mission.bannerImage.choose": "Choose file",
	"mission.bannerImage.description": "The banner image is prominently displayed below the mission title and above the mission's description",
	"mission.bannerImage.feedback.fileType": "Invalid file type (only jpeg, png and gif are allowed)",
	"mission.bannerImage.feedback.size": "File too large (max. 2 MiB)",
	"mission.bannerImage.notSelected": "No banner image selected",
	"mission.briefingTime": "Briefing time",
	"mission.briefingTime.description": "Date and time the leadership briefing will be held",
	"mission.briefingTime.short": "Briefing",
	"mission.by": "by",
	"mission.collapsedDescription.description": "An optional, collapsed mission description can be used to provide even greater mission details and preparations to your players without having to scroll endlessly every time they want to check out the slotlist. This description is collapsed by default - only displaying a toggle button - and will be displayed after the mission's detailed description and before the slotlist",
	"mission.collapsedDescription.optional": "Collapsed mission description <em>(optional)</em>",
	"mission.collapsedDescription.toggle.close": "Collapse additional mission description",
	"mission.collapsedDescription.toggle.open": "Extend additional mission description",
	"mission.community": "Community",
	"mission.confirm.delete": "Delete mission?",
	"mission.convert.slotTemplate.description": "You can convert the current slotlist of this mission to a slot template, allowing you to reuse the configured slot groups and slots for other missions. Slot templates do not include community restrictions or slot assignments. Converting a mission to a slot template does not modify or delete the mission's slotlist in any way.<br>Choose a title and a visibility setting for the converted slot template.",
	"mission.creator": "Creator",
	"mission.creator.addToCommunity": "Add mission to community?",
	"mission.creator.addToCommunity.description": "Adding a mission to your community <strong>{communityInfo}</strong> makes it visible in the community's mission list",
	"mission.creator.title": "Create new mission",
	"mission.creator.title.browser": "Mission creator",
	"mission.description": "Description",
	"mission.description.description": "Description of the mission, providing a quick summary for the mission list",
	"mission.detailedDescription": "Detailed description",
	"mission.detailedDescription.description": "Detailed description of mission story, scenario, plot, tasks, etc. Everything your players should know before choosing to participate",
	"mission.details": "Mission details",
	"mission.duplicate.briefingTime.description": "New, optional briefing time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.description": "Choose a new slug to use for the duplicated mission.<br>You can also overwrite the mission's title, mission times as well as visibility and community settings.<br>All data omitted will be replaced by the original mission's values.",
	"mission.duplicate.endTime.description": "New, optional end time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.slottingTime.description": "New, optional slotting time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.slug.description": "Slug to use for duplicate mission",
	"mission.duplicate.startTime.description": "New, optional start time to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.title.description": "New, optional title to overwrite for duplicated mission - can be omitted",
	"mission.duplicate.visibility.description": "Defines visibility of duplicated mission to other users, only allowing access to selected group",
	"mission.endTime": "End time",
	"mission.endTime.description": "Estimated date and time the mission will end at",
	"mission.feedback.dateTime": "Please enter a valid date and time",
	"mission.feedback.dateTime.afterSlotting": "Start time must be after slotting time",
	"mission.feedback.dateTime.afterStart": "End time must be after start time",
	"mission.feedback.description": "Please enter a short description",
	"mission.feedback.detailedDescription": "Please enter a detailed description",
	"mission.feedback.orderNumber": "Please enter an order number",
	"mission.feedback.repository.kind": "Please select a repository type",
	"mission.feedback.repository.name": "Please provide a repository name",
	"mission.feedback.repository.url": "Please provide a valid URL",
	"mission.feedback.repository.url.arma3sync": "Please provide a repository URL for an ArmA3Sync repository",
	"mission.feedback.repository.urlOrNotes": "Please provide at least either a repository URL or notes",
	"mission.feedback.serverInfo.hostnamePort": "Both hostname and port must be provided",
	"mission.feedback.serverInfo.portRange": "Port values must be between 0 and 65535",
	"mission.feedback.slot.autoAssignable.mission": "All slots will be created as auto-assignable since the mission's auto-assignable setting is enabled",
	"mission.feedback.slug": "Enter a slug",
	"mission.feedback.slug.checking": "<em>Checking mission slug availability...</em>",
	"mission.feedback.slug.notAvailable": "Mission slug not available",
	"mission.feedback.title": "Please enter a mission title",
	"mission.feedback.title.slot": "Please enter a slot title",
	"mission.feedback.title.slotGroup": "Please enter a slot group title",
	"mission.feedback.visibility": "Please select a visibility setting",
	"mission.gameServer": "Gameserver",
	"mission.gameServer.hostname.description": "Hostname/IP address of the gameserver the mission will be held on",
	"mission.gameServer.hostname.optional": "Gameserver hostname/IP <em>(optional)</em>",
	"mission.gameServer.name.description": "Name of the gameserver (e.g. in a server list) the mission will be held on. Leave empty if not relevant",
	"mission.gameServer.name.optional": "Gameserver name <em>(optional)</em>",
	"mission.gameServer.password.description": "Password for the gameserver the mission will be held on. Leave empty if no password is required",
	"mission.gameServer.password.optional": "Gameserver password <em>(optional)</em>",
	"mission.gameServer.port.description": "Port of the gameserver the mission will be held on",
	"mission.gameServer.port.optional": "Gameserver port <em>(optional)</em>",
	"mission.list.creator": "Creator",
	"mission.list.description": "Description",
	"mission.list.filter": "Filter - past missions are hidden by default",
	"mission.list.filter.assigned": "Missions with assigned slots",
	"mission.list.filter.ended": "Show past missions",
	"mission.list.filter.registered": "Missions with slot registrations",
	"mission.list.isMissionEditor": "You have editor permissions for this mission",
	"mission.list.search": "Search missions",
	"mission.list.search.description": "Start typing to search for a mission with the given title, including partial matches. Clicking a mission result will take you to its details page",
	"mission.list.slot.counts": "# of players",
	"mission.list.slot.counts.available": "Available slots",
	"mission.list.slot.counts.available.popover": "<strong>{open}</strong> slots are available to you",
	"mission.list.slot.counts.available.popover.community": "<strong>{open}</strong> slots are available to you and your fellow community members",
	"mission.list.slot.counts.popover": "<strong>{unassigned}</strong> slots have registrations, but have not been assigned yet. <strong>{assigned}</strong> slots have been assigned, <strong>{external}</strong> slots have been assigned to external players.<br>There are <strong>{blocked}</strong> blocked, <strong>{restricted}</strong> restricted and <strong>{reserve}</strong> reserve slots",
	"mission.list.slot.status": "Registration",
	"mission.list.slot.status.assigned": "Slot registration <span class='font-weight-bold text-success'>confirmed</span>, assigned to slot",
	"mission.list.slot.status.registered": "Slot registration <span class='font-weight-bold text-danger'>not confirmed</span>, not assigned to slot yet",
	"mission.list.startTime": "Start time",
	"mission.list.title": "Title",
	"mission.modal.access": "Mission access",
	"mission.modal.apply.slotTemplate": "Apply slot template to mission",
	"mission.modal.bannerImage": "Edit banner image",
	"mission.modal.convert.slotTemplate": "Convert mission to slot template",
	"mission.modal.duplicate": "Duplicate mission",
	"mission.modal.edit": "Edit mission",
	"mission.modal.embed": "Embed mission",
	"mission.modal.permission": "Mission permissions",
	"mission.modal.slot.assign": "Assign user to slot {slotInfo}",
	"mission.modal.slot.create": "Create slot in slot group",
	"mission.modal.slot.details": "Slot details",
	"mission.modal.slot.edit": "Edit slot",
	"mission.modal.slot.register": "Register for slot",
	"mission.modal.slot.register.text": "Confirm registration as {slotInfo}?",
	"mission.modal.slot.selection.edit": "Edit selected slots",
	"mission.modal.slotGroup.create": "Create slot group",
	"mission.modal.slotGroup.edit": "Edit slot group",
	"mission.permission.add": "Add mission permission",
	"mission.permission.creator": "Mission creator",
	"mission.permission.editor": "Mission editor",
	"mission.permission.existing": "Existing mission permissions",
	"mission.permission.permission": "Permission to grant to user",
	"mission.permission.permission.description": "Select the permission to grant to the user. <span class='font-weight-bold'>Mission editors</span> can modify your mission's details and slotlist, but cannot delete the mission or grant permissions to others. Users with the <span class='font-weight-bold'>Community slot manager</span> permission can assign and unassign registrations for slots restricted to their community, but cannot modify any other mission data or slot registrations",
	"mission.permission.slotlist.community": "Community slot manager",
	"mission.permission.user.selection": "Search for user to grant permission to",
	"mission.permission.user.selection.description": "Start typing to search for an user with the given nickname, including partial matches",
	"mission.registration.comment": "Comment",
	"mission.registration.comment.description": "Optional comment to the mission creator (max. 128 char)",
	"mission.registration.comment.optional": "Comment <em>(optional)</em>",
	"mission.registration.confirmed": "Confirmed",
	"mission.registration.registered": "Registered",
	"mission.repository.kind": "Type",
	"mission.repository.kind.arma3sync": "ArmA3Sync",
	"mission.repository.kind.description": "Defined the type of mod repository. Clicking an <code>ArmA3Sync</code> repository link automatically copies it to clipboard",
	"mission.repository.kind.other": "Other",
	"mission.repository.list": "Mod repositories",
	"mission.repository.list.empty": "No mod repositories required",
	"mission.repository.name": "Name",
	"mission.repository.name.description": "Name of the mod repository, mostly useful for searching in repo lists",
	"mission.repository.name.optional": "Name <em>(optional)</em>",
	"mission.repository.name.required": "Name",
	"mission.repository.notes": "Notes",
	"mission.repository.notes.description": "Optional notes about a repository, e.g. explaining the usage or required files. Required if no URL is provided",
	"mission.repository.notes.optional": "Notes <em>(optional)</em>",
	"mission.repository.url": "URL",
	"mission.repository.url.description": "URL of the mod repository. Required for <code>ArmA3Sync</code> repos, optional for others",
	"mission.repository.url.empty": "no repo URL provided",
	"mission.repository.url.optional": "URL <em>(optional)</em>",
	"mission.repositoryUrl": "Repository URL",
	"mission.repositoryUrl.description": "Can either be empty (if not required), a single URL to your repository or multiple links, including custom HTML formatting",
	"mission.repositoryUrl.optional": "Repository URL <em>(optional)</em>",
	"mission.requiredDLCs": "Required DLCs",
	"mission.requiredDLCs.aow": "Art of War",
	"mission.requiredDLCs.apex": "Apex",
	"mission.requiredDLCs.contact": "Contact",
	"mission.requiredDLCs.csla": "CSLA Iron Curtain",
	"mission.requiredDLCs.gm": "Global Mobilization",
	"mission.requiredDLCs.helicopters": "Helicopters",
	"mission.requiredDLCs.jets": "Jets",
	"mission.requiredDLCs.karts": "Karts",
	"mission.requiredDLCs.laws-of-war": "Laws of War",
	"mission.requiredDLCs.marksmen": "Marksmen",
	"mission.requiredDLCs.none": "no DLCs required",
	"mission.requiredDLCs.tac-ops": "Tac-Ops",
	"mission.requiredDLCs.tanks": "Tanks",
	"mission.requiredDLCs.vn": "S.O.G. Prairie Fire",
	"mission.rules": "Rules",
	"mission.rules.description": "General rules and guidelines for players while participating - mission specific restrictions should be added as a detailed description",
	"mission.rules.optional": "Rules <em>(optional)</em>",
	"mission.serverInfo.hostname": "Hostname/IP",
	"mission.serverInfo.name": "Server name",
	"mission.serverInfo.password": "Password",
	"mission.serverInfo.port": "Port",
	"mission.slot.assign.force": "Force slot assignment",
	"mission.slot.assign.force.description": "Forcing a slot assignment removes the selected user from their current slot if they have been assigned already - furthermore, the user currently assigned to the selected slot will be removed",
	"mission.slot.assign.selection": "Search for user to assign to slot",
	"mission.slot.assign.selection.description": "Start typing to search for an user with the given nickname, including partial matches",
	"mission.slot.assignee.registration": "no registrations | registration | registrations",
	"mission.slot.autoAssignable.description": "Auto-assignable slots do not require a registration-confirmation by a mission editor, but will automatically be assigned to the first user that register for it",
	"mission.slot.autoAssignable.slot": "Auto-assignable slot",
	"mission.slot.blocked": "blocked - no registration possible",
	"mission.slot.blocked.description": "Blocked slots are not available for registration",
	"mission.slot.blocked.popover": "Blocked - this slot has been blocked by the mission creator and is not available for registration",
	"mission.slot.blocked.slot": "Blocked slot",
	"mission.slot.confirm.delete": "Delete slot?",
	"mission.slot.confirm.delete.selection": "Delete selected slots?",
	"mission.slot.confirm.unassign.selection": "Unassign selected slots?",
	"mission.slot.confirm.unregister": "Unregister from slot?",
	"mission.slot.description": "Description",
	"mission.slot.description.description": "Optional, short description of the slot, e.g. explaining the equipment or vehicle used - displayed in slotlist",
	"mission.slot.description.optional": "Description <em>(optional)</em>",
	"mission.slot.detailedDescription": "Detailed description",
	"mission.slot.detailedDescription.description": "Optional, more detailed description of the slot, adding more information about the responsibilities or tasks assigned - displayed in slot details",
	"mission.slot.detailedDescription.optional": "Detailed description <em>(optional)</em>",
	"mission.slot.difficulty": "Difficulty",
	"mission.slot.difficulty.advanced": "Advanced",
	"mission.slot.difficulty.beginner": "Beginner",
	"mission.slot.difficulty.description": "Difficulity of the slot, helping players choose a role",
	"mission.slot.difficulty.easy": "Easy",
	"mission.slot.difficulty.expert": "Expert",
	"mission.slot.difficulty.medium": "Medium",
	"mission.slot.externalAssignee.description": "You can set an external assignee to assign a slot to a player that is not a user of our website. A slot can only either be assigned to a user <em>or</em> an external assignee",
	"mission.slot.externalAssignee.optional": "External assignee <em>(optional)</em>",
	"mission.slot.insertAfter": "Insert new slot after",
	"mission.slot.insertAfter.description": "Select the position after which the new slot should be inserted",
	"mission.slot.insertAfter.top": "Top of list",
	"mission.slot.move": "Move slot",
	"mission.slot.move.description": "Move the slot to a new position",
	"mission.slot.moveAfter": "Show slot after",
	"mission.slot.moveAfter.description": "Select the position after which the slot should be displayed",
	"mission.slot.moveAfter.keep": "Keep current position",
	"mission.slot.orderNumber": "Order number",
	"mission.slot.orderNumber.description": "Used for sorting slot in the mission slotlist",
	"mission.slot.player": "Player",
	"mission.slot.registrations": "Registrations",
	"mission.slot.reserve": "reserve",
	"mission.slot.reserve.description": "Reserve slots will only be filled if all other slots have been taken before",
	"mission.slot.reserve.popover": "Reserve - only filled after other slots are taken",
	"mission.slot.reserve.regular": "regular",
	"mission.slot.reserve.slot": "Reserve slot",
	"mission.slot.restricted": "restricted to {communityInfo}",
	"mission.slot.restricted.description": "Restricted slots are not available to the public, but only to players of the selected community",
	"mission.slot.restricted.popover": "Restricted - only available to <strong>{communityInfo}</strong> members",
	"mission.slot.restricted.selection": "Search for community to restrict slot to",
	"mission.slot.restricted.selection.description": "Start typing to search for a community with the given name or tag, including partial matches",
	"mission.slot.restricted.slot": "Restricted slot",
	"mission.slot.restricted.unrestricted": "unrestricted",
	"mission.slot.role": "Role",
	"mission.slot.selection.actions": "Perform actions for 1 selected slot | Perform actions for {count} selected slots",
	"mission.slot.selection.edit": "Allows you to edit certain values of 1 selected slot.<br>Data omitted will not be modified, you can thus only edit the values you want changed and leave the rest empty/not selected. Unfortunately, the slot statuses <code>restricted</code>, <code>reserve</code>,<code>blocked</code> and <code>auto-assignable</code> can only be removed for one slot at a time.<br>The following slot is affected: | Allows you to edit certain values of {count} selected slots.<br>Data omitted will not be modified, you can thus only edit the values you want changed and leave the rest empty/not selected. Unfortunately, the slot statuses <code>restricted</code>, <code>reserve</code>, <code>blocked</code> and <code>auto-assignable</code> can only be removed for one slot at a time.<br>The following slots are affected: ",
	"mission.slot.selection.hint": "Select multiple slots at the same time by clicking on them while holding <kbd>CTRL</kbd>",
	"mission.slot.status": "Status",
	"mission.slot.title": "Title",
	"mission.slot.title.description": "Title of the slot as displayed in the mission's slotlist",
	"mission.slotGroup.confirm.delete": "Delete slot group?",
	"mission.slotGroup.description": "Description",
	"mission.slotGroup.description.description": "Optional, short description of the slot group, e.g. explaining the group's general task or callsign - displayed in slotlist",
	"mission.slotGroup.description.optional": "Description <em>(optional)</em>",
	"mission.slotGroup.insertAfter": "Insert new slot group after",
	"mission.slotGroup.insertAfter.description": "Select the position after which the new slot group should be inserted",
	"mission.slotGroup.insertAfter.top": "Top of list",
	"mission.slotGroup.move": "Move slot group",
	"mission.slotGroup.move.description": "Move the slot group to a new position",
	"mission.slotGroup.moveAfter": "Show slot group after",
	"mission.slotGroup.moveAfter.description": "Select the position after which the slot group should be displayed",
	"mission.slotGroup.moveAfter.keep": "Keep current position",
	"mission.slotGroup.orderNumber": "Order number",
	"mission.slotGroup.orderNumber.description": "Used for sorting slot groups in the mission slotlist",
	"mission.slotGroup.title": "Title",
	"mission.slotGroup.title.description": "Title of the slot group as displayed in the mission's slotlist",
	"mission.slotlist": "Slotlist",
	"mission.slotlist.filter": "Filter",
	"mission.slotlist.filter.assigned": "assigned",
	"mission.slotlist.filter.blocked": "blocked",
	"mission.slotlist.filter.hasRegistrations": "has registrations",
	"mission.slotlist.filter.open": "open",
	"mission.slotlist.filter.restricted": "restricted",
	"mission.slotsAutoAssignable": "Auto-assignable slots",
	"mission.slotsAutoAssignable.description": "Auto-assignable slots do not require a registration-confirmation by a mission editor, but will automatically be assigned to the first user that register for it. By enabling this setting, all slots created <strong>from this point on</strong> will be set to be auto-assignable - existing slots will not be affected",
	"mission.slotTemplate": "Slot template",
	"mission.slotTemplate.confirm.delete": "Delete slot template?",
	"mission.slotTemplate.confirm.save.slotlist": "Save template slotlist?",
	"mission.slotTemplate.confirm.unsavedChanges": "Do you really want to leave? Your unsaved template slotlist changes will be lost!",
	"mission.slotTemplate.creator.title": "Create new slot template",
	"mission.slotTemplate.creator.title.browser": "Slot template creator",
	"mission.slotTemplate.duplicate.description": "You can overwrite the slot template's title as well as visibility setting.<br>All data omitted will be replaced by the original slot templates's values.",
	"mission.slotTemplate.duplicate.title.description": "New, optional title to overwrite for duplicated slot template - can be omitted",
	"mission.slotTemplate.duplicate.visibility.description": "Defines visibility of duplicated slot template to other users, only allowing access to selected group",
	"mission.slotTemplate.feedback.title": "Please enter a slot template title",
	"mission.slotTemplate.feedback.visibility": "Please select a visibility setting",
	"mission.slotTemplate.filter": "Slot template filter",
	"mission.slotTemplate.filter.description": "Filter slot templates by title or creator name, including partial matches",
	"mission.slotTemplate.insertAfter": "Apply slot template after",
	"mission.slotTemplate.insertAfter.description": "Select the position after which the slot template should be applied",
	"mission.slotTemplate.list.counts.slots": "# of slots",
	"mission.slotTemplate.list.counts.slots.groups": "# of slot groups",
	"mission.slotTemplate.modal.duplicate": "Duplicate slot template",
	"mission.slotTemplate.modal.edit": "Edit slot template",
	"mission.slotTemplate.slotlist": "Template slotlist",
	"mission.slotTemplate.title.description": "Title of the slot template, displayed in slot template list and details",
	"mission.slotTemplate.visibility.community": "community members",
	"mission.slotTemplate.visibility.default": "unknown",
	"mission.slotTemplate.visibility.description": "Defines visibility of the slot template to other users, only allowing access to the selected group",
	"mission.slotTemplate.visibility.hidden": "template creator only",
	"mission.slotTemplate.visibility.private": "selected communities and users",
	"mission.slotTemplate.visibility.public": "everyone",
	"mission.slottingTime": "Slotting time",
	"mission.slottingTime.description": "Date and time the missions slotting starts at",
	"mission.slug": "Slug",
	"mission.slug.description": "Slug to use for mission URL, must be unique",
	"mission.startTime": "Start time",
	"mission.startTime.description": "Date and time the mission starts",
	"mission.techSupport": "Tech support",
	"mission.techSupport.description": "Optional information about tech support or checks provided before the mission",
	"mission.techSupport.optional": "Tech support <em>(optional)</em>",
	"mission.times": "Slotting time: {slotting}\nStart time: {start}\nEnd time (est.): {end}\nBriefing (ldrsp.): {briefing}",
	"mission.times.ical": "Slotting time: {slotting}\\nStart time: {start}\\nEnd time (est.): {end}\\nBriefing (ldrsp.): {briefing}",
	"mission.timezone": "All mission times are displayed in the <em>{timezone}</em> timezone",
	"mission.title": "Title",
	"mission.title.description": "Title of the mission, displayed in mission list and details",
	"mission.token": "Mission token",
	"mission.token.description": "Mission tokens can be used as an alternative, static authentication method for embedding missions into different websites or forums. By default, all public missions can be embedded without extra configuration, however missions that do not have a public visibility setting require a mission token for embedding.<br>On the contrary to regular user authentication, mission tokens do not expire and only grant access to this specific mission. The information returned is identical to what a regular user would receive - no mission editor or creator specific data is provided.<br>By clicking the <strong>Generate</strong> button, you can generate a new mission token. Please note that this invalidates any previous tokens.<br>Using the <strong>Delete</strong> button, you can completely remove all mission tokens and thus remove all options to embed a non-public mission.",
	"mission.token.notGeneratedYet": "not generated yet",
	"mission.visibility": "Visibility",
	"mission.visibility.community": "community members",
	"mission.visibility.default": "unknown",
	"mission.visibility.description": "Defines visibility of the mission to other users, only allowing access to selected group",
	"mission.visibility.hidden": "mission creator & editors only",
	"mission.visibility.private": "selected communities and users",
	"mission.visibility.public": "everyone",
	"mission.voiceComms": "Voice Comms",
	"mission.voiceComms.hostname.description": "Hostname/IP address of the voice comms server used for the mission",
	"mission.voiceComms.hostname.optional": "Voice comms hostname/IP <em>(optional)</em>",
	"mission.voiceComms.name.description": "Name of the voice comms server (e.g. in a server list) the mission will be held on. Leave empty if not relevant",
	"mission.voiceComms.name.optional": "Voice comms name <em>(optional)</em>",
	"mission.voiceComms.password.description": "Password for the voice comms server used for the mission. Leave empty if no password is required",
	"mission.voiceComms.password.optional": "Voice comms password <em>(optional)</em>",
	"mission.voiceComms.port.description": "Port of the voice comms server used for the mission",
	"mission.voiceComms.port.optional": "Voice comms port <em>(optional)</em>",
	"nav.about": "About",
	"nav.account": "Account",
	"nav.admin.panel": "Admin Panel",
	"nav.api": "API",
	"nav.communities": "Communities",
	"nav.home": "Home",
	"nav.imprint": "Imprint",
	"nav.login": "Login",
	"nav.logout": "Logout",
	"nav.missions": "Missions",
	"nav.missionSlotTemplates": "Slot templates",
	"nav.notifications": "Notifications",
	"nav.privacy": "Privacy",
	"nav.users": "Users",
	"notification.list.filter": "Filter",
	"notification.list.filter.seen": "Include seen notifications",
	"notification.notification": "Notification",
	"notification.received": "Received",
	"notification.seen": "Seen",
	"notification.suppress": "Suppress notifications",
	"notification.suppress.description": "By suppressing notifications, you can prevent spamming your users due to multiple, subsequent or minor updates. If this checkbox is ticked, no notification will be created for the action performed. Please note that \"destructive\" actions such as slot unassignments, permission removal or mission deletion cannot have their notifications suppressed",
	"notification.type.community.application.accepted": "Your application to the community <strong>{communityName}</strong> has been <span class='text-success font-weight-bold'>accepted</span>",
	"notification.type.community.application.deleted": "<strong>{userNickname}</strong> has <span class='text-danger font-weight-bold'>deleted</span> their application to your community <strong>{communityName}</strong>",
	"notification.type.community.application.denied": "Your application to the community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>denied</span>",
	"notification.type.community.application.new": "<strong>{userNickname}</strong> has <span class='text-success font-weight-bold'>applied</span> to your community <strong>{communityName}</strong>",
	"notification.type.community.application.removed": "You have been <span class='text-danger font-weight-bold'>removed</span> from your community <strong>{communityName}</strong> by a community recruiter",
	"notification.type.community.deleted": "Your community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>deleted</span> by its founder",
	"notification.type.community.permission.granted": "You have been <span class='text-success font-weight-bold'>granted</span> the <strong>{translatedPermission}</strong> permission for your community <strong>{communityName}</strong>",
	"notification.type.community.permission.revoked": "Your <strong>{translatedPermission}</strong> permission for your community <strong>{communityName}</strong> has been <span class='text-danger font-weight-bold'>revoked</span>",
	"notification.type.mission.deleted": "The mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>deleted</span> by its creator",
	"notification.type.mission.permission.granted": "You have been <span class='text-success font-weight-bold'>granted</span> the <strong>{translatedPermission}</strong> permission for the mission <strong>{missionTitle}</strong>",
	"notification.type.mission.permission.revoked": "Your <strong>{translatedPermission}</strong> permission for the mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>revoked</span>",
	"notification.type.mission.slot.assigned": "You have been <span class='text-success font-weight-bold'>assigned</span> as <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong>",
	"notification.type.mission.slot.registration.new": "<strong>{userNicknameWithTag}</strong> has <span class='text-success font-weight-bold'>registered</span> for slot <strong>{slotTitle}</strong> for the mission <strong>{missionTitle}</strong>",
	"notification.type.mission.slot.unassigned": "Your assignment as <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong> has been <span class='text-danger font-weight-bold'>removed</span>",
	"notification.type.mission.slot.unregistered": "<strong>{userNicknameWithTag}</strong> has <span class='text-danger font-weight-bold'>unregistered</span> from their slot <strong>{slotTitle}</strong> in mission <strong>{missionTitle}</strong>",
	"notification.type.mission.updated": "Mission <strong>{missionTitle}</strong> was updated by a mission editor",
	"rights.reserved": "All rights reserved",
	"store.addMissionAccess": "Adding mission access...",
	"store.addMissionAccess.error": "Failed to add mission access",
	"store.addMissionAccess.success": "Successfully added mission access",
	"store.addMissionPermission": "Adding mission permission...",
	"store.addMissionPermission.error": "Failed to add mission permission",
	"store.addMissionPermission.success": "Successfully added mission permission",
	"store.applySlotTemplateToMission": "Applying slot template to mission...",
	"store.applySlotTemplateToMission.error": "Failed to apply slot template to mission",
	"store.applySlotTemplateToMission.success": "Successfully applied slot template to mission",
	"store.applyToCommunity": "Applying to community...",
	"store.applyToCommunity.error": "Failed to apply to community",
	"store.applyToCommunity.success": "Successfully applied to community",
	"store.assignMissionSlot": "Assigning slot...",
	"store.assignMissionSlot.error": "Failed to assign slot",
	"store.assignMissionSlot.success": "Successfully assigned slot",
	"store.checkCommunitySlugAvailability.error": "Failed to check availability of community slug",
	"store.checkMissionSlugAvailability.error": "Failed to check availability of mission slug <strong>{payload}</strong>",
	"store.createCommunity": "Creating community...",
	"store.createCommunity.error": "Failed to create community",
	"store.createCommunity.success": "Successfully created community",
	"store.createCommunityPermission": "Creating community permission...",
	"store.createCommunityPermission.error": "Failed to create community permission",
	"store.createCommunityPermission.success": "Successfully created community permission",
	"store.createMission": "Creating mission...",
	"store.createMission.error": "Failed to create mission <strong>{title}</strong>",
	"store.createMission.success": "Successfully created mission <strong>{title}</strong>",
	"store.createMissionSlot": "Creating slot... | Creating {count} slots...",
	"store.createMissionSlot.error": "Failed to create slot | Failed to create {count} slots",
	"store.createMissionSlot.success": "Successfully created slot | Successfully created {count} slots",
	"store.createMissionSlotGroup": "Creating slot group...",
	"store.createMissionSlotGroup.error": "Failed to create slot group <strong>{slotGroupInfo}</strong>",
	"store.createMissionSlotGroup.success": "Successfully created slot group <strong>{slotGroupInfo}</strong>",
	"store.createMissionSlotTemplate": "Creating slot template...",
	"store.createMissionSlotTemplate.error": "Failed to create slot template <strong>{title}</strong>",
	"store.createMissionSlotTemplate.success": "Successfully created slot template <strong>{title}</strong>",
	"store.deleteAccount": "Deleting account...",
	"store.deleteAccount.error": "Failed to delete account",
	"store.deleteAccount.success": "Successfully deleted account",
	"store.deleteCommunity": "Deleting community...",
	"store.deleteCommunity.error": "Failed to delete community",
	"store.deleteCommunity.success": "Successfully deleted community",
	"store.deleteCommunityLogo": "Deleting logo...",
	"store.deleteCommunityLogo.error": "Failed to delete logo",
	"store.deleteCommunityLogo.success": "Successfully deleted logo",
	"store.deleteCommunityPermission": "Deleting community permission...",
	"store.deleteCommunityPermission.error": "Failed to delete community permission",
	"store.deleteCommunityPermission.success": "Successfully deleted community permission",
	"store.deleteMission": "Deleting mission...",
	"store.deleteMission.error": "Failed to delete mission <strong>{title}</strong>",
	"store.deleteMission.success": "Successfully deleted mission <strong>{title}</strong>",
	"store.deleteMissionAccess": "Deleting mission access...",
	"store.deleteMissionAccess.error": "Failed to delete mission access",
	"store.deleteMissionAccess.success": "Successfully deleted mission access",
	"store.deleteMissionBannerImage": "Deleting banner image...",
	"store.deleteMissionBannerImage.error": "Failed to delete banner image",
	"store.deleteMissionBannerImage.success": "Successfully deleted banner image",
	"store.deleteMissionPermission": "Deleting mission permission...",
	"store.deleteMissionPermission.error": "Failed to delete mission permission",
	"store.deleteMissionPermission.success": "Successfully deleted mission permission",
	"store.deleteMissionSlot": "Deleting slot...",
	"store.deleteMissionSlot.error": "Failed to delete slot <strong>{slotInfo}</strong>",
	"store.deleteMissionSlot.success": "Successfully deleted slot <strong>{slotInfo}</strong>",
	"store.deleteMissionSlotGroup": "Deleting slot group...",
	"store.deleteMissionSlotGroup.error": "Failed to delete slot group <strong>{title}</strong>",
	"store.deleteMissionSlotGroup.success": "Successfully deleted slot group <strong>{title}</strong>",
	"store.deleteMissionSlotRegistration": "Deleting slot registration...",
	"store.deleteMissionSlotRegistration.error": "Failed to delete slot registration",
	"store.deleteMissionSlotRegistration.success": "Successfully deleted slot registration",
	"store.deleteMissionSlotTemplate": "Deleting slot template...",
	"store.deleteMissionSlotTemplate.error": "Failed to delete slot template <strong>{title}</strong>",
	"store.deleteMissionSlotTemplate.success": "Successfully deleted slot template <strong>{title}</strong>",
	"store.deleteMissionToken": "Deleting mission token...",
	"store.deleteMissionToken.error": "Failed to delete mission token",
	"store.deleteMissionToken.success": "Successfully deleted mission token",
	"store.deleteSelectedMissionSlots": "Deleting 1 slot... | Deleting {count} slots...",
	"store.deleteSelectedMissionSlots.error": "Failed to delete one or multiple selected slots",
	"store.deleteSelectedMissionSlots.success": "Successfully deleted 1 slot | Successfully deleted {count} slots",
	"store.deleteUser": "Deleting user...",
	"store.deleteUser.error": "Failed to delete user",
	"store.deleteUser.success": "Successfully deleted user",
	"store.duplicateMission": "Duplicating mission...",
	"store.duplicateMission.error": "Failed to duplicate mission",
	"store.duplicateMission.success": "Successfully duplicated mission",
	"store.duplicateMissionSlotGroup": "Duplicating slot group...",
	"store.duplicateMissionSlotGroup.error": "Failed to duplicate slot group <strong>{slotGroupInfo}</strong>",
	"store.duplicateMissionSlotGroup.success": "Successfully duplicated slot group <strong>{slotGroupInfo}</strong>",
	"store.editAccount": "Updating account details...",
	"store.editAccount.error": "Failed to update account details",
	"store.editAccount.success": "Successfully updated account details",
	"store.editCommunity": "Updating community details...",
	"store.editCommunity.error": "Failed to update community details",
	"store.editCommunity.success": "Successfully updated community details",
	"store.editMission": "Editing mission...",
	"store.editMission.error": "Failed to edit mission <strong>{title}</strong>",
	"store.editMission.success": "Successfully edited mission <strong>{title}</strong>",
	"store.editMissionSlot": "Editing slot...",
	"store.editMissionSlot.error": "Failed to edit slot <strong>{slotInfo}</strong>",
	"store.editMissionSlot.success": "Successfully edited slot <strong>{slotInfo}</strong>",
	"store.editMissionSlotGroup": "Editing slot group...",
	"store.editMissionSlotGroup.error": "Failed to edit slot group",
	"store.editMissionSlotGroup.success": "Successfully edited slot group",
	"store.editMissionSlotTemplate": "Editing slot template...",
	"store.editMissionSlotTemplate.error": "Failed to edit slot template <strong>{title}</strong>",
	"store.editMissionSlotTemplate.success": "Successfully edited slot template <strong>{title}</strong>",
	"store.editSelectedMissionSlots": "Editing 1 slot... | Editing {count} slots...",
	"store.editSelectedMissionSlots.error": "Failed to edit one or multiple selected slots",
	"store.editSelectedMissionSlots.success": "Successfully edited 1 slot | Successfully edited {count} slots",
	"store.editUser": "Updating user details...",
	"store.editUser.error": "Failed to update user details",
	"store.editUser.success": "Successfully updated user details",
	"store.generateMissionToken": "Generating mission token...",
	"store.generateMissionToken.error": "Failed to generate mission token",
	"store.generateMissionToken.success": "Successfully generated mission token",
	"store.getAccountDetails": "Loading account details...",
	"store.getAccountDetails.error": "Failed to load account details",
	"store.getCommunities": "Loading communities...",
	"store.getCommunities.error": "Failed to load communities",
	"store.getCommunityApplications": "Loading community applications...",
	"store.getCommunityApplications.error": "Failed to load community applications",
	"store.getCommunityApplicationStatus": "Loading community application status...",
	"store.getCommunityApplicationStatus.error": "Failed to load community application status",
	"store.getCommunityDetails": "Loading community details...",
	"store.getCommunityDetails.error": "Failed to load community details",
	"store.getCommunityDetails.error.notFound": "A community with the slug <strong>{slug}</strong> was not found",
	"store.getCommunityMissions": "Loading community missions...",
	"store.getCommunityMissions.error": "Failed to load community missions",
	"store.getCommunityPermissions": "Loading community permissions...",
	"store.getCommunityPermissions.error": "Failed to load community permissions",
	"store.getCommunityRepositories": "Loading community mod repositories...",
	"store.getCommunityRepositories.error": "Failed to load community mod repositories",
	"store.getCommunityServers": "Loading community servers...",
	"store.getCommunityServers.error": "Failed to load community servers",
	"store.getLoginRedirectUrl.error": "Failed to get Steam SSO URL",
	"store.getMissionAccesses": "Loading mission access...",
	"store.getMissionAccesses.error": "Failed to load mission access",
	"store.getMissionDetails": "Loading mission details...",
	"store.getMissionDetails.error": "Failed to load mission details",
	"store.getMissionDetails.error.notFound": "A mission with the slug <strong>{slug}</strong> was not found or is not visible",
	"store.getMissionPermissions": "Loading mission permissions...",
	"store.getMissionPermissions.error": "Failed to load mission permissions",
	"store.getMissions": "Loading missions...",
	"store.getMissions.error": "Failed to load missions",
	"store.getMissionsForCalendar.error": "Failed to load missions for calendar",
	"store.getMissionSlotlist": "Loading mission slotlist...",
	"store.getMissionSlotlist.error": "Failed to load mission slotlist",
	"store.getMissionSlotRegistrations": "Loading slot registrations...",
	"store.getMissionSlotRegistrations.error": "Failed to load slot registrations for slot <strong>{slotInfo}</strong>",
	"store.getMissionSlotTemplateDetails": "Loading slot template details...",
	"store.getMissionSlotTemplateDetails.error": "Failed to load slot template details...",
	"store.getMissionSlotTemplates": "Loading slot templates...",
	"store.getMissionSlotTemplates.error": "Failed to load slot templates",
	"store.getMissionToken": "Loading mission token...",
	"store.getMissionToken.error": "Failed to load mission token",
	"store.getNotifications": "Loading notifications...",
	"store.getNotifications.error": "Failed to load notifications",
	"store.getUnseenNotificationCount.error": "Failed to load unseen notification count",
	"store.getUserDetails": "Loading user details...",
	"store.getUserDetails.error": "Failed to load user details",
	"store.getUserMissions": "Loading user missions...",
	"store.getUserMissions.error": "Failed to load user missions",
	"store.getUsers": "Loading users...",
	"store.getUsers.error": "Failed to load users",
	"store.modifyMissionSlotRegistration": "Editing slot registration...",
	"store.modifyMissionSlotRegistration.error": "Failed to edit slot registration",
	"store.modifyMissionSlotRegistration.success": "Successfully edited slot registration",
	"store.performLogin": "Logging in...",
	"store.performLogin.error": "Failed to perform login",
	"store.processCommunityApplication": "Processing community application...",
	"store.processCommunityApplication.accept": "accept",
	"store.processCommunityApplication.accepted": "accepted",
	"store.processCommunityApplication.denied": "denied",
	"store.processCommunityApplication.deny": "deny",
	"store.processCommunityApplication.error": "Failed to {action} community application for user <strong>{nickname}</strong>",
	"store.processCommunityApplication.success": "Successfullly {action} community application for user <strong>{nickname}</strong>",
	"store.refreshToken": "Refreshing authentication...",
	"store.refreshToken.error": "Failed to perform login",
	"store.registerForMissionSlot": "Registering for slot...",
	"store.registerForMissionSlot.error": "Failed to register for slot <strong>{slotInfo}</strong>",
	"store.registerForMissionSlot.success": "Successfully registered for slot <strong>{slotInfo}</strong>",
	"store.removeCommunityMember": "Removing community member...",
	"store.removeCommunityMember.error": "Failed to remove community member <strong>{nickname}</strong>",
	"store.removeCommunityMember.success": "Successfully removed community member <strong>{nickname}</strong>",
	"store.searchCommunities.error": "Failed to search communities",
	"store.searchMissions.error": "Failed to search missions",
	"store.searchUsers.error": "Failed to search users",
	"store.unassignSelectedMissionSlots": "Unassigning 1 slot... | Unassigning {count} slots...",
	"store.unassignSelectedMissionSlots.error": "Failed to unassign one or multiple selected slots",
	"store.unassignSelectedMissionSlots.success": "Successfully unassigned 1 slot | Successfully unassigned {count} slots",
	"store.unregisterFromMissionSlot": "Unregistering from slot...",
	"store.unregisterFromMissionSlot.error": "Failed to unregister from slot <strong>{slotInfo}</strong>",
	"store.unregisterFromMissionSlot.success": "Successfully unregistered from slot <strong>{slotInfo}</strong>",
	"store.uploadCommunityLogo": "Uploading logo...",
	"store.uploadCommunityLogo.error": "Failed to upload logo",
	"store.uploadCommunityLogo.success": "Successfully uploaded logo",
	"store.uploadMissionBannerImage": "Uploading banner image...",
	"store.uploadMissionBannerImage.error": "Failed to upload banner image",
	"store.uploadMissionBannerImage.success": "Successfully uploaded banner image",
	"title.browser": "ArmA 3 mission and slotlist management",
	"user": "User",
	"user.confirm.activate": "Activate user account?",
	"user.confirm.deactivate": "Deactivate user account?",
	"user.confirm.delete": "Delete user?",
	"user.list.search": "Search users",
	"user.list.search.description": "Start typing to search for an user with the given nickname, including partial matches. Clicking a user result will take you to their details page",
	"user.modal.edit": "Edit user details",
	"user.nickname": "Nickname",
	"user.status": "Status",
	"user.status.deactivated": "Account deactivated",
	"user.status.normal": "normal",
	"user.steamId": "Steam ID"
};

/***/ }),
/* 594 */
/* unknown exports provided */
/* all exports used */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(/*! ./app */ 6);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ })
],[594]);


// WEBPACK FOOTER //
// client.5ba57d94.js